const testsModuleEn = {
  common: {
    loading: "Loading...",
    back: "Back",
    backToHome: "Back to home",
    select: "Select",
    choose: "Choose",
    save: "Save",
    saving: "Saving...",
    delete: "Delete",
    edit: "Edit",
    preview: "Preview",
    start: "Start",
    submit: "Submit",
    submitting: "Submitting...",
    leave: "Leave",
    durationMinutes: "Duration (minutes)",
    level: "Level",
    program: "Program",
    title: "Title",
    description: "Description",
    prompt: "Prompt",
    type: "Type",
    notAllowed: "Not allowed",
    unauthorized: "Unauthorized",
    remove: "Remove",
  },
  testTypes: {
    text_comprehension: "Text Comprehension",
    grammar: "Grammar",
    vocabulary: "Vocabulary",
    math_problems: "Math Problems",
    calculations: "Calculations",
    qcm: "QCM",
    problem_solving: "Problem Solving",
    data_interpretation: "Data Interpretation",
    written_expression: "Written Expression",
    mixed_test: "Mixed Test",
  },
  dashboard: {
    roleAdmin: "Admin",
    roleTeacher: "Teacher",
    title: "Program tests",
    subtitle: "Create placement tests, publish them, and review submissions.",
    previewPlacement: "Preview placement flow",
    createCardTitle: "Create a test",
    placeholderLevel: "e.g. CP or 6ème",
    creating: "Creating...",
    create: "Create",
    stats: {
      tests: "Tests",
      forCurrentFilters: "For current filters",
      published: "Published",
      visibleForStudents: "Visible for students",
      submissions: "Submissions",
      totalSubmissions: "Total submissions",
      notReviewed: "Not reviewed",
      needsReview: "Needs review",
    },
    insightsTitle: "Insights",
    insightsSubtitle:
      "Quick signals about publishing, review load, and activity.",
    publishRate: "Publish rate",
    publishedVsDrafts: "Published vs drafts",
    drafts: "Drafts",
    reviewLoad: "Review load",
    topTestsNeedingReview: "Top tests needing review",
    nothingToReview: "Nothing to review right now.",
    testActivity: "Test activity",
    newTests14Days: "New tests over last 14 days",
    needsReviewTitle: "Needs review",
    needsReviewSubtitle: "Tests with unreviewed submissions.",
    startReview: "Start review",
    manageTitle: "Tests",
    manageSubtitle: "Manage tests and review submissions by level.",
    newTest: "New test",
    filterProgram: "Filter by program",
    filterLevel: "Filter by level",
    allPrograms: "All programs",
    allLevels: "All levels",
    onlyNotReviewed: "Only not reviewed",
    noTestsFound: "No tests found.",
    confirmDelete: "Delete this test?",
    failedUpdate: "Failed to update test",
    failedDelete: "Failed to delete test",
    statusPublished: "Published",
    statusDraft: "Draft",
    publish: "Publish",
    unpublish: "Unpublish",
    review: "Review",
    failedLoadTests: "Failed to load tests",
  },
  exerciseTypes: {
    multiple_choice: "Choose",
    true_false: "True / False",
    short_text: "Write",
    long_text: "Write",
    essay: "Essay",
    fill_blanks: "Fill blanks",
    match_pairs: "Match",
    connect_arrow: "Connect",
    select_words: "Select words",
    stimulus: "Read",
    diagram_label: "Label diagram",
    image_label: "Label image",
    drag_drop: "Drag & drop",
    data_interpretation: "Data",
    task: "Task",
  },
  newTest: {
    subtitle: "Create a new test, then start adding exercises.",
    detailsTitle: "Test details",
    failedCreate: "Failed to create test",
  },
  take: {
    doNotLeave: "Do not leave the page during the test.",
    confirmLeave: "Do you want to leave the test?",
    answered: "Answered:",
    progress: "Progress",
    questionNavigation: "Question navigation",
    questionLabel: "Question {{num}}",
    submittedTitle: "Submitted",
    submittedBody: "Your answers were sent to the teacher.",
    backToTests: "Back to tests",
    test: "Test",
    timeLeft: "Time left",
    durationLabel: "Duration",
    minutesShort: "min",
    failedLoad: "Failed to load test",
    failedSubmit: "Failed to submit test",
    testNotFound: "Test not found.",
    noExercisesYet: "No exercises yet.",
    previewModeNote: "Preview mode (teachers/admins cannot submit).",
    passage: "Passage",
  },
  placement: {
    title: "Placement test",
    chooseLevel: "Choose a level",
    pickSubtitle: "We’ll pick the most recent published test for that level.",
    backHome: "Back to home",
    editInfo: "Edit info",
    start: "Start",
    failedLoad: "Failed to load placement tests",
    noPublished: "No published placement tests found for this program.",
    noteNoLead:
      "Pick a level, then fill the child/contact form before starting the test.",
    noteLead: "Child: {{child}} — Parent: {{parent}}",
    requireInfoOnlyStudentsParents: "Only students/parents can submit.",
    requireInfoFillFirst: "Please fill the info form first.",
    testNotFound: "Test not found",
    tryAnotherLevel: "Try choosing another level.",
    chooseLevelCta: "Choose level",
    diagramAlt: "Diagram",
    startForm: {
      validationError:
        "Please fill the child info and at least one contact (phone or email).",
      title: "Child information",
      subtitle:
        "We’ll send the results to the teacher so they can contact you.",
      childFullName: "Child full name",
      childAge: "Age",
      childGrade: "Grade/Level",
      parentFullName: "Parent full name",
      parentPhone: "Phone",
      parentEmail: "Email",
      city: "City",
      notes: "Notes",
      consent:
        "I agree to send my info and test results to the teacher for contact.",
      continue: "Continue",
    },
  },
  runner: {
    matchInstruction: "Select a left item, then select its match on the right.",
    imageAlt: "Image",
    categorizeAria: "Categorize",
    orderInstruction: "Order the items.",
    dataAlt: "Data",
    writeLabel: "Write the label",
    diagramLabelingNote: "Diagram labeling question.",
    writeAnswer: "Write your answer here...",
    blankLabel: "Blank {{id}}",
    choose: "Choose",
    true: "True",
    false: "False",
    hotspotLabel: "Hotspot {{id}}",
    imageLabelInstruction:
      "Pick a label then tap a hotspot (or pick a hotspot then a label). To clear: focus a hotspot and press Delete.",
    moveUp: "Move up",
    moveDown: "Move down",
    unsupportedType: "Unsupported question type: {{type}}",
  },
  editor: {
    editTestTitle: "Edit test",
    details: "Details",
    exercises: "Exercises",
    testType: "Test type",
    durationMinutes: "Duration (minutes)",
    published: "Published",
    topic: "Topic",
    prompt: "Prompt",
    text: "Text",
    rows: "Rows",
    points: "Points",
    pointsAbbrev: "pts",
    pointsIgnored: "Points (ignored for auto-score)",

    livePreview: "Live preview",
    noExercisesYet: "No exercises yet.",

    add: "Add",
    adding: "Adding...",

    confirmDeleteExercise: "Delete this exercise?",
    failedAddExercise: "Failed to add exercise",
    failedDeleteExercise: "Failed to delete exercise",
    failedSaveExercise: "Failed to save exercise",
    failedSaveTest: "Failed to save test",

    gradingTitle: "Grading",
    allowPartialCredit: "Allow partial credit",
    negativePerWrongOptional: "Negative per wrong (optional)",
    caseInsensitiveMatching: "Case-insensitive matching",

    presentation: "Presentation",
    presentationList: "List",
    presentationUnderline: "Underline (paper-like)",

    qcmMode: "QCM mode",
    qcmModeSingle: "Single choice",
    qcmModeMultiple: "Multiple choice",
    allowMultipleAnswers: "Allow multiple answers",
    optionTextPlaceholder: "Option text",
    addOption: "+ Add option",
    removeOption: "Remove option",

    answerKey: "Answer key",
    correctId: "Correct ID",

    fillBlanksTemplateLabel: "Template",
    blankPlaceholder: "Blank placeholder",
    blankAcceptedAnswersComma: "Accepted answers (comma-separated)",
    acceptedAnswersOnePerLine: "Accepted answers (one per line)",
    addBlank: "+ Add blank",
    removeBlank: "Remove blank",

    mode: "Mode",
    modeOrder: "Order",
    modeCategorize: "Categorize",
    order: "Order",
    orderAnswerKeyHint: "Define the correct order using the IDs above.",

    categories: "Categories",
    categoryLabelPlaceholder: "Category label",
    addCategory: "+ Add category",
    removeCategory: "Remove category",

    items: "Items",
    itemAcceptedAnswersComma: "Accepted answers (comma-separated)",
    itemCorrectCategory: "Correct category",
    addItem: "+ Add item",
    removeItem: "Remove item",

    labels: "Labels",
    labelPlaceholder: "Label",
    labelTextPlaceholder: "Label text",
    placeholderLabel: "Label",
    addLabel: "+ Add label",
    removeLabel: "Remove label",

    hotspots: "Hotspots",
    hotspotsHint: "Add hotspots by clicking on the image.",
    addHotspot: "+ Add hotspot",
    removeHotspot: "Remove hotspot",
    hotspotCorrectLabel: "Correct label",
    hotspotBuilderAria: "Hotspot builder",
    hotspotAlt: "Hotspot",
    hotspotBuilderTip:
      "Click to add. Drag to move/resize. Press Delete to remove.",
    resizeHotspotLabel: "Resize hotspot {{id}}",

    imageUrl: "Image URL",
    imageUrlOptional: "Image URL (optional)",
    uploading: "Uploading...",
    replaceImage: "Replace image",
    imageOptional: "Image (optional)",
    uploadFailed: "Upload failed",
    imageAlt: "Image",

    selectWordsHint: "Select the correct words.",
    selectWordsHighlight: "Highlight",
    selectWordsCircle: "Circle",
    wordPlaceholder: "Word",
    addWord: "+ Add word",
    removeWord: "Remove word",

    writtenHint: "Answer in writing.",
    comprehensionHint: "Answer based on the passage.",
    essayManualHint: "Manual grading required for essays.",
    longTextManualHint: "Manual grading may be required.",

    leftColumn: "Left column",
    rightColumn: "Right column",
    textPlaceholder: "Text",
    addLeftItem: "+ Add left item",
    addRightItem: "+ Add right item",
    removeLeft: "Remove left",
    removeRight: "Remove right",
    leftCorrectRightId: "Left {{id}} correct right ID",

    matchPresentationSelect: "Select IDs (simple)",
    matchPresentationArrows: "Arrows (paper-like)",
    matchAllowManyToOne:
      "Allow many left items to connect to the same right item",
    arrowsModeHint:
      '"Arrows" mode lets the student connect left to right by clicking, and draws arrows.',
    answerKeyBuilderArrows: "Answer key builder (arrows)",
    clearAllConnections: "Clear all connections",

    noVisualEditor:
      "This exercise type doesn't have a visual editor yet. Change the exercise type to continue editing.",
  },
  submissions: {
    title: "Submissions",
    notAllowed: "Not allowed",
    failedLoad: "Failed to load submissions",
    failedSave: "Failed to save review",
    saveReview: "Save review",
    testNumber: "Test #{{id}}",
    empty: "No submissions yet.",
    submissionNumber: "Submission #{{id}}",
    studentId: "student_id: {{id}}",
    exerciseNumber: "Exercise #{{id}}",
    noAnswers: "No answers payload.",
    points: "Points: {{n}}",
    awardedPoints: "Awarded (0–{{max}})",
    autoScore: "Auto: {{n}}",
  },
};

const testsModuleAr = {
  ...testsModuleEn,
  common: {
    ...testsModuleEn.common,
    loading: "جارٍ التحميل...",
    back: "رجوع",
    backToHome: "العودة للرئيسية",
    select: "اختر",
    choose: "اختر",
    save: "حفظ",
    saving: "جارٍ الحفظ...",
    delete: "حذف",
    edit: "تعديل",
    preview: "معاينة",
    start: "ابدأ",
    submit: "إرسال",
    submitting: "جارٍ الإرسال...",
    leave: "مغادرة",
    durationMinutes: "المدة (بالدقائق)",
    level: "المستوى",
    program: "البرنامج",
    title: "العنوان",
    description: "الوصف",
    prompt: "التعليمات",
    type: "النوع",
    notAllowed: "غير مسموح",
    unauthorized: "غير مصرح",
    remove: "إزالة",
  },
  dashboard: {
    ...testsModuleEn.dashboard,
    roleAdmin: "مشرف",
    roleTeacher: "معلم",
    title: "اختبارات البرنامج",
    subtitle: "أنشئ اختبارات تحديد المستوى، انشرها، وراجع الإجابات.",
    previewPlacement: "معاينة اختبار تحديد المستوى",
    createCardTitle: "إنشاء اختبار",
    creating: "جارٍ الإنشاء...",
    create: "إنشاء",
    confirmDelete: "حذف هذا الاختبار؟",
    failedUpdate: "فشل تحديث الاختبار",
    failedDelete: "فشل حذف الاختبار",
    statusPublished: "منشور",
    statusDraft: "مسودة",
    publish: "نشر",
    unpublish: "إلغاء النشر",
    review: "مراجعة",
    failedLoadTests: "فشل تحميل الاختبارات",
  },
  editor: {
    ...testsModuleEn.editor,
    editTestTitle: "تعديل الاختبار",
    details: "التفاصيل",
    exercises: "التمارين",
    testType: "نوع الاختبار",
    durationMinutes: "المدة (بالدقائق)",
    published: "منشور",
    topic: "الموضوع",
    text: "النص",
    rows: "الأسطر",
    points: "النقاط",
    pointsAbbrev: "ن",
    livePreview: "معاينة مباشرة",
    noExercisesYet: "لا توجد تمارين بعد.",
    add: "إضافة",
    adding: "جارٍ الإضافة...",
    confirmDeleteExercise: "حذف هذا التمرين؟",
    failedAddExercise: "فشل إضافة التمرين",
    failedDeleteExercise: "فشل حذف التمرين",
    failedSaveExercise: "فشل حفظ التمرين",
    failedSaveTest: "فشل حفظ الاختبار",
    gradingTitle: "التقييم",
    allowPartialCredit: "السماح بدرجات جزئية",
    qcmMode: "وضع الاختيار",
    qcmModeSingle: "اختيار واحد",
    qcmModeMultiple: "اختيارات متعددة",
    allowMultipleAnswers: "السماح بإجابات متعددة",
    addOption: "+ إضافة خيار",
    removeOption: "حذف خيار",
    answerKey: "مفتاح الإجابة",
    addBlank: "+ إضافة فراغ",
    removeBlank: "حذف الفراغ",
    addCategory: "+ إضافة فئة",
    removeCategory: "حذف الفئة",
    addItem: "+ إضافة عنصر",
    removeItem: "حذف العنصر",
    addLabel: "+ إضافة تسمية",
    removeLabel: "حذف التسمية",
    hotspots: "مناطق",
    hotspotsHint: "أضف مناطق بالنقر على الصورة.",
    addHotspot: "+ إضافة منطقة",
    removeHotspot: "حذف المنطقة",
    uploading: "جارٍ الرفع...",
    replaceImage: "استبدال الصورة",
    imageOptional: "صورة (اختياري)",
    uploadFailed: "فشل الرفع",
    clearAllConnections: "مسح كل التوصيلات",
    noVisualEditor:
      "لا يوجد محرر بصري لهذا النوع بعد. غيّر نوع التمرين للمتابعة.",
  },
  take: {
    ...testsModuleEn.take,
    doNotLeave: "لا تغادر الصفحة أثناء الاختبار.",
    confirmLeave: "هل تريد مغادرة الاختبار؟",
    progress: "التقدم",
    questionNavigation: "التنقل بين الأسئلة",
    submittedTitle: "تم الإرسال",
    submittedBody: "تم إرسال إجاباتك إلى المعلم.",
    backToTests: "العودة للاختبارات",
    timeLeft: "الوقت المتبقي",
    failedLoad: "فشل تحميل الاختبار",
    failedSubmit: "فشل إرسال الاختبار",
    testNotFound: "الاختبار غير موجود.",
  },
  placement: {
    ...testsModuleEn.placement,
    title: "اختبار تحديد المستوى",
    chooseLevel: "اختر المستوى",
    pickSubtitle: "سنختار أحدث اختبار منشور لهذا المستوى.",
    failedLoad: "فشل تحميل اختبارات تحديد المستوى",
    noPublished: "لا توجد اختبارات منشورة لهذا البرنامج.",
    start: "ابدأ",
    editInfo: "تعديل المعلومات",
  },
};

const testsModuleFr = {
  ...testsModuleEn,
  common: {
    ...testsModuleEn.common,
    loading: "Chargement...",
    back: "Retour",
    save: "Enregistrer",
    saving: "Enregistrement...",
    delete: "Supprimer",
    edit: "Modifier",
    preview: "Aperçu",
    start: "Démarrer",
    submit: "Envoyer",
    submitting: "Envoi...",
    leave: "Quitter",
    durationMinutes: "Durée (minutes)",
    level: "Niveau",
    program: "Programme",
    title: "Titre",
    description: "Description",
    prompt: "Consigne",
    type: "Type",
    notAllowed: "Non autorisé",
    unauthorized: "Non autorisé",
    remove: "Retirer",
  },
  dashboard: {
    ...testsModuleEn.dashboard,
    roleTeacher: "Enseignant",
    title: "Tests du programme",
    subtitle:
      "Créez des tests de positionnement, publiez-les et relisez les réponses.",
    previewPlacement: "Aperçu du test de positionnement",
    createCardTitle: "Créer un test",
    creating: "Création...",
    create: "Créer",
    confirmDelete: "Supprimer ce test ?",
    failedUpdate: "Échec de la mise à jour du test",
    failedDelete: "Échec de la suppression du test",
    statusPublished: "Publié",
    statusDraft: "Brouillon",
    publish: "Publier",
    unpublish: "Dépublier",
    review: "Relire",
    failedLoadTests: "Échec du chargement des tests",
  },
  editor: {
    ...testsModuleEn.editor,
    editTestTitle: "Modifier le test",
    details: "Détails",
    exercises: "Exercices",
    testType: "Type de test",
    published: "Publié",
    livePreview: "Aperçu en direct",
    addOption: "+ Ajouter une option",
    removeOption: "Supprimer l'option",
    answerKey: "Corrigé",
    clearAllConnections: "Effacer toutes les connexions",
    uploadFailed: "Échec de l'envoi",
    uploading: "Envoi...",
    replaceImage: "Remplacer l'image",
    imageOptional: "Image (optionnel)",
  },
};

const testsModuleDe = {
  ...testsModuleEn,
  common: {
    ...testsModuleEn.common,
    loading: "Laden...",
    back: "Zurück",
    save: "Speichern",
    saving: "Wird gespeichert...",
    delete: "Löschen",
    edit: "Bearbeiten",
    preview: "Vorschau",
    start: "Start",
    submit: "Senden",
    submitting: "Wird gesendet...",
    leave: "Verlassen",
    durationMinutes: "Dauer (Minuten)",
    level: "Niveau",
    program: "Programm",
    title: "Titel",
    description: "Beschreibung",
    prompt: "Aufgabe",
    type: "Typ",
    notAllowed: "Nicht erlaubt",
    unauthorized: "Nicht autorisiert",
    remove: "Entfernen",
  },
  dashboard: {
    ...testsModuleEn.dashboard,
    roleTeacher: "Lehrer",
    title: "Programmtests",
    subtitle: "Erstellen, veröffentlichen und Abgaben prüfen.",
    previewPlacement: "Einstufungsvorschau",
    createCardTitle: "Test erstellen",
    creating: "Wird erstellt...",
    create: "Erstellen",
    confirmDelete: "Diesen Test löschen?",
    failedUpdate: "Test konnte nicht aktualisiert werden",
    failedDelete: "Test konnte nicht gelöscht werden",
    statusPublished: "Veröffentlicht",
    statusDraft: "Entwurf",
    publish: "Veröffentlichen",
    unpublish: "Zurückziehen",
    review: "Prüfen",
    failedLoadTests: "Tests konnten nicht geladen werden",
  },
  editor: {
    ...testsModuleEn.editor,
    editTestTitle: "Test bearbeiten",
    details: "Details",
    exercises: "Aufgaben",
    testType: "Testtyp",
    published: "Veröffentlicht",
    livePreview: "Live-Vorschau",
    addOption: "+ Option hinzufügen",
    removeOption: "Option entfernen",
    answerKey: "Lösungsschlüssel",
    clearAllConnections: "Alle Verbindungen löschen",
    uploadFailed: "Upload fehlgeschlagen",
    uploading: "Wird hochgeladen...",
    replaceImage: "Bild ersetzen",
    imageOptional: "Bild (optional)",
  },
};

const testsModuleIt = {
  ...testsModuleEn,
  common: {
    ...testsModuleEn.common,
    loading: "Caricamento...",
    back: "Indietro",
    backToHome: "Torna alla home",
    select: "Seleziona",
    choose: "Scegli",
    save: "Salva",
    saving: "Salvataggio...",
    delete: "Elimina",
    edit: "Modifica",
    preview: "Anteprima",
    start: "Inizia",
    submit: "Invia",
    submitting: "Invio...",
    leave: "Esci",
    durationMinutes: "Durata (minuti)",
    level: "Livello",
    program: "Programma",
    title: "Titolo",
    description: "Descrizione",
    prompt: "Istruzioni",
    type: "Tipo",
    notAllowed: "Non consentito",
    unauthorized: "Non autorizzato",
    remove: "Rimuovi",
  },
  testTypes: {
    ...testsModuleEn.testTypes,
    text_comprehension: "Comprensione del testo",
    grammar: "Grammatica",
    vocabulary: "Vocabolario",
    math_problems: "Problemi di matematica",
    calculations: "Calcoli",
    problem_solving: "Risoluzione di problemi",
    data_interpretation: "Interpretazione dei dati",
    written_expression: "Espressione scritta",
    mixed_test: "Test misto",
  },
  dashboard: {
    ...testsModuleEn.dashboard,
    roleTeacher: "Docente",
    title: "Test del programma",
    subtitle: "Crea test di valutazione, pubblicali e rivedi gli invii.",
    previewPlacement: "Anteprima del percorso di valutazione",
    createCardTitle: "Crea un test",
    placeholderLevel: "es. CP o 6ème",
    creating: "Creazione...",
    create: "Crea",
    confirmDelete: "Eliminare questo test?",
    failedUpdate: "Aggiornamento del test non riuscito",
    failedDelete: "Eliminazione del test non riuscita",
    statusPublished: "Pubblicato",
    statusDraft: "Bozza",
    publish: "Pubblica",
    unpublish: "Annulla pubblicazione",
    review: "Revisione",
    failedLoadTests: "Caricamento dei test non riuscito",
  },
  editor: {
    ...testsModuleEn.editor,
    editTestTitle: "Modifica test",
    testType: "Tipo di test",
    durationMinutes: "Durata (minuti)",
    published: "Pubblicato",
    details: "Dettagli",
    exercises: "Esercizi",
    topic: "Argomento",
    text: "Testo",
    rows: "Righe",
    points: "Punti",
    pointsAbbrev: "pt",
    add: "Aggiungi",
    adding: "Aggiunta...",
    confirmDeleteExercise: "Eliminare questo esercizio?",
    failedAddExercise: "Impossibile aggiungere l’esercizio",
    failedDeleteExercise: "Impossibile eliminare l’esercizio",
    failedSaveExercise: "Impossibile salvare l’esercizio",
    failedSaveTest: "Impossibile salvare il test",
    gradingTitle: "Valutazione",
    allowPartialCredit: "Consenti credito parziale",
    negativePerWrongOptional: "Penalità per errore (opzionale)",
    caseInsensitiveMatching:
      "Corrispondenza senza distinzione tra maiuscole/minuscole",
    presentation: "Presentazione",
    presentationList: "Elenco",
    presentationUnderline: "Sottolinea (stile carta)",
    qcmMode: "Modalità QCM",
    allowMultipleAnswers: "Consenti risposte multiple",
    addOption: "+ Aggiungi opzione",
    removeOption: "Rimuovi opzione",
    optionTextPlaceholder: "Testo opzione",
    answerKey: "Chiave risposte",
    correctId: "ID corretto",
    fillBlanksTemplateLabel: "Modello",
    blankPlaceholder: "Placeholder spazio",
    blankAcceptedAnswersComma: "Risposte accettate (separate da virgola)",
    acceptedAnswersOnePerLine: "Risposte accettate (una per riga)",
    addBlank: "+ Aggiungi spazio",
    removeBlank: "Rimuovi spazio",
    mode: "Modalità",
    modeOrder: "Ordina",
    modeCategorize: "Categoria",
    order: "Ordine",
    orderAnswerKeyHint: "Definisci l’ordine corretto usando gli ID sopra.",
    categories: "Categorie",
    categoryLabelPlaceholder: "Etichetta categoria",
    addCategory: "+ Aggiungi categoria",
    removeCategory: "Rimuovi categoria",
    items: "Elementi",
    itemAcceptedAnswersComma: "Risposte accettate (separate da virgola)",
    itemCorrectCategory: "Categoria corretta",
    addItem: "+ Aggiungi elemento",
    removeItem: "Rimuovi elemento",
    labels: "Etichette",
    labelPlaceholder: "Etichetta",
    labelTextPlaceholder: "Testo etichetta",
    addLabel: "+ Aggiungi etichetta",
    removeLabel: "Rimuovi etichetta",
    hotspots: "Hotspot",
    hotspotsHint: "Aggiungi hotspot cliccando sull’immagine.",
    addHotspot: "+ Aggiungi hotspot",
    removeHotspot: "Rimuovi hotspot",
    hotspotCorrectLabel: "Etichetta corretta",
    hotspotBuilderAria: "Costruttore hotspot",
    hotspotAlt: "Hotspot",
    hotspotBuilderTip:
      "Clicca per aggiungere. Trascina per spostare/ridimensionare. Premi Elimina per rimuovere.",
    resizeHotspotLabel: "Ridimensiona hotspot {{id}}",
    imageUrl: "URL immagine",
    imageUrlOptional: "URL immagine (opzionale)",
    selectWordsHint: "Seleziona le parole corrette.",
    selectWordsHighlight: "Evidenzia",
    selectWordsCircle: "Cerchia",
    wordPlaceholder: "Parola",
    addWord: "+ Aggiungi parola",
    removeWord: "Rimuovi parola",
    writtenHint: "Rispondi per iscritto.",
    comprehensionHint: "Rispondi in base al testo.",
    essayManualHint: "Valutazione manuale richiesta per i saggi.",
    longTextManualHint: "Potrebbe essere necessaria la valutazione manuale.",
    leftColumn: "Colonna sinistra",
    rightColumn: "Colonna destra",
    textPlaceholder: "Testo",
    addLeftItem: "+ Aggiungi elemento a sinistra",
    addRightItem: "+ Aggiungi elemento a destra",
    removeLeft: "Rimuovi sinistra",
    removeRight: "Rimuovi destra",
    leftCorrectRightId: "Sinistra {{id}}: ID corretto a destra",
    matchPresentationSelect: "Seleziona ID (semplice)",
    matchPresentationArrows: "Frecce (stile carta)",
    matchAllowManyToOne:
      "Consenti a più elementi sinistra di collegarsi allo stesso elemento destra",
    arrowsModeHint:
      'La modalità "Frecce" permette allo studente di collegare sinistra e destra cliccando, e disegna le frecce.',
    answerKeyBuilderArrows: "Costruttore chiave risposte (frecce)",
    clearAllConnections: "Cancella tutte le connessioni",
    livePreview: "Anteprima live",
    qcmModeSingle: "Scelta singola",
    qcmModeMultiple: "Scelta multipla",
    uploading: "Caricamento...",
    replaceImage: "Sostituisci immagine",
    imageOptional: "Immagine (opzionale)",
    uploadFailed: "Caricamento non riuscito",
    noVisualEditor:
      "Questo tipo di esercizio non ha ancora un editor visuale. Cambia il tipo di esercizio per continuare.",
  },
};

const testsModuleEs = {
  ...testsModuleEn,
  common: {
    ...testsModuleEn.common,
    loading: "Cargando...",
    back: "Atrás",
    backToHome: "Volver al inicio",
    select: "Seleccionar",
    choose: "Elegir",
    save: "Guardar",
    saving: "Guardando...",
    delete: "Eliminar",
    edit: "Editar",
    preview: "Vista previa",
    start: "Comenzar",
    submit: "Enviar",
    submitting: "Enviando...",
    leave: "Salir",
    durationMinutes: "Duración (minutos)",
    level: "Nivel",
    program: "Programa",
    title: "Título",
    description: "Descripción",
    prompt: "Instrucciones",
    type: "Tipo",
    notAllowed: "No permitido",
    unauthorized: "No autorizado",
    remove: "Quitar",
  },
  testTypes: {
    ...testsModuleEn.testTypes,
    text_comprehension: "Comprensión de texto",
    grammar: "Gramática",
    vocabulary: "Vocabulario",
    math_problems: "Problemas de matemáticas",
    calculations: "Cálculos",
    problem_solving: "Resolución de problemas",
    data_interpretation: "Interpretación de datos",
    written_expression: "Expresión escrita",
    mixed_test: "Prueba mixta",
  },
  dashboard: {
    ...testsModuleEn.dashboard,
    roleTeacher: "Docente",
    title: "Pruebas del programa",
    subtitle: "Crea pruebas de nivel, publícalas y revisa las entregas.",
    previewPlacement: "Vista previa del flujo de nivelación",
    createCardTitle: "Crear una prueba",
    placeholderLevel: "p. ej. CP o 6ème",
    creating: "Creando...",
    create: "Crear",
    confirmDelete: "¿Eliminar esta prueba?",
    failedUpdate: "No se pudo actualizar la prueba",
    failedDelete: "No se pudo eliminar la prueba",
    statusPublished: "Publicada",
    statusDraft: "Borrador",
    publish: "Publicar",
    unpublish: "Despublicar",
    review: "Revisar",
    failedLoadTests: "No se pudieron cargar las pruebas",
  },
  editor: {
    ...testsModuleEn.editor,
    editTestTitle: "Editar prueba",
    testType: "Tipo de prueba",
    durationMinutes: "Duración (minutos)",
    published: "Publicada",
    details: "Detalles",
    exercises: "Ejercicios",
    topic: "Tema",
    text: "Texto",
    rows: "Filas",
    points: "Puntos",
    pointsAbbrev: "pts",
    add: "Añadir",
    adding: "Añadiendo...",
    confirmDeleteExercise: "¿Eliminar este ejercicio?",
    failedAddExercise: "No se pudo añadir el ejercicio",
    failedDeleteExercise: "No se pudo eliminar el ejercicio",
    failedSaveExercise: "No se pudo guardar el ejercicio",
    failedSaveTest: "No se pudo guardar la prueba",
    gradingTitle: "Calificación",
    allowPartialCredit: "Permitir crédito parcial",
    negativePerWrongOptional: "Penalización por error (opcional)",
    caseInsensitiveMatching:
      "Coincidencia sin distinguir mayúsculas/minúsculas",
    presentation: "Presentación",
    presentationList: "Lista",
    presentationUnderline: "Subrayar (tipo papel)",
    qcmMode: "Modo QCM",
    allowMultipleAnswers: "Permitir respuestas múltiples",
    addOption: "+ Añadir opción",
    removeOption: "Eliminar opción",
    optionTextPlaceholder: "Texto de la opción",
    answerKey: "Clave de respuestas",
    correctId: "ID correcto",
    fillBlanksTemplateLabel: "Plantilla",
    blankPlaceholder: "Marcador del hueco",
    blankAcceptedAnswersComma: "Respuestas aceptadas (separadas por comas)",
    acceptedAnswersOnePerLine: "Respuestas aceptadas (una por línea)",
    addBlank: "+ Añadir hueco",
    removeBlank: "Eliminar hueco",
    mode: "Modo",
    modeOrder: "Ordenar",
    modeCategorize: "Categorizar",
    order: "Orden",
    orderAnswerKeyHint: "Define el orden correcto usando los ID de arriba.",
    categories: "Categorías",
    categoryLabelPlaceholder: "Etiqueta de categoría",
    addCategory: "+ Añadir categoría",
    removeCategory: "Eliminar categoría",
    items: "Elementos",
    itemAcceptedAnswersComma: "Respuestas aceptadas (separadas por comas)",
    itemCorrectCategory: "Categoría correcta",
    addItem: "+ Añadir elemento",
    removeItem: "Eliminar elemento",
    labels: "Etiquetas",
    labelPlaceholder: "Etiqueta",
    labelTextPlaceholder: "Texto de la etiqueta",
    addLabel: "+ Añadir etiqueta",
    removeLabel: "Eliminar etiqueta",
    hotspots: "Puntos",
    hotspotsHint: "Añade puntos haciendo clic en la imagen.",
    addHotspot: "+ Añadir punto",
    removeHotspot: "Eliminar punto",
    hotspotCorrectLabel: "Etiqueta correcta",
    hotspotBuilderAria: "Constructor de puntos",
    hotspotAlt: "Punto",
    hotspotBuilderTip:
      "Haz clic para añadir. Arrastra para mover/redimensionar. Pulsa Supr para eliminar.",
    resizeHotspotLabel: "Redimensionar punto {{id}}",
    imageUrl: "URL de imagen",
    imageUrlOptional: "URL de imagen (opcional)",
    selectWordsHint: "Selecciona las palabras correctas.",
    selectWordsHighlight: "Resaltar",
    selectWordsCircle: "Rodear",
    wordPlaceholder: "Palabra",
    addWord: "+ Añadir palabra",
    removeWord: "Eliminar palabra",
    writtenHint: "Responde por escrito.",
    comprehensionHint: "Responde según el texto.",
    essayManualHint: "Se requiere calificación manual para ensayos.",
    longTextManualHint: "Puede requerir calificación manual.",
    leftColumn: "Columna izquierda",
    rightColumn: "Columna derecha",
    textPlaceholder: "Texto",
    addLeftItem: "+ Añadir elemento izquierdo",
    addRightItem: "+ Añadir elemento derecho",
    removeLeft: "Eliminar izquierdo",
    removeRight: "Eliminar derecho",
    leftCorrectRightId: "Izquierda {{id}}: ID correcto de la derecha",
    matchPresentationSelect: "Seleccionar ID (simple)",
    matchPresentationArrows: "Flechas (tipo papel)",
    matchAllowManyToOne:
      "Permitir que varios elementos de la izquierda se conecten al mismo elemento de la derecha",
    arrowsModeHint:
      'El modo "Flechas" permite conectar izquierda y derecha haciendo clic y dibuja flechas.',
    answerKeyBuilderArrows: "Constructor de clave (flechas)",
    clearAllConnections: "Borrar todas las conexiones",
    livePreview: "Vista previa en vivo",
    qcmModeSingle: "Opción única",
    qcmModeMultiple: "Opción múltiple",
    uploading: "Subiendo...",
    replaceImage: "Reemplazar imagen",
    imageOptional: "Imagen (opcional)",
    uploadFailed: "Error al subir",
    noVisualEditor:
      "Este tipo de ejercicio aún no tiene editor visual. Cambia el tipo de ejercicio para seguir editando.",
  },
};

const translations = {
  ar: {
    meta: { name: "العربية", dir: "rtl" },
    testsModule: testsModuleAr,
    common: { id: "معرّف" },
    nav: {
      home: "الرئيسية",
      courses: "الدورات",
      about: "من نحن",
      contact: "تواصل",
      searchLabel: "ابحث داخل Casaclass",
      searchPlaceholder: "ابحث عن حصة أو مورد",
      menuLabel: "القائمة",
      languageLabel: "اللغة",
    },
    auth: {
      login: "تسجيل الدخول",
      signup: "إنشاء حساب",
    },
    protectedRoute: {
      loading: "جارٍ التحقق من حسابك...",
    },
    footer: {
      title: "Casaclass",
      description: "منصتك للتعلم وتحقيق نجاح أكاديمي واثق.",
      quickLinks: "روابط سريعة",
      home: "الرئيسية",
      courses: "الدورات",
      about: "من نحن",
      contact: "تواصل",
      email: "contact@casaclassroom.com",
      phone: "+216 55 544 475",
      copyright: "كل الحقوق محفوظة.",
    },
    sidebar: {
      close: "إغلاق",
      toggle: "تبديل الشريط الجانبي",
      role: {
        admin: "مشرف المنصة",
        superadmin: "مشرف عام",
        support: "الدعم",
        accounting: "المحاسبة",
        teacher: "معلم",
        parent: "ولي أمر",
        student: "تلميذ",
        user: "مستخدم",
      },
      searchPlaceholder: "ابحث عن حصة أو مورد",
      links: {
        dashboard: "لوحة التحكم",
        programs: "البرامج",
        lessons: "الحصص",
        timetable: "الجدول الزمني",
        resources: "الموارد",
        tests: "الاختبارات",
        homeworks: "الواجبات",
        offers: "العروض",
        contact: "الدعم",
        profile: "حسابي",
        admin: "لوحة المشرف",
        students: "الطلاب",
        newLesson: "حصة جديدة",
        myStudents: "طلابي",
        myChildren: "أبنائي",
        myLessons: "حصصي",
      },
      sections: {
        main: "القائمة الرئيسية",
        management: "الإدارة الأكاديمية",
        other: "أخرى",
      },
      logout: "تسجيل الخروج",
    },
    studentShell: {
      shortcutsLabel: "اختصارات التلميذ",
      mainNavLabel: "التنقل الرئيسي للتلميذ",
    },
    landingPage: {
      subjectsGrid: {
        title: "المواد",
        description:
          "اكتشف برامجنا المصممة لدعم طفلك في كل مادة، مع مرافقة بيداغوجية متخصصة تعزز التفوق والثقة بالنفس.",
        cta: "اكتشف عروضنا",
        ariaLabel: "البرامج",
        managePrograms: "إدارة البرامج",
        items: [],
      },
      hero: {
        title: "معكم في كل خطوة",
        lead: "Casaclass منصة تعليمية تونسية تصل إلى منزلك أينما كنت. ندعم أبناءك في المواد الأساسية واللغات\nنضع بين أيديكم نخبة من الخبراء في البيداغوجيا، علم النفس، وعلم الأعصاب لمرافقة مشخصة تدعم المواد الأساسية وتُعالج صعوبات التعلم. نهجنا يجمع بين تنمية الذكاء، صقل الهوية، وضمان التفوق الدراسي لكل طفل مهما كان ملفه الإدراكي.",
        primaryCta: "ابدأ الآن",
        secondaryCta: "اكتشف عروضنا",
        videoTitle: "فيديو تعريفي بمنصة Casaclass",
        statsLabel: "أثر Casaclass بالأرقام",
        stats: [
          { value: "5,000+", label: "عائلات رافقناها" },
          { value: "230+", label: "حصص تفاعلية" },
          { value: "45", label: "معلّم تونسي" },
          { value: "4.9/5", label: "رضا الأولياء" },
        ],
      },
      features: {
        tag: "مدرسة لكل طفل",
        title: "لماذا Casaclass؟",
        description:
          "نحافظ على اللغة والثقافة والقيم أينما تعيش العائلة، بدمج البيداغوجيا التونسية مع أدوات حديثة تجعل التعلم محفزًا.",
        cta: "اكتشف برامجنا",
        cards: [
          {
            title: "مسار شخصي",
            description: "اختبار تمهيدي، مسار مخصص، ومرافقة للأهل",
            alt: "طالب يستكشف مسارًا تعليميًا مخصصًا",
          },
          {
            title: "مباشر وعند الطلب",
            description: "حصص مباشرة مع مكتبة فيديو للمراجعة",
            alt: "حصة تعليمية مباشرة على Casaclass",
          },
          {
            title: "إحاطة نيروبيداغوجية",
            description: "تشخيص، مرافقات، ومسارات تعليمية مخصصة للتميز",
            alt: "نشاط تعلمي ممتع ومحفز",
          },
        ],
      },
      journey: {
        ariaLabel: "قصة Casaclass مع العائلات",
        title: "الحكاية",
        imageAlt: "عائلة تثق في مسار Casaclass",
        paragraphs: [
          "كلُّ دماغٍ فريد.",
          "لتحويل التحديات إلى نجاح عبر إحاطة نيروبيداغوجية مُفصّلة، نضع بين يدي طفلك نخبةً من الخبراء في علم النفس، والطب النفسي العصبي، والبيداغوجيا.",
        ],
        cta: "ابدأ اختبار المستوى",
      },
      levels: {
        tag: "لننطلق",
        title: "اختر المستوى الذي تريد اكتشافه",
        description:
          "كل مستوى يجمع فيديوهات قابلة للبث وكتيبات مطبوعة وتتبعًا للأهداف. اختر المستوى وابدأ رحلة تكبر مع طفلك.",
        note: "إذا كان الحلم ممكنًا فالخطة أقرب.",
        ariaPrefix: "استكشف مستوى",
        items: [
          {
            grade: "1",
            label: "السنة 1",
            accent: 1,
            ariaLabel: "استكشف السنة 1",
          },
          {
            grade: "2",
            label: "السنة 2",
            accent: 2,
            ariaLabel: "استكشف السنة 2",
          },
          {
            grade: "3",
            label: "السنة 3",
            accent: 3,
            ariaLabel: "استكشف السنة 3",
          },
          {
            grade: "4",
            label: "السنة 4",
            accent: 4,
            ariaLabel: "استكشف السنة 4",
          },
          {
            grade: "5",
            label: "السنة 5",
            accent: 5,
            ariaLabel: "استكشف السنة 5",
          },
          {
            grade: "6",
            label: "السنة 6",
            accent: 6,
            ariaLabel: "استكشف السنة 6",
          },
          {
            grade: "7",
            label: "السنة 7",
            accent: 7,
            ariaLabel: "استكشف السنة 7",
          },
          {
            grade: "8",
            label: "السنة 8",
            accent: 8,
            ariaLabel: "استكشف السنة 8",
          },
          {
            grade: "9",
            label: "السنة 9",
            accent: 9,
            ariaLabel: "استكشف السنة 9",
          },
        ],
      },
      programs: {
        badge: "برامج Casaclass",
        title: "أركان Casaclass الأربعة",
        imageAlt: "رسم يوضح أركان برامج Casaclass",
        items: [
          {
            title: "1. الدروس الأساسية — من السنة 1 إلى 9",
            list: [
              "مراجعة + تمارين + فيديوهات شرح",
              "مرافقة فردية مع معلمين تونسيين",
              "متابعة شهرية للأولياء",
              "مسار تعلّم خطوة بخطوة",
            ],
            slogan: "تعلم واضح، تقدم مضمون.",
            cta: "انضم لبرنامج التدريس",
            ctaLink: "/signup",
          },
          {
            title: "2. اللغة الفرنسية",
            list: [
              "برنامج معتمد من وزارة التربية التونسية",
              "ورش نطق وتعبير شفوي",
              "قواعد وكتابة مع أمثلة مباشرة",
              "متابعة فردية وتقييمات دورية",
            ],
            slogan: "لغة ثانية تفتح الأبواب.",
            cta: "استكشف دورات الفرنسية",
            ctaLink: "/courses",
          },
          {
            title: "3. العربية • القرآن • الحديث",
            list: [
              "تحفيظ مبسط",
              "أساسيات التجويد",
              "سيرة وقيم",
              "عربية تناسب الأجيال الجديدة",
            ],
            cta: "استكشف دورات العربية والقرآن",
            ctaLink: "/courses",
          },
          {
            title: "4. نادي برمجة الأطفال",
            list: [
              "Scratch، بايثون للصغار، روبوتيك",
              "ألعاب تعليمية",
              "مشاريع شهرية صغيرة",
              "أطفال اليوم مبرمجو الغد",
            ],
            slogan: "تعلّم المستقبل يبدأ الآن.",
            cta: "انضم لنادي البرمجة",
            ctaLink: "/signup",
          },
        ],
      },
      specialNeeds: {
        ariaLabel: "دعم للاحتياجات الخاصة",
        title: "طفلك له احتياجات خاصة",
        description:
          "له مكانه هنا—مع مختصين يساعدونه على الاندماج والتقدم بالوتيرة التي تناسبه وبما يحترم احتياجاته.",
        imageAlt: "أعمدة برامج Casaclass الثلاثة",
        cta: "اتصل بنا",
      },
      ecosystem: {
        title: "كون Casaclass واضح",
        cta: "انضم لعالم Casaclass",
        cards: [
          {
            icon: "👨‍👩‍👦",
            title: "مساحة الولي",
            items: ["تتبع التقدم", "تقرير أسبوعي", "اختيار المعلّم/المجموعة"],
            alt: "لوحة ولي الأمر داخل Casaclass",
          },
          {
            icon: "👦",
            title: "مساحة التلميذ",
            items: ["واجبات", "دروس قصيرة", "شارات ومكافآت"],
            alt: "لوحة التلميذ داخل Casaclass",
          },
          {
            icon: "👩‍🏫",
            title: "مساحة المعلّم",
            items: ["لوحة تحكم", "تخطيط", "تقييمات"],
            alt: "لوحة المعلم داخل Casaclass",
          },
        ],
      },
      ramadan: {
        ariaLabel: "باقات رمضان للأطفال",
        badge: "باقات رمضان للصغار",
        title: "باقات رمضان",
        lead: "30 فيديو ممتلئ بالقيم والقرآن والقصص وبناء الشخصية للأطفال 5–12 حتى يمتلئ رمضان بالنور والهوية والبهجة.",
        items: [
          "برنامج يومي مستوحى من رمضان",
          "قصص مصورة وتمارين قيم لكل يوم",
          "جلسات قرآن مبسطة مع تجويد واضح",
          "أنشطة عائلية تقوّي الروابط",
        ],
        slogan: "نور وعلم وهداية.",
        cta: "قريبا",
        imageAlt: "معلّم Casaclass يوجّه الأطفال في برنامج رمضان",
      },
      testimonials: {
        ariaLabel: "شهادات مجتمع Casaclass",
        tag: "قصص من مجتمعنا",
        title: "العائلات والمعلمون يثقون بنا",
        lead: "من أولياء بالخارج إلى معلمين في تونس، تجمع المنصة أطفالًا ملهمين وتدعمهم خطوة بخطوة.",
        prev: "الشهادة السابقة",
        next: "الشهادة التالية",
        dotsLabel: "تنقل بين الشهادات",
        dotLabel: "اعرض شهادة {{name}}",
        imageAlt: "ولي الأمر: {{name}}",
        items: [
          {
            quote:
              "منذ بدأنا مع Casaclass صارت المراجعة جزءًا سعيدًا من روتين العائلة. ابنتي تحب وضوح المسار والمكافآت الرقمية، وأنا أتابع تقدمها بهدوء من لوحة الولي.",
            name: "آمال بن سالم",
            place: "ليون، فرنسا",
          },
          {
            quote:
              "نعيش في دبي وكانت فروقات التوقيت تعطل الدروس التونسية. مع Casaclass نحضر الحصص المباشرة أو الإعادات وقت ما يناسب العائلة، والأطفال يتواصلون مع المعلمين وكأنهم في تونس.",
            name: "رامي وسيرين",
            place: "دبي، الإمارات",
          },
          {
            quote:
              "ابني يواجه صعوبة في التركيز؛ قدّم لنا مدرب التعلم خطة واضحة. نتلقى تقارير أسبوعية ونصائح، وأصبح متحمسًا ويتحدث عن حصص العربية والقرآن بنفسه.",
            name: "ليلى مرزوقي",
            place: "تورونتو، كندا",
          },
        ],
      },
      faq: {
        ariaLabel: "الأسئلة المتكررة في Casaclass",
        tag: "الأسئلة",
        title: "أسئلتكم",
        lead: "نبقى قريبين من اليوم الأول حتى نحتفل بإنجازات أبنائكم.",
        items: [
          {
            question: "إلى متى يبقى الوصول للموارد؟",
            answer:
              "يمنح الاشتراك الوصول لكل الوحدات لمدة 12 شهرًا مع تحديثات مجانية كل فصل.",
            superadmin: "Super admin",
            support: "Support",
            accounting: "Accounting",
          },
          {
            question: "هل تناسب الحصص العائلات في الخارج؟",
            answer:
              "نعم. المحتوى ثنائي اللغة (عربية/فرنسية) ويتبع البرنامج التونسي بمرونة لمناطق الوقت.",
          },
          {
            question: "هل يمكن حضور الحصص متى نشاء؟",
            answer:
              "يمكنكم متابعة البث المباشر أو مشاهدة الإعادات وقتما يناسب العائلة، مع تحميل الكتيبات والواجبات.",
          },
        ],
      },
      finalCta: {
        ariaLabel: "دعوة أخيرة للانضمام",
        label: "ابدأ اليوم",
        title: "انضم إلى مجتمع Casaclass",
        description:
          "تحدث مع فريقنا، اختر البرنامج المناسب، وأعط أبناءك دفعة تعلم حقيقية.",
        primary: "ابدأ التسجيل",
        secondary: "تواصل مع الفريق",
      },
    },
    aboutPage: {
      hero: {
        label: "Casaclass",
        title: "حكايتنا",
        story: [
          "منذ البداية هدفنا أن نتيح لكل طفل تونسي، داخل أو خارج الوطن، تعلّمًا دافئًا وحديثًا يحفظ هويته.",
          "التعليم أكثر من معرفة؛ هو جسر بين الأجيال ومصدر انتماء.",
        ],
        illustrationAlt: "رسم يوضح مجتمع Casaclass",
        highlights: [
          {
            icon: "🌍",
            title: "جالية متصلة",
            description: "مدرسة تونسية ترافق عائلتك أينما كانت.",
          },
          {
            icon: "🎓",
            title: "خبراء شغوفون",
            description: "معلّمون تونسيون معتمدون يصممون كل مسار.",
          },
          {
            icon: "🤝",
            title: "متابعة داعمة",
            description: "اختبار تمهيدي، تدريب فردي، وشهادات تقدم.",
          },
        ],
      },
      mission: {
        label: "رسالتنا",
        title: "ما الذي ندافع عنه",
        description: "نمزج التميز الأكاديمي بالجذور الثقافية لكل عائلة تونسية.",
        items: [
          {
            title: "وصول بجودة",
            description: "دروس مخصصة يقدمها معلمون تونسيون مؤهلون.",
          },
          {
            title: "جذور وهوية",
            description: "عربية وقرآن وحديث للحفاظ على الارتباط.",
          },
          {
            title: "ملاءمة عالمية",
            description: "برامج تراعي المناهج التونسية والدولية.",
          },
          {
            title: "مرنة ومحفزة",
            description: "باقات رمضان، الصيف، والمراجعة بجلسات مشوقة.",
          },
        ],
      },
      resources: {
        label: "مواردنا",
        title: "ماذا نقدّم",
        description: "أدوات عملية وباقات جاهزة وفريق حاضر دائمًا للمساندة.",
        items: [
          {
            title: "فريق مختص",
            description: "معلمون خبراء في المسارات الأكاديمية والروحية.",
          },
          {
            title: "باقات جاهزة",
            description: "باقات رمضان، وحدات مدرسية، ودعم مستمر.",
          },
          {
            title: "توجيه كامل",
            description: "اختبار تمهيدي، متابعة فردية، تقييمات وشهادات.",
          },
          {
            title: "منصة متاحة",
            description: "وصول عبر الإنترنت من أوروبا والخليج وتونس.",
          },
        ],
      },
      values: {
        label: "قيمنا",
        title: "مبادئ نتمسك بها",
        description: "قيمنا تقود كل قرار تربوي وإنساني.",
        items: [
          {
            title: "رعاية",
            description: "المتعلم في المركز مع متابعة إنسانية دافئة.",
          },
          { title: "إتقان", description: "كل درس مصاغ ومراجَع بعناية." },
          {
            title: "أصالة",
            description: "نحترم الجذور التونسية والبُعد الروحي.",
          },
          {
            title: "ابتكار",
            description: "أدوات حديثة، فيديوهات تفاعلية، وتقييمات ممتعة.",
          },
          { title: "إنصاف", description: "تعليم متاح أينما تعيش العائلات." },
        ],
      },
      vision: {
        label: "رؤيتنا",
        title: "إلى أين نتجه",
        description: "ندفع Casaclass نحو نموذج مستدام ينمو مع العائلات.",
        intro: "نطمح أن نكون المرجع التونسي للتعلم الرقمي للأطفال عبر بناء:",
        points: [
          "مجتمع من التلاميذ والأولياء والمعلمين يتقاسم الثقافة والطموح.",
          "برامج متجددة مع باقات موضوعية وابتكار تربوي.",
          "منصة قابلة للتوسع تصل إلى العائلات التونسية في كل مكان.",
        ],
      },
      uniques: {
        label: "ما يميزنا",
        title: "لماذا تتميز Casaclass",
        description: "تجربة شاملة تجمع الصرامة والبعد الروحي والابتكار الرقمي.",
        items: [
          {
            title: "نهج هجين",
            description: "أكاديمي وروحي مع مهارات التفكير الرقمي.",
          },
          {
            title: "تخصيص كامل",
            description: "اختبار تمهيدي ومسار مصمم لكل طفل.",
          },
          {
            title: "مرونة جغرافية",
            description: "مثالي للعائلات في أوروبا والخليج وتونس.",
          },
          {
            title: "التزام تربوي",
            description: "معلمون شغوفون وأدوات حديثة ومتابعة حقيقية.",
          },
        ],
      },
      showcase: {
        label: "بالصور",
        title: "رؤيتنا في لقطات",
        description:
          "ثلاث لمحات عن Casaclass: طاقة المجتمع، مسار موجه، ومنصة في كل مكان.",
        cards: [
          {
            title: "مجتمع متفاعل",
            description: "عائلات ومتعلّمون وموجهون يتقدمون معًا.",
            alt: "مجتمع Casaclass",
          },
          {
            title: "رحلة غامرة",
            description: "خريطة طريق واضحة، أنشطة ممتعة، تغذية راجعة مستمرة.",
            alt: "مسار التعلم في Casaclass",
          },
          {
            title: "وصول دائم",
            description: "واجهة بسيطة حديثة في كل رحلة وعلى كل جهاز.",
            alt: "منصة Casaclass",
          },
        ],
      },
      cta: {
        title: "جاهز للانضمام إلى مجتمع Casaclass؟",
        description:
          "تحدث مع فريقنا، اختر البرنامج المناسب، وأعط تعلم أبنائك دفعة قوية.",
        primary: "تحدث مع الفريق",
        secondary: "أنشئ حسابًا",
      },
    },
    contactPage: {
      status: {
        loading: "جارٍ إرسال رسالتك...",
        success: "تم إرسال الرسالة! سنعود إليك قريبًا.",
        error: "تعذر إرسال الرسالة. حاول مرة أخرى.",
      },
      hero: {
        label: "تواصل معنا",
        title: "لنخطط معًا رحلة تعلم ملهمة",
        lead: "شارك احتياجاتك لنصمم مسارًا يناسب عائلتك. فريقنا جاهز للمساعدة في كل خطوة.",
      },
      form: {
        cardTitle: "تواصل معنا مباشرة",
        cardSubtitle: "املأ النموذج وسنرد خلال يوم عمل واحد.",
        fullNameLabel: "الاسم الكامل",
        fullNamePlaceholder: "اكتب اسمك",
        emailLabel: "البريد الإلكتروني",
        emailPlaceholder: "example@mail.com",
        phoneLabel: "رقم الهاتف",
        phonePlaceholder: "اكتب رقم هاتفك",
        subjectLabel: "الموضوع",
        subjectPlaceholder: "أضف موضوعًا مختصرًا",
        messageLabel: "كيف يمكننا المساعدة؟",
        messagePlaceholder: "صف احتياجاتك لنقترح أفضل خطة",
        submit: "أرسل الرسالة",
        submitting: "جارٍ الإرسال...",
        phoneAppend: "رقم الهاتف: {{phone}}",
      },
      calendly: {
        title: "احجز استشارة",
        subtitle: "اختر وقتًا يناسبك للتحدث مع فريقنا.",
      },
    },
    offers: {
      heroTag: "عروض Casaclass",
      heroTitle: "اختر الصيغة التي تناسب عائلتك",
      heroDescription:
        "دروس مباشرة، لغات، وبرامج مستقبلية مع متابعة حقيقية ودعم للأهل.",
      packLabel: "باقات متاحة",
      packPlaceholder: "اختر باقة",
      sections: {
        classTypes: {
          tag: "أنواع الحصص",
          heading: "اختر صيغة الحضور",
          description:
            "من حصص فردية إلى مجموعات صغيرة بصيغ مرنة في الوقت والتكلفة.",
        },
        languages: {
          tag: "اللغات",
          heading: "برامج اللغات",
          description: "دعم العربية والفرنسية والإنجليزية بأساليب حديثة.",
        },
        upcoming: {
          tag: "قريبًا",
          heading: "برامج قادمة",
          description: "دورات جديدة للمهارات الرقمية والقيادة.",
        },
      },
      classTypes: {
        full: {
          category: "حصة فردية",
          title: "حصص فردية كاملة",
          subtitle: "تركيز كامل مع معلم متخصص",
          description: "خطة شخصية ومسار واضح مع مرونة تامة في الوقت.",
          price: "سعر مخصص حسب الحاجة",
          billing: "مدة الحصة 60 دقيقة",
          features: [
            "تقييم أولي وتخطيط أهداف",
            "موارد رقمية وتمارين متابعة",
            "تقارير تقدم دورية للأهل",
          ],
          cta: "احجز حصة فردية",
        },
        duo: {
          category: "حصة ثنائية",
          title: "حصص ثنائية",
          subtitle: "طالبان مع معلم واحد",
          description: "توازن بين التفاعل والتكلفة مع زميل متقارب المستوى.",
          price: "سعر اقتصادي",
          billing: "60 دقيقة للحصة",
          features: [
            "تفاعل ثنائي محفز",
            "تقسيم وقت موجه لكل طالب",
            "خطط واجبات مشتركة",
          ],
          cta: "جرّب الحصة الثنائية",
          badge: "شائع",
        },
        vip: {
          category: "VIP",
          title: "VIP فردي",
          subtitle: "أولوية في الجدولة والمتابعة",
          description: "متابعة لصيقة وجلسات إضافية قصيرة بين الحصص.",
          price: "خطة مميزة",
          billing: "حصص رئيسية + مكالمات متابعة",
          features: [
            "مكالمات قصيرة بين الحصص",
            "مراجعة واجبات فورية",
            "تنبيهات وتذكير شخصية",
          ],
          cta: "اطلب خطة VIP",
        },
        normal: {
          category: "مجموعة صغيرة",
          title: "حصص جماعية",
          subtitle: "حتى 8 تلاميذ",
          description: "خيار اقتصادي يحافظ على التفاعل داخل مجموعة تعاونية.",
          price: "خيار اقتصادي",
          billing: "60 دقيقة للحصة",
          features: ["أنشطة جماعية وتحفيز", "مراجعة مشتركة", "تقييمات خفيفة"],
          cta: "انضم للمجموعة",
        },
      },
      languagePrograms: {
        french: {
          category: "فرنسي",
          title: "برنامج اللغة الفرنسية",
          subtitle: "منهج معتمد مع دعم النطق",
          description: "دروس تفاعلية للقراءة والكتابة والمحادثة.",
          price: "خطط شهرية",
          billing: "حصص مباشرة + موارد PDF",
          features: ["تمارين صوتية", "مشاريع كتابة قصيرة", "اختبارات دورية"],
          cta: "استكشف الفرنسية",
        },
        english: {
          category: "إنجليزي",
          title: "برنامج اللغة الإنجليزية",
          subtitle: "ثقة في التحدث والاستماع",
          description: "ورش تواصل عملي وقواعد مبسطة.",
          price: "خطط مرنة",
          billing: "حصص أسبوعية مباشرة",
          features: ["تمارين محادثة", "مفردات موضوعية", "مشاريع عرض قصيرة"],
          cta: "استكشف الإنجليزية",
          badge: "جديد",
        },
        arabic: {
          category: "عربية",
          title: "برنامج العربية والقرآن",
          subtitle: "هوية ولغة وقيم",
          description: "قراءة سليمة، تجويد مبسط، وأنشطة قيم.",
          price: "باقات متنوعة",
          billing: "حصص مباشرة + كتيبات",
          features: ["تجويد مبسط", "قصص وقيم", "أنشطة كتابة وقراءة"],
          cta: "استكشف العربية",
        },
      },
      upcoming: {
        coding: {
          category: "برمجة",
          title: "نادي البرمجة للصغار",
          subtitle: "Scratch وروبوتيك ومشاريع ممتعة",
          description: "مهارات رقمية مبكرة مع مشاريع شهرية.",
          price: "قريبًا",
          billing: "جلسات تفاعلية + مهام منزلية",
          features: ["مشاريع مرئية", "ألعاب تعليمية", "تحديات شهرية"],
          cta: "سجّل اهتمامك",
        },
        ai: {
          category: "ذكاء اصطناعي",
          title: "مهارات المستقبل بالذكاء الاصطناعي",
          subtitle: "مفاهيم بسيطة للأطفال",
          description: "تعرّف على الذكاء الاصطناعي بأمثلة عملية.",
          price: "قريبًا",
          billing: "ورش قصيرة",
          features: ["تجارب تفاعلية", "مشاريع مصغرة", "مفاهيم أخلاقية مبسطة"],
          cta: "انضم لقائمة الانتظار",
        },
        leaders: {
          category: "قيادة",
          title: "قادة المستقبل",
          subtitle: "مهارات تواصل وتنظيم",
          description: "أنشطة قيادية وعمل جماعي للأطفال.",
          price: "قريبًا",
          billing: "جلسات أسبوعية",
          features: ["تقديم عروض", "إدارة الوقت", "عمل جماعي"],
          cta: "سجّل اهتمامك",
        },
      },
      addons: {
        tag: "خدمات إضافية",
        heading: "ادعم تجربة طفلك",
        description: "خيارات مكمّلة للمتابعة والتقييم الفردي.",
        coaching: {
          title: "جلسة تدريب أكاديمي",
          price: "سعر للجلسة",
          description: "متابعة فردية لضبط الخطط وتحفيز التلميذ.",
          points: ["خطة عمل أسبوعية", "نصائح تركيز", "متابعة مع الأهل"],
          cta: "احجز التدريب",
        },
        assessment: {
          title: "تقييم مستوى",
          price: "سعر لمرة واحدة",
          description: "اختبار تشخيصي شامل مع توصيات واضحة.",
          points: [
            "اختبار قراءة ورياضيات",
            "تقرير مكتوب",
            "مقابلة شرح النتائج",
          ],
          cta: "اطلب التقييم",
        },
        oneToOne: {
          title: "حصة فردية إضافية",
          price: "حسب الحجز",
          description: "جلسة خصوصية لمعالجة نقاط محددة.",
          points: ["تركيز على مهارة محددة", "تصحيح فوري", "مرونة في الموعد"],
          cta: "احجز الآن",
        },
      },
      support: {
        heading: "نحن معك في كل خطوة",
        description: "تواصل معنا للاختيار أو لبدء التسجيل الآن.",
        ctaCall: "اتصل بالفريق",
        ctaSignup: "ابدأ التسجيل",
      },
    },
    dashboard: {
      role: {
        admin: "مشرف المنصة",
        superadmin: "مشرف عام",
        support: "دعم",
        accounting: "محاسبة",
        teacher: "معلم Casaclass",
        parent: "ولي أمر",
        member: "عضو Casaclass",
      },
      searchPlaceholder: "ابحث...",
      loading: "جاري تحميل البيانات...",
      hero: {
        greeting: "مرحبًا {{name}}, 👋",
        intro:
          "نظرة سريعة على الحصص القادمة، التلاميذ المسجلين، وأبرز باقات Casaclass.",
        manageLessons: "إدارة الحصص",
        browseOffers: "تصفح العروض",
        nextLesson: "أقرب حصة",
        student: "التلميذ",
        teacher: "المعلم",
        time: "الوقت",
        duration: "المدة",
      },
      stats: {
        total: { label: "عدد الحصص", hint: "كل الحصص المسجلة" },
        upcoming: { label: "الحصص القادمة", hint: "في الفترة القادمة" },
        completed: { label: "مكتملة", hint: "تم إنهاؤها" },
        cancelled: { label: "ملغاة", hint: "تم إلغاؤها" },
      },
      upcoming: {
        title: "الحصص القادمة",
        subtitle: "أربع حصص تالية للبقاء على اطلاع.",
        viewAll: "عرض الكل",
        loading: "جاري تحميل الحصص...",
        empty: "لا توجد حصص قادمة. يمكنك جدولة حصة جديدة من صفحة الحصص.",
      },
      students: {
        title: "التلاميذ المسجلون",
        subtitle: "التلاميذ المرتبطون بحسابك.",
        id: "المعرف",
        dob: "تاريخ الميلاد",
        empty: "لا توجد بيانات تلاميذ.",
      },
      featured: {
        title: "باقات مقترحة",
        subtitle: "اقتراحات من كتالوج Casaclass.",
        explore: "استكشف كل الباقات",
        lessonsCount: "عدد الحصص",
        sessionLength: "مدة الجلسة",
        price: "السعر",
        learnMore: "اعرف المزيد",
      },
      errors: {
        loadData: "تعذر تحميل بعض البيانات: {{error}}",
      },
      teacher: {
        roleLabel: "لوحة المعلم",
        greeting: "مرحبًا {{name}}",
        intro: "إدارة سريعة للحصص، التلاميذ والتواصل مع الأولياء.",
        performance: {
          title: "الأداء",
          completed: "مكتملة",
          cancelled: "ملغاة",
        },
        programs: {
          title: "برامجي",
          loading: "جاري تحميل البرامج...",
          edit: "تعديل",
          empty: "لا توجد برامج بعد.",
        },
        weeklyActivity: {
          title: "النشاط الأسبوعي",
          hint: "آخر 7 أيام",
        },
        topStudents: {
          title: "أكثر التلاميذ نشاطًا",
          lessons: "{{count}} حصص",
          empty: "لا توجد بيانات كافية بعد.",
        },
        updates: {
          title: "آخر التحديثات",
          empty: "لا توجد تحديثات بعد.",
        },
        actions: {
          schedule: "جدول الحصص",
          newLesson: "إنشاء حصة",
        },
        stats: {
          activeStudents: { label: "تلاميذ نشطون" },
          hoursGiven: { label: "ساعات تدريس" },
          completed: { label: "جلسات مكتملة" },
          cancelled: { label: "جلسات ملغاة" },
        },
        schedule: {
          title: "جدول الحصص المباشرة",
          subtitle: "أقرب الحصص وحالتها.",
          view: "عرض الجدول",
          loading: "جاري تحميل الجدول...",
          empty: "لا توجد حصص قادمة.",
        },
        manage: {
          title: "إدارة الحصص",
          subtitle: "إنشاء الحصص والموارد والحضور.",
          createEdit: {
            title: "إنشاء / تعديل",
            description: "خطط وعدل أو انسخ الحصص بسهولة.",
          },
          upload: {
            title: "رفع الموارد",
            description: "أضف ملفات PDF أو فيديو أو اختبارات.",
          },
          attendance: {
            title: "تسجيل الحضور",
            description: "تسجيل حضور كل حصة.",
          },
        },
        assessments: {
          title: "التقييمات والتغذية الراجعة",
          subtitle: "درجات، تعليقات، وسجل الواجبات/الاختبارات.",
          grades: {
            title: "درجات وملاحظات",
            description: "أضف درجة وملاحظة لكل تلميذ.",
          },
          homework: {
            title: "سجل الواجبات / الاختبارات",
            description: "راجع الواجبات المصححة وتابعها.",
          },
        },
        communication: {
          title: "التواصل",
          subtitle: "رسائل داخلية وإشعارات.",
          messaging: {
            title: "رسائل داخلية",
            description: "دردشة آمنة مع التلاميذ والأولياء.",
          },
          notifications: {
            title: "إشعارات النظام",
            description: "طلاب جدد أو تغييرات المواعيد.",
          },
        },
        payments: {
          title: "المدفوعات",
          subtitle: "تحويلات Casaclass والفواتير الشهرية.",
          history: {
            title: "سجل التحويلات",
            description: "تظهر تحويلاتك هنا.",
          },
          invoicing: {
            title: "فواتير تلقائية",
            description: "ملخص شهري يُنشأ تلقائيًا.",
          },
        },
      },
      parent: {
        roleLabel: "لوحة الولي",
        greeting: "مرحبًا {{name}}",
        intro: "تابع أبناءك، الحصص، التنبيهات والفوترة.",
        classes: {
          title: "الأقسام",
          subtitle: "الأقسام الحالية لكل طفل",
        },
        widgets: {
          studentModeLabel: "وضع التلميذ",
          studentModePlaceholder: "الدخول كوضع التلميذ",
          notifications: "الإشعارات",
          weekSubtitle: "نظرة سريعة على حصص هذا الأسبوع.",
          noLessons: "لا توجد حصص.",
          reminders: "تذكيرات",
          reminderCheckbox: "وضع علامة كمكتمل",
          recommended: "مقترحات",
          monthStats: "إحصائيات هذا الشهر",
          monthStatsHint: "ملخص سريع",
          children: "الأبناء",
          homework: "المتابعة",
          homeworkHint: "أقرب الحصص القادمة.",
        },
        notifications: {
          empty: "لا توجد إشعارات.",
          markRead: "وضع علامة كمقروء",
          status: {
            cancelled: "ملغاة",
            postponed: "مؤجلة",
            updated: "تم التحديث",
          },
        },
        actions: {
          weekly: "الجدول الأسبوعي",
          support: "افتح تذكرة دعم",
        },
        activeStudent: {
          status: "وضع التلميذ مفعل",
          none: "لا يوجد تلميذ محدد",
          label: "وضع {{name}}",
          subtitle: "وصول مباشر لمساحة التلميذ المختار.",
          deactivate: "إيقاف الوضع",
          prompt: "اختر تلميذًا لتفعيل مساحته.",
        },
        children: {
          title: "الأبناء المرتبطون",
          subtitle: "التقدم العام وأقرب الحصص.",
          addChild: "إضافة طفل",
          progress: "التقدم",
          nextLesson: "أقرب حصة",
          activate: "تفعيل وضع التلميذ",
          active: "وضع التلميذ مفعل",
          viewLessons: "عرض الحصص",
          loading: "جاري تحميل الأبناء...",
          empty: "لا يوجد أبناء مرتبطون.",
        },
        followup: {
          title: "متابعة الحصص",
          subtitle: "الجدول الأسبوعي والسجلات (إعادات/موارد).",
          loading: "جاري تحميل الحصص...",
          empty: "لا توجد حصص مجدولة هذا الأسبوع.",
        },
        communication: {
          title: "التواصل",
          subtitle: "دردشة آمنة مع المعلمين والدعم.",
          teacherChat: {
            title: "دردشة المعلم",
            description: "خيط خاص لكل حصة.",
          },
          supportTicket: {
            title: "تذكرة دعم",
            description: "أرسل طلباتك لفريق Casaclass.",
          },
        },
        billing: {
          title: "المدفوعات والفوترة",
          subtitle: "الاشتراكات، فواتير PDF، وإدارة الباقات.",
          activeSubs: {
            title: "اشتراكات نشطة",
            description: "تظهر عروضك الحالية هنا.",
          },
          invoices: {
            title: "فواتير قابلة للتنزيل",
            description: "حمّل فواتيرك (PDF).",
          },
          renew: {
            title: "تجديد / إلغاء",
            description: "إدارة خيارات الاشتراك.",
          },
        },
        profile: {
          title: "ملف الولي",
          subtitle: "بيانات التواصل وطريقة الدفع المفضلة.",
          contact: {
            title: "بيانات التواصل",
            description: "حدّث معلوماتك الشخصية.",
          },
          payment: {
            title: "طريقة الدفع",
            description: "أضف أو غيّر طريقة الدفع.",
          },
          widgets: {
            studentModeLabel: "تفعيل وضع التلميذ",
            studentModePlaceholder: "الدخول كتلميذ",
            notifications: "الإشعارات",
            weekSubtitle: "نظرة سريعة على حصص هذا الأسبوع.",
            noLessons: "لا توجد حصص.",
            reminders: "تذكيرات",
            reminderCheckbox: "وضع علامة كمكتمل",
            recommended: "مقترحات",
            monthStats: "إحصائيات هذا الشهر",
            monthStatsHint: "ملخص سريع",
            children: "الأبناء",
            homework: "المتابعة",
            homeworkHint: "أقرب الحصص القادمة.",
          },
          manageChildren: {
            title: "إدارة الأبناء",
            description: "أضف أو أزل أبناء مرتبطين.",
          },
        },
        modal: {
          exitTitle: "تأكيد العودة إلى وضع الولي",
          exitBody: "للسلامة، أدخل كلمة مرور الولي قبل العودة.",
          passwordLabel: "كلمة المرور",
          passwordError: "كلمة مرور غير صحيحة. حاول مجددًا.",
          cancel: "إلغاء",
          confirm: "تأكيد",
          verifying: "جاري التحقق...",
          backToParent: "العودة إلى وضع الولي",
          logout: "تسجيل الخروج",
        },
      },
      studentSpace: {
        tag: "مساحة التلميذ",
        title: "لوحة التلميذ — {{name}}",
        subtitle: "الحصص القادمة، التقدم، الرسائل والموارد.",
        errors: {
          profileLoad: "تعذر تحميل ملف التلميذ.",
        },
        banner: {
          badge: "نجمة اليوم",
          greeting: "مرحبًا، {{name}}",
          hint: "سعداء بعودتك! جهّز نفسك وتابع حصتك اليوم.",
          imageAlt: "أطفال يتعلمون",
          stats: {
            courses: "دروس",
            xp: "نقاط",
            completed: "مكتمل",
          },
        },
        today: {
          title: "حصص اليوم",
          hint: "حصص ممتعة في انتظارك اليوم!",
          empty: "لا توجد حصص اليوم. خذ استراحة ممتعة!",
        },
        missions: {
          title: "مهماتك",
          hint: "اختر مهمة ممتعة لتكسب النجوم!",
          mentor: {
            title: "اسأل المُعلم",
            body: "احصل على نصيحة سريعة اليوم.",
          },
          challenge: {
            title: "تحدي جديد",
            body: "ابدأ درسًا جديدًا واجمع النقاط!",
          },
        },
        classes: {
          title: "قسمك",
          hint: "أقسامك وأصدقاؤك",
          allTab: "الكل",
          friends: "{{count}} أصدقاء",
          classLabel: "القسم: {{name}}",
          empty: "لا توجد أقسام مرتبطة.",
        },
        activity: {
          title: "نشاطك",
          hint: "لوحة سريعة لمتابعة تقدمك خلال الأشهر الأخيرة.",
        },
        cards: {
          upcoming: { label: "الحصص القادمة", hint: "جلسات مجدولة" },
          past: { label: "حصص سابقة", hint: "آخر السجلات" },
          badges: { label: "شارات", hint: "تقدم مرئي" },
          stars: { label: "نجوم", hint: "تحفيز" },
        },
        upcoming: {
          title: "الحصص القادمة",
          subtitle: "ادخل مباشرة إلى القاعة (Zoom/BBB).",
          empty: "لا توجد حصص مجدولة.",
          join: "دخول القاعة",
        },
        past: {
          title: "الحصص السابقة",
          subtitle: "إعادات، ملفات، واختبارات.",
          empty: "لا توجد حصص سابقة.",
          viewResources: "عرض الموارد",
        },
        resources: {
          title: "الموارد",
          subtitle: "مكتبة حسب المادة وروابط وفيديوهات.",
        },
        messages: {
          title: "آخر الرسائل",
          subtitle: "تبادل مع المعلمين.",
          open: "فتح الرسائل",
        },
        feedback: {
          title: "التغذية الراجعة",
          subtitle: "اطلع على الدرجات والتعليقات وقيم الحصة.",
        },
      },
    },
    studentsPage: {
      noAccess: {
        title: "إدارة الأبناء",
        lead: "هذه الصفحة مخصصة للأولياء لإدارة أبنائهم على Casaclass.",
        body: "لا يملك حسابك الصلاحيات لإدارة التلاميذ. الرجاء العودة إلى لوحة التحكم.",
      },
      title: "أبنائي",
      lead: "أضف أبناءً جددًا، حدّث بياناتهم، وتابع الحصص القادمة من هنا.",
      leadStudentMode:
        'يمكنك تفعيل "وضع التلميذ" لأي ابن للتبديل إلى مساحته من حساب الولي.',
      form: {
        newTitle: "إضافة تلميذ جديد",
        editTitle: "تحديث بيانات التلميذ",
        firstName: "الاسم",
        lastName: "اللقب",
        dob: "تاريخ الميلاد",
        password: "كلمة المرور",
        notes: "ملاحظات",
      },
      placeholders: {
        firstName: "مثال: ياسمين",
        lastName: "مثال: بن صالح",
        password: "على الأقل 8 أحرف",
        notes: "معلومات إضافية تساعد المعلمين.",
      },
      actions: {
        create: "إضافة تلميذ",
        update: "تحديث التلميذ",
        saving: "جارٍ الحفظ",
        cancel: "إلغاء",
      },
      list: {
        title: "قائمة الأبناء",
        refresh: "تحديث",
        loading: "جارٍ تحميل التلاميذ...",
        empty: "لا يوجد أبناء مسجلون بعد.",
      },
      card: {
        upcoming: "{{count}} حصص قادمة",
        noUpcoming: "لا توجد حصص قادمة",
        dob: "تاريخ الميلاد: {{date}}",
        edit: "تعديل",
        enterAs: "الدخول كتلميذ",
        delete: "حذف",
      },
      confirmDelete: "هل تريد حذف هذا التلميذ؟",
      feedback: {
        created: "تمت إضافة التلميذ بنجاح.",
        createdWithLogin: "تمت إضافة التلميذ. بريد الدخول: {{email}}",
        updated: "تم تحديث بيانات التلميذ بنجاح.",
        deleted: "تم حذف التلميذ بنجاح.",
      },
      detail: {
        title: "تفاصيل {{name}}",
        lead: "راجع ملف التلميذ والحصص القادمة هنا.",
        loadingLessons: "جارٍ تحديث الحصص...",
        activate: "تفعيل وضع التلميذ",
        active: "وضع التلميذ مفعل لهذا الحساب",
        stats: {
          total: "إجمالي الحصص",
          completed: "مكتملة",
          cancelled: "ملغاة",
        },
        info: {
          title: "بيانات التلميذ",
          name: "الاسم:",
          dob: "تاريخ الميلاد:",
          notes: "ملاحظات:",
          noNotes: "لا توجد ملاحظات",
        },
        upcoming: {
          title: "الحصص القادمة",
          time: "الوقت: {{value}}",
          duration: "المدة: {{value}} دقيقة",
          teacher: "المعلم: {{value}}",
          empty: "لا توجد حصص قادمة لهذا التلميذ.",
        },
      },
      errors: {
        firstNameRequired: "الاسم مطلوب",
        passwordRequired: "كلمة المرور مطلوبة",
        passwordMin: "يجب أن تحتوي كلمة المرور على 8 أحرف على الأقل",
      },
    },
    adminPage: {
      accessDenied: "الوصول مخصص للمشرفين.",
      headerTag: "إدارة النظام المتكاملة",
      headerTitle: "لوحة تحكم المشرف",
      dashboard: {
        welcome: "مرحبًا بعودتك!",
        viewAll: "عرض الكل",
        manageTitle: "روابط الإدارة",
        manageColumns: {
          section: "القسم",
          count: "العدد",
          open: "فتح",
        },
        cards: {
          newStudents: "طلاب جدد",
          newStudentsHint: "خلال الفترة الحالية",
          totalStudents: "إجمالي الطلاب",
          totalStudentsHint: "إجمالي الحسابات",
          dailyAttend: "نسبة الحضور",
          dailyAttendHint: "آخر 7 أيام",
          averageAttend: "متوسط الحضور",
          averageAttendHint: "هذا الشهر",
        },
        activityTitle: "نشاط الطلاب",
        thisMonth: "هذا الشهر",
        lastMonths: "الشهر الماضي",
        examsTitle: "الاختبارات",
        examsFallback: "متابعة الاختبارات",
        studentsTitle: "قائمة الطلاب",
        studentsColumns: {
          id: "المعرف",
          student: "الطالب",
          parent: "ولي الأمر",
          attends: "الحضور",
        },
        teachersTitle: "المعلمون",
        teacherVerified: "موثّق",
        teacherPending: "بانتظار التوثيق",
        empty: "لا توجد بيانات بعد.",
      },
      tabs: {
        overview: "نظرة عامة",
        users: "المستخدمون",
        students: "الطلاب",
        lessons: "الدروس والجدولة",
        timetable: "الجدول الزمني",
        classes: "الأقسام",
        packs: "الباقات",
        payments: "المدفوعات",
        support: "الدعم",
      },
      actions: {
        save: "حفظ",
        saving: "جارٍ الحفظ…",
        create: "إنشاء",
        cancel: "إلغاء",
        edit: "تعديل",
        delete: "حذف",
      },
      timetable: {
        calendarTitle: "التقويم",
        addEvent: "إضافة حدث",
        configure: "إعدادات",
        previousDay: "اليوم السابق",
        nextDay: "اليوم التالي",
        scopeTeacher: "المعلم",
        scopeClass: "القسم",
        scopeStudent: "التلميذ",
        allTeachers: "كل المعلمين",
        allClasses: "كل الأقسام",
        allStudents: "كل التلاميذ",
        viewWeek: "أسبوع",
        viewDay: "يوم",
        faculty: "الهيئة التعليمية",
        searchFacultyPlaceholder: "ابحث عن المعلمين...",
        editLessonTitle: "تعديل الحصة",
        newLessonTitle: "حصة جديدة",
        selectPlaceholder: "اختر…",
        lessonTitlePlaceholder: "عنوان الحصة",
        minutesShort: "د",
        permanentWeekly: "أسبوعي دائم",
        fields: {
          teacher: "المعلم",
          class: "القسم",
          students: "التلاميذ",
          assignTo: "إسناد إلى",
          student: "تلميذ",
          title: "العنوان",
          start: "البداية",
          duration: "المدة",
          status: "الحالة",
        },
        assignModes: {
          student: "تلميذ",
          class: "قسم",
        },
      },
      classes: {
        panelTitleEdit: "تعديل القسم",
        panelTitleCreate: "إنشاء قسم",
        classNamePlaceholder: "اسم القسم",
        fields: {
          name: "الاسم",
          students: "التلاميذ",
        },
        errors: {
          nameRequired: "اسم القسم مطلوب",
        },
        confirmDelete: "هل تريد حذف هذا القسم؟",
        table: {
          class: "القسم",
          teacher: "المعلم",
          students: "التلاميذ",
          actions: "الإجراءات",
        },
      },
      loading: "جاري تحميل البيانات...",
      stats: {
        activeStudents: "الطلاب النشطون",
        monthlyRevenue: "الإيراد الشهري",
        satisfaction: "معدل الرضا",
        outOfFive: "من 5",
        supportMessages: "رسائل الدعم",
        teachers: "المعلمون",
        pendingTeachers: "معلمون بانتظار التوثيق",
        unread: "غير مقروءة",
      },
      teachers: {
        title: "المعلمون",
        empty: "لا يوجد معلمون لعرضهم.",
        resume: "تحميل السيرة الذاتية",
        activeYes: "نعم",
        activeNo: "لا",
        filter: {
          label: "تصفية حسب الحالة",
          all: "الكل",
          pending: "قيد التوثيق",
          verified: "موثق",
        },
        status: {
          verified: "موثق",
          pending: "قيد التوثيق",
        },
        fields: {
          email: "البريد",
          phone: "الهاتف",
          active: "نشط",
          joined: "تاريخ التسجيل",
        },
      },
      roles: {
        superadmin: "مشرف عام",
        admin: "مدير",
        support: "دعم فني",
        accounting: "محاسبة",
        teacher: "معلم",
        parent: "ولي أمر",
      },
      users: {
        title: "إدارة المستخدمين",
        filter: "تصفية حسب الدور",
        filterAll: "الكل",
        columns: {
          email: "البريد الإلكتروني",
          name: "الاسم",
          role: "الدور",
          phone: "الهاتف",
          joined: "تاريخ التسجيل",
          verify: "توثيق المعلم",
          active: "نشط",
          actions: "إجراءات",
        },
        verify: "توثيق",
        unverify: "إلغاء التوثيق",
        toggleActiveAria: "تفعيل أو تعطيل المستخدم",
        deleteConfirm: "هل تريد حذف هذا المستخدم؟",
        delete: "حذف",
      },
      students: {
        title: "الطلاب",
        ageYears: "سنة",
        parent: "ولي الأمر",
        dob: "تاريخ الميلاد",
      },
      lessons: {
        title: "الدروس والجدولة",
        idLabel: "المعرف",
        student: "الطالب",
        teacher: "المعلم",
        duration: "المدة",
        minutes: "دقيقة",
        status: {
          scheduled: "مجدول",
          completed: "مكتمل",
          cancelled: "ملغي",
        },
      },
      packs: {
        formEdit: "تعديل باقة",
        formNew: "باقة جديدة",
        fields: {
          name: "اسم الباقة",
          description: "الوصف",
          subject: "المادة",
          subjectPlaceholder: "اختر...",
          price: "السعر",
          currency: "العملة",
          lessons: "عدد الجلسات",
          sessionLength: "مدة الجلسة (دقيقة)",
          resources: "المصادر (روابط مفصولة بسطر جديد)",
          image: "الصورة (اختياري)",
          recommended: "مُوصى به لـ",
          gradientColors: "ألوان التدرج",
          gradientStart: "لون بداية التدرج",
          gradientEnd: "لون نهاية التدرج",
          featured: "عرض في الواجهة",
          offersSection: "قسم صفحة العروض",
          offersSectionNone: "بدون",
          offersKind: "نوع البطاقة",
          offersDisplayOrder: "ترتيب الظهور",
          offersAccent: "لون التمييز",
          offersCategoryKey: "مفتاح التصنيف",
          offersTitleKey: "مفتاح العنوان",
          offersSubtitleKey: "مفتاح العنوان الفرعي",
          offersDescriptionKey: "مفتاح الوصف (في صفحة العروض)",
          offersPriceKey: "مفتاح السعر",
          offersBillingKey: "مفتاح الفوترة",
          offersFeaturesKey: "مفتاح المزايا",
          offersCtaKey: "مفتاح زر الدعوة",
          offersCtaLink: "رابط زر الدعوة",
          offersBadgeKey: "مفتاح الشارة",
          offersNoteKey: "مفتاح الملاحظة",
          offersPointsKey: "مفتاح النقاط",
        },
        placeholderResources: "https://.../video.mp4\nhttps://.../document.pdf",
        placeholders: {
          name: "مثال: باقة اللغة العربية",
          description: "مثال: حصص أسبوعية مع مدرس مختص",
          price: "مثال: 120",
          lessons: "مثال: 6",
          sessionLength: "مثال: 60",
          image: "مثال: https://example.com/image.png",
          recommended: "مثال: طلاب الإعدادي",
          offersKey: "مثال: offers.languages.arabic.title",
          offersLink: "مثال: /contact",
        },
        actions: {
          saving: "جاري الحفظ...",
          save: "حفظ",
          reset: "إعادة تعيين",
        },
        listTitle: "الباقات الحالية",
        sessions: "جلسات",
        minutesPerSession: "دقيقة/جلسة",
        resourcesCount: "مصادر",
        badgeFeatured: "مميز",
        edit: "تعديل",
        delete: "حذف",
        deleteConfirm: "هل تريد حذف هذه الباقة؟",
        errorMissingNameSubject: "يرجى إدخال اسم الباقة والمادة.",
        detailsTitle: "تفاصيل الباقة",
        errorPackNotFound: "تعذر العثور على هذه الباقة.",
      },
      payments: {
        title: "المدفوعات",
        columns: {
          user: "المستخدم",
          pack: "الباقة",
          amount: "المبلغ",
          status: "الحالة",
        },
        statuses: {
          pending: "قيد المعالجة",
          completed: "مكتمل",
          failed: "فشل",
          refunded: "مسترد",
        },
      },
      support: {
        title: "الدعم والرسائل",
        from: "من",
        read: "مقروء",
        new: "جديد",
        type: "النوع",
        markRead: "وضع علامة كمقروء",
        reply: "رد",
        replyTitle: "رسالة جديدة",
        replyClose: "إغلاق",
        replyTo: "إلى",
        replySubject: "الموضوع",
        replyMessage: "الرسالة",
        replySend: "إرسال",
        replySending: "جارٍ الإرسال...",
        replyEmpty: "يرجى كتابة رسالة قبل الإرسال.",
        replySubjectFallback: "رد على رسالة تواصل",
      },
    },
    authPage: {
      loginTitle: "تسجيل الدخول",
      loginLead: "واصل التعلم من حيث توقفت بثقة.",
      email: "البريد الإلكتروني",
      emailPlaceholder: "example@mail.com",
      phoneLabel: "رقم الهاتف",
      phonePlaceholder: "اكتب رقم هاتفك",
      password: "كلمة المرور",
      passwordPlaceholder: "••••••••",
      showPassword: "إظهار كلمة المرور",
      hidePassword: "إخفاء كلمة المرور",
      loginCta: "تسجيل الدخول",
      loginLoading: "جارٍ تسجيل الدخول...",
      noAccount: "ليس لديك حساب؟",
      goSignup: "أنشئ حسابًا الآن",
      signupTitle: "إنشاء حساب",
      signupLead: "انضم إلى Casaclass لمسارات تعلم مشوقة.",
      name: "الاسم الكامل",
      namePlaceholder: "اكتب اسمك الكامل",
      roleLabel: "نوع الحساب",
      roleParent: "ولي أمر",
      roleTeacher: "معلّم",
      resumeLabel: "السيرة الذاتية (CV)",
      resumeRequired: "يرجى رفع السيرة الذاتية لإتمام تسجيل حساب المعلّم.",
      confirmPassword: "تأكيد كلمة المرور",
      confirmPasswordPlaceholder: "أعد كتابة كلمة المرور",
      signupCta: "انضم إلى Casaclass",
      signupLoading: "جارٍ الإنشاء...",
      hasAccount: "لديك حساب بالفعل؟",
      goLogin: "تسجيل الدخول",
      passwordLength: "يجب أن تكون كلمة المرور 8 أحرف على الأقل.",
      passwordMatch: "كلمتا المرور غير متطابقتين.",
      loginError: "تعذر تسجيل الدخول. حاول مرة أخرى.",
      signupError: "تعذر إنشاء الحساب. يرجى المحاولة لاحقًا.",
      forgotLink: "نسيت كلمة المرور؟",
      forgotTitle: "استرجاع كلمة المرور",
      forgotLead:
        "أدخل بريدك الإلكتروني وسنرسل رابط إعادة التعيين إن كان الحساب موجودًا.",
      forgotCta: "أرسل رابط إعادة التعيين",
      forgotSending: "جارٍ الإرسال...",
      forgotSuccess:
        "إذا كان البريد مسجلًا، ستصلك تعليمات إعادة التعيين قريبًا.",
      forgotBack: "العودة لتسجيل الدخول",
      socialDivider: "أو تابع باستخدام Google",
      googleError: "تعذر تسجيل الدخول عبر Google. حاول مرة أخرى.",
      googleLoading: "جارٍ التحقق من حساب Google...",
    },
    verificationPage: {
      title: "الحساب قيد التحقق",
      message:
        "تم إنشاء حساب المعلّم بنجاح، لكن لا يمكنكم استخدام المنصة حتى يقوم المشرف بتوثيق الحساب.",
      logout: "تسجيل الخروج",
    },
    resources: {
      title: "الموارد",
      subtitleTeacher: "أنشئ موارد وعيّنها لقسم أو لتلميذ.",
      subtitleStudent: "ستظهر الموارد المعيّنة لك هنا.",
      loading: "جارٍ التحميل...",
      create: "إنشاء مورد",
      creating: "جارٍ الإنشاء...",
      listTitle: "الموارد",
      empty: "لا توجد موارد بعد.",
      delete: "حذف",
      confirmDelete: "حذف هذا المورد؟",
      failedLoad: "تعذر تحميل الموارد",
      failedCreate: "تعذر إنشاء المورد",
      failedDelete: "تعذر حذف المورد",
      titleRequired: "العنوان مطلوب",
      targetRequired: "يرجى اختيار قسم أو تلميذ",
      targetClass: "قسم",
      targetStudent: "تلميذ",
      fields: {
        title: "العنوان",
        titlePlaceholder: "مثال: موارد الأسبوع الثالث",
        text: "نص",
        textPlaceholder: "وصف أو تعليمات (اختياري)",
        assignTo: "تعيين إلى",
        class: "قسم",
        student: "تلميذ",
        attachments: "مرفقات",
      },
      assign: {
        class: "قسم",
        student: "تلميذ",
      },
      pickClass: "اختر قسمًا",
      pickStudent: "اختر تلميذًا",
    },
    comingSoon: {
      badge: "قريبًا",
      defaultTitle: "الصفحة قيد الإنشاء",
      levelTitle: "المستوى {{level}}",
      defaultDescription: "الصفحة التي تحاول الوصول إليها قيد الإنشاء.",
      levelDescription: "نقوم بتحضير محتوى المستوى {{level}} — قريبًا.",
      pathNotReady: "المسار {{path}} غير متاح بعد.",
      backHome: "العودة للرئيسية",
      contactUs: "تواصل معنا",
      notFoundTitle: "الصفحة غير متاحة",
      notFoundMessage: "الصفحة التي تبحث عنها غير موجودة أو قيد الإنشاء.",
    },
    errors: {
      adminRequired: "تتطلب هذه العملية حساب مشرف.",
      authRequired: "يتطلب هذا الإجراء تسجيل الدخول.",
      operationFailed: "تعذر إتمام العملية.",
      fetchFailed: "تعذر جلب البيانات، حاولوا مجددًا.",
      lessonIdRequired: "رقم الحصة مطلوب",
    },
    lessons: {
      title: "الحصص",
      subtitleStudent: "عرض حصص التلميذ المحدد",
      subtitleStaff: "كل الحصص المرتبطة بحسابك مع فلاتر وتتبع الحالة.",
      newLesson: "حصة جديدة",
      searchLabel: "بحث في الحصص",
      searchPlaceholder: "العنوان، التلميذ، المعلّم",
      statusFilter: "تصفية حسب الحالة",
      refresh: "تحديث القائمة",
      loading: "جارٍ تحميل الحصص...",
      empty: "لا توجد حصص مطابقة للعرض الحالي.",
      emptyCta: "إنشاء أول حصة",
      error: "خطأ أثناء تحميل الحصص: ",
      deleteConfirm: "هل أنت متأكد من حذف هذه الحصة؟",
      student: "التلميذ",
      teacher: "المعلّم",
      pack: "الباقة",
      duration: "المدة",
      minutes: "دقيقة",
      viewDetails: "عرض التفاصيل",
      joinMeeting: "دخول الحصة",
      joinMeetingSoon: "متاح قبل ساعتين",
      generateMeeting: "إنشاء رابط الاجتماع",
      generatingMeeting: "جارٍ الإنشاء...",
      edit: "تعديل",
      delete: "حذف",
      statusScheduled: "مجدولة",
      statusCompleted: "مكتملة",
      statusCancelled: "ملغاة",
      filterAll: "كل الحالات",
      filterScheduled: "قادمة",
      filterCompleted: "مكتملة",
      filterCancelled: "ملغاة",
      timetable: {
        days: "الأيام",
        item: "عنصر",
        items: "عناصر",
        noLessonsForWeek: "لا توجد حصص هذا الأسبوع",
        selectChild: "اختر طفلًا",
        previousWeek: "الأسبوع السابق",
        nextWeek: "الأسبوع التالي",
        today: "اليوم",
        classLabel: "القسم:",
        month: "شهر",
        week: "أسبوع",
        yourWeeklyTimetable: "جدولك الأسبوعي",
      },
    },
    programDetails: {
      loading: "جاري التحميل...",
      eyebrow: "البرامج",
      notFound: {
        title: "البرنامج غير موجود",
        hint: "اختر برنامجًا من القائمة أو أنشئ برنامجًا جديدًا.",
      },
      actions: {
        backToDashboard: "العودة للوحة التحكم",
        backToHome: "العودة للرئيسية",
        newProgram: "برنامج جديد",
        addLevel: "إضافة مستوى",
      },
      sidebar: {
        allPrograms: "كل البرامج",
        editTitle: "تعديل",
        editAction: "تعديل",
      },
      sections: {
        overview: "نظرة عامة",
        learning: "ماذا سيتعلم الطالب",
        morePrograms: "برامج أخرى",
        levels: { single: "المستوى", plural: "المستويات" },
      },
      levels: {
        pickFirst: "اختر مستوى أولاً لعرض تفاصيله.",
        chooseLevel: "اختر المستوى",
        levelTitle: "المستوى {{grade}}",
        levelImageAlt: "صورة المستوى {{grade}}",
      },
      cta: { enrollNow: "سجل الآن" },
      editor: {
        title: "تعديل البرنامج",
        delete: "حذف",
        save: "حفظ",
        cancel: "إلغاء",
      },
      fields: {
        accentColor: "لون الحدود",
        icon: "الأيقونة",
        custom: "مخصص",
        assignedTeacher: "المعلم المكلّف",
        unassigned: "غير محدد",
        teacherFallback: "معلّم",
        title: "العنوان",
        shortDescription: "الوصف المختصر",
        details: "تفاصيل",
        keyPoints: "النقاط",
        levels: "المستويات",
        previewLevelsPage: "عرض صفحة المستويات",
        levelRowTitle: "مستوى {{index}}",
        remove: "حذف",
        grade: "الدرجة",
        label: "الاسم",
        description: "الوصف",
        uploadImage: "رفع صورة",
        uploading: "جارٍ الرفع...",
        chooseFile: "اختر ملف",
        removeImage: "حذف الصورة",
        imageUrl: "رابط الصورة",
        ctaLabel: "نص الزر",
        ctaLink: "رابط الزر",
        displayOrder: "ترتيب العرض",
        active: "نشط",
      },
      placeholders: { grade: "مثال: 1", levelName: "اسم المستوى" },
      errors: {
        unauthorized: "غير مصرح",
        uploadFailed: "فشل رفع الصورة",
        levelsRequireGrade:
          "يرجى إدخال رقم/معرف المستوى لكل المستويات قبل الحفظ",
        titleRequired: "العنوان مطلوب",
      },
      confirm: {
        deleteProgram: "هل تريد حذف هذا البرنامج؟ لا يمكن التراجع عن ذلك.",
      },
      draft: { title: "برنامج جديد" },
      icons: {
        reading: "قراءة",
        graduation: "تخرج",
        math: "رياضيات",
        science: "علوم",
        language: "لغة",
        coding: "برمجة",
        islamicStudies: "علوم إسلامية",
        atom: "ذرة",
        design: "تصميم",
        writing: "كتابة",
        globe: "كرة أرضية",
        star: "نجمة",
        bookLegacy: "كتاب (قديم)",
        scienceLegacy: "علوم (قديم)",
      },
    },
    programLevelSelect: {
      title: "اختر المستوى",
      subtitle: {
        forProgram: "للبرنامج: {{title}}",
        continue: "ثم انتقل إلى تفاصيل البرنامج.",
      },
      actions: { backToHome: "العودة للرئيسية" },
      states: { noLevels: "لا توجد مستويات متاحة لهذا البرنامج حالياً." },
    },
    lessonDetail: {
      idLabel: "معرف الحصة",
      backToList: "العودة للقائمة",
      edit: "تعديل الحصة",
      delete: "حذف الحصة",
      deleteConfirm: "هل تريد حذف هذه الحصة نهائيًا؟",
      loading: "جارٍ تحميل تفاصيل الحصة...",
      error: "تعذر تحميل الحصة: ",
      notFound: "الحصة غير موجودة.",
      scheduledAt: "تاريخ ووقت الحصة",
      description: "وصف الحصة",
      student: "التلميذ",
      teacher: "المعلّم",
      duration: "مدة الحصة",
      minutes: "دقيقة",
      createdAt: "تاريخ الإنشاء",
      updatedAt: "آخر تحديث",
      packInfo: "تفاصيل الباقة",
      pack: "الباقة",
      subject: "المادة",
      price: "السعر",
      partOfPack: "ضمن باقة",
      meetingStatus: "رابط الاجتماع",
      meetingReady: "جاهز",
      meetingPending: "غير مُنشأ بعد",
      joinMeeting: "دخول الحصة",
      generateMeeting: "إنشاء رابط الاجتماع",
      generatingMeeting: "جارٍ الإنشاء...",
      notifyParentsTitle: "إشعار ولي الأمر",
      notifyParentsStatus: "الحالة",
      notifyParentsMessage: "التفاصيل",
      notifyParentsSend: "إرسال",
      notifyParentsSending: "جارٍ الإرسال...",
      notifyParentsSuccess: "تم إرسال الإشعار.",
      notifyParentsSuccessCount:
        "تم إرسال الإشعار إلى {{count}} من أولياء الأمور.",
    },
    lessonEditor: {
      accessDenied: "لا يمكن لهذا الحساب إنشاء أو تعديل الحصص.",
      backToList: "العودة لقائمة الحصص",
      loading: "جارٍ تجهيز نموذج الحصة...",
      loadError: "تعذر تحميل الحصة",
      title: { edit: "تعديل حصة", create: "إنشاء حصة جديدة" },
      note: {
        edit: "حدّث تفاصيل الحصة والوقت أو الحالة.",
        create: "أدخل تفاصيل الحصة القادمة واربط التلميذ الصحيح.",
      },
      genericError: "حدث خطأ أثناء التحميل",
      form: {
        title: "عنوان الحصة",
        description: "الوصف",
        scheduledAt: "وقت الحصة",
        duration: "مدة الحصة (دقائق)",
        status: "حالة الحصة",
        classGroup: "القسم",
        allStudents: "كل التلاميذ",
        students: "التلاميذ",
        student: "التلميذ",
        allowParentJoinMeeting: "السماح لولي الأمر بدخول الحصة",
        teacher: "معرف المعلم (للمشرفين)",
        pack: "ربط بباقة (اختياري)",
        image: "رابط الصورة (اختياري)",
      },
      placeholders: {
        title: "مثال: مراجعة رياضيات – الكسور",
        description: "ملاحظات حول الأهداف أو الموارد أو التعليمات",
        student: "أدخل معرف التلميذ أو اختر من القائمة",
        teacher: "أدخل معرف المعلم المسؤول",
        noPack: "بدون باقة",
        image: "https://",
      },
      help: {
        scheduledAt:
          "يُحفظ الوقت حسب منطقتك الزمنية ثم يُحوّل تلقائيًا إلى UTC.",
        student:
          "تظهر معرفات التلاميذ هنا. يرى الولي كل الأبناء؛ ويرى المعلم التلاميذ الذين درسهم سابقًا.",
        allowParentJoinMeeting: "إذا تم إيقافه فلن يرى الولي رابط الاجتماع.",
        teacher: "يجب أن يعود هذا الرقم لمستخدم بدور معلّم.",
        classCreatesLessons:
          "عند اختيار قسم سيتم إنشاء درس لكل تلميذ داخل هذا القسم.",
        classStudents: "تلاميذ القسم",
      },
      status: {
        scheduled: "مجدولة",
        completed: "مكتملة",
        cancelled: "ملغاة",
      },
      errors: {
        title: "يرجى إدخال عنوان للحصة.",
        schedule: "يرجى اختيار تاريخ ووقت صحيحين.",
        student: "معرف التلميذ غير صالح.",
        duration: "يجب أن تكون مدة الحصة رقمًا موجبًا.",
        teacher: "معرف المعلم غير صالح.",
        noStudentsInClass: "هذا القسم لا يحتوي على تلاميذ",
      },
      actions: {
        saving: "جارٍ الحفظ...",
        update: "تحديث الحصة",
        save: "حفظ الحصة",
        cancel: "إلغاء والعودة",
      },
    },
    teacherPublicProfile: {
      avatarAlt: "صورة شخصية",
      actions: {
        back: "رجوع",
        follow: "متابعة",
        chat: "مراسلة",
        viewProfile: "عرض",
      },
      sections: {
        about: "نبذة",
        experience: "الخبرات",
        education: "التعليم",
        skills: "المهارات",
        teachers: "المعلّمون",
      },
      labels: {
        noInfo: "لا توجد معلومات بعد",
        defaultHeadline: "معلّم Casaclass",
        since: "منذ",
        verified: "موثق",
        teacher: "معلّم",
      },
      states: {
        loading: "جار التحميل...",
        notFound: "لم يتم العثور على المعلم.",
        loadError: "تعذر تحميل ملف المعلم.",
      },
      tooltips: { comingSoon: "قريباً" },
    },
    profile: {
      roles: {
        adminFull: "مشرف المنصة",
        teacherFull: "معلّم Casaclass",
        parentFull: "ولي أمر",
        studentFull: "تلميذ",
        adminShort: "مشرف",
        teacherShort: "معلّم",
        parentShort: "ولي",
      },
      common: {
        loadingData: "جاري تحميل البيانات...",
        idLabel: "المعرف: {{id}}",
        dobLabel: "تاريخ الميلاد: {{date}}",
        unknown: "غير محدد",
      },
      messages: {
        profileUpdated: "تم تحديث بياناتكم بنجاح.",
        avatarUpdated: "تم تحديث صورة الحساب بنجاح.",
      },
      actions: {
        saving: "جارٍ الحفظ",
        saveChanges: "حفظ التغييرات",
        cancelEdit: "إلغاء التعديل",
        edit: "تعديل",
        delete: "حذف",
        refresh: "تحديث",
      },
      overview: {
        aboutTitle: "نبذة",
        aboutTextStudent: "هذا ملف التلميذ المرتبط بوضع التلميذ.",
        aboutTextUser:
          "يتحكم هذا القسم في معلومات الحساب الأساسية، كما يمكنكم تحديث الاسم الظاهر في المنصة.",
        uploadingPhoto: "جارٍ رفع الصورة",
        changePhoto: "تغيير الصورة",
        upcomingLessons: "الحصص القادمة",
        noUpcomingLessons: "لا توجد حصص قادمة.",
      },
      progress: {
        title: "تقدم الملف الشخصي",
        subtitle: "أكملوا معلوماتكم لتحسين التجربة.",
        completeProfile: "إكمال الملف",
      },
      studentDetails: {
        title: "تفاصيل التلميذ",
        notFound: "تعذر العثور على التلميذ.",
      },
      personal: {
        title: "المعلومات الشخصية",
        subtitleStudent: "معلومات التلميذ في وضع التلميذ.",
        subtitleUser: "حدّثوا الاسم الذي يظهر في المنصة.",
        edit: "تعديل",
        accountDetailsAria: "تفاصيل الحساب",
      },
      fields: {
        firstName: "الاسم",
        lastName: "اللقب",
        phone: "رقم الهاتف",
        role: "الدور",
        email: "البريد الإلكتروني",
        dob: "تاريخ الميلاد",
        completion: "اكتمال الملف",
        status: "الحالة",
        notes: "ملاحظات",
      },
      placeholders: {
        firstName: "مثال: أحمد",
        lastName: "مثال: بن محمود",
        phone: "مثال: +216 55 544 475",
      },
      students: {
        title: "أبنائي",
        subtitle:
          "أضيفوا أبناءً جددًا أو حدّثوا بياناتهم ليتمكن المعلمون من جدولة الحصص بسهولة.",
        placeholders: {
          firstName: "مثال: علي",
          lastName: "مثال: بن سالم",
          notes: "معلومات إضافية تهم فريق Casaclass",
        },
        actions: {
          add: "إضافة تلميذ",
          update: "تحديث التلميذ",
        },
        loading: "جاري تحميل التلاميذ...",
        empty: "لم يتم تسجيل أبناء بعد.",
        errors: {
          firstNameRequired: "الاسم مطلوب",
        },
        confirmDelete: "هل تودون حذف هذا التلميذ؟",
      },
      classes: {
        title: "أقسامي",
        subtitle:
          "أنشئوا قسماً يضم تلميذاً واحداً أو عدة تلاميذ لتسهيل تنظيم الحصص.",
        fields: {
          name: "اسم القسم",
          students: "التلاميذ",
        },
        placeholders: {
          name: "مثال: قسم الرياضيات",
        },
        actions: {
          add: "إضافة قسم",
          update: "تحديث القسم",
        },
        loading: "جاري تحميل الأقسام...",
        empty: "لم يتم إنشاء أقسام بعد.",
        emptyRoster: "لا توجد تلاميذ مرتبطون بحصصكم بعد.",
        studentsCount: "عدد التلاميذ: {{count}}",
        noStudentsSelected: "لم يتم اختيار تلاميذ.",
        errors: {
          nameRequired: "اسم القسم مطلوب",
        },
        confirmDelete: "هل تودون حذف هذا القسم؟",
      },
      lessons: {
        title: "متابعة الحصص",
        subtitle: "لمحة عن الحصص المرتبطة بحسابكم مع أقرب المواعيد القادمة.",
        stats: {
          total: "إجمالي الحصص",
          completed: "مكتملة",
          cancelled: "ملغاة",
        },
        labels: {
          scheduledAt: "الموعد: {{datetime}}",
          student: "التلميذ: {{name}}",
          duration: "المدة: {{minutes}} دقيقة",
        },
        empty: "لم يتم تسجيل حصص حتى الآن.",
      },
      users: {
        title: "إدارة المستخدمين",
        subtitle: "استعرضوا الحسابات المسجلة وغيّروا الأدوار حسب الحاجة.",
        filters: {
          role: "تصفية حسب الدور",
          allRoles: "جميع الأدوار",
          search: "بحث بالبريد أو الاسم",
        },
        placeholders: {
          search: "example@casaclass.com",
        },
        actions: {
          search: "بحث",
          reset: "إعادة التعيين",
        },
        loading: "جاري تحميل المستخدمين...",
        summary:
          "إجمالي النتائج: {{total}} — مدراء: {{admins}}، معلمون: {{teachers}}، أولياء: {{parents}}",
        empty: "لا توجد حسابات مطابقة للبحث.",
        table: {
          email: "البريد",
          name: "الاسم",
          role: "الدور",
          status: "تحديث",
        },
      },
    },
  },
  en: {
    meta: { name: "English", dir: "ltr" },
    testsModule: testsModuleEn,
    common: { id: "ID" },
    nav: {
      home: "Home",
      courses: "Courses",
      about: "About",
      contact: "Contact",
      searchLabel: "Search within Casaclass",
      searchPlaceholder: "Search for a lesson or resource",
      menuLabel: "Menu",
      languageLabel: "Language",
    },
    auth: {
      login: "Log In",
      signup: "Sign Up",
    },
    protectedRoute: {
      loading: "Checking your account...",
    },
    footer: {
      title: "Casaclass",
      description: "Your learning platform for confident academic success.",
      quickLinks: "Quick Links",
      home: "Home",
      courses: "Courses",
      about: "About",
      contact: "Contact",
      email: "contact@casaclassroom.com",
      phone: "+216 55 544 475",
      copyright: "All rights reserved.",
    },
    sidebar: {
      close: "Close",
      toggle: "Toggle sidebar",
      role: {
        admin: "Platform admin",
        superadmin: "Super admin",
        support: "Support",
        accounting: "Accounting",
        teacher: "Teacher",
        parent: "Parent",
        student: "Student",
        user: "User",
      },
      links: {
        dashboard: "Dashboard",
        programs: "Programs",
        lessons: "Lessons",
        timetable: "Timetable",
        resources: "Resources",
        tests: "Tests",
        homeworks: "Homeworks",
        offers: "Offers",
        contact: "Support",
        profile: "My account",
        admin: "Admin console",
        students: "Students",
        newLesson: "New lesson",
        myStudents: "My students",
        myChildren: "My children",
        myLessons: "My lessons",
      },
      sections: {
        main: "Main menu",
        management: "Academic management",
        other: "Other menu",
      },
      logout: "Log out",
    },
    studentShell: {
      shortcutsLabel: "Student shortcuts",
      mainNavLabel: "Student main navigation",
    },
    comingSoon: {
      badge: "Soon",
      defaultTitle: "Page coming soon",
      levelTitle: "Level {{level}}",
      defaultDescription:
        "The page you’re trying to reach is under construction.",
      levelDescription:
        "We’re preparing content for level {{level}} — coming soon.",
      pathNotReady: "Path {{path}} is not available yet.",
      backHome: "Back to home",
      contactUs: "Contact us",
      notFoundTitle: "Page not available",
      notFoundMessage:
        "The page you’re looking for does not exist or is under construction.",
    },
    contactPage: {
      status: {
        loading: "Sending your message...",
        success: "Message sent! We will get back to you soon.",
        error: "We could not send the message. Please try again.",
      },
      hero: {
        label: "Contact us",
        title: "Let's plan an inspiring learning journey",
        lead: "Share what you need and we'll design a learning path that fits your family. Our team is ready to help at every step.",
      },
      form: {
        cardTitle: "Reach us directly",
        cardSubtitle:
          "Fill out the form below and we'll reply within one business day.",
        fullNameLabel: "Full name",
        fullNamePlaceholder: "Enter your name",
        emailLabel: "Email",
        emailPlaceholder: "example@mail.com",
        phoneLabel: "Phone number",
        phonePlaceholder: "Enter your phone number",
        subjectLabel: "Subject",
        subjectPlaceholder: "Add a short subject",
        messageLabel: "How can we help?",
        messagePlaceholder:
          "Describe what you need so we can propose the best plan",
        submit: "Send message",
        submitting: "Sending...",
        phoneAppend: "Phone number: {{phone}}",
      },
      calendly: {
        title: "Book a consultation",
        subtitle: "Pick a time that works for you to speak with our team.",
      },
    },
    errors: {
      adminRequired: "This action requires an admin account.",
      authRequired: "You need to be logged in to do this.",
      operationFailed: "Could not complete the operation.",
      fetchFailed: "Could not fetch the data. Please try again.",
      lessonIdRequired: "Lesson ID is required.",
    },
    lessons: {
      title: "Lessons",
      subtitleStudent: "Showing lessons for the active student",
      subtitleStaff:
        "All lessons linked to your account with filters and status tracking.",
      newLesson: "New lesson",
      searchLabel: "Search lessons",
      searchPlaceholder: "Title, student, teacher",
      statusFilter: "Filter by status",
      refresh: "Refresh list",
      loading: "Loading lessons...",
      empty: "No lessons match the current view.",
      emptyCta: "Create the first lesson",
      error: "Error while loading lessons: ",
      deleteConfirm: "Are you sure you want to delete this lesson?",
      student: "Student",
      teacher: "Teacher",
      pack: "Pack",
      duration: "Duration",
      minutes: "minutes",
      viewDetails: "View details",
      joinMeeting: "Join meeting",
      joinMeetingSoon: "Available 2 hours before",
      generateMeeting: "Generate meeting link",
      generatingMeeting: "Generating...",
      edit: "Edit",
      delete: "Delete",
      statusScheduled: "Scheduled",
      statusCompleted: "Completed",
      statusCancelled: "Cancelled",
      filterAll: "All statuses",
      filterScheduled: "Upcoming",
      filterCompleted: "Completed",
      filterCancelled: "Cancelled",
      timetable: {
        days: "Days",
        item: "item",
        items: "items",
        noLessonsForWeek: "No lessons for this week",
        selectChild: "Select child",
        previousWeek: "Previous week",
        nextWeek: "Next week",
        today: "Today",
        classLabel: "Class:",
        month: "Month",
        week: "Week",
        yourWeeklyTimetable: "Your weekly timetable",
      },
    },
    programDetails: {
      loading: "Loading...",
      eyebrow: "Programs",
      notFound: {
        title: "Program not found",
        hint: "Choose a program from the list or create a new one.",
      },
      actions: {
        backToDashboard: "Back to dashboard",
        backToHome: "Back to home",
        newProgram: "New program",
        addLevel: "Add level",
      },
      sidebar: {
        allPrograms: "All programs",
        editTitle: "Edit",
        editAction: "Edit",
      },
      sections: {
        overview: "Overview",
        learning: "What students will learn",
        morePrograms: "More programs",
        levels: { single: "Level", plural: "Levels" },
      },
      levels: {
        pickFirst: "Pick a level first to view its details.",
        chooseLevel: "Choose level",
        levelTitle: "Level {{grade}}",
        levelImageAlt: "Level image {{grade}}",
      },
      cta: { enrollNow: "Enroll now" },
      editor: {
        title: "Edit program",
        delete: "Delete",
        save: "Save",
        cancel: "Cancel",
      },
      fields: {
        accentColor: "Accent color",
        icon: "Icon",
        custom: "Custom",
        assignedTeacher: "Assigned teacher",
        unassigned: "Unassigned",
        teacherFallback: "Teacher",
        title: "Title",
        shortDescription: "Short description",
        details: "Details",
        keyPoints: "Key points",
        levels: "Levels",
        previewLevelsPage: "Preview levels page",
        levelRowTitle: "Level {{index}}",
        remove: "Remove",
        grade: "Grade",
        label: "Label",
        description: "Description",
        uploadImage: "Upload image",
        uploading: "Uploading…",
        chooseFile: "Choose file",
        removeImage: "Remove image",
        imageUrl: "Image URL",
        ctaLabel: "CTA label",
        ctaLink: "CTA link",
        displayOrder: "Display order",
        active: "Active",
      },
      placeholders: { grade: "e.g. 1", levelName: "Level name" },
      errors: {
        unauthorized: "Unauthorized",
        uploadFailed: "Upload failed",
        levelsRequireGrade:
          "Please fill the level grade/id for all levels before saving",
        titleRequired: "Title is required",
      },
      confirm: {
        deleteProgram: "Delete this program? This cannot be undone.",
      },
      draft: { title: "New Program" },
      icons: {
        reading: "Reading",
        graduation: "Graduation",
        math: "Math",
        science: "Science",
        language: "Language",
        coding: "Coding",
        islamicStudies: "Islamic studies",
        atom: "Atom",
        design: "Design",
        writing: "Writing",
        globe: "Globe",
        star: "Star",
        bookLegacy: "Book (legacy)",
        scienceLegacy: "Science (legacy)",
      },
    },
    programLevelSelect: {
      title: "Choose a level",
      subtitle: {
        forProgram: "For program: {{title}}",
        continue: "Then continue to the program details.",
      },
      actions: { backToHome: "Back to home" },
      states: { noLevels: "No levels available for this program yet." },
    },
    lessonDetail: {
      idLabel: "Lesson ID",
      backToList: "Back to list",
      edit: "Edit lesson",
      delete: "Delete lesson",
      deleteConfirm: "Do you want to delete this lesson permanently?",
      loading: "Loading lesson details...",
      error: "Could not load the lesson: ",
      notFound: "Lesson not found.",
      scheduledAt: "Lesson date and time",
      description: "Lesson description",
      student: "Student",
      teacher: "Teacher",
      duration: "Lesson duration",
      minutes: "minutes",
      createdAt: "Created",
      updatedAt: "Updated",
      packInfo: "Pack details",
      pack: "Pack",
      subject: "Subject",
      price: "Price",
      partOfPack: "Part of pack",
      meetingStatus: "Meeting link",
      meetingReady: "Ready",
      meetingPending: "Not created yet",
      joinMeeting: "Join meeting",
      generateMeeting: "Generate meeting link",
      generatingMeeting: "Generating...",
      notifyParentsTitle: "Notify parents",
      notifyParentsStatus: "Status",
      notifyParentsMessage: "Message",
      notifyParentsSend: "Send",
      notifyParentsSending: "Sending...",
      notifyParentsSuccess: "Notification sent.",
      notifyParentsSuccessCount: "Notified {{count}} parents.",
    },
    lessonEditor: {
      accessDenied: "This account cannot create or edit lessons.",
      backToList: "Back to lessons list",
      loading: "Preparing lesson form...",
      loadError: "Could not load lesson",
      title: { edit: "Edit lesson", create: "Create a new lesson" },
      note: {
        edit: "Update lesson details, time, or status.",
        create:
          "Enter the upcoming lesson details and link the correct student.",
      },
      genericError: "An error occurred while loading",
      form: {
        title: "Lesson title",
        description: "Description",
        scheduledAt: "Lesson time",
        duration: "Lesson duration (minutes)",
        status: "Lesson status",
        classGroup: "Class",
        allStudents: "All students",
        students: "Students",
        student: "Student",
        allowParentJoinMeeting: "Allow parent to join meeting",
        teacher: "Teacher ID (admins)",
        pack: "Linked pack (optional)",
        image: "Image URL (optional)",
      },
      placeholders: {
        title: "e.g. Math review – decimals",
        description: "Notes about objectives, resources, or instructions",
        student: "Enter student ID or choose from list",
        teacher: "Enter the responsible teacher ID",
        noPack: "No specific pack",
        image: "https://",
      },
      help: {
        scheduledAt:
          "Time is saved in your local timezone and auto-converted to UTC.",
        student:
          "Student IDs appear here. Parents see all children; teachers see previously taught students.",
        allowParentJoinMeeting:
          "If disabled, parents will not see the meeting link for this lesson.",
        teacher: "This number must belong to a user with the Teacher role.",
        classCreatesLessons:
          "Selecting a class will create one lesson per student in that class.",
        classStudents: "Class students",
      },
      status: {
        scheduled: "Scheduled",
        completed: "Completed",
        cancelled: "Cancelled",
      },
      errors: {
        title: "Please enter a lesson title.",
        schedule: "Please select a valid date and time.",
        student: "Invalid student ID. Use the numeric student identifier.",
        duration: "Lesson duration must be a positive number.",
        teacher: "Invalid teacher ID.",
        noStudentsInClass: "This class has no students",
      },
      actions: {
        saving: "Saving...",
        update: "Update lesson",
        save: "Save lesson",
        cancel: "Cancel and go back",
      },
    },
    teacherPublicProfile: {
      avatarAlt: "Avatar",
      actions: {
        back: "Back",
        follow: "Follow",
        chat: "Chat",
        viewProfile: "View",
      },
      sections: {
        about: "About",
        experience: "Work Experience",
        education: "Education",
        skills: "Skills",
        teachers: "Teachers",
      },
      labels: {
        noInfo: "No information yet",
        defaultHeadline: "Casaclass Teacher",
        since: "Since",
        verified: "Verified",
        teacher: "Teacher",
      },
      states: {
        loading: "Loading...",
        notFound: "Teacher not found.",
        loadError: "Unable to load teacher profile.",
      },
      tooltips: { comingSoon: "Coming soon" },
    },
    profile: {
      roles: {
        adminFull: "Platform Admin",
        teacherFull: "Casaclass Teacher",
        parentFull: "Parent",
        studentFull: "Student",
        adminShort: "Admin",
        teacherShort: "Teacher",
        parentShort: "Parent",
      },
      common: {
        loadingData: "Loading...",
        idLabel: "ID: {{id}}",
        dobLabel: "Date of birth: {{date}}",
        unknown: "Unknown",
      },
      messages: {
        profileUpdated: "Your details were updated successfully.",
        avatarUpdated: "Your profile picture was updated successfully.",
      },
      actions: {
        saving: "Saving...",
        saveChanges: "Save changes",
        cancelEdit: "Cancel edit",
        edit: "Edit",
        delete: "Delete",
        refresh: "Refresh",
      },
      overview: {
        aboutTitle: "About",
        aboutTextStudent:
          "This is the student's profile linked to Student mode.",
        aboutTextUser:
          "Manage your core account info here, and update the name shown on the platform.",
        uploadingPhoto: "Uploading photo...",
        changePhoto: "Change photo",
        upcomingLessons: "Upcoming lessons",
        noUpcomingLessons: "No upcoming lessons.",
      },
      progress: {
        title: "Profile progress",
        subtitle: "Complete your details to improve your experience.",
        completeProfile: "Complete profile",
      },
      studentDetails: {
        title: "Student details",
        notFound: "Unable to find the student.",
      },
      personal: {
        title: "Personal information",
        subtitleStudent: "Student information in Student mode.",
        subtitleUser: "Update the name shown on the platform.",
        edit: "Edit",
        accountDetailsAria: "Account details",
      },
      fields: {
        firstName: "First name",
        lastName: "Last name",
        phone: "Phone number",
        role: "Role",
        email: "Email",
        dob: "Date of birth",
        completion: "Profile completion",
        status: "Status",
        notes: "Notes",
      },
      placeholders: {
        firstName: "e.g. Ahmed",
        lastName: "e.g. Ben Mahmoud",
        phone: "e.g. +216 55 544 475",
      },
      students: {
        title: "My children",
        subtitle:
          "Add children or update their details so teachers can schedule lessons more easily.",
        placeholders: {
          firstName: "e.g. Ali",
          lastName: "e.g. Ben Salem",
          notes: "Additional info for the Casaclass team",
        },
        actions: {
          add: "Add student",
          update: "Update student",
        },
        loading: "Loading students...",
        empty: "No children have been added yet.",
        errors: {
          firstNameRequired: "First name is required",
        },
        confirmDelete: "Do you want to delete this student?",
      },
      classes: {
        title: "My classes",
        subtitle:
          "Create a class with one or more students to organize lessons.",
        fields: {
          name: "Class name",
          students: "Students",
        },
        placeholders: {
          name: "e.g. Math class",
        },
        actions: {
          add: "Add class",
          update: "Update class",
        },
        loading: "Loading classes...",
        empty: "No classes have been created yet.",
        emptyRoster: "No students are linked to your lessons yet.",
        studentsCount: "Students: {{count}}",
        noStudentsSelected: "No students selected.",
        errors: {
          nameRequired: "Class name is required",
        },
        confirmDelete: "Do you want to delete this class?",
      },
      lessons: {
        title: "Lessons overview",
        subtitle:
          "A quick look at your lessons and the nearest upcoming schedules.",
        stats: {
          total: "Total lessons",
          completed: "Completed",
          cancelled: "Cancelled",
        },
        labels: {
          scheduledAt: "Scheduled: {{datetime}}",
          student: "Student: {{name}}",
          duration: "Duration: {{minutes}} minutes",
        },
        empty: "No lessons recorded yet.",
      },
      users: {
        title: "User management",
        subtitle: "Browse registered accounts and change roles as needed.",
        filters: {
          role: "Filter by role",
          allRoles: "All roles",
          search: "Search by email or name",
        },
        placeholders: {
          search: "example@casaclass.com",
        },
        actions: {
          search: "Search",
          reset: "Reset",
        },
        loading: "Loading users...",
        summary:
          "Total results: {{total}} — Admins: {{admins}}, Teachers: {{teachers}}, Parents: {{parents}}",
        empty: "No accounts match your search.",
        table: {
          email: "Email",
          name: "Name",
          role: "Role",
          status: "Status",
        },
      },
    },
    authPage: {
      loginTitle: "Log in",
      loginLead: "Pick up where you left off and keep learning.",
      email: "Email",
      emailPlaceholder: "example@mail.com",
      phoneLabel: "Phone number",
      phonePlaceholder: "Enter your phone number",
      password: "Password",
      passwordPlaceholder: "Enter your password",
      showPassword: "Show password",
      hidePassword: "Hide password",
      loginCta: "Log in",
      loginLoading: "Signing in...",
      noAccount: "Don't have an account?",
      goSignup: "Create one now",
      signupTitle: "Create an account",
      signupLead: "Join Casaclass for engaging learning paths.",
      name: "Full name",
      namePlaceholder: "Enter your full name",
      roleLabel: "Account type",
      roleParent: "Parent",
      roleTeacher: "Teacher",
      resumeLabel: "Resume (CV)",
      resumeRequired: "Please upload your resume to register as a teacher.",
      confirmPassword: "Confirm password",
      confirmPasswordPlaceholder: "Re-enter your password",
      signupCta: "Join Casaclass",
      signupLoading: "Creating...",
      hasAccount: "Already have an account?",
      goLogin: "Log in",
      passwordLength: "Password must be at least 8 characters.",
      passwordMatch: "Passwords do not match.",
      loginError: "Could not log in. Please try again.",
      signupError: "Could not create the account. Please try later.",
      forgotLink: "Forgot password?",
      forgotTitle: "Forgot your password",
      forgotLead:
        "Enter your email and we'll send a reset link if your account exists.",
      forgotCta: "Send reset link",
      forgotSending: "Sending...",
      forgotSuccess:
        "If this email is registered, you'll receive reset instructions shortly.",
      forgotBack: "Back to login",
      socialDivider: "Or continue with Google",
      googleError: "We could not sign you in with Google. Try again.",
      googleLoading: "Verifying your Google account...",
    },
    verificationPage: {
      title: "Account pending verification",
      message:
        "Your teacher account was created successfully, but you can’t access the platform until an admin verifies your account.",
      logout: "Log out",
    },
    resources: {
      title: "Resources",
      subtitleTeacher:
        "Create resources and assign them to a class or a student.",
      subtitleStudent: "Resources assigned to you will appear here.",
      loading: "Loading...",
      create: "Create resource",
      creating: "Creating...",
      listTitle: "Resources",
      empty: "No resources yet.",
      delete: "Delete",
      confirmDelete: "Delete this resource?",
      failedLoad: "Failed to load resources",
      failedCreate: "Failed to create resource",
      failedDelete: "Failed to delete resource",
      titleRequired: "Title is required",
      targetRequired: "Please choose a class or a student",
      targetClass: "Class",
      targetStudent: "Student",
      fields: {
        title: "Title",
        titlePlaceholder: "e.g. Week 3 material",
        text: "Text",
        textPlaceholder: "Optional description or instructions",
        assignTo: "Assign to",
        class: "Class",
        student: "Student",
        attachments: "Attachments",
      },
      assign: {
        class: "Class",
        student: "Student",
      },
      pickClass: "Select a class",
      pickStudent: "Select a student",
    },
    offers: {
      heroTag: "Offers",
      heroTitle: "Casaclass ready-made packs",
      heroDescription:
        "Choose the path that fits your family. Each offer combines live teaching, digital resources, and support from our pedagogical team.",
      packLabel: "Choose a pack:",
      packPlaceholder: "-- Select --",
      sections: {
        classTypes: {
          tag: "Learning modes",
          heading: "Pick the environment your child prefers",
          description:
            "From one-to-one sessions to larger groups, each format is tailored for different personalities and budgets.",
        },
        languages: {
          tag: "Global languages",
          heading: "Live language tracks",
          description:
            "Complete journeys from basics to international exams, with interactive content that builds confidence.",
        },
        upcoming: {
          tag: "Coming soon",
          heading: "Future-skills courses on the way",
          description:
            "Register interest to get notified when we open coding, AI, and young leaders labs.",
        },
      },
      classTypes: {
        full: {
          category: "Class types",
          title: "Full Classes",
          subtitle: "Fully personalized one-to-one",
          description:
            "A 100% personal experience with one teacher building the plan around your child's needs.",
          price: "25 TND / session",
          billing: "60-minute private session",
          features: [
            "Personal syllabus reviewed regularly",
            "Individual attention from the teacher",
            "Full flexibility for scheduling",
          ],
          cta: "Join Full Classes",
        },
        duo: {
          category: "Class types",
          title: "DUO Classes",
          subtitle: "Shared lesson with a friend or sibling",
          description:
            "Designed for a duo that motivates each other through joint learning.",
          price: "15 TND / session",
          billing: "Price per learner",
          features: [
            "Content tailored for two",
            "Interactive activities for collaboration",
            "Follow-up on task sharing",
          ],
          cta: "Join DUO Classes",
          badge: "Most popular",
        },
        vip: {
          category: "Class types",
          title: "VIP Classes",
          subtitle: "Small groups up to 4 students",
          description:
            "Continuous engagement in a carefully selected group with personal attention.",
          price: "10 TND / session",
          billing: "Price per learner",
          features: [
            "Interactive sessions with close peers",
            "Collaborative activities to build confidence",
            "Individual guidance within the group",
          ],
          cta: "Join VIP Classes",
        },
        normal: {
          category: "Class types",
          title: "Normal Classes",
          subtitle: "Up to 8 students",
          description:
            "Budget-friendly option that keeps kids engaged in a cooperative group.",
          price: "7.5 TND / session",
          billing: "Price per learner",
          features: [
            "Structured group setting",
            "Activities that encourage participation",
            "Best value for steady learning",
          ],
          cta: "Join Normal Classes",
        },
      },
      languagePrograms: {
        french: {
          category: "Language programs",
          title: "French",
          subtitle: "A1 to C2 • DELF/DALF",
          description:
            "Strengthen grammar and conversation with full prep for DELF/DALF exams at a Tunisian pace.",
          price: "180 TND / month",
          billing: "Live sessions + digital resources",
          features: [
            "Progressive content from letters to academic writing",
            "DELF/DALF exam practice",
            "Pronunciation and speaking workshops",
          ],
          cta: "Enroll in French",
        },
        english: {
          category: "Language programs",
          title: "English",
          subtitle: "Conversation + IELTS",
          description:
            "Comprehensive path to polish speaking and prepare for IELTS with business-focused units.",
          price: "220 TND / month",
          billing: "Live sessions • interactive resources",
          features: [
            "Full IELTS preparation",
            "Business English and interviews",
            "Weekly conversation clubs",
          ],
          cta: "Try a trial lesson",
          badge: "Favorite",
        },
        arabic: {
          category: "Language programs",
          title: "Arabic",
          subtitle: "For non-native speakers",
          description:
            "Introduces learners to letters, proper pronunciation, and daily conversation with cultural flavor.",
          price: "160 TND / month",
          billing: "Live communication + home support",
          features: [
            "Letters and accurate sounds from day one",
            "Daily dialogue and core vocabulary",
            "Stories and cultural activities",
          ],
          cta: "Enroll in Arabic",
        },
      },
      upcoming: {
        coding: {
          category: "Coming soon",
          title: "Coding for Kids",
          subtitle: "Scratch and Minecraft projects",
          description:
            "A digital lab teaching logical thinking through playful projects every month.",
          price: "Coming soon",
          billing: "Enrollment opens next quarter",
          features: [
            "Progressive coding workshops",
            "Digital achievement badges",
            "Collaboration in small teams",
          ],
          cta: "Notify me at launch",
        },
        ai: {
          category: "Coming soon",
          title: "AI & Future Skills",
          subtitle: "AI made simple for youth",
          description:
            "Explore AI concepts, design thinking, and automation through mini projects.",
          price: "Coming soon",
          billing: "Launching Summer 2026",
          features: [
            "AI concepts without complexity",
            "Robotics workshops with simple kits",
            "Critical thinking challenges",
          ],
          cta: "Join the waitlist",
        },
        leaders: {
          category: "Coming soon",
          title: "Future Leaders Lab",
          subtitle: "Communication and presentation skills",
          description:
            "Combines presenting, problem solving, and mini projects for teens.",
          price: "Coming soon",
          billing: "Pilot launch Fall 2026",
          features: [
            "1:1 and group sessions",
            "Real-world applied projects",
            "Coaching by communication experts",
          ],
          cta: "Register interest",
        },
      },
      addons: {
        tag: "Optional add-ons",
        heading: "Services that complete your child's experience",
        description:
          "Attach these to any main pack or book them separately whenever you need an extra boost.",
        coaching: {
          title: "Family coaching session",
          price: "30 TND / session",
          description:
            "45-minute call to assess needs and set a monthly progress plan.",
          points: [
            "Quick snapshot of current level",
            "Four-week goal map",
            "Home activities and follow-up plan",
          ],
          cta: "Book the session",
        },
        assessment: {
          title: "Advanced placement test",
          price: "45 TND one time",
          description:
            "Interactive test + written report with precise recommendations.",
          points: [
            "Digital test in language and math",
            "Written analysis of strengths and needs",
            "Transition plan for the first weeks",
          ],
          cta: "Request the report",
        },
        oneToOne: {
          title: "Intensive one-to-one",
          price: "25 TND / session",
          description:
            "Online private lessons with a Casaclass teacher to strengthen a specific skill.",
          points: [
            "Flexible subject and timing",
            "Follow-up note after each session",
            "Great before exams or to build confidence",
          ],
          cta: "Coordinate with us",
        },
      },
      support: {
        heading: "Need help choosing?",
        description:
          "The Casaclass team can craft a personalized learning plan. Reach out and we'll propose the right path and check readiness before you start.",
        ctaCall: "Book a guidance call",
        ctaSignup: "Create an account now",
      },
    },
    dashboard: {
      role: {
        admin: "Platform admin",
        superadmin: "Super admin",
        support: "Support",
        accounting: "Accounting",
        teacher: "Teacher",
        parent: "Parent",
        member: "Casaclass member",
      },
      searchPlaceholder: "Search...",
      loading: "Loading...",
      hero: {
        greeting: "Welcome {{name}}, 👋",
        intro:
          "A quick look at your upcoming lessons, linked students, and featured Casaclass packs.",
        manageLessons: "Manage lessons",
        browseOffers: "Browse offers",
        nextLesson: "Next lesson",
        student: "Student",
        teacher: "Teacher",
        time: "Time",
        duration: "Duration",
      },
      stats: {
        total: { label: "Lessons", hint: "All recorded lessons" },
        upcoming: { label: "Upcoming", hint: "Scheduled soon" },
        completed: { label: "Completed", hint: "Already done" },
        cancelled: { label: "Cancelled", hint: "Cancelled lessons" },
      },
      upcoming: {
        title: "Upcoming lessons",
        subtitle: "Next four lessons to stay on track.",
        viewAll: "View all",
        loading: "Loading lessons...",
        empty:
          "No upcoming lessons. You can schedule a new one from the Lessons page.",
      },
      students: {
        title: "Linked students",
        subtitle: "Students attached to your account.",
        id: "ID",
        dob: "Date of birth",
        empty: "No student data.",
      },
      featured: {
        title: "Suggested packs",
        subtitle: "Recommendations from the Casaclass catalog.",
        explore: "Explore all packs",
        lessonsCount: "Lessons",
        sessionLength: "Session length",
        price: "Price",
        learnMore: "Learn more",
      },
      errors: {
        loadData: "We could not load some data: {{error}}",
      },
      teacher: {
        roleLabel: "Teacher dashboard",
        greeting: "Hello {{name}}",
        intro: "Quick control of lessons, students, and parent communication.",
        performance: {
          title: "Performance",
          completed: "Completed",
          cancelled: "Cancelled",
        },
        programs: {
          title: "My programs",
          loading: "Loading programs...",
          edit: "Edit",
          empty: "No programs yet.",
        },
        weeklyActivity: {
          title: "Weekly activity",
          hint: "Last 7 days",
        },
        topStudents: {
          title: "Most active students",
          lessons: "{{count}} lessons",
          empty: "Not enough data yet.",
        },
        updates: {
          title: "Latest updates",
          empty: "No updates yet.",
        },
        actions: {
          schedule: "Schedule lessons",
          newLesson: "Create lesson",
        },
        stats: {
          activeStudents: { label: "Active students" },
          hoursGiven: { label: "Teaching hours" },
          completed: { label: "Completed sessions" },
          cancelled: { label: "Cancelled sessions" },
        },
        schedule: {
          title: "Live lesson schedule",
          subtitle: "Closest lessons and their status.",
          view: "View schedule",
          loading: "Loading schedule...",
          empty: "No upcoming lessons.",
        },
        manage: {
          title: "Manage lessons",
          subtitle: "Create lessons, resources, and attendance.",
          createEdit: {
            title: "Create / edit",
            description: "Plan, edit, or duplicate lessons easily.",
          },
          upload: {
            title: "Upload resources",
            description: "Add PDF, video, or quizzes.",
          },
          attendance: {
            title: "Record attendance",
            description: "Mark attendance for each lesson.",
          },
        },
        assessments: {
          title: "Assessments & feedback",
          subtitle: "Grades, comments, and homework/tests history.",
          grades: {
            title: "Grades & notes",
            description: "Add a grade and note for each student.",
          },
          homework: {
            title: "Homework / tests log",
            description: "Review corrected homework and track it.",
          },
        },
        communication: {
          title: "Communication",
          subtitle: "Internal messages and notifications.",
          messaging: {
            title: "Internal messages",
            description: "Secure chat with students and parents.",
          },
          notifications: {
            title: "System notifications",
            description: "New students or schedule changes.",
          },
        },
        payments: {
          title: "Payments",
          subtitle: "Casaclass transfers and monthly invoices.",
          history: {
            title: "Transfer history",
            description: "Your transfers appear here.",
          },
          invoicing: {
            title: "Auto invoices",
            description: "Monthly summary generated automatically.",
          },
        },
      },
      parent: {
        roleLabel: "Parent dashboard",
        greeting: "Hello {{name}}",
        intro: "Track your kids, lessons, alerts, and billing.",
        classes: {
          title: "Classes",
          subtitle: "Current classes for each child",
        },
        widgets: {
          studentModeLabel: "Student mode",
          studentModePlaceholder: "Enter as student",
          notifications: "Notifications",
          weekSubtitle: "Quick view of lessons this week.",
          noLessons: "No lessons.",
          reminders: "Reminders",
          reminderCheckbox: "Mark as done",
          recommended: "Recommended",
          monthStats: "This month’s stats",
          monthStatsHint: "Quick snapshot",
          children: "Children",
          homework: "Homework",
          homeworkHint: "Next upcoming lessons.",
        },
        notifications: {
          empty: "No notifications.",
          markRead: "Mark as read",
          status: {
            cancelled: "Cancelled",
            postponed: "Postponed",
            updated: "Updated",
          },
        },
        actions: {
          weekly: "Weekly schedule",
          support: "Open support ticket",
        },
        activeStudent: {
          status: "Student mode is active",
          none: "No student selected",
          label: "Mode {{name}}",
          subtitle: "Direct access to the selected student's space.",
          deactivate: "Deactivate mode",
          prompt: "Select a student to activate their space.",
        },
        children: {
          title: "Linked children",
          subtitle: "Overall progress and next lessons.",
          addChild: "Add child",
          progress: "Progress",
          nextLesson: "Next lesson",
          activate: "Activate student mode",
          active: "Student mode active",
          viewLessons: "View lessons",
          loading: "Loading children...",
          empty: "No linked children.",
        },
        followup: {
          title: "Lesson follow-up",
          subtitle: "Weekly schedule and records (replays/resources).",
          loading: "Loading lessons...",
          empty: "No lessons scheduled this week.",
        },
        communication: {
          title: "Communication",
          subtitle: "Secure chat with teachers and support.",
          teacherChat: {
            title: "Teacher chat",
            description: "Private thread per lesson.",
          },
          supportTicket: {
            title: "Support ticket",
            description: "Send your requests to the Casaclass team.",
          },
        },
        billing: {
          title: "Payments & billing",
          subtitle: "Subscriptions, PDF invoices, and pack management.",
          activeSubs: {
            title: "Active subscriptions",
            description: "Your current offers appear here.",
          },
          invoices: {
            title: "Downloadable invoices",
            description: "Download your invoices (PDF).",
          },
          renew: {
            title: "Renew / cancel",
            description: "Manage subscription options.",
          },
        },
        profile: {
          title: "Parent profile",
          subtitle: "Contact info and preferred payment method.",
          contact: {
            title: "Contact details",
            description: "Update your personal info.",
          },
          payment: {
            title: "Payment method",
            description: "Add or change payment method.",
          },
          widgets: {
            studentModeLabel: "Mode élève",
            studentModePlaceholder: "Entrer en mode élève",
            notifications: "Notifications",
            weekSubtitle: "Aperçu des cours de cette semaine.",
            noLessons: "Aucun cours.",
            reminders: "Rappels",
            reminderCheckbox: "Marquer comme fait",
            recommended: "Recommandé",
            monthStats: "Statistiques du mois",
            monthStatsHint: "Aperçu",
            children: "Enfants",
            homework: "Devoirs",
            homeworkHint: "Prochains cours à venir.",
          },
          manageChildren: {
            title: "Manage children",
            description: "Add or remove linked children.",
          },
        },
        modal: {
          exitTitle: "Confirm return to parent mode",
          exitBody:
            "For security, enter the parent password before switching back.",
          passwordLabel: "Password",
          passwordError: "Incorrect password. Try again.",
          cancel: "Cancel",
          confirm: "Confirm",
          verifying: "Verifying...",
          backToParent: "Back to parent mode",
          logout: "Log out",
        },
      },
      studentSpace: {
        tag: "Student space",
        title: "Student dashboard — {{name}}",
        subtitle: "Upcoming lessons, progress, messages, and resources.",
        errors: {
          profileLoad: "Could not load student profile.",
        },
        banner: {
          badge: "Star of the day",
          greeting: "Hello, {{name}}",
          hint: "Nice to have you back, get ready and continue your lesson today.",
          imageAlt: "Kids learning",
          stats: {
            courses: "Courses",
            xp: "XP",
            completed: "Completed",
          },
        },
        today: {
          title: "Today's lessons",
          hint: "Fun classes are waiting for you today!",
          empty: "No lessons today. Enjoy a fun break!",
        },
        missions: {
          title: "Your missions",
          hint: "Pick a fun mission and earn stars!",
          mentor: {
            title: "Ask a mentor",
            body: "Get a quick tip for today.",
          },
          challenge: {
            title: "New challenge",
            body: "Start a new lesson and collect XP!",
          },
        },
        classes: {
          title: "Your class",
          hint: "Your classes & friends",
          allTab: "All",
          friends: "{{count}} friends",
          classLabel: "Class: {{name}}",
          empty: "No classes linked.",
        },
        activity: {
          title: "Your activity",
          hint: "A quick look at your progress over the last months.",
        },
        cards: {
          upcoming: { label: "Upcoming lessons", hint: "Scheduled sessions" },
          past: { label: "Past lessons", hint: "Recent records" },
          badges: { label: "Badges", hint: "Visible progress" },
          stars: { label: "Stars", hint: "Motivation" },
        },
        upcoming: {
          title: "Upcoming lessons",
          subtitle: "Join the live room (Zoom/BBB).",
          empty: "No scheduled lessons.",
          join: "Join room",
        },
        past: {
          title: "Past lessons",
          subtitle: "Replays, files, and assessments.",
          empty: "No past lessons.",
          viewResources: "View resources",
        },
        resources: {
          title: "Resources",
          subtitle: "Library by subject with links and videos.",
        },
        messages: {
          title: "Latest messages",
          subtitle: "Exchange with teachers.",
          open: "Open messages",
        },
        feedback: {
          title: "Feedback",
          subtitle: "See grades, comments, and rate the lesson.",
        },
      },
    },
    studentsPage: {
      noAccess: {
        title: "Students management",
        lead: "This page is reserved for parents to manage their children in Casaclass.",
        body: "Your account does not have permissions to manage students. Please return to the dashboard.",
      },
      title: "My children",
      lead: "Add new children, update their info, and track their upcoming lessons from here.",
      leadStudentMode:
        'You can enable "student mode" for any child to switch into their view directly from the parent account.',
      form: {
        newTitle: "Add a new student",
        editTitle: "Update student details",
        firstName: "First name",
        lastName: "Last name",
        dob: "Date of birth",
        password: "Password",
        notes: "Notes",
      },
      placeholders: {
        firstName: "e.g., Yasmine",
        lastName: "e.g., Ben Salah",
        password: "At least 8 characters",
        notes: "Extra information that helps teachers.",
      },
      actions: {
        create: "Add student",
        update: "Update student",
        saving: "Saving",
        cancel: "Cancel",
      },
      list: {
        title: "Children list",
        refresh: "Refresh",
        loading: "Loading students...",
        timetable: "Emploi du temps",
        empty: "No children recorded yet.",
      },
      card: {
        upcoming: "{{count}} upcoming lessons",
        noUpcoming: "No upcoming lessons",
        dob: "Date of birth: {{date}}",
        edit: "Edit",
        enterAs: "Enter as student",
        delete: "Delete",
      },
      confirmDelete: "Do you want to delete this student?",
      feedback: {
        created: "Student added successfully.",
        createdWithLogin: "Student added. Login email: {{email}}",
        updated: "Student updated successfully.",
        deleted: "Student deleted successfully.",
      },
      detail: {
        title: "Details for {{name}}",
        lead: "Review the student profile and their upcoming lessons here.",
        loadingLessons: "Refreshing lessons...",
        activate: "Enable student mode",
        active: "Student mode is active for this account",
        stats: {
          total: "Total lessons",
          completed: "Completed",
          cancelled: "Cancelled",
        },
        info: {
          title: "Student info",
          name: "Name:",
          dob: "Date of birth:",
          notes: "Notes:",
          noNotes: "No notes",
        },
        upcoming: {
          title: "Upcoming lessons",
          time: "Time: {{value}}",
          duration: "Duration: {{value}} minutes",
          teacher: "Teacher: {{value}}",
          empty: "No upcoming lessons for this student.",
        },
      },
      errors: {
        firstNameRequired: "First name is required",
        passwordRequired: "Password is required",
        passwordMin: "Password must contain at least 8 characters",
      },
    },
    aboutPage: {
      hero: {
        label: "Casaclass",
        title: "Our story",
        story: [
          "Since day one our goal has been to let every Tunisian child, at home or abroad, learn in a warm, modern environment that protects their identity.",
          "Education is more than knowledge; it is a bridge across generations and a source of belonging.",
        ],
        illustrationAlt: "Casaclass community illustration",
        highlights: [
          {
            icon: "🌍",
            title: "Connected diaspora",
            description:
              "A Tunisian school that travels with your family everywhere.",
          },
          {
            icon: "🎓",
            title: "Passionate experts",
            description:
              "Certified Tunisian teachers crafting every learning path.",
          },
          {
            icon: "🤝",
            title: "Supportive follow-up",
            description:
              "Placement test, 1:1 coaching, and progress certificates.",
          },
        ],
      },
      mission: {
        label: "Our mission",
        title: "What we stand for",
        description:
          "Blending academic excellence with cultural roots for every Tunisian family.",
        items: [
          {
            title: "Quality access",
            description: "Tailored lessons led by qualified Tunisian teachers.",
          },
          {
            title: "Roots & identity",
            description: "Arabic, Quran, and Hadith to stay connected.",
          },
          {
            title: "Global fit",
            description:
              "Programs aligned with Tunisian and international curricula.",
          },
          {
            title: "Flexible & motivating",
            description:
              "Ramadan, summer, revision packs, and engaging sessions.",
          },
        ],
      },
      resources: {
        label: "Our resources",
        title: "What we provide",
        description:
          "Concrete tools, themed packs, and a team ready to help at any time.",
        items: [
          {
            title: "Specialist team",
            description:
              "Expert teachers across academic and spiritual tracks.",
          },
          {
            title: "Ready-made packs",
            description: "Ramadan packs, school units, continuous support.",
          },
          {
            title: "Full guidance",
            description:
              "Placement test, 1:1 follow-up, assessments, and certificates.",
          },
          {
            title: "Accessible platform",
            description: "Online access from Europe, the Gulf, and Tunisia.",
          },
        ],
      },
      values: {
        label: "Our values",
        title: "Principles we hold",
        description: "Our values guide every educational and human decision.",
        items: [
          {
            title: "Care",
            description: "Learners at the center with warm human follow-up.",
          },
          {
            title: "Excellence",
            description: "Every lesson crafted and peer-reviewed.",
          },
          {
            title: "Authenticity",
            description: "Honoring Tunisian roots and the spiritual dimension.",
          },
          {
            title: "Innovation",
            description:
              "Modern tools, interactive videos, and fun assessments.",
          },
          {
            title: "Equity",
            description: "Education accessible wherever families live.",
          },
        ],
      },
      vision: {
        label: "Our vision",
        title: "Where we are heading",
        description:
          "Pushing Casaclass toward a sustainable model that grows with families.",
        intro:
          "We aim to be the leading Tunisian e-learning reference for kids by building:",
        points: [
          "A community of students, parents, and teachers sharing culture and ambition.",
          "Continuously renewed programs with themed packs and pedagogical innovation.",
          "A scalable, sustainable platform reaching Tunisian families everywhere.",
        ],
      },
      uniques: {
        label: "What makes us different",
        title: "Why Casaclass stands out",
        description:
          "A holistic experience combining rigor, spirituality, and digital innovation.",
        items: [
          {
            title: "Hybrid approach",
            description:
              "Academic and spiritual, plus digital thinking skills.",
          },
          {
            title: "Full personalization",
            description: "Placement test and tailored path for each child.",
          },
          {
            title: "Geographic flexibility",
            description: "Ideal for families in Europe, the Gulf, and Tunisia.",
          },
          {
            title: "Educational commitment",
            description: "Passionate teachers, modern tools, real follow-up.",
          },
        ],
      },
      showcase: {
        label: "In pictures",
        title: "Our vision in snapshots",
        description:
          "Three glimpses of Casaclass: community energy, a guided path, and a platform everywhere.",
        cards: [
          {
            title: "Engaged community",
            description:
              "Families, learners, and mentors progressing together.",
            alt: "Casaclass community",
          },
          {
            title: "Immersive journey",
            description:
              "Clear roadmap, enjoyable activities, steady feedback.",
            alt: "Casaclass learning path",
          },
          {
            title: "Always accessible",
            description: "A simple modern interface on every trip and device.",
            alt: "Casaclass platform",
          },
        ],
      },
      cta: {
        title: "Ready to join the Casaclass community?",
        description:
          "Talk to our team, find the right program for your family, and give your child's learning a boost.",
        primary: "Talk to the team",
        secondary: "Create an account",
      },
    },
    landingPage: {
      subjectsGrid: {
        title: "Subjects",
        description:
          "Discover our programs designed to support your child in every subject, with specialized pedagogical guidance that builds excellence and confidence.",
        cta: "Explore our offers",
        ariaLabel: "Programs",
        managePrograms: "Manage programs",
        items: [],
      },
      hero: {
        title: "With you at every step",
        lead: "Casaclass is a Tunisian learning platform that reaches your home wherever you are. We support your kids in academics, languages, and values so they grow with confidence, identity, and knowledge.",
        primaryCta: "Start now",
        secondaryCta: "Explore our offers",
        videoTitle: "Casaclass hero video",
        statsLabel: "Casaclass impact stats",
        stats: [
          { value: "5,000+", label: "Families accompanied" },
          { value: "230+", label: "Interactive lessons" },
          { value: "45", label: "Tunisian teachers" },
          { value: "4.9/5", label: "Parent satisfaction" },
        ],
      },
      features: {
        tag: "A school for every child",
        title: "Why Casaclass?",
        description:
          "Built to keep our children connected to their language, culture, and values—wherever they live. We blend Tunisian pedagogy with modern tools to deliver motivating learning.",
        cta: "Discover our programs",
        cards: [
          {
            title: "Personal path",
            description: "Placement test, tailored journey, and family support",
            alt: "Student exploring a personalized learning path",
          },
          {
            title: "Live & on-demand",
            description: "Live sessions plus a video library for review",
            alt: "Live learning session on Casaclass",
          },
          {
            title: "Neuro-Pedagogical Support",
            description:
              "Assessment, guidance, and personalized learning paths for excellence",
            alt: "Neuro-pedagogical support illustration",
          },
        ],
      },
      journey: {
        ariaLabel: "Casaclass story with families",
        title: "The story",
        imageAlt: "Family trusting the Casaclass journey",
        paragraphs: [
          "Every brain is unique.",
          "To turn challenges into success through tailored neuro-pedagogical support, we connect your child with top experts in psychology, neuropsychiatry, and education.",
        ],
        cta: "Start the placement test",
      },
      levels: {
        tag: "Let's begin",
        title: "Choose the grade you want to explore",
        description:
          "Each grade combines streamable videos, printable booklets, and goal tracking. Pick the right grade today and start a journey that grows with your child.",
        note: "If the dream is possible, the plan is closer.",
        ariaPrefix: "Explore grade",
        items: [
          {
            grade: "1",
            label: "Grade 1",
            accent: 1,
            ariaLabel: "Explore grade 1",
          },
          {
            grade: "2",
            label: "Grade 2",
            accent: 2,
            ariaLabel: "Explore grade 2",
          },
          {
            grade: "3",
            label: "Grade 3",
            accent: 3,
            ariaLabel: "Explore grade 3",
          },
          {
            grade: "4",
            label: "Grade 4",
            accent: 4,
            ariaLabel: "Explore grade 4",
          },
          {
            grade: "5",
            label: "Grade 5",
            accent: 5,
            ariaLabel: "Explore grade 5",
          },
          {
            grade: "6",
            label: "Grade 6",
            accent: 6,
            ariaLabel: "Explore grade 6",
          },
          {
            grade: "7",
            label: "Grade 7",
            accent: 7,
            ariaLabel: "Explore grade 7",
          },
          {
            grade: "8",
            label: "Grade 8",
            accent: 8,
            ariaLabel: "Explore grade 8",
          },
          {
            grade: "9",
            label: "Grade 9",
            accent: 9,
            ariaLabel: "Explore grade 9",
          },
        ],
      },
      programs: {
        badge: "Casaclass programs",
        title: "Four pillars of Casaclass",
        imageAlt: "Casaclass program pillars illustration",
        items: [
          {
            title: "1. Core academics — Grade 1 to 9",
            list: [
              "Review + exercises + explainer videos",
              "1:1 support with Tunisian teachers",
              "Monthly parent follow-up",
              "Step-by-step learning path",
            ],
            slogan: "Clear learning, guaranteed progress.",
            cta: "Join the teaching program",
            ctaLink: "/signup",
          },
          {
            title: "2. French language",
            list: [
              "Curriculum approved by the Tunisian Ministry",
              "Pronunciation and speaking workshops",
              "Grammar and writing review with live examples",
              "1:1 follow-up and regular assessments",
            ],
            slogan: "A second language—an open door abroad.",
            cta: "Explore French courses",
            ctaLink: "/courses",
          },
          {
            title: "3. Arabic • Quran • Hadith",
            list: [
              "Simplified memorization",
              "Tajweed basics",
              "Sirah & values",
              "Arabic tailored to new generations",
            ],
            cta: "Explore Arabic & Quran courses",
            ctaLink: "/courses",
          },
          {
            title: "4. Kids Coding Club",
            list: [
              "Scratch, Python Kids, robotics",
              "Learning games",
              "Monthly mini-projects",
              "Today’s kids, tomorrow’s coders",
            ],
            slogan: "Learning the future starts now.",
            cta: "Join the coding club",
            ctaLink: "/signup",
          },
        ],
      },
      specialNeeds: {
        ariaLabel: "Support for special needs",
        title: "Your child has specific needs",
        description:
          "There is a place for them here—connected with specialists to help them integrate and progress at their own pace, respecting their needs.",
        imageAlt: "Three pillars of Casaclass programs",
        cta: "Contact us",
      },
      ecosystem: {
        title: "A clear Casaclass universe",
        cta: "Join the Casaclass world",
        cards: [
          {
            icon: "👨‍👩‍👦",
            title: "Parent space",
            items: [
              "Progress tracking",
              "Weekly report",
              "Choose teacher/group",
            ],
            alt: "Parent dashboard inside Casaclass",
          },
          {
            icon: "👦",
            title: "Student space",
            items: ["Homework", "Short lessons", "Badges and rewards"],
            alt: "Student dashboard inside Casaclass",
          },
          {
            icon: "👩‍🏫",
            title: "Teacher space",
            items: ["Dashboard", "Planning", "Assessments"],
            alt: "Teacher dashboard inside Casaclass",
          },
        ],
      },
      ramadan: {
        ariaLabel: "Ramadan packs for kids",
        badge: "Packs & Ramadan for kids",
        title: "Ramadan packs",
        lead: "30 value-packed videos, Quran, stories, and character-building for kids 5–12 so Ramadan is filled with light, identity, and wonder.",
        items: [
          "Daily programming inspired by Ramadan",
          "Illustrated stories and value exercises for each day",
          "Simple Quran sessions with clear tajweed",
          "Family activities to strengthen bonds",
        ],
        slogan: "Light, learning, and guidance.",
        cta: "Coming soon",
        imageAlt: "Casaclass teacher guiding kids through Ramadan program",
      },
      testimonials: {
        ariaLabel: "Casaclass community testimonials",
        tag: "Stories from our community",
        title: "Families and teachers trust us",
        lead: "From parents abroad to teachers in Tunisia, the platform gathers inspiring kids and supports them step by step.",
        prev: "Previous testimonial",
        next: "Next testimonial",
        dotsLabel: "Navigate testimonials",
        dotLabel: "Show testimonial {{name}}",
        imageAlt: "Parent: {{name}}",
        items: [
          {
            quote:
              "Since we started with Casaclass, revision became a happy part of our family routine. My daughter loves the clear path and digital rewards, and I track progress calmly from the parent dashboard.",
            name: "Amel Ben Salem",
            place: "Lyon, France",
          },
          {
            quote:
              "We live in Dubai and time zones made Tunisian lessons hard to find. With Casaclass we join live sessions or watch replays when it suits the family, and the kids connect with teachers as if they were in Tunisia.",
            name: "Rami & Sirine",
            place: "Dubai, UAE",
          },
          {
            quote:
              "My son struggles to focus; the learning coach gave us a clear plan. We get weekly reports and tips, and now he is excited and talks about Arabic and Quran classes on his own.",
            name: "Laila Marzouki",
            place: "Toronto, Canada",
          },
        ],
      },
      faq: {
        ariaLabel: "Casaclass frequently asked questions",
        tag: "FAQ",
        title: "Your questions",
        lead: "We stay close from day one until we celebrate your child's milestones.",
        items: [
          {
            question: "How long do we keep access to resources?",
            answer:
              "Each subscription opens all units for 12 months with free updates every term.",
          },
          {
            question: "Are the lessons suited for families abroad?",
            answer:
              "Yes. Content is bilingual (Arabic/French) and follows the Tunisian program with flexibility for time zones.",
          },
          {
            question: "Is there personal follow-up?",
            answer:
              "From registration you get a learning coach with monthly check-ins and tailored tips for your family.",
          },
          {
            question: "How do I get started?",
            answer:
              "Create an account, choose your child's grade, and start immediately with the placement quiz and first lessons.",
          },
        ],
      },
      finalCta: {
        ariaLabel: "Join Casaclass",
        label: "Ready?",
        title: "Activate the first lesson today",
        description: "Fast signup + free trial session",
        primary: "Sign up now",
        secondary: "Talk to an advisor",
      },
    },
    adminPage: {
      accessDenied: "Access is restricted to admins.",
      headerTag: "Unified admin console",
      headerTitle: "Admin dashboard",
      dashboard: {
        welcome: "Welcome back!",
        viewAll: "View all",
        manageTitle: "Manage",
        manageColumns: {
          section: "Section",
          count: "Count",
          open: "Open",
        },
        cards: {
          newStudents: "New students",
          newStudentsHint: "This period",
          totalStudents: "Total students",
          totalStudentsHint: "All students",
          dailyAttend: "Daily attend",
          dailyAttendHint: "Last 7 days",
          averageAttend: "Average attend",
          averageAttendHint: "This month",
        },
        activityTitle: "Student activity",
        thisMonth: "This month",
        lastMonths: "Last month",
        examsTitle: "Exams",
        examsFallback: "Exams attend",
        studentsTitle: "Students list",
        studentsColumns: {
          id: "ID",
          student: "Student",
          parent: "Parent",
          attends: "Attends",
        },
        teachersTitle: "Teachers",
        teacherVerified: "Verified",
        teacherPending: "Pending",
        empty: "No data yet.",
      },
      tabs: {
        overview: "Overview",
        users: "Users",
        students: "Students",
        lessons: "Lessons & schedule",
        timetable: "Timetable",
        pendingTeachers: "Pending teacher verifications",
        classes: "Classes",
        packs: "Packs",
        teachers: "Teachers",
        payments: "Payments",
        support: "Support",
      },
      teachers: {
        title: "Teachers",
        empty: "No teachers to display.",
        resume: "Download resume",
        activeYes: "Yes",
        activeNo: "No",
        filter: {
          label: "Filter by status",
          all: "All",
          pending: "Pending",
          verified: "Verified",
        },
        status: {
          verified: "Verified",
          pending: "Pending",
        },
        fields: {
          email: "Email",
          phone: "Phone",
          active: "Active",
          joined: "Joined",
        },
      },
      actions: {
        save: "Save",
        saving: "Saving…",
        create: "Create",
        cancel: "Cancel",
        edit: "Edit",
        delete: "Delete",
      },
      timetable: {
        calendarTitle: "Calendar",
        addEvent: "Add event",
        configure: "Configure",
        previousDay: "Previous day",
        nextDay: "Next day",
        scopeTeacher: "Teacher",
        scopeClass: "Class",
        scopeStudent: "Student",
        allTeachers: "All teachers",
        allClasses: "All classes",
        allStudents: "All students",
        viewWeek: "Week",
        viewDay: "Day",
        faculty: "Faculty",
        searchFacultyPlaceholder: "Search faculty...",
        editLessonTitle: "Edit lesson",
        newLessonTitle: "New lesson",
        selectPlaceholder: "Select…",
        lessonTitlePlaceholder: "Lesson title",
        minutesShort: "min",
        permanentWeekly: "Permanent weekly",
        fields: {
          teacher: "Teacher",
          class: "Class",
          students: "Students",
          assignTo: "Assign to",
          student: "Student",
          title: "Title",
          start: "Start",
          duration: "Duration",
          status: "Status",
        },
        assignModes: {
          student: "Student",
          class: "Class",
        },
      },
      classes: {
        panelTitleEdit: "Edit class",
        panelTitleCreate: "Create class",
        classNamePlaceholder: "Class name",
        fields: {
          name: "Name",
          students: "Students",
        },
        errors: {
          nameRequired: "Name is required",
        },
        confirmDelete: "Delete this class?",
        table: {
          class: "Class",
          teacher: "Teacher",
          students: "Students",
          actions: "Actions",
        },
      },
      loading: "Loading data...",
      stats: {
        activeStudents: "Active students",
        monthlyRevenue: "Monthly revenue",
        satisfaction: "Satisfaction rate",
        outOfFive: "of 5",
        supportMessages: "Support messages",
        teachers: "Teachers",
        unread: "unread",
      },
      roles: {
        superadmin: "Super admin",
        admin: "Admin",
        support: "Support",
        accounting: "Accounting",
        teacher: "Teacher",
        parent: "Parent",
      },
      users: {
        title: "User management",
        filter: "Filter by role",
        filterAll: "All",
        columns: {
          email: "Email",
          name: "Name",
          role: "Role",
          phone: "Phone",
          joined: "Joined",
          verify: "Teacher verification",
          active: "Active",
          actions: "Actions",
        },
        verify: "Verify",
        unverify: "Unverify",
        toggleActiveAria: "Enable or disable user",
        deleteConfirm: "Do you want to delete this user?",
        delete: "Delete",
      },
      students: {
        title: "Students",
        ageYears: "years",
        parent: "Parent",
        dob: "Date of birth",
      },
      lessons: {
        title: "Lessons & schedule",
        idLabel: "ID",
        student: "Student",
        teacher: "Teacher",
        duration: "Duration",
        minutes: "minutes",
        status: {
          scheduled: "Scheduled",
          completed: "Completed",
          cancelled: "Cancelled",
        },
      },
      packs: {
        formEdit: "Edit pack",
        formNew: "New pack",
        fields: {
          name: "Pack name",
          description: "Description",
          subject: "Subject",
          subjectPlaceholder: "Choose...",
          price: "Price",
          currency: "Currency",
          lessons: "Sessions count",
          sessionLength: "Session length (minutes)",
          resources: "Resources (one URL per line)",
          image: "Image (optional)",
          recommended: "Recommended for",
          gradientColors: "Gradient colors",
          gradientStart: "Gradient start color",
          gradientEnd: "Gradient end color",
          featured: "Show on homepage",
          offersSection: "Offers section",
          offersSectionNone: "None",
          offersKind: "Offers kind",
          offersDisplayOrder: "Offers display order",
          offersAccent: "Offers accent",
          offersCategoryKey: "Offers category",
          offersTitleKey: "Offers title",
          offersSubtitleKey: "Offers subtitle",
          offersDescriptionKey: "Offers description",
          offersPriceKey: "Offers price",
          offersBillingKey: "Offers billing",
          offersFeaturesKey: "Offers features",
          offersCtaKey: "Offers CTA",
          offersCtaLink: "Offers CTA link",
          offersBadgeKey: "Offers badge",
          offersNoteKey: "Offers note",
          offersPointsKey: "Offers points",
        },
        placeholderResources: "https://.../video.mp4\nhttps://.../document.pdf",
        placeholders: {
          name: "Example: Arabic language pack",
          description: "Example: Weekly sessions with a teacher",
          price: "Example: 120",
          lessons: "Example: 6",
          sessionLength: "Example: 60",
          image: "Example: https://example.com/image.png",
          recommended: "Example: Middle school students",
          offersKey: "Example: offers.languages.arabic.title",
          offersLink: "Example: /contact",
        },
        actions: {
          saving: "Saving...",
          save: "Save",
          reset: "Reset",
        },
        listTitle: "Current packs",
        sessions: "sessions",
        minutesPerSession: "min/session",
        resourcesCount: "resources",
        badgeFeatured: "Featured",
        edit: "Edit",
        delete: "Delete",
        deleteConfirm: "Delete this pack?",
        errorMissingNameSubject: "Please enter a pack name and subject.",
        detailsTitle: "Pack details",
        errorPackNotFound: "Could not find this pack.",
      },
      payments: {
        title: "Payments",
        columns: {
          user: "User",
          pack: "Pack",
          amount: "Amount",
          status: "Status",
        },
        statuses: {
          pending: "Pending",
          completed: "Completed",
          failed: "Failed",
          refunded: "Refunded",
        },
      },
      support: {
        title: "Support messages",
        from: "From",
        read: "Read",
        new: "New",
        type: "Type",
        markRead: "Mark as read",
        reply: "Reply",
        replyTitle: "New message",
        replyClose: "Close",
        replyTo: "To",
        replySubject: "Subject",
        replyMessage: "Message",
        replySend: "Send",
        replySending: "Sending...",
        replyEmpty: "Please write a message before sending.",
        replySubjectFallback: "Re: Contact message",
      },
    },
  },
  fr: {
    meta: { name: "Français", dir: "ltr" },
    testsModule: testsModuleFr,
    common: { id: "ID" },
    nav: {
      home: "Accueil",
      courses: "Offres",
      about: "À propos",
      contact: "Contact",
      searchLabel: "Rechercher dans Casaclass",
      searchPlaceholder: "Cherchez un cours ou une ressource",
      menuLabel: "Menu",
      languageLabel: "Langue",
    },
    auth: {
      login: "Connexion",
      signup: "Créer un compte",
    },
    protectedRoute: {
      loading: "Vérification de votre compte...",
    },
    footer: {
      title: "Casaclass",
      description: "Votre plateforme d'apprentissage pour réussir sereinement.",
      quickLinks: "Liens rapides",
      home: "Accueil",
      courses: "Cours",
      about: "À propos",
      contact: "Contact",
      email: "contact@casaclassroom.com",
      phone: "+216 55 544 475",
      copyright: "Tous droits réservés.",
    },
    sidebar: {
      close: "Fermer",
      toggle: "Afficher/masquer le menu",
      role: {
        admin: "Administrateur",
        superadmin: "Super administrateur",
        support: "Support",
        accounting: "Comptabilité",
        teacher: "Enseignant",
        parent: "Parent",
        student: "Élève",
        user: "Utilisateur",
      },
      links: {
        dashboard: "Tableau de bord",
        programs: "Programmes",
        lessons: "Cours",
        timetable: "Emploi du temps",
        resources: "Ressources",
        tests: "Tests",
        homeworks: "Devoirs",
        offers: "Offres",
        contact: "Support",
        gradientStart: "Couleur de départ du dégradé",
        gradientEnd: "Couleur de fin du dégradé",
        profile: "Mon compte",
        admin: "Console admin",
        students: "Élèves",
        newLesson: "Nouveau cours",
        myStudents: "Mes élèves",
        myChildren: "Mes enfants",
        myLessons: "Mes cours",
      },
      logout: "Se déconnecter",
    },
    studentShell: {
      shortcutsLabel: "Raccourcis élève",
      mainNavLabel: "Navigation principale élève",
    },
    comingSoon: {
      badge: "Bientôt",
      defaultTitle: "Page en préparation",
      levelTitle: "Niveau {{level}}",
      defaultDescription:
        "La page que vous cherchez est en cours de construction.",
      levelDescription:
        "Nous préparons le contenu du niveau {{level}} — bientôt disponible.",
      pathNotReady: "Le chemin {{path}} n'est pas encore disponible.",
      backHome: "Retour à l'accueil",
      contactUs: "Nous contacter",
      notFoundTitle: "Page indisponible",
      notFoundMessage:
        "La page recherchée n'existe pas ou est en cours de préparation.",
    },
    contactPage: {
      status: {
        loading: "Envoi de votre message...",
        success: "Message envoyé ! Nous revenons vers vous rapidement.",
        error: "Impossible d'envoyer le message. Réessayez.",
      },
      hero: {
        label: "Contactez-nous",
        title: "Planifions une expérience d'apprentissage inspirante",
        lead: "Partagez vos besoins et nous concevrons un parcours adapté à votre famille. Notre équipe vous accompagne à chaque étape.",
      },
      form: {
        cardTitle: "Contact direct",
        cardSubtitle:
          "Remplissez le formulaire ci-dessous et nous vous répondrons sous un jour ouvré.",
        fullNameLabel: "Nom complet",
        fullNamePlaceholder: "Entrez votre nom",
        emailLabel: "E-mail",
        emailPlaceholder: "example@mail.com",
        phoneLabel: "Numéro de téléphone",
        phonePlaceholder: "Entrez votre numéro de téléphone",
        subjectLabel: "Sujet du message",
        subjectPlaceholder: "Ajoutez un sujet court",
        messageLabel: "Comment pouvons-nous vous aider ?",
        messagePlaceholder:
          "Décrivez votre besoin pour que nous proposions la meilleure solution",
        submit: "Envoyer le message",
        submitting: "Envoi...",
        phoneAppend: "Numéro de téléphone : {{phone}}",
      },
      calendly: {
        title: "Réserver une consultation",
        subtitle:
          "Choisissez le créneau qui vous convient pour échanger avec notre équipe.",
      },
    },
    errors: {
      adminRequired: "Cette action nécessite un compte administrateur.",
      authRequired: "Vous devez être connecté pour effectuer cette action.",
      operationFailed: "Impossible de réaliser l'opération.",
      fetchFailed: "Impossible de récupérer les données. Réessayez.",
      lessonIdRequired: "L'identifiant du cours est requis.",
    },
    lessons: {
      title: "Cours",
      subtitleStudent: "Cours de l'élève actif",
      subtitleStaff:
        "Tous les cours liés à votre compte avec filtres et suivi.",
      newLesson: "Nouveau cours",
      searchLabel: "Rechercher un cours",
      searchPlaceholder: "Titre, élève, enseignant",
      statusFilter: "Filtrer par statut",
      refresh: "Rafraîchir la liste",
      loading: "Chargement des cours...",
      empty: "Aucun cours ne correspond à la vue actuelle.",
      emptyCta: "Créer le premier cours",
      error: "Erreur lors du chargement des cours : ",
      deleteConfirm: "Confirmer la suppression de ce cours ?",
      student: "Élève",
      teacher: "Enseignant",
      pack: "Pack",
      duration: "Durée",
      minutes: "min",
      viewDetails: "Voir les détails",
      joinMeeting: "Rejoindre la réunion",
      joinMeetingSoon: "Disponible 2 h avant",
      generateMeeting: "Créer le lien de réunion",
      generatingMeeting: "Création en cours...",
      edit: "Modifier",
      delete: "Supprimer",
      statusScheduled: "Planifié",
      statusCompleted: "Terminé",
      statusCancelled: "Annulé",
      filterAll: "Tous les statuts",
      filterScheduled: "À venir",
      filterCompleted: "Terminés",
      filterCancelled: "Annulés",
      timetable: {
        days: "Jours",
        item: "élément",
        items: "éléments",
        noLessonsForWeek: "Aucune leçon cette semaine",
        selectChild: "Sélectionner un enfant",
        previousWeek: "Semaine précédente",
        nextWeek: "Semaine suivante",
        today: "Aujourd’hui",
        classLabel: "Classe :",
        month: "Mois",
        week: "Semaine",
        yourWeeklyTimetable: "Votre emploi du temps hebdomadaire",
      },
    },
    programDetails: {
      loading: "Chargement...",
      eyebrow: "Programmes",
      notFound: {
        title: "Programme introuvable",
        hint: "Choisissez un programme dans la liste ou créez-en un nouveau.",
      },
      actions: {
        backToDashboard: "Retour au tableau de bord",
        backToHome: "Retour à l'accueil",
        newProgram: "Nouveau programme",
        addLevel: "Ajouter un niveau",
      },
      sidebar: {
        allPrograms: "Tous les programmes",
        editTitle: "Modifier",
        editAction: "Modifier",
      },
      sections: {
        overview: "Aperçu",
        learning: "Ce que les élèves apprendront",
        morePrograms: "Plus de programmes",
        levels: { single: "Niveau", plural: "Niveaux" },
      },
      levels: {
        pickFirst: "Choisissez d'abord un niveau pour voir ses détails.",
        chooseLevel: "Choisir un niveau",
        levelTitle: "Niveau {{grade}}",
        levelImageAlt: "Image du niveau {{grade}}",
      },
      cta: { enrollNow: "S'inscrire maintenant" },
      editor: {
        title: "Modifier le programme",
        delete: "Supprimer",
        save: "Enregistrer",
        cancel: "Annuler",
      },
      fields: {
        accentColor: "Couleur d'accent",
        icon: "Icône",
        custom: "Personnalisé",
        assignedTeacher: "Enseignant assigné",
        unassigned: "Non attribué",
        teacherFallback: "Enseignant",
        title: "Titre",
        shortDescription: "Description courte",
        details: "Détails",
        keyPoints: "Points clés",
        levels: "Niveaux",
        previewLevelsPage: "Prévisualiser la page des niveaux",
        levelRowTitle: "Niveau {{index}}",
        remove: "Retirer",
        grade: "Niveau",
        label: "Libellé",
        description: "Description",
        uploadImage: "Téléverser une image",
        uploading: "Téléversement…",
        chooseFile: "Choisir un fichier",
        removeImage: "Supprimer l'image",
        imageUrl: "URL de l'image",
        ctaLabel: "Libellé du bouton",
        ctaLink: "Lien du bouton",
        displayOrder: "Ordre d'affichage",
        active: "Actif",
      },
      placeholders: { grade: "ex. 1", levelName: "Nom du niveau" },
      errors: {
        unauthorized: "Non autorisé",
        uploadFailed: "Échec du téléversement",
        levelsRequireGrade:
          "Veuillez renseigner l'identifiant/niveau pour tous les niveaux avant d'enregistrer",
        titleRequired: "Le titre est requis",
      },
      confirm: {
        deleteProgram:
          "Supprimer ce programme ? Cette action est irréversible.",
      },
      draft: { title: "Nouveau programme" },
      icons: {
        reading: "Lecture",
        graduation: "Diplôme",
        math: "Mathématiques",
        science: "Science",
        language: "Langues",
        coding: "Programmation",
        islamicStudies: "Études islamiques",
        atom: "Atome",
        design: "Design",
        writing: "Écriture",
        globe: "Globe",
        star: "Étoile",
        bookLegacy: "Livre (ancien)",
        scienceLegacy: "Science (ancien)",
      },
    },
    programLevelSelect: {
      title: "Choisir un niveau",
      subtitle: {
        forProgram: "Pour le programme : {{title}}",
        continue: "Puis continuez vers les détails du programme.",
      },
      actions: { backToHome: "Retour à l'accueil" },
      states: {
        noLevels: "Aucun niveau disponible pour ce programme pour le moment.",
      },
    },
    lessonDetail: {
      idLabel: "ID du cours",
      backToList: "Retour à la liste",
      edit: "Modifier le cours",
      delete: "Supprimer le cours",
      deleteConfirm: "Supprimer définitivement ce cours ?",
      loading: "Chargement des détails du cours...",
      error: "Impossible de charger le cours : ",
      notFound: "Cours introuvable.",
      scheduledAt: "Date et heure du cours",
      description: "Description du cours",
      student: "Élève",
      teacher: "Enseignant",
      duration: "Durée du cours",
      minutes: "minutes",
      createdAt: "Créé le",
      updatedAt: "Mis à jour",
      packInfo: "Détails du pack",
      pack: "Pack",
      subject: "Matière",
      price: "Prix",
      partOfPack: "Fait partie du pack",
      meetingStatus: "Lien de réunion",
      meetingReady: "Prêt",
      meetingPending: "Pas encore créé",
      joinMeeting: "Rejoindre la réunion",
      generateMeeting: "Créer le lien de réunion",
      generatingMeeting: "Création en cours...",
      notifyParentsTitle: "Notifier les parents",
      notifyParentsStatus: "Statut",
      notifyParentsMessage: "Message",
      notifyParentsSend: "Envoyer",
      notifyParentsSending: "Envoi...",
      notifyParentsSuccess: "Notification envoyée.",
      notifyParentsSuccessCount: "Notification envoyée à {{count}} parents.",
    },
    lessonEditor: {
      accessDenied: "Ce compte ne peut pas créer ou modifier des cours.",
      backToList: "Retour à la liste des cours",
      loading: "Préparation du formulaire du cours...",
      loadError: "Impossible de charger le cours",
      title: { edit: "Modifier le cours", create: "Créer un nouveau cours" },
      note: {
        edit: "Mettez à jour les détails, l'horaire ou l'état du cours.",
        create:
          "Saisissez les détails du prochain cours et associez le bon élève.",
      },
      genericError: "Une erreur s'est produite lors du chargement",
      form: {
        title: "Titre du cours",
        description: "Description",
        scheduledAt: "Horaire du cours",
        duration: "Durée du cours (minutes)",
        status: "Statut du cours",
        classGroup: "Classe",
        allStudents: "Tous les élèves",
        students: "Élèves",
        student: "Élève",
        teacher: "ID enseignant (admins)",
        allowParentJoinMeeting: "Autoriser le parent à rejoindre la réunion",
        pack: "Pack associé (optionnel)",
        image: "URL de l'image (optionnel)",
      },
      placeholders: {
        title: "Ex : Révision maths – décimaux",
        description: "Notes sur les objectifs, ressources ou consignes",
        student: "Entrez l'ID élève ou choisissez dans la liste",
        teacher: "Entrez l'ID de l'enseignant responsable",
        noPack: "Aucun pack spécifique",
        image: "https://",
      },
      help: {
        scheduledAt:
          "L'horaire est enregistré dans votre fuseau local et converti en UTC.",
        student:
          "Les IDs élèves apparaissent ici. Les parents voient tous leurs enfants, les enseignants voient leurs élèves précédents.",
        teacher:
          "Ce numéro doit appartenir à un utilisateur avec le rôle Enseignant.",
        allowParentJoinMeeting:
          "Si désactivé, le parent ne verra pas le lien de réunion.",
        classCreatesLessons:
          "Choisir une classe créera une leçon par élève dans cette classe.",
        classStudents: "Élèves de la classe",
      },
      status: {
        scheduled: "Planifié",
        completed: "Terminé",
        cancelled: "Annulé",
      },
      errors: {
        title: "Veuillez saisir un titre de cours.",
        schedule: "Veuillez choisir une date et une heure valides.",
        student: "ID élève invalide. Utilisez l'identifiant numérique.",
        duration: "La durée doit être un nombre positif.",
        teacher: "ID enseignant invalide.",
        noStudentsInClass: "Cette classe n’a pas d’élèves",
      },
      actions: {
        saving: "Enregistrement...",
        update: "Mettre à jour le cours",
        save: "Enregistrer le cours",
        cancel: "Annuler et revenir",
      },
    },
    teacherPublicProfile: {
      avatarAlt: "Avatar",
      actions: {
        back: "Retour",
        follow: "Suivre",
        chat: "Discuter",
        viewProfile: "Voir",
      },
      sections: {
        about: "À propos",
        experience: "Expérience",
        education: "Éducation",
        skills: "Compétences",
        teachers: "Enseignants",
      },
      labels: {
        noInfo: "Aucune information pour le moment",
        defaultHeadline: "Enseignant Casaclass",
        since: "Depuis",
        verified: "Vérifié",
        teacher: "Enseignant",
      },
      states: {
        loading: "Chargement...",
        notFound: "Enseignant introuvable.",
        loadError: "Impossible de charger le profil enseignant.",
      },
      tooltips: { comingSoon: "Bientôt" },
    },
    profile: {
      roles: {
        adminFull: "Administrateur de la plateforme",
        teacherFull: "Enseignant Casaclass",
        parentFull: "Parent",
        studentFull: "Élève",
        adminShort: "Admin",
        teacherShort: "Enseignant",
        parentShort: "Parent",
      },
      common: {
        loadingData: "Chargement...",
        idLabel: "ID : {{id}}",
        dobLabel: "Date de naissance : {{date}}",
        unknown: "Inconnu",
      },
      messages: {
        profileUpdated: "Vos informations ont été mises à jour avec succès.",
        avatarUpdated: "Votre photo de profil a été mise à jour avec succès.",
      },
      actions: {
        saving: "Enregistrement...",
        saveChanges: "Enregistrer les modifications",
        cancelEdit: "Annuler la modification",
        edit: "Modifier",
        delete: "Supprimer",
        refresh: "Rafraîchir",
      },
      overview: {
        aboutTitle: "À propos",
        aboutTextStudent: "Ceci est le profil de l'élève lié au mode Élève.",
        aboutTextUser:
          "Gérez ici les informations principales du compte et mettez à jour le nom affiché sur la plateforme.",
        uploadingPhoto: "Téléversement de la photo...",
        changePhoto: "Changer la photo",
        upcomingLessons: "Prochains cours",
        noUpcomingLessons: "Aucun cours à venir.",
      },
      progress: {
        title: "Progression du profil",
        subtitle: "Complétez vos informations pour améliorer l'expérience.",
        completeProfile: "Compléter le profil",
      },
      studentDetails: {
        title: "Détails de l'élève",
        notFound: "Impossible de trouver l'élève.",
      },
      personal: {
        title: "Informations personnelles",
        subtitleStudent: "Informations de l'élève en mode Élève.",
        subtitleUser: "Mettez à jour le nom affiché sur la plateforme.",
        edit: "Modifier",
        accountDetailsAria: "Détails du compte",
      },
      fields: {
        firstName: "Prénom",
        lastName: "Nom",
        phone: "Numéro de téléphone",
        role: "Rôle",
        email: "E-mail",
        dob: "Date de naissance",
        completion: "Complétude du profil",
        status: "Statut",
        notes: "Notes",
      },
      placeholders: {
        firstName: "ex. Ahmed",
        lastName: "ex. Ben Mahmoud",
        phone: "ex. +216 55 544 475",
      },
      students: {
        title: "Mes enfants",
        subtitle:
          "Ajoutez des enfants ou mettez leurs informations à jour pour faciliter la planification des cours.",
        placeholders: {
          firstName: "ex. Ali",
          lastName: "ex. Ben Salem",
          notes: "Infos supplémentaires utiles à l'équipe Casaclass",
        },
        actions: {
          add: "Ajouter un élève",
          update: "Mettre à jour l'élève",
        },
        loading: "Chargement des élèves...",
        empty: "Aucun enfant n'a encore été ajouté.",
        errors: {
          firstNameRequired: "Le prénom est obligatoire",
        },
        confirmDelete: "Voulez-vous supprimer cet élève ?",
      },
      classes: {
        title: "Mes classes",
        subtitle:
          "Créez une classe avec un ou plusieurs élèves pour organiser les cours.",
        fields: {
          name: "Nom de la classe",
          students: "Élèves",
        },
        placeholders: {
          name: "ex. Classe de maths",
        },
        actions: {
          add: "Ajouter une classe",
          update: "Mettre à jour la classe",
        },
        loading: "Chargement des classes...",
        empty: "Aucune classe n'a encore été créée.",
        emptyRoster: "Aucun élève n'est encore lié à vos cours.",
        studentsCount: "Élèves : {{count}}",
        noStudentsSelected: "Aucun élève sélectionné.",
        errors: {
          nameRequired: "Le nom de la classe est obligatoire",
        },
        confirmDelete: "Voulez-vous supprimer cette classe ?",
      },
      lessons: {
        title: "Suivi des cours",
        subtitle: "Un aperçu de vos cours et des prochaines échéances.",
        stats: {
          total: "Total des cours",
          completed: "Terminés",
          cancelled: "Annulés",
        },
        labels: {
          scheduledAt: "Date : {{datetime}}",
          student: "Élève : {{name}}",
          duration: "Durée : {{minutes}} min",
        },
        empty: "Aucun cours enregistré pour le moment.",
      },
      users: {
        title: "Gestion des utilisateurs",
        subtitle:
          "Consultez les comptes enregistrés et modifiez les rôles si nécessaire.",
        filters: {
          role: "Filtrer par rôle",
          allRoles: "Tous les rôles",
          search: "Rechercher par e-mail ou nom",
        },
        placeholders: {
          search: "example@casaclass.com",
        },
        actions: {
          search: "Rechercher",
          reset: "Réinitialiser",
        },
        loading: "Chargement des utilisateurs...",
        summary:
          "Résultats : {{total}} — Admins : {{admins}}, Enseignants : {{teachers}}, Parents : {{parents}}",
        empty: "Aucun compte ne correspond à votre recherche.",
        table: {
          email: "E-mail",
          name: "Nom",
          role: "Rôle",
          status: "Statut",
        },
      },
    },
    studentsPage: {
      noAccess: {
        title: "Gestion des enfants",
        lead: "Cette page est réservée aux parents pour gérer leurs enfants sur Casaclass.",
        body: "Votre compte n'a pas les droits pour gérer les élèves. Retournez au tableau de bord.",
      },
      title: "Mes enfants",
      lead: "Ajoutez des enfants, mettez leurs informations à jour et suivez leurs prochaines leçons.",
      leadStudentMode:
        "Vous pouvez activer le \"mode élève\" pour basculer vers l'espace d'un enfant depuis le compte parent.",
      form: {
        newTitle: "Ajouter un nouvel élève",
        editTitle: "Mettre à jour l'élève",
        firstName: "Prénom",
        lastName: "Nom",
        dob: "Date de naissance",
        password: "Mot de passe",
        notes: "Notes",
      },
      placeholders: {
        firstName: "ex. Yasmine",
        lastName: "ex. Ben Salah",
        password: "Au moins 8 caractères",
        notes: "Infos supplémentaires utiles aux enseignants.",
      },
      actions: {
        create: "Ajouter l'élève",
        update: "Mettre à jour",
        saving: "En cours...",
        cancel: "Annuler",
      },
      list: {
        title: "Liste des enfants",
        refresh: "Rafraîchir",
        loading: "Chargement des élèves...",
        timetable: "Stundenplan",
        empty: "Aucun enfant enregistré pour l'instant.",
      },
      card: {
        upcoming: "{{count}} leçons à venir",
        noUpcoming: "Aucune leçon à venir",
        dob: "Date de naissance : {{date}}",
        edit: "Modifier",
        enterAs: "Ouvrir en élève",
        delete: "Supprimer",
      },
      confirmDelete: "Voulez-vous supprimer cet élève ?",
      feedback: {
        created: "Élève ajouté avec succès.",
        createdWithLogin: "Élève ajouté. Email de connexion : {{email}}",
        updated: "Élève mis à jour.",
        deleted: "Élève supprimé.",
      },
      detail: {
        title: "Détails pour {{name}}",
        lead: "Consultez le profil de l'élève et ses prochaines leçons ici.",
        loadingLessons: "Mise à jour des leçons...",
        activate: "Activer le mode élève",
        active: "Mode élève actif pour ce compte",
        stats: {
          total: "Total des leçons",
          completed: "Terminées",
          cancelled: "Annulées",
        },
        info: {
          title: "Infos élève",
          name: "Nom :",
          dob: "Date de naissance :",
          notes: "Notes :",
          noNotes: "Aucune note",
        },
        upcoming: {
          title: "Leçons à venir",
          time: "Heure : {{value}}",
          duration: "Durée : {{value}} minutes",
          teacher: "Enseignant : {{value}}",
          empty: "Aucune leçon à venir pour cet élève.",
        },
      },
      errors: {
        firstNameRequired: "Le prénom est requis",
        passwordRequired: "Le mot de passe est requis",
        passwordMin: "Le mot de passe doit contenir au moins 8 caractères",
      },
    },
    aboutPage: {
      hero: {
        label: "Casaclass",
        title: "Notre histoire",
        story: [
          "Depuis le premier jour, nous voulons offrir à chaque enfant tunisien, en Tunisie ou à l'étranger, un espace chaleureux et moderne qui protège son identité.",
          "L'éducation est plus qu'un savoir ; c'est un lien entre les générations et une source d'appartenance.",
        ],
        sections: {
          main: "Menu principal",
          management: "Gestion académique",
          other: "Autre",
        },
        illustrationAlt: "Illustration de la communauté Casaclass",
        highlights: [
          {
            icon: "🌍",
            title: "Diaspora connectée",
            description: "Une école tunisienne qui voyage avec votre famille.",
          },
          {
            icon: "🎓",
            title: "Experts passionnés",
            description:
              "Des enseignants certifiés qui conçoivent chaque parcours.",
          },
          {
            icon: "🤝",
            title: "Suivi bienveillant",
            description:
              "Test de niveau, accompagnement individuel et attestations.",
          },
        ],
      },
      mission: {
        label: "Notre mission",
        title: "Ce que nous défendons",
        description:
          "Allier excellence académique et racines culturelles pour chaque famille tunisienne.",
        items: [
          {
            title: "Accès de qualité",
            description:
              "Cours adaptés animés par des enseignants tunisiens qualifiés.",
          },
          {
            title: "Racines & identité",
            description: "Arabe, Coran et Hadith pour rester connectés.",
          },
          {
            title: "Ouverture mondiale",
            description:
              "Programmes alignés sur les référentiels tunisien et internationaux.",
          },
          {
            title: "Flexible & motivant",
            description:
              "Packs Ramadan, été, révisions et séances engageantes.",
          },
        ],
      },
      resources: {
        label: "Nos ressources",
        title: "Ce que nous apportons",
        description:
          "Des outils concrets, des packs thématiques et une équipe toujours disponible.",
        items: [
          {
            title: "Équipe spécialisée",
            description:
              "Des enseignants experts sur les axes académique et spirituel.",
          },
          {
            title: "Packs prêts",
            description: "Packs Ramadan, unités scolaires, soutien continu.",
          },
          {
            title: "Accompagnement complet",
            description:
              "Test de positionnement, suivi individuel, évaluations et attestations.",
          },
          {
            title: "Plateforme accessible",
            description:
              "Accès en ligne depuis l'Europe, le Golfe et la Tunisie.",
          },
        ],
      },
      values: {
        label: "Nos valeurs",
        title: "Principes qui nous guident",
        description:
          "Nos valeurs orientent chaque décision éducative et humaine.",
        items: [
          {
            title: "Bienveillance",
            description:
              "L'apprenant au centre avec un suivi humain chaleureux.",
          },
          {
            title: "Excellence",
            description: "Chaque séance est conçue et relue avec exigence.",
          },
          {
            title: "Authenticité",
            description:
              "Respect des racines tunisiennes et de la dimension spirituelle.",
          },
          {
            title: "Innovation",
            description:
              "Outils modernes, vidéos interactives et évaluations ludiques.",
          },
          {
            title: "Équité",
            description: "Une éducation accessible où que vivent les familles.",
          },
        ],
      },
      vision: {
        label: "Notre vision",
        title: "Où nous allons",
        description:
          "Faire grandir Casaclass avec les familles dans un modèle durable.",
        intro:
          "Nous visons à devenir la référence e-learning tunisienne pour enfants en bâtissant :",
        points: [
          "Une communauté d'élèves, de parents et d'enseignants partageant culture et ambition.",
          "Des programmes renouvelés avec packs thématiques et innovation pédagogique.",
          "Une plateforme scalable et durable pour les familles tunisiennes partout dans le monde.",
        ],
      },
      uniques: {
        label: "Ce qui nous distingue",
        title: "Pourquoi Casaclass est unique",
        description:
          "Une expérience globale qui mêle rigueur, spiritualité et innovation digitale.",
        items: [
          {
            title: "Approche hybride",
            description:
              "Académique et spirituelle, avec compétences numériques.",
          },
          {
            title: "Personnalisation totale",
            description:
              "Test de niveau et parcours ajusté pour chaque enfant.",
          },
          {
            title: "Flexibilité géographique",
            description:
              "Idéal pour les familles en Europe, au Golfe et en Tunisie.",
          },
          {
            title: "Engagement pédagogique",
            description: "Enseignants passionnés, outils modernes, vrai suivi.",
          },
        ],
      },
      showcase: {
        label: "En images",
        title: "Notre vision en instantanés",
        description:
          "Trois regards sur Casaclass : l'énergie de la communauté, un parcours guidé et une plateforme partout.",
        cards: [
          {
            title: "Communauté engagée",
            description:
              "Familles, apprenants et mentors qui avancent ensemble.",
            alt: "Communauté Casaclass",
          },
          {
            title: "Parcours immersif",
            description:
              "Une feuille de route claire, des activités plaisantes, un feedback régulier.",
            alt: "Parcours Casaclass",
          },
          {
            title: "Toujours accessible",
            description:
              "Interface moderne et simple à chaque déplacement et sur chaque appareil.",
            alt: "Plateforme Casaclass",
          },
        ],
      },
      cta: {
        title: "Prêt à rejoindre la communauté Casaclass ?",
        description:
          "Échangez avec notre équipe, choisissez le bon programme et donnez de l'élan aux apprentissages de votre enfant.",
        primary: "Parler à l'équipe",
        secondary: "Créer un compte",
      },
    },
    dashboard: {
      role: {
        admin: "Admin de plateforme",
        superadmin: "Super admin",
        support: "Support",
        accounting: "Comptabilité",
        teacher: "Enseignant",
        parent: "Parent",
        member: "Membre Casaclass",
      },
      searchPlaceholder: "Rechercher...",
      loading: "Chargement...",
      hero: {
        greeting: "Bienvenue {{name}}, 👋",
        intro:
          "Un aperçu rapide de vos prochains cours, des élèves liés et des packs Casaclass recommandés.",
        manageLessons: "Gérer les cours",
        browseOffers: "Voir les offres",
        nextLesson: "Prochain cours",
        student: "Élève",
        teacher: "Enseignant",
        time: "Horaire",
        duration: "Durée",
      },
      stats: {
        total: { label: "Cours", hint: "Tous les cours enregistrés" },
        upcoming: { label: "À venir", hint: "Planifiés bientôt" },
        completed: { label: "Terminés", hint: "Déjà effectués" },
        cancelled: { label: "Annulés", hint: "Cours annulés" },
      },
      upcoming: {
        title: "Cours à venir",
        subtitle: "Les quatre prochains cours pour rester sur la bonne voie.",
        viewAll: "Voir tout",
        loading: "Chargement des cours...",
        empty:
          "Aucun cours à venir. Vous pouvez en planifier un nouveau depuis la page Cours.",
      },
      students: {
        title: "Élèves liés",
        subtitle: "Élèves rattachés à votre compte.",
        id: "Identifiant",
        dob: "Date de naissance",
        empty: "Aucune donnée élève.",
      },
      featured: {
        title: "Packs suggérés",
        subtitle: "Recommandations du catalogue Casaclass.",
        explore: "Explorer tous les packs",
        lessonsCount: "Cours",
        sessionLength: "Durée de séance",
        price: "Prix",
        learnMore: "En savoir plus",
      },
      errors: {
        loadData: "Impossible de charger certaines données : {{error}}",
      },
      teacher: {
        roleLabel: "Tableau de bord enseignant",
        greeting: "Bonjour {{name}}",
        intro:
          "Contrôle rapide des cours, des élèves et de la communication avec les parents.",
        performance: {
          title: "Performance",
          completed: "Terminées",
          cancelled: "Annulées",
        },
        programs: {
          title: "Mes programmes",
          loading: "Chargement des programmes...",
          edit: "Modifier",
          empty: "Aucun programme pour le moment.",
        },
        weeklyActivity: {
          title: "Activité hebdomadaire",
          hint: "7 derniers jours",
        },
        topStudents: {
          title: "Élèves les plus actifs",
          lessons: "{{count}} cours",
          empty: "Pas assez de données pour le moment.",
        },
        updates: {
          title: "Dernières mises à jour",
          empty: "Aucune mise à jour pour le moment.",
        },
        actions: {
          schedule: "Planifier des cours",
          newLesson: "Créer un cours",
        },
        stats: {
          activeStudents: { label: "Élèves actifs" },
          hoursGiven: { label: "Heures d'enseignement" },
          completed: { label: "Séances terminées" },
          cancelled: { label: "Séances annulées" },
        },
        schedule: {
          title: "Planning des cours",
          subtitle: "Les cours les plus proches et leur statut.",
          view: "Voir le planning",
          loading: "Chargement du planning...",
          empty: "Aucun cours à venir.",
        },
        manage: {
          title: "Gérer les cours",
          subtitle: "Créer des cours, des ressources et l'assiduité.",
          createEdit: {
            title: "Créer / modifier",
            description:
              "Planifiez, modifiez ou dupliquez facilement des cours.",
          },
          upload: {
            title: "Déposer des ressources",
            description: "Ajoutez des PDF, vidéos ou quiz.",
          },
          attendance: {
            title: "Noter l'assiduité",
            description: "Marquez la présence pour chaque cours.",
          },
        },
        assessments: {
          title: "Évaluations & retours",
          subtitle: "Notes, commentaires et historique des devoirs/tests.",
          grades: {
            title: "Notes & appréciations",
            description:
              "Ajoutez une note et un commentaire pour chaque élève.",
          },
          homework: {
            title: "Journal devoirs / tests",
            description: "Consultez les devoirs corrigés et suivez-les.",
          },
        },
        communication: {
          title: "Messages",
          subtitle: "Messages internes et notifications.",
          messaging: {
            title: "Messages internes",
            description: "Chat sécurisé avec élèves et parents.",
          },
          notifications: {
            title: "Notifications système",
            description: "Nouveaux élèves ou changements de planning.",
          },
        },
        payments: {
          title: "Paiements",
          subtitle: "Virements Casaclass et factures mensuelles.",
          history: {
            title: "Historique des virements",
            description: "Vos virements apparaissent ici.",
          },
          invoicing: {
            title: "Factures automatiques",
            description: "Récap mensuel généré automatiquement.",
          },
        },
      },
      parent: {
        roleLabel: "Tableau de bord parent",
        greeting: "Bonjour {{name}}",
        intro: "Suivez vos enfants, les cours, les alertes et la facturation.",
        classes: {
          title: "Classes",
          subtitle: "Classes actuelles pour chaque enfant",
        },
        widgets: {
          studentModeLabel: "Mode élève",
          studentModePlaceholder: "Entrer en mode élève",
          notifications: "Notifications",
          weekSubtitle: "Aperçu des cours de cette semaine.",
          noLessons: "Aucun cours.",
          reminders: "Rappels",
          reminderCheckbox: "Marquer comme fait",
          recommended: "Recommandé",
          monthStats: "Statistiques du mois",
          monthStatsHint: "Aperçu",
          children: "Enfants",
          homework: "Devoirs",
          homeworkHint: "Prochains cours à venir.",
        },
        notifications: {
          empty: "Aucune notification.",
          markRead: "Marquer comme lu",
          status: {
            cancelled: "Annulé",
            postponed: "Reporté",
            updated: "Mis à jour",
          },
        },
        actions: {
          weekly: "Planning hebdomadaire",
          support: "Ouvrir un ticket support",
        },
        activeStudent: {
          status: "Le mode élève est actif",
          none: "Aucun élève sélectionné",
          label: "Mode élève : {{name}}",
          subtitle: "Accès direct à l'espace de l'élève sélectionné.",
          deactivate: "Désactiver le mode",
          prompt: "Sélectionnez un élève pour activer son espace.",
        },
        children: {
          title: "Enfants liés",
          subtitle: "Progression globale et prochains cours.",
          addChild: "Ajouter un enfant",
          progress: "Progression",
          nextLesson: "Prochain cours",
          activate: "Activer le mode élève",
          active: "Mode élève actif",
          viewLessons: "Voir les cours",
          loading: "Chargement des enfants...",
          empty: "Aucun enfant lié.",
        },
        followup: {
          title: "Suivi des cours",
          subtitle: "Planning de la semaine et contenus (replays/ressources).",
          loading: "Chargement des cours...",
          empty: "Aucun cours prévu cette semaine.",
        },
        communication: {
          title: "Messagerie",
          subtitle: "Chat sécurisé avec les enseignants et le support.",
          teacherChat: {
            title: "Chat enseignant",
            description: "Fil privé par cours.",
          },
          supportTicket: {
            title: "Ticket support",
            description: "Envoyez vos demandes à l'équipe Casaclass.",
          },
        },
        billing: {
          title: "Paiements & facturation",
          subtitle: "Abonnements, factures PDF et gestion des packs.",
          activeSubs: {
            title: "Abonnements actifs",
            description: "Vos offres en cours apparaissent ici.",
          },
          invoices: {
            title: "Factures téléchargeables",
            description: "Téléchargez vos factures (PDF).",
          },
          renew: {
            title: "Renouveler / annuler",
            description: "Gérez les options d'abonnement.",
          },
        },
        profile: {
          title: "Profil parent",
          subtitle: "Coordonnées et moyen de paiement préféré.",
          contact: {
            title: "Détails de contact",
            description: "Mettez à jour vos informations.",
          },
          payment: {
            title: "Moyen de paiement",
            description: "Ajoutez ou modifiez un moyen de paiement.",
          },
          widgets: {
            studentModeLabel: "Schülermodus",
            studentModePlaceholder: "Als Schüler öffnen",
            notifications: "Benachrichtigungen",
            weekSubtitle: "Schnellansicht der Stunden dieser Woche.",
            noLessons: "Keine Stunden.",
            reminders: "Erinnerungen",
            reminderCheckbox: "Als erledigt markieren",
            recommended: "Empfohlen",
            monthStats: "Statistik dieses Monats",
            monthStatsHint: "Kurzübersicht",
            children: "Kinder",
            homework: "Hausaufgaben",
            homeworkHint: "Nächste anstehende Stunden.",
          },
          manageChildren: {
            title: "Gérer les enfants",
            description: "Ajoutez ou retirez des enfants liés.",
          },
        },
        modal: {
          exitTitle: "Confirmer le retour au mode parent",
          exitBody:
            "Pour la sécurité, saisissez le mot de passe parent avant de revenir.",
          passwordLabel: "Mot de passe",
          passwordError: "Mot de passe incorrect. Réessayez.",
          cancel: "Annuler",
          confirm: "Confirmer",
          verifying: "Vérification...",
          backToParent: "Retour au mode parent",
          logout: "Se déconnecter",
        },
      },
      studentSpace: {
        tag: "Espace élève",
        title: "Tableau de bord élève — {{name}}",
        subtitle: "Cours à venir, progression, messages et ressources.",
        errors: {
          profileLoad: "Impossible de charger le profil de l'élève.",
        },
        banner: {
          badge: "Étoile du jour",
          greeting: "Bonjour, {{name}}",
          hint: "Content de te revoir ! Prépare-toi et continue ton cours aujourd'hui.",
          imageAlt: "Enfants qui apprennent",
          stats: {
            courses: "Cours",
            xp: "XP",
            completed: "Terminés",
          },
        },
        today: {
          title: "Cours du jour",
          hint: "Des cours amusants t'attendent aujourd'hui !",
          empty: "Aucun cours aujourd'hui. Profite d'une pause !",
        },
        missions: {
          title: "Tes missions",
          hint: "Choisis une mission fun et gagne des étoiles !",
          mentor: {
            title: "Demander à un mentor",
            body: "Obtiens un conseil rapide pour aujourd'hui.",
          },
          challenge: {
            title: "Nouveau défi",
            body: "Commence un nouveau cours et gagne de l'XP !",
          },
        },
        classes: {
          title: "Ta classe",
          hint: "Tes classes & amis",
          allTab: "Tout",
          friends: "{{count}} amis",
          classLabel: "Classe : {{name}}",
          empty: "Aucune classe associée.",
        },
        activity: {
          title: "Ton activité",
          hint: "Un aperçu rapide de tes progrès sur les derniers mois.",
        },
        cards: {
          upcoming: { label: "Cours à venir", hint: "Séances planifiées" },
          past: { label: "Cours passés", hint: "Enregistrements récents" },
          badges: { label: "Insignes", hint: "Progression visible" },
          stars: { label: "Étoiles", hint: "Encouragement" },
        },
        upcoming: {
          title: "Cours à venir",
          subtitle: "Rejoignez la salle live (Zoom/BBB).",
          empty: "Aucun cours planifié.",
          join: "Rejoindre la salle",
        },
        past: {
          title: "Cours passés",
          subtitle: "Replays, fichiers et évaluations.",
          empty: "Aucun cours passé.",
          viewResources: "Voir les ressources",
        },
        resources: {
          title: "Ressources",
          subtitle: "Bibliothèque par matière avec liens et vidéos.",
        },
        messages: {
          title: "Derniers messages",
          subtitle: "Échanges avec les enseignants.",
          open: "Ouvrir les messages",
        },
        feedback: {
          title: "Retours",
          subtitle: "Voir les notes, commentaires et évaluer le cours.",
        },
      },
    },
    landingPage: {
      subjectsGrid: {
        title: "Matières",
        description:
          "Découvrez nos programmes conçus pour accompagner votre enfant dans chaque matière, avec un suivi pédagogique spécialisé qui favorise l'excellence et la confiance en soi.",
        cta: "Découvrir nos offres",
        ariaLabel: "Programmes",
        managePrograms: "Gérer les programmes",
        items: [],
      },
      hero: {
        title: "À vos côtés à chaque étape",
        lead: "Casaclass est une plateforme tunisienne qui rejoint votre foyer où que vous soyez. Nous accompagnons vos enfants en scolaire, langues et valeurs pour qu'ils grandissent avec confiance, identité et savoir.",
        primaryCta: "Commencer maintenant",
        secondaryCta: "Découvrir nos offres",
        videoTitle: "Vidéo de présentation Casaclass",
        statsLabel: "Statistiques d'impact Casaclass",
        stats: [
          { value: "5 000+", label: "Familles accompagnées" },
          { value: "230+", label: "Cours interactifs" },
          { value: "45", label: "Enseignants tunisiens" },
          { value: "4,9/5", label: "Satisfaction parents" },
        ],
      },
      features: {
        tag: "Une école pour chaque enfant",
        title: "Pourquoi Casaclass ?",
        description:
          "Créée pour garder nos enfants connectés à leur langue, leur culture et leurs valeurs, où qu'ils vivent. Nous combinons pédagogie tunisienne et outils modernes pour un apprentissage motivant.",
        cta: "Découvrir nos programmes",
        cards: [
          {
            title: "Parcours personnalisé",
            description:
              "Test de niveau, parcours sur mesure et soutien famille",
            alt: "Élève qui découvre un parcours personnalisé",
          },
          {
            title: "En direct et à la demande",
            description: "Sessions live + bibliothèque vidéo pour réviser",
            alt: "Session en direct sur Casaclass",
          },
          {
            title: "Accompagnement Neuro-Pédagogique",
            description:
              "Diagnostic, accompagnements et parcours éducatifs personnalisés pour l'excellence",
            alt: "Illustration d'un accompagnement neuro-pédagogique",
          },
        ],
      },
      journey: {
        ariaLabel: "Histoire de Casaclass avec les familles",
        title: "L'histoire",
        imageAlt: "Famille qui fait confiance au parcours Casaclass",
        paragraphs: [
          "Chaque cerveau est unique.",
          "Pour transformer les défis en réussite grâce à un accompagnement neuro-pédagogique sur mesure, nous fournissons à votre enfant les meilleurs experts en psychologie, neuropsychiatrie et pédagogie.",
        ],
        cta: "Lancer le test de niveau",
      },
      levels: {
        tag: "On démarre",
        title: "Choisissez le niveau à explorer",
        description:
          "Chaque niveau combine vidéos en streaming, livrets imprimables et suivi d'objectifs. Choisissez le niveau adapté et commencez un parcours qui grandit avec votre enfant.",
        note: "Si le rêve est possible, le plan est tout proche.",
        ariaPrefix: "Découvrir le niveau",
        items: [
          {
            grade: "1",
            label: "Niveau 1",
            accent: 1,
            ariaLabel: "Découvrir le niveau 1",
          },
          {
            grade: "2",
            label: "Niveau 2",
            accent: 2,
            ariaLabel: "Découvrir le niveau 2",
          },
          {
            grade: "3",
            label: "Niveau 3",
            accent: 3,
            ariaLabel: "Découvrir le niveau 3",
          },
          {
            grade: "4",
            label: "Niveau 4",
            accent: 4,
            ariaLabel: "Découvrir le niveau 4",
          },
          {
            grade: "5",
            label: "Niveau 5",
            accent: 5,
            ariaLabel: "Découvrir le niveau 5",
          },
          {
            grade: "6",
            label: "Niveau 6",
            accent: 6,
            ariaLabel: "Découvrir le niveau 6",
          },
          {
            grade: "7",
            label: "Niveau 7",
            accent: 7,
            ariaLabel: "Découvrir le niveau 7",
          },
          {
            grade: "8",
            label: "Niveau 8",
            accent: 8,
            ariaLabel: "Découvrir le niveau 8",
          },
          {
            grade: "9",
            label: "Niveau 9",
            accent: 9,
            ariaLabel: "Découvrir le niveau 9",
          },
        ],
      },
      programs: {
        badge: "Programmes Casaclass",
        title: "Les quatre piliers Casaclass",
        imageAlt: "Illustration des piliers Casaclass",
        items: [
          {
            title: "1. Scolaire — du CP à la 9ème",
            list: [
              "Révision + exercices + vidéos explicatives",
              "Accompagnement individuel par des enseignants tunisiens",
              "Suivi mensuel parent",
              "Parcours qui avance pas à pas",
            ],
            slogan: "Des bases claires, des progrès assurés.",
            cta: "Rejoindre le programme scolaire",
            ctaLink: "/signup",
          },
          {
            title: "2. Français",
            list: [
              "Programmes agréés par le ministère tunisien",
              "Ateliers de prononciation et expression orale",
              "Révision grammaire et expression écrite avec exemples",
              "Suivi individuel et évaluations régulières",
            ],
            slogan: "Une deuxième langue, une clé à l'étranger.",
            cta: "Découvrir les cours de français",
            ctaLink: "/courses",
          },
          {
            title: "3. Arabe • Coran • Hadith",
            list: [
              "Mémorisation facilitée",
              "Bases de tajwid",
              "Sira et valeurs",
              "Arabe pensé pour la nouvelle génération",
            ],
            cta: "Découvrir nos cours d'arabe et Coran",
            ctaLink: "/courses",
          },
          {
            title: "4. Club de code enfants",
            list: [
              "Scratch, Python Kids, robotique",
              "Jeux éducatifs",
              "Mini-projets mensuels",
              "Les enfants d'aujourd'hui, codeurs de demain",
            ],
            slogan: "Apprendre le futur dès maintenant.",
            cta: "Rejoindre le club de code",
            ctaLink: "/signup",
          },
        ],
      },
      specialNeeds: {
        ariaLabel: "Accompagnement besoins particuliers",
        title: "Votre enfant a des besoins spécifiques",
        description:
          "Il a sa place ici, relié à des spécialistes pour l'aider à s'intégrer et progresser à son rythme, selon ses besoins.",
        imageAlt: "Les trois piliers des programmes Casaclass",
        cta: "Contactez-nous",
      },
      ecosystem: {
        title: "Un univers Casaclass clair",
        cta: "Rejoindre l'univers Casaclass",
        cards: [
          {
            icon: "👨‍👩‍👦",
            title: "Espace parents",
            items: [
              "Suivi des progrès",
              "Rapport hebdo",
              "Choix enseignant/groupe",
            ],
            alt: "Tableau de bord parent Casaclass",
          },
          {
            icon: "👦",
            title: "Espace élève",
            items: ["Devoirs", "Leçons courtes", "Badges et récompenses"],
            alt: "Espace élève Casaclass",
          },
          {
            icon: "👩‍🏫",
            title: "Espace enseignant",
            items: ["Dashboard", "Planification", "Évaluations"],
            alt: "Espace enseignant Casaclass",
          },
        ],
      },
      ramadan: {
        ariaLabel: "Packs Ramadan enfants",
        badge: "Packs & Ramadan enfants",
        title: "Packs Ramadan",
        lead: "30 vidéos de valeurs, Coran, histoires et éthique pour les 5-12 ans, un Ramadan plein de lumière, d'identité et de découvertes.",
        items: [
          "Programmation quotidienne inspirée de Ramadan",
          "Histoires illustrées et exercices de valeurs chaque jour",
          "Séances de Coran simplifiées et tajwid clair",
          "Activités familiales pour renforcer le lien",
        ],
        slogan: "Lumière, savoir et guidance.",
        cta: "Bientôt",
        imageAlt:
          "Enseignant Casaclass accompagnant les enfants pendant Ramadan",
      },
      testimonials: {
        ariaLabel: "Témoignages de la communauté Casaclass",
        tag: "Histoires de notre communauté",
        title: "Confiance des familles et des enseignants",
        lead: "Des parents à l'étranger aux enseignants en Tunisie, la plateforme réunit des enfants inspirants accompagnés pas à pas.",
        prev: "Témoignage précédent",
        next: "Témoignage suivant",
        dotsLabel: "Naviguer dans les témoignages",
        dotLabel: "Afficher le témoignage de {{name}}",
        imageAlt: "Parent : {{name}}",
        items: [
          {
            quote:
              "Depuis que nous avons commencé avec Casaclass, la révision est devenue un moment agréable en famille. Ma fille aime le parcours clair et les récompenses numériques, et je suis ses progrès sereinement depuis l'espace parent.",
            name: "Amel Ben Salem",
            place: "Lyon, France",
          },
          {
            quote:
              "Nous vivons à Dubaï et les horaires compliquaient l'accès aux cours tunisiens. Avec Casaclass, nous rejoignons les lives ou les replays quand cela convient, et les enfants interagissent avec les profs comme s'ils étaient en Tunisie.",
            name: "Rami & Sirine",
            place: "Dubaï, EAU",
          },
          {
            quote:
              "Mon fils a des difficultés de concentration ; le coach pédagogique nous a donné un plan clair. Nous recevons des rapports hebdo et des conseils, et maintenant il est motivé et raconte ses cours d'arabe et de Coran tout seul.",
            name: "Laila Marzouki",
            place: "Toronto, Canada",
          },
        ],
      },
      faq: {
        ariaLabel: "FAQ Casaclass",
        tag: "FAQ",
        title: "Vos questions",
        lead: "Nous restons proches dès le premier jour jusqu'aux réussites de vos enfants.",
        items: [
          {
            question: "Combien de temps dure l'accès aux ressources ?",
            answer:
              "Chaque abonnement ouvre toutes les unités pendant 12 mois avec mises à jour gratuites chaque trimestre.",
          },
          {
            question: "Les cours conviennent-ils à la diaspora ?",
            answer:
              "Oui, le contenu est bilingue (arabe/français) et suit le programme tunisien avec flexibilité pour les fuseaux horaires.",
          },
          {
            question: "Y a-t-il un suivi personnalisé ?",
            answer:
              "Dès l'inscription, un coach pédagogique vous suit avec des points mensuels et des conseils adaptés à la famille.",
          },
          {
            question: "Comment démarrer ?",
            answer:
              "Créez un compte, choisissez le niveau de votre enfant et lancez le quiz de positionnement et les premières leçons.",
          },
        ],
      },
      finalCta: {
        ariaLabel: "Rejoindre Casaclass",
        label: "Prêts ?",
        title: "Activez la première leçon aujourd'hui",
        description: "Inscription rapide + séance d'essai offerte",
        primary: "S'inscrire maintenant",
        secondary: "Parler à un conseiller",
      },
    },
    authPage: {
      loginTitle: "Connexion",
      loginLead: "Reprenez vos cours en un instant.",
      email: "E-mail",
      emailPlaceholder: "example@mail.com",
      phoneLabel: "Numéro de téléphone",
      phonePlaceholder: "Entrez votre numéro de téléphone",
      password: "Mot de passe",
      passwordPlaceholder: "Entrez votre mot de passe",
      showPassword: "Afficher le mot de passe",
      hidePassword: "Masquer le mot de passe",
      loginCta: "Se connecter",
      loginLoading: "Connexion...",
      noAccount: "Pas de compte ?",
      goSignup: "Créez-en un",
      signupTitle: "Créer un compte",
      signupLead: "Rejoignez Casaclass et progressez avec plaisir.",
      name: "Nom complet",
      namePlaceholder: "Entrez votre nom complet",
      roleLabel: "Type de compte",
      roleParent: "Parent",
      roleTeacher: "Enseignant",
      resumeLabel: "CV (PDF/DOC)",
      resumeRequired:
        "Veuillez joindre votre CV pour créer un compte enseignant.",
      confirmPassword: "Confirmez le mot de passe",
      confirmPasswordPlaceholder: "Ressaisissez le mot de passe",
      signupCta: "Rejoindre Casaclass",
      signupLoading: "Création...",
      hasAccount: "Vous avez déjà un compte ?",
      goLogin: "Connectez-vous",
      passwordLength: "Le mot de passe doit comporter au moins 8 caractères.",
      passwordMatch: "Les mots de passe ne correspondent pas.",
      loginError: "Connexion impossible. Réessayez.",
      signupError: "Impossible de créer le compte. Réessayez plus tard.",
      forgotLink: "Mot de passe oublié ?",
      forgotTitle: "Mot de passe oublié",
      forgotLead:
        "Saisissez votre e-mail et nous enverrons un lien de réinitialisation si votre compte existe.",
      forgotCta: "Envoyer le lien",
      forgotSending: "Envoi...",
      forgotSuccess:
        "Si cet e-mail est enregistré, vous recevrez les instructions bientôt.",
      forgotBack: "Retour à la connexion",
      socialDivider: "Ou continuer avec Google",
      googleError: "Connexion Google impossible. Réessayez.",
      googleLoading: "Vérification de votre compte Google...",
    },
    verificationPage: {
      title: "Compte en attente de vérification",
      message:
        "Votre compte enseignant a bien été créé, mais l’accès à la plateforme sera activé après validation par un administrateur.",
      logout: "Se déconnecter",
    },
    resources: {
      title: "Ressources",
      subtitleTeacher:
        "Créez des ressources et assignez-les à une classe ou à un élève.",
      subtitleStudent:
        "Les ressources qui vous sont assignées apparaîtront ici.",
      loading: "Chargement...",
      create: "Créer une ressource",
      creating: "Création...",
      listTitle: "Ressources",
      empty: "Aucune ressource pour le moment.",
      delete: "Supprimer",
      confirmDelete: "Supprimer cette ressource ?",
      failedLoad: "Impossible de charger les ressources",
      failedCreate: "Impossible de créer la ressource",
      failedDelete: "Impossible de supprimer la ressource",
      titleRequired: "Le titre est obligatoire",
      targetRequired: "Veuillez choisir une classe ou un élève",
      targetClass: "Classe",
      targetStudent: "Élève",
      fields: {
        title: "Titre",
        titlePlaceholder: "ex. Support semaine 3",
        text: "Texte",
        textPlaceholder: "Description ou consignes (optionnel)",
        assignTo: "Assigner à",
        class: "Classe",
        student: "Élève",
        attachments: "Pièces jointes",
      },
      assign: {
        class: "Classe",
        student: "Élève",
      },
      pickClass: "Sélectionner une classe",
      pickStudent: "Sélectionner un élève",
    },
    offers: {
      heroTag: "Nos offres",
      heroTitle: "Packs Casaclass prêts à l'emploi",
      heroDescription:
        "Choisissez le parcours qui convient à votre famille. Chaque offre combine cours en direct, ressources numériques et accompagnement pédagogique.",
      packLabel: "Choisissez un pack :",
      packPlaceholder: "-- Sélectionner --",
      sections: {
        classTypes: {
          tag: "Modes d'apprentissage",
          heading: "Choisissez le cadre où votre enfant est à l'aise",
          description:
            "Du cours particulier aux groupes plus larges, chaque format est pensé pour différents profils et budgets.",
        },
        languages: {
          tag: "Langues",
          heading: "Parcours de langues en direct",
          description:
            "Des bases jusqu'aux examens internationaux, avec du contenu interactif qui renforce la confiance.",
        },
        upcoming: {
          tag: "Bientôt",
          heading: "Compétences du futur en préparation",
          description:
            "Inscrivez votre intérêt pour être prévenu lors de l'ouverture des clubs de coding, d'IA et de leadership.",
        },
      },
      classTypes: {
        full: {
          category: "Types de classes",
          title: "Full Classes",
          subtitle: "Cours individuel entièrement personnalisé",
          description:
            "Une expérience 100 % personnelle avec un enseignant qui construit le plan autour de votre enfant.",
          price: "25 TND / séance",
          billing: "Séance privée de 60 minutes",
          features: [
            "Programme revu régulièrement",
            "Attention individuelle de l'enseignant",
            "Flexibilité totale des horaires",
          ],
          cta: "Rejoindre Full Classes",
        },
        duo: {
          category: "Types de classes",
          title: "DUO Classes",
          subtitle: "Cours partagé avec un ami ou un frère",
          description:
            "Pensé pour un duo qui s'encourage dans l'apprentissage partagé.",
          price: "15 TND / séance",
          billing: "Prix par apprenant",
          features: [
            "Contenu adapté pour deux",
            "Activités collaboratives",
            "Suivi de la répartition des tâches",
          ],
          cta: "Rejoindre DUO Classes",
          badge: "Le plus demandé",
        },
        vip: {
          category: "Types de classes",
          title: "VIP Classes",
          subtitle: "Petits groupes jusqu'à 4 élèves",
          description:
            "Engagement continu dans un groupe sélectionné avec attention personnalisée.",
          price: "10 TND / séance",
          billing: "Prix par apprenant",
          features: [
            "Séances interactives avec des pairs proches",
            "Activités coopératives pour renforcer la confiance",
            "Encadrement individuel dans le groupe",
          ],
          cta: "Rejoindre VIP Classes",
        },
        normal: {
          category: "Types de classes",
          title: "Normal Classes",
          subtitle: "Jusqu'à 8 élèves",
          description:
            "Solution économique qui maintient l'engagement au sein d'un groupe coopératif.",
          price: "7.5 TND / séance",
          billing: "Prix par apprenant",
          features: [
            "Cadre collectif structuré",
            "Activités qui encouragent la participation",
            "Meilleur rapport valeur/progression",
          ],
          cta: "Rejoindre Normal Classes",
        },
      },
      languagePrograms: {
        french: {
          category: "Programmes de langues",
          title: "Français",
          subtitle: "A1 à C2 • DELF/DALF",
          description:
            "Renforcez grammaire et oral avec une préparation complète aux examens DELF/DALF.",
          price: "180 TND / mois",
          billing: "Séances live + ressources numériques",
          features: [
            "Progression des lettres à l'écrit académique",
            "Exercices DELF/DALF",
            "Ateliers de prononciation et expression orale",
          ],
          cta: "S'inscrire en français",
        },
        english: {
          category: "Programmes de langues",
          title: "Anglais",
          subtitle: "Conversation + IELTS",
          description:
            "Parcours complet pour l'oral et la préparation IELTS avec des modules business.",
          price: "220 TND / mois",
          billing: "Séances live • ressources interactives",
          features: [
            "Préparation IELTS complète",
            "Business English et entretiens",
            "Clubs de conversation hebdomadaires",
          ],
          cta: "Essayer un cours d'essai",
          badge: "Favori",
        },
        arabic: {
          category: "Programmes de langues",
          title: "Arabe",
          subtitle: "Pour non natifs",
          description:
            "Découverte des lettres, bonne prononciation et conversation quotidienne avec touche culturelle.",
          price: "160 TND / mois",
          billing: "Sessions interactives + suivi maison",
          features: [
            "Lettres et sons justes dès le début",
            "Dialogues quotidiens et vocabulaire clé",
            "Histoires et activités culturelles",
          ],
          cta: "S'inscrire en arabe",
        },
      },
      upcoming: {
        coding: {
          category: "Bientôt",
          title: "Coding for Kids",
          subtitle: "Projets Scratch et Minecraft",
          description:
            "Un labo numérique qui enseigne la logique via des projets ludiques chaque mois.",
          price: "Bientôt",
          billing: "Inscriptions ouvertes le prochain trimestre",
          features: [
            "Ateliers de code progressifs",
            "Badges numériques",
            "Collaboration en petites équipes",
          ],
          cta: "Prévenez-moi au lancement",
        },
        ai: {
          category: "Bientôt",
          title: "IA & Compétences du futur",
          subtitle: "IA simplifiée pour les jeunes",
          description:
            "Découverte de l'IA, du design thinking et de l'automatisation via des mini-projets.",
          price: "Bientôt",
          billing: "Lancement été 2026",
          features: [
            "Concepts d'IA sans complexité",
            "Ateliers robotique avec kits simples",
            "Défis de pensée critique",
          ],
          cta: "Rejoindre la liste d'attente",
        },
        leaders: {
          category: "Bientôt",
          title: "Future Leaders Lab",
          subtitle: "Compétences de communication et présentation",
          description:
            "Combine présentations, résolution de problèmes et mini-projets pour ados.",
          price: "Bientôt",
          billing: "Pilote à l'automne 2026",
          features: [
            "Sessions individuelles et de groupe",
            "Projets appliqués réels",
            "Coaching par des experts en communication",
          ],
          cta: "Manifester mon intérêt",
        },
      },
      addons: {
        tag: "Options",
        heading: "Services complémentaires pour votre enfant",
        description:
          "Associez-les à n'importe quel pack principal ou réservez-les séparément quand vous en avez besoin.",
        coaching: {
          title: "Session de coaching familial",
          price: "30 TND / séance",
          description:
            "Appel de 45 minutes pour évaluer les besoins et fixer un plan mensuel.",
          points: [
            "Diagnostic rapide du niveau",
            "Plan d'objectifs sur 4 semaines",
            "Activités maison et suivi",
          ],
          cta: "Réserver la session",
        },
        assessment: {
          title: "Test de positionnement avancé",
          price: "45 TND une fois",
          description:
            "Test interactif + rapport écrit avec recommandations précises.",
          points: [
            "Test numérique langue et maths",
            "Analyse écrite des forces et besoins",
            "Plan de transition pour les premières semaines",
          ],
          cta: "Demander le rapport",
        },
        oneToOne: {
          title: "Cours individuel intensif",
          price: "25 TND / séance",
          description:
            "Cours privés en ligne avec enseignant Casaclass pour renforcer une compétence précise.",
          points: [
            "Flexibilité matière et horaire",
            "Note de suivi après chaque séance",
            "Idéal avant examens ou pour la confiance",
          ],
          cta: "Organiser avec nous",
        },
      },
      support: {
        heading: "Besoin d'aide pour choisir ?",
        description:
          "L'équipe Casaclass peut bâtir un plan personnalisé. Contactez-nous pour proposer le bon parcours et vérifier la préparation avant de commencer.",
        ctaCall: "Réserver un appel conseil",
        ctaSignup: "Créer un compte maintenant",
      },
    },
    adminPage: {
      accessDenied: "Accès réservé aux administrateurs.",
      headerTag: "Console d'administration",
      headerTitle: "Tableau de bord admin",
      dashboard: {
        welcome: "Bon retour !",
        viewAll: "Voir tout",
        manageTitle: "Gestion",
        manageColumns: {
          section: "Section",
          count: "Nombre",
          open: "Ouvrir",
        },
        cards: {
          newStudents: "Nouveaux élèves",
          newStudentsHint: "Période actuelle",
          totalStudents: "Total élèves",
          totalStudentsHint: "Tous les élèves",
          dailyAttend: "Assiduité",
          dailyAttendHint: "7 derniers jours",
          averageAttend: "Assiduité moyenne",
          averageAttendHint: "Ce mois",
        },
        activityTitle: "Activité des élèves",
        thisMonth: "Ce mois",
        lastMonths: "Mois dernier",
        examsTitle: "Examens",
        examsFallback: "Suivi des examens",
        studentsTitle: "Liste des élèves",
        studentsColumns: {
          id: "ID",
          student: "Élève",
          parent: "Parent",
          attends: "Présences",
        },
        teachersTitle: "Enseignants",
        teacherVerified: "Vérifié",
        teacherPending: "En attente",
        empty: "Aucune donnée pour le moment.",
      },
      tabs: {
        overview: "Vue d'ensemble",
        users: "Utilisateurs",
        students: "Élèves",
        lessons: "Cours & planning",
        timetable: "Emploi du temps",
        pendingTeachers: "Vérifications enseignants en attente",
        classes: "Classes",
        packs: "Forfaits",
        payments: "Paiements",
        teachers: "Enseignants",
        support: "Assistance",
      },
      teachers: {
        title: "Enseignants",
        empty: "Aucun enseignant à afficher.",
        resume: "Télécharger le CV",
        activeYes: "Oui",
        activeNo: "Non",
        filter: {
          label: "Filtrer par statut",
          all: "Tous",
          pending: "En attente",
          verified: "Vérifié",
        },
        status: {
          verified: "Vérifié",
          pending: "En attente",
        },
        fields: {
          email: "Email",
          phone: "Téléphone",
          active: "Actif",
          joined: "Inscrit",
        },
      },
      actions: {
        save: "Enregistrer",
        saving: "Enregistrement…",
        create: "Créer",
        cancel: "Annuler",
        edit: "Modifier",
        delete: "Supprimer",
      },
      timetable: {
        calendarTitle: "Calendrier",
        addEvent: "Ajouter un événement",
        configure: "Configurer",
        previousDay: "Jour précédent",
        nextDay: "Jour suivant",
        scopeTeacher: "Professeur",
        scopeClass: "Classe",
        scopeStudent: "Élève",
        allTeachers: "Tous les professeurs",
        allClasses: "Toutes les classes",
        allStudents: "Tous les élèves",
        viewWeek: "Semaine",
        viewDay: "Jour",
        faculty: "Corps enseignant",
        searchFacultyPlaceholder: "Rechercher un enseignant...",
        editLessonTitle: "Modifier le cours",
        newLessonTitle: "Nouveau cours",
        selectPlaceholder: "Sélectionner…",
        lessonTitlePlaceholder: "Titre du cours",
        minutesShort: "min",
        permanentWeekly: "Hebdomadaire permanent",
        fields: {
          teacher: "Professeur",
          class: "Classe",
          students: "Élèves",
          assignTo: "Attribuer à",
          student: "Élève",
          title: "Titre",
          start: "Début",
          duration: "Durée",
          status: "Statut",
        },
        assignModes: {
          student: "Élève",
          class: "Classe",
        },
      },
      classes: {
        panelTitleEdit: "Modifier la classe",
        panelTitleCreate: "Créer une classe",
        classNamePlaceholder: "Nom de la classe",
        fields: {
          name: "Nom",
          students: "Élèves",
        },
        errors: {
          nameRequired: "Le nom est requis",
        },
        confirmDelete: "Supprimer cette classe ?",
        table: {
          class: "Classe",
          teacher: "Professeur",
          students: "Élèves",
          actions: "Actions",
        },
      },
      loading: "Chargement des données...",
      stats: {
        activeStudents: "Élèves actifs",
        monthlyRevenue: "Revenu mensuel",
        satisfaction: "Taux de satisfaction",
        outOfFive: "sur 5",
        supportMessages: "Messages support",
        teachers: "Enseignants",
        unread: "non lus",
      },
      roles: {
        superadmin: "Super administrateur",
        admin: "Administrateur",
        support: "Assistance",
        accounting: "Comptabilité",
        teacher: "Enseignant",
        parent: "Parent",
      },
      users: {
        title: "Gestion des utilisateurs",
        filter: "Filtrer par rôle",
        filterAll: "Tous",
        columns: {
          email: "E-mail",
          name: "Nom",
          role: "Rôle",
          phone: "Téléphone",
          joined: "Inscription",
          verify: "Vérification enseignant",
          active: "Actif",
          actions: "Actions",
        },
        verify: "Vérifier",
        unverify: "Retirer",
        toggleActiveAria: "Activer ou désactiver l'utilisateur",
        deleteConfirm: "Supprimer cet utilisateur ?",
        delete: "Supprimer",
      },
      students: {
        title: "Élèves",
        ageYears: "ans",
        parent: "Parent",
        dob: "Date de naissance",
      },
      lessons: {
        title: "Cours & planning",
        idLabel: "Identifiant",
        student: "Élève",
        teacher: "Enseignant",
        duration: "Durée",
        minutes: "min",
        status: {
          scheduled: "Planifié",
          completed: "Terminé",
          cancelled: "Annulé",
        },
      },
      packs: {
        formEdit: "Modifier le pack",
        formNew: "Nouveau pack",
        fields: {
          name: "Nom du pack",
          description: "Description",
          subject: "Matière",
          subjectPlaceholder: "Choisir...",
          price: "Prix",
          currency: "Devise",
          lessons: "Nombre de séances",
          sessionLength: "Durée (minutes)",
          resources: "Ressources (une URL par ligne)",
          image: "Image (optionnel)",
          recommended: "Recommandé pour",
          gradientColors: "Couleurs du dégradé",
          gradientStart: "Couleur de départ du dégradé",
          gradientEnd: "Couleur de fin du dégradé",
          featured: "Afficher sur l'accueil",
          offersSection: "Section des offres",
          offersSectionNone: "Aucune",
          offersKind: "Type d'offre",
          offersDisplayOrder: "Ordre d'affichage (offres)",
          offersAccent: "Accent (offres)",
          offersCategoryKey: "Clé de catégorie (offres)",
          offersTitleKey: "Clé du titre (offres)",
          offersSubtitleKey: "Clé du sous-titre (offres)",
          offersDescriptionKey: "Clé de description (offres)",
          offersPriceKey: "Clé de prix (offres)",
          offersBillingKey: "Clé de facturation (offres)",
          offersFeaturesKey: "Clé des avantages (offres)",
          offersCtaKey: "Clé du bouton (offres)",
          offersCtaLink: "Lien du bouton (offres)",
          offersBadgeKey: "Clé du badge (offres)",
          offersNoteKey: "Clé de note (offres)",
          offersPointsKey: "Clé des points (offres)",
        },
        placeholderResources: "https://.../video.mp4\nhttps://.../document.pdf",
        placeholders: {
          name: "Exemple : pack langue arabe",
          description: "Exemple : séances hebdomadaires avec un enseignant",
          price: "Exemple : 120",
          lessons: "Exemple : 6",
          sessionLength: "Exemple : 60",
          image: "Exemple : https://example.com/image.png",
          recommended: "Exemple : collégiens",
          offersKey: "Exemple : offers.languages.arabic.title",
          offersLink: "Exemple : /contact",
        },
        actions: {
          saving: "Enregistrement...",
          save: "Enregistrer",
          reset: "Réinitialiser",
        },
        listTitle: "Packs existants",
        sessions: "séances",
        minutesPerSession: "min/séance",
        resourcesCount: "ressources",
        badgeFeatured: "Mis en avant",
        edit: "Modifier",
        delete: "Supprimer",
        deleteConfirm: "Supprimer ce pack ?",
        errorMissingNameSubject:
          "Veuillez renseigner le nom du pack et la matière.",
        detailsTitle: "Détails du pack",
        errorPackNotFound: "Impossible de trouver ce pack.",
      },
      payments: {
        title: "Paiements",
        columns: {
          user: "Utilisateur",
          pack: "Forfait",
          amount: "Montant",
          status: "Statut",
        },
        statuses: {
          pending: "En attente",
          completed: "Terminé",
          failed: "Échoué",
          refunded: "Remboursé",
        },
      },
      support: {
        title: "Support & messages",
        from: "De",
        read: "Lu",
        new: "Nouveau",
        type: "Catégorie",
        markRead: "Marquer comme lu",
        reply: "Répondre",
        replyTitle: "Nouveau message",
        replyClose: "Fermer",
        replyTo: "À",
        replySubject: "Objet",
        replyMessage: "Message",
        replySend: "Envoyer",
        replySending: "Envoi...",
        replyEmpty: "Veuillez écrire un message avant d'envoyer.",
        replySubjectFallback: "Re: Message de contact",
      },
    },
  },
  de: {
    meta: { name: "Deutsch", dir: "ltr" },
    testsModule: testsModuleDe,
    common: { id: "ID" },
    nav: {
      home: "Startseite",
      courses: "Angebote",
      about: "Über uns",
      contact: "Kontakt",
      searchLabel: "In Casaclass suchen",
      searchPlaceholder: "Nach Kurs oder Ressource suchen",
      menuLabel: "Menü",
      languageLabel: "Sprache",
    },
    auth: {
      login: "Anmelden",
      signup: "Konto erstellen",
    },
    protectedRoute: {
      loading: "Ihr Konto wird überprüft...",
    },
    footer: {
      title: "Casaclass",
      description: "Ihre Lernplattform für schulischen Erfolg.",
      quickLinks: "Schnellzugriff",
      home: "Startseite",
      courses: "Kurse",
      about: "Über uns",
      contact: "Kontakt",
      email: "contact@casaclassroom.com",
      phone: "+216 55 544 475",
      copyright: "Alle Rechte vorbehalten.",
    },
    sidebar: {
      close: "Schließen",
      toggle: "Seitenleiste umschalten",
      role: {
        admin: "Plattform-Admin",
        superadmin: "Superadmin",
        support: "Support",
        accounting: "Buchhaltung",
        teacher: "Lehrer",
        parent: "Eltern",
        student: "Schüler",
        user: "Benutzer",
      },
      links: {
        dashboard: "Dashboard",
        programs: "Programme",
        lessons: "Kurse",
        timetable: "Stundenplan",
        resources: "Ressourcen",
        tests: "Tests",
        homeworks: "Hausaufgaben",
        offers: "Angebote",
        contact: "Support",
        gradientStart: "Verlauf-Startfarbe",
        gradientEnd: "Verlauf-Endfarbe",
        profile: "Mein Konto",
        admin: "Admin-Konsole",
        students: "Schüler",
        newLesson: "Neuer Kurs",
        myStudents: "Meine Schüler",
        myChildren: "Meine Kinder",
        myLessons: "Meine Kurse",
      },
      sections: {
        main: "Hauptmenü",
        management: "Akademische Verwaltung",
        other: "Sonstiges",
      },
      logout: "Abmelden",
    },
    studentShell: {
      shortcutsLabel: "Schüler-Kurzbefehle",
      mainNavLabel: "Hauptnavigation für Schüler",
    },
    comingSoon: {
      badge: "Bald",
      defaultTitle: "Seite folgt",
      levelTitle: "Level {{level}}",
      defaultDescription: "Die gesuchte Seite wird gerade erstellt.",
      levelDescription:
        "Wir bereiten Inhalte für Level {{level}} vor – bald verfügbar.",
      pathNotReady: "Pfad {{path}} ist noch nicht verfügbar.",
      backHome: "Zur Startseite",
      contactUs: "Kontakt",
      notFoundTitle: "Seite nicht verfügbar",
      notFoundMessage:
        "Die gesuchte Seite existiert nicht oder wird aktuell erstellt.",
    },
    contactPage: {
      status: {
        loading: "Nachricht wird gesendet...",
        success: "Nachricht gesendet! Wir melden uns bald.",
        error:
          "Nachricht konnte nicht gesendet werden. Bitte erneut versuchen.",
      },
      hero: {
        label: "Kontakt",
        title: "Planen wir eine inspirierende Lernreise",
        lead: "Teilen Sie uns Ihren Bedarf mit, und wir entwickeln einen Lernpfad für Ihre Familie. Unser Team unterstützt Sie bei jedem Schritt.",
      },
      form: {
        cardTitle: "Direkt Kontakt aufnehmen",
        cardSubtitle:
          "Füllen Sie das Formular aus, wir antworten innerhalb eines Werktags.",
        fullNameLabel: "Vollständiger Name",
        fullNamePlaceholder: "Geben Sie Ihren Namen ein",
        emailLabel: "E-Mail",
        emailPlaceholder: "example@mail.com",
        phoneLabel: "Telefonnummer",
        phonePlaceholder: "Geben Sie Ihre Telefonnummer ein",
        subjectLabel: "Betreff",
        subjectPlaceholder: "Fügen Sie einen kurzen Betreff hinzu",
        messageLabel: "Wie können wir helfen?",
        messagePlaceholder:
          "Beschreiben Sie Ihren Bedarf, damit wir die beste Lösung vorschlagen",
        submit: "Nachricht senden",
        submitting: "Senden...",
        phoneAppend: "Telefonnummer: {{phone}}",
      },
      calendly: {
        title: "Beratungstermin buchen",
        subtitle:
          "Wählen Sie eine passende Zeit für ein kurzes Gespräch mit unserem Team.",
      },
    },
    errors: {
      adminRequired: "Diese Aktion erfordert ein Admin-Konto.",
      authRequired: "Bitte melden Sie sich an, um diese Aktion auszuführen.",
      operationFailed: "Vorgang konnte nicht ausgeführt werden.",
      fetchFailed:
        "Daten konnten nicht geladen werden. Bitte erneut versuchen.",
      lessonIdRequired: "Lektions-ID ist erforderlich.",
    },
    lessons: {
      title: "Lektionen",
      subtitleStudent: "Lektionen für den aktiven Schüler",
      subtitleStaff: "Alle Lektionen Ihres Kontos mit Filtern und Status.",
      newLesson: "Neue Lektion",
      searchLabel: "Lektionen suchen",
      searchPlaceholder: "Titel, Schüler, Lehrer",
      statusFilter: "Nach Status filtern",
      refresh: "Liste aktualisieren",
      loading: "Lektionen werden geladen...",
      empty: "Keine Lektionen passen zur aktuellen Ansicht.",
      emptyCta: "Erste Lektion erstellen",
      error: "Fehler beim Laden der Lektionen: ",
      deleteConfirm: "Diese Lektion wirklich löschen?",
      student: "Schüler",
      teacher: "Lehrer",
      pack: "Paket",
      duration: "Dauer",
      minutes: "Minuten",
      viewDetails: "Details anzeigen",
      joinMeeting: "Meeting beitreten",
      joinMeetingSoon: "2 Std. vorher verfügbar",
      generateMeeting: "Meeting-Link erstellen",
      generatingMeeting: "Wird erstellt...",
      edit: "Bearbeiten",
      delete: "Löschen",
      statusScheduled: "Geplant",
      statusCompleted: "Abgeschlossen",
      statusCancelled: "Abgesagt",
      filterAll: "Alle Status",
      filterScheduled: "Bevorstehend",
      filterCompleted: "Abgeschlossen",
      filterCancelled: "Abgesagt",
      timetable: {
        days: "Tage",
        item: "Element",
        items: "Elemente",
        noLessonsForWeek: "Keine Stunden diese Woche",
        selectChild: "Kind auswählen",
        previousWeek: "Vorherige Woche",
        nextWeek: "Nächste Woche",
        today: "Heute",
        classLabel: "Klasse:",
        month: "Monat",
        week: "Woche",
        yourWeeklyTimetable: "Dein Wochenplan",
      },
    },
    programDetails: {
      loading: "Wird geladen...",
      eyebrow: "Programme",
      notFound: {
        title: "Programm nicht gefunden",
        hint: "Wähle ein Programm aus der Liste oder erstelle ein neues.",
      },
      actions: {
        backToDashboard: "Zurück zum Dashboard",
        backToHome: "Zur Startseite",
        newProgram: "Neues Programm",
        addLevel: "Stufe hinzufügen",
      },
      sidebar: {
        allPrograms: "Alle Programme",
        editTitle: "Bearbeiten",
        editAction: "Bearbeiten",
      },
      sections: {
        overview: "Übersicht",
        learning: "Was Schüler lernen werden",
        morePrograms: "Weitere Programme",
        levels: { single: "Stufe", plural: "Stufen" },
      },
      levels: {
        pickFirst: "Wähle zuerst eine Stufe aus, um Details zu sehen.",
        chooseLevel: "Stufe wählen",
        levelTitle: "Stufe {{grade}}",
        levelImageAlt: "Bild der Stufe {{grade}}",
      },
      cta: { enrollNow: "Jetzt anmelden" },
      editor: {
        title: "Programm bearbeiten",
        delete: "Löschen",
        save: "Speichern",
        cancel: "Abbrechen",
      },
      fields: {
        accentColor: "Akzentfarbe",
        icon: "Symbol",
        custom: "Benutzerdefiniert",
        assignedTeacher: "Zugewiesene Lehrkraft",
        unassigned: "Nicht zugewiesen",
        teacherFallback: "Lehrkraft",
        title: "Titel",
        shortDescription: "Kurzbeschreibung",
        details: "Details",
        keyPoints: "Kernpunkte",
        levels: "Stufen",
        previewLevelsPage: "Stufen-Seite ansehen",
        levelRowTitle: "Stufe {{index}}",
        remove: "Entfernen",
        grade: "Stufe/ID",
        label: "Bezeichnung",
        description: "Beschreibung",
        uploadImage: "Bild hochladen",
        uploading: "Wird hochgeladen…",
        chooseFile: "Datei auswählen",
        removeImage: "Bild entfernen",
        imageUrl: "Bild-URL",
        ctaLabel: "Button-Text",
        ctaLink: "Button-Link",
        displayOrder: "Anzeigereihenfolge",
        active: "Aktiv",
      },
      placeholders: { grade: "z. B. 1", levelName: "Name der Stufe" },
      errors: {
        unauthorized: "Nicht autorisiert",
        uploadFailed: "Upload fehlgeschlagen",
        levelsRequireGrade:
          "Bitte fülle die Stufen-ID/den Grad für alle Stufen aus, bevor du speicherst",
        titleRequired: "Titel ist erforderlich",
      },
      confirm: {
        deleteProgram:
          "Dieses Programm löschen? Das kann nicht rückgängig gemacht werden.",
      },
      draft: { title: "Neues Programm" },
      icons: {
        reading: "Lesen",
        graduation: "Abschluss",
        math: "Mathe",
        science: "Wissenschaft",
        language: "Sprache",
        coding: "Programmierung",
        islamicStudies: "Islamische Studien",
        atom: "Atom",
        design: "Design",
        writing: "Schreiben",
        globe: "Globus",
        star: "Stern",
        bookLegacy: "Buch (alt)",
        scienceLegacy: "Wissenschaft (alt)",
      },
    },
    programLevelSelect: {
      title: "Stufe auswählen",
      subtitle: {
        forProgram: "Für das Programm: {{title}}",
        continue: "Dann weiter zu den Programmdetails.",
      },
      actions: { backToHome: "Zur Startseite" },
      states: {
        noLevels: "Derzeit sind keine Stufen für dieses Programm verfügbar.",
      },
    },
    lessonDetail: {
      idLabel: "Lektions-ID",
      backToList: "Zurück zur Liste",
      edit: "Lektion bearbeiten",
      delete: "Lektion löschen",
      deleteConfirm: "Diese Lektion dauerhaft löschen?",
      loading: "Lektionsdetails werden geladen...",
      error: "Lektion konnte nicht geladen werden: ",
      notFound: "Lektion nicht gefunden.",
      scheduledAt: "Datum und Uhrzeit",
      description: "Lektionsbeschreibung",
      student: "Schüler",
      teacher: "Lehrer",
      duration: "Dauer der Lektion",
      minutes: "Minuten",
      createdAt: "Erstellt am",
      updatedAt: "Aktualisiert am",
      packInfo: "Pack-Informationen",
      pack: "Paket",
      subject: "Fach",
      price: "Preis",
      partOfPack: "Teil des Pakets",
      meetingStatus: "Meeting-Link",
      meetingReady: "Bereit",
      meetingPending: "Noch nicht erstellt",
      joinMeeting: "Meeting beitreten",
      generateMeeting: "Meeting-Link erstellen",
      generatingMeeting: "Wird erstellt...",
      notifyParentsTitle: "Eltern benachrichtigen",
      notifyParentsStatus: "Status",
      notifyParentsMessage: "Nachricht",
      notifyParentsSend: "Senden",
      notifyParentsSending: "Wird gesendet...",
      notifyParentsSuccess: "Benachrichtigung gesendet.",
      notifyParentsSuccessCount:
        "Benachrichtigung an {{count}} Eltern gesendet.",
    },
    lessonEditor: {
      accessDenied:
        "Dieser Account kann keine Lektionen erstellen oder bearbeiten.",
      backToList: "Zurück zur Lektionenliste",
      loading: "Formular wird vorbereitet...",
      loadError: "Lektion konnte nicht geladen werden",
      title: { edit: "Lektion bearbeiten", create: "Neue Lektion erstellen" },
      note: {
        edit: "Aktualisieren Sie Details, Zeit oder Status der Lektion.",
        create:
          "Tragen Sie die nächste Lektion ein und verknüpfen Sie den richtigen Schüler.",
      },
      genericError: "Beim Laden ist ein Fehler aufgetreten",
      form: {
        title: "Titel der Lektion",
        description: "Beschreibung",
        scheduledAt: "Zeit der Lektion",
        duration: "Dauer der Lektion (Minuten)",
        status: "Status der Lektion",
        classGroup: "Klasse",
        allStudents: "Alle Schüler",
        students: "Schüler",
        student: "Schüler",
        teacher: "Lehrer-ID (Admins)",
        allowParentJoinMeeting: "Elternteil darf dem Meeting beitreten",
        pack: "Verknüpftes Paket (optional)",
        image: "Bild-URL (optional)",
      },
      placeholders: {
        title: "z. B. Mathe-Review – Dezimalzahlen",
        description: "Notizen zu Zielen, Ressourcen oder Anweisungen",
        student: "Schüler-ID eingeben oder aus Liste wählen",
        teacher: "ID des verantwortlichen Lehrers eingeben",
        noPack: "Kein bestimmtes Paket",
        image: "https://",
      },
      help: {
        scheduledAt:
          "Zeit wird in Ihrer lokalen Zeitzone gespeichert und automatisch in UTC konvertiert.",
        student:
          "Schüler-IDs erscheinen hier. Eltern sehen alle Kinder, Lehrkräfte sehen zuvor unterrichtete Schüler.",
        teacher:
          "Diese Nummer muss zu einem Benutzer mit der Rolle Lehrer gehören.",
        allowParentJoinMeeting:
          "Wenn deaktiviert, sieht der Elternteil den Meeting-Link nicht.",
        classCreatesLessons:
          "Die Auswahl einer Klasse erstellt eine Lektion pro Schüler in dieser Klasse.",
        classStudents: "Schüler der Klasse",
      },
      status: {
        scheduled: "Geplant",
        completed: "Abgeschlossen",
        cancelled: "Abgesagt",
      },
      errors: {
        title: "Bitte einen Titel eingeben.",
        schedule: "Bitte ein gültiges Datum und eine gültige Zeit wählen.",
        student: "Ungültige Schüler-ID. Verwenden Sie die numerische Kennung.",
        duration: "Die Dauer muss eine positive Zahl sein.",
        teacher: "Ungültige Lehrer-ID.",
        noStudentsInClass: "Diese Klasse hat keine Schüler",
      },
      actions: {
        saving: "Wird gespeichert...",
        update: "Lektion aktualisieren",
        save: "Lektion speichern",
        cancel: "Abbrechen und zurück",
      },
    },
    teacherPublicProfile: {
      avatarAlt: "Avatar",
      actions: {
        back: "Zurück",
        follow: "Folgen",
        chat: "Chat",
        viewProfile: "Ansehen",
      },
      sections: {
        about: "Über",
        experience: "Berufserfahrung",
        education: "Ausbildung",
        skills: "Fähigkeiten",
        teachers: "Lehrkräfte",
      },
      labels: {
        noInfo: "Noch keine Informationen",
        defaultHeadline: "Casaclass Lehrer",
        since: "Seit",
        verified: "Verifiziert",
        teacher: "Lehrer",
      },
      states: {
        loading: "Wird geladen...",
        notFound: "Lehrer nicht gefunden.",
        loadError: "Lehrerprofil konnte nicht geladen werden.",
      },
      tooltips: { comingSoon: "Kommt bald" },
    },
    profile: {
      roles: {
        adminFull: "Plattform-Administrator",
        teacherFull: "Casaclass Lehrkraft",
        parentFull: "Elternteil",
        studentFull: "Schüler",
        adminShort: "Admin",
        teacherShort: "Lehrer",
        parentShort: "Eltern",
      },
      common: {
        loadingData: "Wird geladen...",
        idLabel: "ID: {{id}}",
        dobLabel: "Geburtsdatum: {{date}}",
        unknown: "Unbekannt",
      },
      messages: {
        profileUpdated: "Ihre Angaben wurden erfolgreich aktualisiert.",
        avatarUpdated: "Ihr Profilbild wurde erfolgreich aktualisiert.",
      },
      actions: {
        saving: "Wird gespeichert...",
        saveChanges: "Änderungen speichern",
        cancelEdit: "Bearbeitung abbrechen",
        edit: "Bearbeiten",
        delete: "Löschen",
        refresh: "Aktualisieren",
      },
      overview: {
        aboutTitle: "Über",
        aboutTextStudent:
          "Dies ist das Schülerprofil, das mit dem Schülermodus verknüpft ist.",
        aboutTextUser:
          "Hier können Sie Ihre Kontoinformationen verwalten und den angezeigten Namen aktualisieren.",
        uploadingPhoto: "Foto wird hochgeladen...",
        changePhoto: "Foto ändern",
        upcomingLessons: "Bevorstehende Lektionen",
        noUpcomingLessons: "Keine bevorstehenden Lektionen.",
      },
      progress: {
        title: "Profilfortschritt",
        subtitle:
          "Vervollständigen Sie Ihre Angaben für eine bessere Erfahrung.",
        completeProfile: "Profil vervollständigen",
      },
      studentDetails: {
        title: "Schülerdetails",
        notFound: "Schüler konnte nicht gefunden werden.",
      },
      personal: {
        title: "Persönliche Informationen",
        subtitleStudent: "Schülerinformationen im Schülermodus.",
        subtitleUser:
          "Aktualisieren Sie den Namen, der auf der Plattform angezeigt wird.",
        edit: "Bearbeiten",
        accountDetailsAria: "Kontodetails",
      },
      fields: {
        firstName: "Vorname",
        lastName: "Nachname",
        phone: "Telefonnummer",
        role: "Rolle",
        email: "E-Mail",
        dob: "Geburtsdatum",
        completion: "Profilstatus",
        status: "Status",
        notes: "Notizen",
      },
      placeholders: {
        firstName: "z. B. Ahmed",
        lastName: "z. B. Ben Mahmoud",
        phone: "z. B. +216 55 544 475",
      },
      students: {
        title: "Meine Kinder",
        subtitle:
          "Fügen Sie Kinder hinzu oder aktualisieren Sie ihre Daten, damit Lehrkräfte leichter planen können.",
        placeholders: {
          firstName: "z. B. Ali",
          lastName: "z. B. Ben Salem",
          notes: "Zusätzliche Informationen für das Casaclass-Team",
        },
        actions: {
          add: "Schüler hinzufügen",
          update: "Schüler aktualisieren",
        },
        loading: "Schüler werden geladen...",
        empty: "Es wurden noch keine Kinder hinzugefügt.",
        errors: {
          firstNameRequired: "Vorname ist erforderlich",
        },
        confirmDelete: "Möchten Sie diesen Schüler löschen?",
      },
      classes: {
        title: "Meine Klassen",
        subtitle:
          "Erstellen Sie eine Klasse mit einem oder mehreren Schülern, um Lektionen zu organisieren.",
        fields: {
          name: "Klassenname",
          students: "Schüler",
        },
        placeholders: {
          name: "z. B. Matheklasse",
        },
        actions: {
          add: "Klasse hinzufügen",
          update: "Klasse aktualisieren",
        },
        loading: "Klassen werden geladen...",
        empty: "Es wurden noch keine Klassen erstellt.",
        emptyRoster: "Noch keine Schüler sind mit Ihren Lektionen verknüpft.",
        studentsCount: "Schüler: {{count}}",
        noStudentsSelected: "Keine Schüler ausgewählt.",
        errors: {
          nameRequired: "Klassenname ist erforderlich",
        },
        confirmDelete: "Möchten Sie diese Klasse löschen?",
      },
      lessons: {
        title: "Lektionsübersicht",
        subtitle:
          "Ein schneller Überblick über Ihre Lektionen und die nächsten Termine.",
        stats: {
          total: "Lektionen gesamt",
          completed: "Abgeschlossen",
          cancelled: "Abgesagt",
        },
        labels: {
          scheduledAt: "Termin: {{datetime}}",
          student: "Schüler: {{name}}",
          duration: "Dauer: {{minutes}} Minuten",
        },
        empty: "Noch keine Lektionen vorhanden.",
      },
      users: {
        title: "Benutzerverwaltung",
        subtitle:
          "Sehen Sie registrierte Konten ein und ändern Sie Rollen bei Bedarf.",
        filters: {
          role: "Nach Rolle filtern",
          allRoles: "Alle Rollen",
          search: "Nach E-Mail oder Name suchen",
        },
        placeholders: {
          search: "example@casaclass.com",
        },
        actions: {
          search: "Suchen",
          reset: "Zurücksetzen",
        },
        loading: "Benutzer werden geladen...",
        summary:
          "Ergebnisse: {{total}} — Admins: {{admins}}, Lehrer: {{teachers}}, Eltern: {{parents}}",
        empty: "Keine Konten passen zu Ihrer Suche.",
        table: {
          email: "E-Mail",
          name: "Name",
          role: "Rolle",
          status: "Status",
        },
      },
    },
    studentsPage: {
      noAccess: {
        title: "Schülerverwaltung",
        lead: "Diese Seite ist Eltern vorbehalten, um ihre Kinder in Casaclass zu verwalten.",
        body: "Ihr Konto hat keine Berechtigung, Schüler zu verwalten. Bitte zurück zum Dashboard.",
      },
      title: "Meine Kinder",
      lead: "Fügen Sie Kinder hinzu, aktualisieren Sie ihre Daten und verfolgen Sie kommende Lektionen hier.",
      leadStudentMode:
        'Aktivieren Sie den "Schülermodus" für ein Kind, um direkt aus dem Elternkonto zu dessen Ansicht zu wechseln.',
      form: {
        newTitle: "Neuen Schüler hinzufügen",
        editTitle: "Schülerdaten aktualisieren",
        firstName: "Vorname",
        lastName: "Nachname",
        dob: "Geburtsdatum",
        password: "Passwort",
        notes: "Notizen",
      },
      placeholders: {
        firstName: "z. B. Yasmine",
        lastName: "z. B. Ben Salah",
        password: "Mindestens 8 Zeichen",
        notes: "Zusätzliche Infos für Lehrkräfte.",
      },
      actions: {
        create: "Schüler hinzufügen",
        update: "Schüler aktualisieren",
        saving: "Speichern...",
        cancel: "Abbrechen",
      },
      list: {
        title: "Kinderliste",
        refresh: "Aktualisieren",
        loading: "Schüler werden geladen...",
        timetable: "Orario",
        empty: "Noch keine Kinder erfasst.",
      },
      card: {
        upcoming: "{{count}} anstehende Lektionen",
        noUpcoming: "Keine anstehenden Lektionen",
        dob: "Geburtsdatum: {{date}}",
        edit: "Bearbeiten",
        enterAs: "Als Schüler öffnen",
        delete: "Löschen",
      },
      confirmDelete: "Möchten Sie diesen Schüler löschen?",
      feedback: {
        created: "Schüler erfolgreich hinzugefügt.",
        createdWithLogin: "Schüler hinzugefügt. Login-E-Mail: {{email}}",
        updated: "Schüler aktualisiert.",
        deleted: "Schüler gelöscht.",
      },
      detail: {
        title: "Details für {{name}}",
        lead: "Hier sehen Sie das Profil und die kommenden Lektionen des Schülers.",
        loadingLessons: "Lektionen werden aktualisiert...",
        activate: "Schülermodus aktivieren",
        active: "Schülermodus ist für dieses Konto aktiv",
        stats: {
          total: "Anzahl Lektionen",
          completed: "Abgeschlossen",
          cancelled: "Abgesagt",
        },
        info: {
          title: "Schülerinfos",
          name: "Name:",
          dob: "Geburtsdatum:",
          notes: "Notizen:",
          noNotes: "Keine Notizen",
        },
        upcoming: {
          title: "Kommende Lektionen",
          time: "Termin: {{value}}",
          duration: "Dauer: {{value}} Minuten",
          teacher: "Lehrkraft: {{value}}",
          empty: "Keine kommenden Lektionen für diesen Schüler.",
        },
      },
      errors: {
        firstNameRequired: "Vorname ist erforderlich",
        passwordRequired: "Passwort ist erforderlich",
        passwordMin: "Das Passwort muss mindestens 8 Zeichen enthalten",
      },
    },
    aboutPage: {
      hero: {
        label: "Casaclass",
        title: "Unsere Geschichte",
        story: [
          "Seit Tag eins möchten wir jedem tunesischen Kind, ob in Tunesien oder im Ausland, einen warmen, modernen Lernraum bieten, der seine Identität schützt.",
          "Bildung ist mehr als Wissen; sie verbindet Generationen und stiftet Zugehörigkeit.",
        ],
        illustrationAlt: "Casaclass Community Illustration",
        highlights: [
          {
            icon: "🌍",
            title: "Vernetzte Diaspora",
            description:
              "Eine tunesische Schule, die mit Ihrer Familie mitreist.",
          },
          {
            icon: "🎓",
            title: "Leidenschaftliche Experten",
            description:
              "Zertifizierte tunesische Lehrkräfte gestalten jeden Lernweg.",
          },
          {
            icon: "🤝",
            title: "Fürsorgliche Begleitung",
            description:
              "Einstufungstest, 1:1 Coaching und Fortschrittszertifikate.",
          },
        ],
      },
      mission: {
        label: "Unsere Mission",
        title: "Wofür wir stehen",
        description:
          "Akademische Exzellenz mit kulturellen Wurzeln für jede tunesische Familie verbinden.",
        items: [
          {
            title: "Qualitätszugang",
            description:
              "Passgenaue Lektionen von qualifizierten tunesischen Lehrkräften.",
          },
          {
            title: "Wurzeln & Identität",
            description: "Arabisch, Koran und Hadith, um verbunden zu bleiben.",
          },
          {
            title: "Globaler Fit",
            description:
              "Programme im Einklang mit tunesischen und internationalen Curricula.",
          },
          {
            title: "Flexibel & motivierend",
            description:
              "Ramadan-, Sommer-, Revisionspakete und mitreißende Sessions.",
          },
        ],
      },
      resources: {
        label: "Unsere Ressourcen",
        title: "Was wir bereitstellen",
        description:
          "Konkrete Tools, Themenpakete und ein Team, das jederzeit hilft.",
        items: [
          {
            title: "Spezialisiertes Team",
            description: "Expert:innen für akademische und spirituelle Wege.",
          },
          {
            title: "Fertige Pakete",
            description:
              "Ramadan-Pakete, Schulmodule, kontinuierliche Unterstützung.",
          },
          {
            title: "Rundum-Begleitung",
            description:
              "Einstufungstest, 1:1 Follow-up, Assessments und Zertifikate.",
          },
          {
            title: "Zugängliche Plattform",
            description: "Online-Zugang aus Europa, dem Golf und Tunesien.",
          },
        ],
      },
      values: {
        label: "Unsere Werte",
        title: "Leitprinzipien",
        description:
          "Diese Werte steuern jede pädagogische und menschliche Entscheidung.",
        items: [
          {
            title: "Fürsorge",
            description: "Lernende im Mittelpunkt mit warmherziger Begleitung.",
          },
          {
            title: "Exzellenz",
            description: "Jede Stunde wird sorgfältig konzipiert und geprüft.",
          },
          {
            title: "Authentizität",
            description:
              "Wahrung tunesischer Wurzeln und spiritueller Dimension.",
          },
          {
            title: "Innovation",
            description:
              "Moderne Tools, interaktive Videos, spielerische Checks.",
          },
          {
            title: "Gerechtigkeit",
            description: "Bildung zugänglich machen – egal wo Familien leben.",
          },
        ],
      },
      vision: {
        label: "Unsere Vision",
        title: "Wohin wir gehen",
        description:
          "Casaclass zu einem nachhaltigen Modell machen, das mit Familien wächst.",
        intro:
          "Wir wollen die führende tunesische E-Learning-Referenz für Kinder werden, indem wir aufbauen:",
        points: [
          "Eine Gemeinschaft aus Schülern, Eltern und Lehrkräften, die Kultur und Ambition teilen.",
          "Kontinuierlich erneuerte Programme mit Themenpaketen und pädagogischer Innovation.",
          "Eine skalierbare, nachhaltige Plattform für tunesische Familien überall.",
        ],
      },
      uniques: {
        label: "Was uns unterscheidet",
        title: "Warum Casaclass herausragt",
        description:
          "Ein ganzheitliches Erlebnis, das Strenge, Spiritualität und digitale Innovation verbindet.",
        items: [
          {
            title: "Hybrider Ansatz",
            description:
              "Akademisch und spirituell plus digitale Denkfähigkeiten.",
          },
          {
            title: "Volle Personalisierung",
            description:
              "Einstufungstest und individueller Pfad für jedes Kind.",
          },
          {
            title: "Geografische Flexibilität",
            description:
              "Ideal für Familien in Europa, im Golf und in Tunesien.",
          },
          {
            title: "Pädagogisches Engagement",
            description:
              "Engagierte Lehrkräfte, moderne Tools, echtes Follow-up.",
          },
        ],
      },
      showcase: {
        label: "In Bildern",
        title: "Unsere Vision in Momentaufnahmen",
        description:
          "Drei Einblicke in Casaclass: Community-Energie, ein geführter Pfad und eine Plattform überall.",
        cards: [
          {
            title: "Engagierte Community",
            description: "Familien, Lernende und Mentoren wachsen gemeinsam.",
            alt: "Casaclass Community",
          },
          {
            title: "Immersiver Weg",
            description:
              "Klarer Fahrplan, angenehme Aktivitäten, stetiges Feedback.",
            alt: "Casaclass Lernpfad",
          },
          {
            title: "Immer erreichbar",
            description:
              "Eine moderne, einfache Oberfläche auf jeder Reise und jedem Gerät.",
            alt: "Casaclass Plattform",
          },
        ],
      },
      cta: {
        title: "Bereit, der Casaclass-Community beizutreten?",
        description:
          "Sprechen Sie mit unserem Team, finden Sie das passende Programm und geben Sie dem Lernen Ihres Kindes Schub.",
        primary: "Mit dem Team sprechen",
        secondary: "Konto erstellen",
      },
    },
    dashboard: {
      role: {
        admin: "Plattform-Admin",
        superadmin: "Superadmin",
        support: "Support",
        accounting: "Buchhaltung",
        teacher: "Lehrkraft",
        parent: "Elternteil",
        member: "Casaclass-Mitglied",
      },
      searchPlaceholder: "Suchen...",
      loading: "Laden...",
      hero: {
        greeting: "Willkommen {{name}}, 👋",
        intro:
          "Ein schneller Überblick über kommende Stunden, verknüpfte Schüler:innen und empfohlene Casaclass-Pakete.",
        manageLessons: "Stunden verwalten",
        browseOffers: "Angebote ansehen",
        nextLesson: "Nächste Stunde",
        student: "Schüler:in",
        teacher: "Lehrkraft",
        time: "Zeit",
        duration: "Dauer",
      },
      stats: {
        total: { label: "Stunden", hint: "Alle erfassten Stunden" },
        upcoming: { label: "Bevorstehend", hint: "Demnächst geplant" },
        completed: { label: "Abgeschlossen", hint: "Bereits erledigt" },
        cancelled: { label: "Abgesagt", hint: "Abgesagte Stunden" },
      },
      upcoming: {
        title: "Bevorstehende Stunden",
        subtitle: "Die nächsten vier Stunden, um dran zu bleiben.",
        viewAll: "Alle ansehen",
        loading: "Lade Stunden...",
        empty:
          "Keine bevorstehenden Stunden. Du kannst eine neue Stunde auf der Stunden-Seite planen.",
      },
      students: {
        title: "Verknüpfte Schüler:innen",
        subtitle: "Schüler:innen, die mit deinem Konto verbunden sind.",
        id: "Kennung",
        dob: "Geburtsdatum",
        empty: "Keine Schülerdaten.",
      },
      featured: {
        title: "Empfohlene Pakete",
        subtitle: "Empfehlungen aus dem Casaclass-Katalog.",
        explore: "Alle Pakete entdecken",
        lessonsCount: "Stunden",
        sessionLength: "Sitzungsdauer",
        price: "Preis",
        learnMore: "Mehr erfahren",
      },
      errors: {
        loadData: "Einige Daten konnten nicht geladen werden: {{error}}",
      },
      teacher: {
        roleLabel: "Lehrkraft-Dashboard",
        greeting: "Hallo {{name}}",
        intro:
          "Schneller Überblick über Stunden, Schüler:innen und Kommunikation mit Eltern.",
        performance: {
          title: "Leistung",
          completed: "Abgeschlossen",
          cancelled: "Abgesagt",
        },
        programs: {
          title: "Meine Programme",
          loading: "Programme werden geladen...",
          edit: "Bearbeiten",
          empty: "Noch keine Programme.",
        },
        weeklyActivity: {
          title: "Wöchentliche Aktivität",
          hint: "Letzte 7 Tage",
        },
        topStudents: {
          title: "Aktivste Schüler:innen",
          lessons: "{{count}} Stunden",
          empty: "Noch nicht genug Daten.",
        },
        updates: {
          title: "Letzte Updates",
          empty: "Noch keine Updates.",
        },
        actions: {
          schedule: "Stunden planen",
          newLesson: "Stunde erstellen",
        },
        stats: {
          activeStudents: { label: "Aktive Schüler:innen" },
          hoursGiven: { label: "Unterrichtsstunden" },
          completed: { label: "Abgeschlossene Sitzungen" },
          cancelled: { label: "Abgesagte Sitzungen" },
        },
        schedule: {
          title: "Live-Stundenplan",
          subtitle: "Nächste Stunden und ihr Status.",
          view: "Plan ansehen",
          loading: "Lade Plan...",
          empty: "Keine bevorstehenden Stunden.",
        },
        manage: {
          title: "Stunden verwalten",
          subtitle: "Stunden, Ressourcen und Anwesenheit verwalten.",
          createEdit: {
            title: "Erstellen / bearbeiten",
            description: "Stunden einfach planen, bearbeiten oder duplizieren.",
          },
          upload: {
            title: "Ressourcen hochladen",
            description: "PDF, Video oder Quiz hinzufügen.",
          },
          attendance: {
            title: "Anwesenheit erfassen",
            description: "Anwesenheit pro Stunde markieren.",
          },
        },
        assessments: {
          title: "Assessments & Feedback",
          subtitle: "Noten, Kommentare und Hausaufgaben-/Testhistorie.",
          grades: {
            title: "Noten & Hinweise",
            description: "Note und Kommentar pro Schüler:in hinzufügen.",
          },
          homework: {
            title: "Hausaufgaben / Tests",
            description: "Korrigierte Aufgaben prüfen und nachverfolgen.",
          },
        },
        communication: {
          title: "Messages",
          subtitle: "Interne Nachrichten und Benachrichtigungen.",
          messaging: {
            title: "Interne Nachrichten",
            description: "Sicherer Chat mit Schüler:innen und Eltern.",
          },
          notifications: {
            title: "Systembenachrichtigungen",
            description: "Neue Schüler:innen oder Planänderungen.",
          },
        },
        payments: {
          title: "Zahlungen",
          subtitle: "Casaclass-Auszahlungen und monatliche Abrechnungen.",
          history: {
            title: "Auszahlungshistorie",
            description: "Deine Auszahlungen erscheinen hier.",
          },
          invoicing: {
            title: "Automatische Rechnungen",
            description: "Monatsübersicht wird automatisch erstellt.",
          },
        },
      },
      parent: {
        roleLabel: "Eltern-Dashboard",
        greeting: "Hallo {{name}}",
        intro: "Behalte Kinder, Stunden, Hinweise und Abrechnung im Blick.",
        classes: {
          title: "Klassen",
          subtitle: "Aktuelle Klassen für jedes Kind",
        },
        widgets: {
          studentModeLabel: "Schülermodus",
          studentModePlaceholder: "Als Schüler öffnen",
          notifications: "Benachrichtigungen",
          weekSubtitle: "Schnellansicht der Stunden dieser Woche.",
          noLessons: "Keine Stunden.",
          reminders: "Erinnerungen",
          reminderCheckbox: "Als erledigt markieren",
          recommended: "Empfohlen",
          monthStats: "Statistik dieses Monats",
          monthStatsHint: "Kurzübersicht",
          children: "Kinder",
          homework: "Hausaufgaben",
          homeworkHint: "Nächste anstehende Stunden.",
        },
        notifications: {
          empty: "Keine Benachrichtigungen.",
          markRead: "Als gelesen markieren",
          status: {
            cancelled: "Abgesagt",
            postponed: "Verschoben",
            updated: "Aktualisiert",
          },
        },
        actions: {
          weekly: "Wochenplan",
          support: "Support-Ticket öffnen",
        },
        activeStudent: {
          status: "Schülermodus ist aktiv",
          none: "Kein/e Schüler:in ausgewählt",
          label: "Modus {{name}}",
          subtitle: "Direkter Zugriff auf den Bereich der ausgewählten Person.",
          deactivate: "Modus deaktivieren",
          prompt: "Wähle eine/n Schüler:in aus, um den Bereich zu aktivieren.",
        },
        children: {
          title: "Verknüpfte Kinder",
          subtitle: "Gesamtfortschritt und nächste Stunden.",
          addChild: "Kind hinzufügen",
          progress: "Fortschritt",
          nextLesson: "Nächste Stunde",
          activate: "Schülermodus aktivieren",
          active: "Schülermodus aktiv",
          viewLessons: "Stunden ansehen",
          loading: "Lade Kinder...",
          empty: "Keine verknüpften Kinder.",
        },
        followup: {
          title: "Stunden-Follow-up",
          subtitle: "Wochenplan und Aufzeichnungen (Replays/Ressourcen).",
          loading: "Lade Stunden...",
          empty: "Diese Woche sind keine Stunden geplant.",
        },
        communication: {
          title: "Kommunikation",
          subtitle: "Sicherer Chat mit Lehrkräften und Support.",
          teacherChat: {
            title: "Lehrkraft-Chat",
            description: "Privater Thread pro Stunde.",
          },
          supportTicket: {
            title: "Support-Ticket",
            description: "Anfragen an das Casaclass-Team senden.",
          },
        },
        billing: {
          title: "Zahlungen & Abrechnung",
          subtitle: "Abos, PDF-Rechnungen und Paketverwaltung.",
          activeSubs: {
            title: "Aktive Abos",
            description: "Aktuelle Angebote erscheinen hier.",
          },
          invoices: {
            title: "Download-Rechnungen",
            description: "Rechnungen (PDF) herunterladen.",
          },
          renew: {
            title: "Verlängern / kündigen",
            description: "Abo-Optionen verwalten.",
          },
        },
        profile: {
          title: "Elternprofil",
          subtitle: "Kontaktinfos und bevorzugte Zahlungsmethode.",
          contact: {
            title: "Kontaktdaten",
            description: "Persönliche Daten aktualisieren.",
          },
          payment: {
            title: "Zahlungsmethode",
            description: "Zahlungsmethode hinzufügen oder ändern.",
          },
          widgets: {
            studentModeLabel: "Modalità studente",
            studentModePlaceholder: "Entra come studente",
            notifications: "Notifiche",
            weekSubtitle: "Vista rapida delle lezioni di questa settimana.",
            noLessons: "Nessuna lezione.",
            reminders: "Promemoria",
            reminderCheckbox: "Segna come fatto",
            recommended: "Consigliati",
            monthStats: "Statistiche del mese",
            monthStatsHint: "Panoramica",
            children: "Figli",
            homework: "Compiti",
            homeworkHint: "Prossime lezioni in arrivo.",
          },
          manageChildren: {
            title: "Kinder verwalten",
            description: "Verknüpfte Kinder hinzufügen oder entfernen.",
          },
        },
        modal: {
          exitTitle: "Rückkehr zum Elternmodus bestätigen",
          exitBody:
            "Zur Sicherheit bitte das Eltern-Passwort eingeben, bevor du zurück wechselst.",
          passwordLabel: "Passwort",
          passwordError: "Falsches Passwort. Bitte erneut versuchen.",
          cancel: "Abbrechen",
          confirm: "Bestätigen",
          verifying: "Wird geprüft...",
          backToParent: "Zurück zum Elternmodus",
          logout: "Abmelden",
        },
      },
      studentSpace: {
        tag: "Schülerbereich",
        title: "Schüler-Dashboard — {{name}}",
        subtitle:
          "Bevorstehende Stunden, Fortschritt, Nachrichten und Ressourcen.",
        errors: {
          profileLoad: "Schülerprofil konnte nicht geladen werden.",
        },
        banner: {
          badge: "Stern des Tages",
          greeting: "Hallo, {{name}}",
          hint: "Schön, dass du wieder da bist! Mach dich bereit und lerne heute weiter.",
          imageAlt: "Kinder beim Lernen",
          stats: {
            courses: "Kurse",
            xp: "XP",
            completed: "Abgeschlossen",
          },
        },
        today: {
          title: "Stunden heute",
          hint: "Spaßige Stunden warten heute auf dich!",
          empty: "Heute keine Stunden. Viel Spaß in der Pause!",
        },
        missions: {
          title: "Deine Missionen",
          hint: "Wähle eine Mission und sammle Sterne!",
          mentor: {
            title: "Mentor fragen",
            body: "Hol dir heute einen kurzen Tipp.",
          },
          challenge: {
            title: "Neue Herausforderung",
            body: "Starte eine neue Stunde und sammle XP!",
          },
        },
        classes: {
          title: "Deine Klasse",
          hint: "Deine Klassen & Freunde",
          allTab: "Alle",
          friends: "{{count}} Freunde",
          classLabel: "Klasse: {{name}}",
          empty: "Keine Klassen verknüpft.",
        },
        activity: {
          title: "Deine Aktivität",
          hint: "Schneller Blick auf deinen Fortschritt der letzten Monate.",
        },
        cards: {
          upcoming: { label: "Bevorstehend", hint: "Geplante Sitzungen" },
          past: { label: "Vergangen", hint: "Aktuelle Einträge" },
          badges: { label: "Abzeichen", hint: "Sichtbarer Fortschritt" },
          stars: { label: "Sterne", hint: "Ansporn" },
        },
        upcoming: {
          title: "Bevorstehende Stunden",
          subtitle: "Live-Raum betreten (Zoom/BBB).",
          empty: "Keine geplanten Stunden.",
          join: "Raum betreten",
        },
        past: {
          title: "Vergangene Stunden",
          subtitle: "Replays, Dateien und Assessments.",
          empty: "Keine vergangenen Stunden.",
          viewResources: "Ressourcen ansehen",
        },
        resources: {
          title: "Ressourcen",
          subtitle: "Bibliothek nach Fach mit Links und Videos.",
        },
        messages: {
          title: "Neueste Nachrichten",
          subtitle: "Austausch mit Lehrkräften.",
          open: "Nachrichten öffnen",
        },
        feedback: {
          title: "Rückmeldungen",
          subtitle: "Noten, Kommentare sehen und die Stunde bewerten.",
        },
      },
    },
    landingPage: {
      subjectsGrid: {
        title: "Fächer",
        description:
          "Entdecken Sie unsere Programme, die Ihr Kind in jedem Fach unterstützen, mit spezialisierter pädagogischer Begleitung für Exzellenz und Selbstvertrauen.",
        cta: "Unsere Angebote ansehen",
        ariaLabel: "Programme",
        managePrograms: "Programme verwalten",
        items: [],
      },
      hero: {
        title: "An eurer Seite bei jedem Schritt",
        lead: "Casaclass ist eine tunesische Lernplattform, die euer Zuhause überall erreicht. Wir begleiten eure Kinder in Schule, Sprachen und Werten, damit sie mit Selbstvertrauen, Identität und Wissen wachsen.",
        primaryCta: "Jetzt starten",
        secondaryCta: "Unsere Angebote ansehen",
        videoTitle: "Casaclass Vorstellungsvideo",
        statsLabel: "Casaclass Kennzahlen",
        stats: [
          { value: "5.000+", label: "Begleitete Familien" },
          { value: "230+", label: "Interaktive Lektionen" },
          { value: "45", label: "Tunesische Lehrkräfte" },
          { value: "4,9/5", label: "Zufriedenheit der Eltern" },
        ],
      },
      features: {
        tag: "Eine Schule für jedes Kind",
        title: "Warum Casaclass?",
        description:
          "Entstanden, um unsere Kinder mit Sprache, Kultur und Werten zu verbinden – egal wo sie leben. Wir verbinden tunesische Pädagogik mit modernen Tools für motivierendes Lernen.",
        cta: "Programme entdecken",
        cards: [
          {
            title: "Individueller Weg",
            description:
              "Einstufungstest, maßgeschneiderter Pfad, Familien-Support",
            alt: "Schüler erkundet einen personalisierten Lernpfad",
          },
          {
            title: "Live & on-demand",
            description: "Live-Sitzungen plus Videothek zum Wiederholen",
            alt: "Live-Unterricht auf Casaclass",
          },
          {
            title: "Neuro-pädagogische Begleitung",
            description:
              "Diagnose, Begleitung und personalisierte Lernwege für Exzellenz",
            alt: "Illustration neuro-pädagogische Begleitung",
          },
        ],
      },
      journey: {
        ariaLabel: "Casaclass-Geschichte mit Familien",
        title: "Die Geschichte",
        imageAlt: "Familie vertraut dem Casaclass-Weg",
        paragraphs: [
          "Jedes Gehirn ist einzigartig.",
          "Um Herausforderungen dank maßgeschneiderter neuro-pädagogischer Begleitung in Erfolg zu verwandeln, stellen wir Ihrem Kind die besten Expertinnen und Experten aus Psychologie, Neuropsychiatrie und Pädagogik zur Seite.",
        ],
        cta: "Einstufungstest starten",
      },
      levels: {
        tag: "Los geht's",
        title: "Wählt die Klassenstufe aus",
        description:
          "Jede Stufe vereint streambare Videos, druckbare Hefte und Ziel-Tracking. Wählt heute die passende Stufe und startet eine Reise, die mit eurem Kind wächst.",
        note: "Wenn der Traum möglich ist, ist der Plan nah.",
        ariaPrefix: "Stufe entdecken",
        items: [
          {
            grade: "1",
            label: "Klasse 1",
            accent: 1,
            ariaLabel: "Klasse 1 entdecken",
          },
          {
            grade: "2",
            label: "Klasse 2",
            accent: 2,
            ariaLabel: "Klasse 2 entdecken",
          },
          {
            grade: "3",
            label: "Klasse 3",
            accent: 3,
            ariaLabel: "Klasse 3 entdecken",
          },
          {
            grade: "4",
            label: "Klasse 4",
            accent: 4,
            ariaLabel: "Klasse 4 entdecken",
          },
          {
            grade: "5",
            label: "Klasse 5",
            accent: 5,
            ariaLabel: "Klasse 5 entdecken",
          },
          {
            grade: "6",
            label: "Klasse 6",
            accent: 6,
            ariaLabel: "Klasse 6 entdecken",
          },
          {
            grade: "7",
            label: "Klasse 7",
            accent: 7,
            ariaLabel: "Klasse 7 entdecken",
          },
          {
            grade: "8",
            label: "Klasse 8",
            accent: 8,
            ariaLabel: "Klasse 8 entdecken",
          },
          {
            grade: "9",
            label: "Klasse 9",
            accent: 9,
            ariaLabel: "Klasse 9 entdecken",
          },
        ],
      },
      programs: {
        badge: "Casaclass Programme",
        title: "Vier Casaclass-Säulen",
        imageAlt: "Illustration der Casaclass-Programmsäulen",
        items: [
          {
            title: "1. Kernfächer – Klasse 1 bis 9",
            list: [
              "Wiederholung + Übungen + Erklärvideos",
              "Individuelle Betreuung durch tunesische Lehrkräfte",
              "Monatliches Eltern-Feedback",
              "Schritt-für-Schritt-Lernpfad",
            ],
            slogan: "Klar lernen, sicher vorankommen.",
            cta: "Zum Unterrichtsprogramm",
            ctaLink: "/signup",
          },
          {
            title: "2. Französisch",
            list: [
              "Programme anerkannt vom tunesischen Bildungsministerium",
              "Aussprache- und Sprach-Workshops",
              "Grammatik- und Schreibtraining mit Beispielen",
              "Individuelles Follow-up und regelmäßige Bewertungen",
            ],
            slogan: "Zweitsprache als Tür im Ausland.",
            cta: "Französischkurse entdecken",
            ctaLink: "/courses",
          },
          {
            title: "3. Arabisch • Koran • Hadith",
            list: [
              "Leichtes Auswendiglernen",
              "Tajwid-Grundlagen",
              "Sira & Werte",
              "Arabisch für die neue Generation",
            ],
            cta: "Arabisch- & Korankurse entdecken",
            ctaLink: "/courses",
          },
          {
            title: "4. Coding-Club für Kinder",
            list: [
              "Scratch, Python Kids, Robotik",
              "Lernspiele",
              "Monatliche Mini-Projekte",
              "Kinder von heute, Coder von morgen",
            ],
            slogan: "Zukunft lernen beginnt jetzt.",
            cta: "Dem Coding-Club beitreten",
            ctaLink: "/signup",
          },
        ],
      },
      specialNeeds: {
        ariaLabel: "Unterstützung bei besonderen Bedürfnissen",
        title: "Dein Kind hat besondere Bedürfnisse",
        description:
          "Hier hat es seinen Platz – verbunden mit Fachleuten, die Integration fördern und Fortschritt im eigenen Tempo ermöglichen.",
        imageAlt: "Drei Säulen der Casaclass Programme",
        cta: "Kontaktiert uns",
      },
      ecosystem: {
        title: "Ein klares Casaclass-Universum",
        cta: "Dem Casaclass-Universum beitreten",
        cards: [
          {
            icon: "👨‍👩‍👦",
            title: "Elternbereich",
            items: [
              "Fortschritt verfolgen",
              "Wochenbericht",
              "Lehrer/Gruppe wählen",
            ],
            alt: "Eltern-Dashboard in Casaclass",
          },
          {
            icon: "👦",
            title: "Schülerbereich",
            items: [
              "Hausaufgaben",
              "Kurze Lektionen",
              "Abzeichen & Belohnungen",
            ],
            alt: "Schüler-Dashboard in Casaclass",
          },
          {
            icon: "👩‍🏫",
            title: "Lehrerbereich",
            items: ["Dashboard", "Planung", "Bewertungen"],
            alt: "Lehrer-Dashboard in Casaclass",
          },
        ],
      },
      ramadan: {
        ariaLabel: "Ramadan-Pakete für Kinder",
        badge: "Packs & Ramadan für Kinder",
        title: "Ramadan-Packs",
        lead: "30 wertvolle Videos, Koran, Geschichten und Werteübungen für 5–12-Jährige – ein Ramadan voller Licht, Identität und Staunen.",
        items: [
          "Tagesprogramm inspiriert von Ramadan",
          "Illustrierte Geschichten und Werteübungen jeden Tag",
          "Einfache Koran-Sessions mit klarem Tajwid",
          "Familienaktivitäten für starke Bindung",
        ],
        slogan: "Licht, Lernen und Orientierung.",
        cta: "Bald verfügbar",
        imageAlt: "Casaclass-Lehrer begleitet Kinder im Ramadan-Programm",
      },
      testimonials: {
        ariaLabel: "Casaclass Erfahrungsberichte",
        tag: "Geschichten aus der Community",
        title: "Vertrauen von Familien und Lehrkräften",
        lead: "Von Eltern im Ausland bis zu Lehrkräften in Tunesien – die Plattform vereint inspirierende Kinder und begleitet sie Schritt für Schritt.",
        prev: "Vorheriges Testimonial",
        next: "Nächstes Testimonial",
        dotsLabel: "Testimonials navigieren",
        dotLabel: "Testimonial von {{name}} anzeigen",
        imageAlt: "Elternteil: {{name}}",
        items: [
          {
            quote:
              "Seit wir mit Casaclass begonnen haben, ist Wiederholen ein schöner Teil unseres Familienalltags. Meine Tochter mag den klaren Pfad und digitale Belohnungen, und ich verfolge den Fortschritt entspannt im Elternbereich.",
            name: "Amel Ben Salem",
            place: "Lyon, Frankreich",
          },
          {
            quote:
              "Wir leben in Dubai und durch die Zeitzone waren tunesische Kurse schwer zu finden. Mit Casaclass nehmen wir live teil oder schauen Replays, wann es passt, und die Kinder interagieren mit Lehrern, als wären sie in Tunesien.",
            name: "Rami & Sirine",
            place: "Dubai, VAE",
          },
          {
            quote:
              "Mein Sohn hat Konzentrationsschwierigkeiten; der Lerncoach gab uns einen klaren Plan. Wir erhalten Wochenberichte und Tipps, und jetzt ist er motiviert und erzählt selbst von Arabisch- und Koranstunden.",
            name: "Laila Marzouki",
            place: "Toronto, Kanada",
          },
        ],
      },
      faq: {
        ariaLabel: "Häufige Fragen zu Casaclass",
        tag: "FAQ",
        title: "Eure Fragen",
        lead: "Wir bleiben an eurer Seite vom Start bis zu den Erfolgen eurer Kinder.",
        items: [
          {
            question: "Wie lange bleibt der Zugriff auf die Ressourcen?",
            answer:
              "Jedes Abo öffnet alle Einheiten für 12 Monate mit kostenlosen Updates pro Quartal.",
          },
          {
            question: "Eignen sich die Kurse für die Diaspora?",
            answer:
              "Ja. Der Inhalt ist zweisprachig (Arabisch/Französisch) und folgt dem tunesischen Programm mit Zeitflexibilität.",
          },
          {
            question: "Gibt es persönliches Follow-up?",
            answer:
              "Ab Anmeldung begleitet ein Lerncoach mit monatlichen Check-ins und familientauglichen Tipps.",
          },
          {
            question: "Wie starte ich?",
            answer:
              "Konto erstellen, Klassenstufe wählen und sofort mit Einstufungstest und ersten Lektionen beginnen.",
          },
        ],
      },
      finalCta: {
        ariaLabel: "Casaclass beitreten",
        label: "Bereit?",
        title: "Aktiviere heute die erste Lektion",
        description: "Schnelle Anmeldung + kostenlose Probesession",
        primary: "Jetzt registrieren",
        secondary: "Mit Berater sprechen",
      },
    },
    authPage: {
      loginTitle: "Anmelden",
      loginLead: "Machen Sie dort weiter, wo Sie aufgehört haben.",
      email: "E-Mail",
      emailPlaceholder: "example@mail.com",
      phoneLabel: "Telefonnummer",
      phonePlaceholder: "Geben Sie Ihre Telefonnummer ein",
      password: "Passwort",
      passwordPlaceholder: "Geben Sie Ihr Passwort ein",
      showPassword: "Passwort anzeigen",
      hidePassword: "Passwort verbergen",
      loginCta: "Anmelden",
      loginLoading: "Anmeldung...",
      noAccount: "Noch kein Konto?",
      goSignup: "Jetzt erstellen",
      signupTitle: "Konto erstellen",
      signupLead: "Treten Sie Casaclass bei und lernen Sie motiviert.",
      name: "Vollständiger Name",
      namePlaceholder: "Geben Sie Ihren vollständigen Namen ein",
      resumeLabel: "Lebenslauf (CV)",
      resumeRequired:
        "Bitte laden Sie Ihren Lebenslauf hoch, um ein Lehrkraft-Konto zu erstellen.",
      roleLabel: "Kontotyp",
      roleParent: "Elternteil",
      roleTeacher: "Lehrkraft",
      confirmPassword: "Passwort bestätigen",
      confirmPasswordPlaceholder: "Passwort erneut eingeben",
      signupCta: "Casaclass beitreten",
      signupLoading: "Wird erstellt...",
      hasAccount: "Bereits ein Konto?",
      goLogin: "Anmelden",
      passwordLength: "Passwort muss mindestens 8 Zeichen lang sein.",
      passwordMatch: "Passwörter stimmen nicht überein.",
      loginError: "Anmeldung fehlgeschlagen. Bitte erneut versuchen.",
      signupError: "Konto konnte nicht erstellt werden. Bitte später erneut.",
      forgotLink: "Passwort vergessen?",
      forgotTitle: "Passwort vergessen",
      forgotLead:
        "Gib deine E-Mail ein und wir senden dir einen Link, falls das Konto existiert.",
      forgotCta: "Link senden",
      forgotSending: "Senden...",
      forgotSuccess:
        "Wenn diese E-Mail registriert ist, erhältst du in Kürze Anweisungen.",
      forgotBack: "Zurück zum Login",
      socialDivider: "Oder mit Google fortfahren",
      googleError: "Google-Anmeldung fehlgeschlagen. Bitte erneut versuchen.",
      googleLoading: "Google-Konto wird überprüft...",
    },
    verificationPage: {
      title: "Konto wartet auf Verifizierung",
      message:
        "Ihr Lehrkraft-Konto wurde erstellt, aber Sie können die Plattform erst nutzen, nachdem ein Admin Ihr Konto verifiziert hat.",
      logout: "Abmelden",
    },
    resources: {
      title: "Ressourcen",
      subtitleTeacher:
        "Erstellen Sie Ressourcen und weisen Sie sie einer Klasse oder einem Schüler zu.",
      subtitleStudent: "Dir zugewiesene Ressourcen erscheinen hier.",
      loading: "Laden...",
      create: "Ressource erstellen",
      creating: "Wird erstellt...",
      listTitle: "Ressourcen",
      empty: "Noch keine Ressourcen.",
      delete: "Löschen",
      confirmDelete: "Diese Ressource löschen?",
      failedLoad: "Ressourcen konnten nicht geladen werden",
      failedCreate: "Ressource konnte nicht erstellt werden",
      failedDelete: "Ressource konnte nicht gelöscht werden",
      titleRequired: "Titel ist erforderlich",
      targetRequired: "Bitte wählen Sie eine Klasse oder einen Schüler",
      targetClass: "Klasse",
      targetStudent: "Schüler",
      fields: {
        title: "Titel",
        titlePlaceholder: "z. B. Material Woche 3",
        text: "Text",
        textPlaceholder: "Optionale Beschreibung oder Hinweise",
        assignTo: "Zuweisen an",
        class: "Klasse",
        student: "Schüler",
        attachments: "Anhänge",
      },
      assign: {
        class: "Klasse",
        student: "Schüler",
      },
      pickClass: "Klasse auswählen",
      pickStudent: "Schüler auswählen",
    },
    offers: {
      heroTag: "Angebote",
      heroTitle: "Fertige Casaclass-Pakete",
      heroDescription:
        "Wählen Sie den passenden Weg für Ihre Familie. Jedes Angebot kombiniert Live-Unterricht, digitale Ressourcen und Betreuung.",
      packLabel: "Pack wählen:",
      packPlaceholder: "-- Auswählen --",
      sections: {
        classTypes: {
          tag: "Lernformate",
          heading: "Wählen Sie das Umfeld, das Ihrem Kind liegt",
          description:
            "Von Einzelunterricht bis zu größeren Gruppen – jedes Format passt zu anderen Persönlichkeiten und Budgets.",
        },
        languages: {
          tag: "Sprachen",
          heading: "Sprachpfade live",
          description:
            "Komplette Wege von den Grundlagen bis zu internationalen Prüfungen mit interaktiven Inhalten.",
        },
        upcoming: {
          tag: "Demnächst",
          heading: "Kurse zu Zukunftskompetenzen",
          description:
            "Tragen Sie sich ein, um informiert zu werden, wenn Coding-, KI- und Leadership-Labs starten.",
        },
      },
      classTypes: {
        full: {
          category: "Kurstypen",
          title: "Full Classes",
          subtitle: "Vollständig personalisierter Einzelunterricht",
          description:
            "100 % persönliches Erlebnis mit einer Lehrkraft, die den Plan rund um Ihr Kind baut.",
          price: "25 TND / Sitzung",
          billing: "60-minütige Einzelsitzung",
          features: [
            "Individueller Lehrplan, regelmäßig geprüft",
            "Persönliche Aufmerksamkeit",
            "Volle Terminflexibilität",
          ],
          cta: "Full Classes beitreten",
        },
        duo: {
          category: "Kurstypen",
          title: "DUO Classes",
          subtitle: "Gemeinsamer Unterricht mit Freund oder Geschwister",
          description: "Für ein Duo, das sich gegenseitig motiviert.",
          price: "15 TND / Sitzung",
          billing: "Preis pro Person",
          features: [
            "Inhalt für zwei abgestimmt",
            "Kooperative Aktivitäten",
            "Nachverfolgung der Aufgabenverteilung",
          ],
          cta: "DUO Classes beitreten",
          badge: "Am beliebtesten",
        },
        vip: {
          category: "Kurstypen",
          title: "VIP Classes",
          subtitle: "Kleine Gruppen bis 4 Schüler",
          description:
            "Kontinuierliche Interaktion in einer ausgewählten Gruppe mit persönlicher Betreuung.",
          price: "10 TND / Sitzung",
          billing: "Preis pro Person",
          features: [
            "Interaktive Sitzungen mit nahen Peers",
            "Kooperative Aktivitäten zur Stärkung des Selbstvertrauens",
            "Individuelle Anleitung in der Gruppe",
          ],
          cta: "VIP Classes beitreten",
        },
        normal: {
          category: "Kurstypen",
          title: "Normal Classes",
          subtitle: "Bis zu 8 Schüler",
          description:
            "Kostengünstige Option, die Engagement in einer kooperativen Gruppe erhält.",
          price: "7.5 TND / Sitzung",
          billing: "Preis pro Person",
          features: [
            "Strukturiertes Gruppenumfeld",
            "Aktivitäten fördern Teilnahme",
            "Bestes Preis-Leistungs-Verhältnis",
          ],
          cta: "Normal Classes beitreten",
        },
      },
      languagePrograms: {
        french: {
          category: "Sprachprogramme",
          title: "Französisch",
          subtitle: "A1 bis C2 • DELF/DALF",
          description:
            "Grammatik und Konversation stärken, komplette DELF/DALF-Vorbereitung.",
          price: "180 TND / Monat",
          billing: "Live-Sitzungen + digitale Ressourcen",
          features: [
            "Fortschritt von Buchstaben bis akademischem Schreiben",
            "DELF/DALF-Prüfungsübungen",
            "Aussprache- und Sprechworkshops",
          ],
          cta: "Für Französisch anmelden",
        },
        english: {
          category: "Sprachprogramme",
          title: "Englisch",
          subtitle: "Konversation + IELTS",
          description:
            "Umfassender Weg für mündliche Praxis und IELTS-Vorbereitung mit Business-Schwerpunkt.",
          price: "220 TND / Monat",
          billing: "Live • interaktive Ressourcen",
          features: [
            "Vollständige IELTS-Vorbereitung",
            "Business English und Interviews",
            "Wöchentliche Gesprächsclubs",
          ],
          cta: "Probestunde testen",
          badge: "Favorit",
        },
        arabic: {
          category: "Sprachprogramme",
          title: "Arabisch",
          subtitle: "Für Nicht-Muttersprachler",
          description:
            "Einführung in Buchstaben, richtige Aussprache und Alltagsgespräche mit Kulturanteil.",
          price: "160 TND / Monat",
          billing: "Live-Kommunikation + häusliche Unterstützung",
          features: [
            "Buchstaben und klare Laute ab Tag eins",
            "Tägliche Dialoge und Basisvokabular",
            "Geschichten und Kulturaktivitäten",
          ],
          cta: "Für Arabisch anmelden",
        },
      },
      upcoming: {
        coding: {
          category: "Demnächst",
          title: "Coding for Kids",
          subtitle: "Scratch- und Minecraft-Projekte",
          description:
            "Digitales Labor, das logisches Denken mit spielerischen Projekten lehrt.",
          price: "Bald",
          billing: "Anmeldung öffnet nächstes Quartal",
          features: [
            "Schrittweise Coding-Workshops",
            "Digitale Abzeichen",
            "Zusammenarbeit in kleinen Teams",
          ],
          cta: "Zum Start benachrichtigen",
        },
        ai: {
          category: "Demnächst",
          title: "KI & Future Skills",
          subtitle: "KI einfach für Jugendliche",
          description:
            "Erkundet KI, Design Thinking und Automatisierung über Mini-Projekte.",
          price: "Bald",
          billing: "Start Sommer 2026",
          features: [
            "KI-Konzepte ohne Komplexität",
            "Robotik-Workshops mit einfachen Kits",
            "Kritische Denkaufgaben",
          ],
          cta: "Auf Warteliste setzen",
        },
        leaders: {
          category: "Demnächst",
          title: "Future Leaders Lab",
          subtitle: "Kommunikations- und Präsentationsskills",
          description:
            "Verbindet Präsentieren, Problemlösen und Mini-Projekte für Jugendliche.",
          price: "Bald",
          billing: "Pilotstart Herbst 2026",
          features: [
            "Einzel- und Gruppensitzungen",
            "Praxisprojekte",
            "Coaching durch Kommunikationsexperten",
          ],
          cta: "Interesse anmelden",
        },
      },
      addons: {
        tag: "Optionale Add-ons",
        heading: "Services, die das Erlebnis abrunden",
        description:
          "Mit jedem Hauptpaket kombinierbar oder separat buchbar, wenn Sie einen Extra-Schub brauchen.",
        coaching: {
          title: "Familien-Coaching-Session",
          price: "30 TND / Session",
          description:
            "45-minütiger Anruf, um Bedarf zu klären und einen Monatsplan festzulegen.",
          points: [
            "Schneller Stand der Dinge",
            "Vier-Wochen-Zielplan",
            "Hausaktivitäten und Follow-up",
          ],
          cta: "Session buchen",
        },
        assessment: {
          title: "Fortgeschrittener Einstufungstest",
          price: "45 TND einmalig",
          description:
            "Interaktiver Test + schriftlicher Bericht mit klaren Empfehlungen.",
          points: [
            "Digitaler Test in Sprache & Mathe",
            "Schriftliche Analyse von Stärken und Bedarf",
            "Übergangsplan für die ersten Wochen",
          ],
          cta: "Bericht anfordern",
        },
        oneToOne: {
          title: "Intensives 1:1",
          price: "25 TND / Session",
          description:
            "Private Online-Stunden mit Casaclass-Lehrkraft für gezielte Skills.",
          points: [
            "Flexibles Fach und Timing",
            "Follow-up nach jeder Stunde",
            "Ideal vor Prüfungen oder für mehr Sicherheit",
          ],
          cta: "Mit uns abstimmen",
        },
      },
      support: {
        heading: "Hilfe bei der Wahl?",
        description:
          "Das Casaclass-Team erstellt einen individuellen Lernplan. Kontaktieren Sie uns für den passenden Weg und einen Start-Check.",
        ctaCall: "Beratungsgespräch buchen",
        ctaSignup: "Jetzt Konto erstellen",
      },
    },
    adminPage: {
      accessDenied: "Zugang nur für Admins.",
      headerTag: "Zentrales Admin-Panel",
      headerTitle: "Admin-Dashboard",
      dashboard: {
        welcome: "Willkommen zurück!",
        viewAll: "Alle anzeigen",
        manageTitle: "Verwaltung",
        manageColumns: {
          section: "Bereich",
          count: "Anzahl",
          open: "Öffnen",
        },
        cards: {
          newStudents: "Neue Schüler",
          newStudentsHint: "Aktueller Zeitraum",
          totalStudents: "Gesamtzahl",
          totalStudentsHint: "Alle Schüler",
          dailyAttend: "Anwesenheit",
          dailyAttendHint: "Letzte 7 Tage",
          averageAttend: "Durchschnitt",
          averageAttendHint: "Diesen Monat",
        },
        activityTitle: "Schüleraktivität",
        thisMonth: "Dieser Monat",
        lastMonths: "Letzter Monat",
        examsTitle: "Prüfungen",
        examsFallback: "Prüfungsübersicht",
        studentsTitle: "Schülerliste",
        studentsColumns: {
          id: "ID",
          student: "Schüler",
          parent: "Eltern",
          attends: "Anwesenheit",
        },
        teachersTitle: "Lehrer",
        teacherVerified: "Verifiziert",
        teacherPending: "Ausstehend",
        empty: "Noch keine Daten.",
      },
      tabs: {
        overview: "Übersicht",
        users: "Benutzer",
        students: "Schüler",
        lessons: "Lektionen & Planung",
        timetable: "Stundenplan",
        pendingTeachers: "Ausstehende Lehrer-Verifizierungen",
        classes: "Klassen",
        packs: "Pakete",
        payments: "Zahlungen",
        teachers: "Lehrer",
        support: "Kundendienst",
      },
      teachers: {
        title: "Lehrer",
        empty: "Keine Lehrer zum Anzeigen.",
        resume: "Lebenslauf herunterladen",
        activeYes: "Ja",
        activeNo: "Nein",
        filter: {
          label: "Nach Status filtern",
          all: "Alle",
          pending: "Ausstehend",
          verified: "Verifiziert",
        },
        status: {
          verified: "Verifiziert",
          pending: "Ausstehend",
        },
        fields: {
          email: "E-Mail",
          phone: "Telefon",
          active: "Aktiv",
          joined: "Registriert",
        },
      },
      actions: {
        save: "Speichern",
        saving: "Wird gespeichert…",
        create: "Erstellen",
        cancel: "Abbrechen",
        edit: "Bearbeiten",
        delete: "Löschen",
      },
      timetable: {
        calendarTitle: "Kalender",
        addEvent: "Ereignis hinzufügen",
        configure: "Konfigurieren",
        previousDay: "Vorheriger Tag",
        nextDay: "Nächster Tag",
        scopeTeacher: "Lehrer",
        scopeClass: "Klasse",
        scopeStudent: "Schüler",
        allTeachers: "Alle Lehrer",
        allClasses: "Alle Klassen",
        allStudents: "Alle Schüler",
        viewWeek: "Woche",
        viewDay: "Tag",
        faculty: "Lehrkräfte",
        searchFacultyPlaceholder: "Lehrkräfte suchen...",
        editLessonTitle: "Unterricht bearbeiten",
        newLessonTitle: "Neuer Unterricht",
        selectPlaceholder: "Auswählen…",
        lessonTitlePlaceholder: "Titel der Stunde",
        minutesShort: "Min.",
        permanentWeekly: "Wöchentlich dauerhaft",
        fields: {
          teacher: "Lehrer",
          class: "Klasse",
          students: "Schüler",
          assignTo: "Zuweisen an",
          student: "Schüler",
          title: "Titel",
          start: "Start",
          duration: "Dauer",
          status: "Status",
        },
        assignModes: {
          student: "Schüler",
          class: "Klasse",
        },
      },
      classes: {
        panelTitleEdit: "Klasse bearbeiten",
        panelTitleCreate: "Klasse erstellen",
        classNamePlaceholder: "Klassenname",
        fields: {
          name: "Name",
          students: "Schüler",
        },
        errors: {
          nameRequired: "Name ist erforderlich",
        },
        confirmDelete: "Diese Klasse löschen?",
        table: {
          class: "Klasse",
          teacher: "Lehrer",
          students: "Schüler",
          actions: "Aktionen",
        },
      },
      loading: "Daten werden geladen...",
      stats: {
        activeStudents: "Aktive Schüler",
        monthlyRevenue: "Monatlicher Umsatz",
        satisfaction: "Zufriedenheitsrate",
        outOfFive: "von 5",
        supportMessages: "Support-Nachrichten",
        teachers: "Lehrer",
        unread: "ungelesen",
      },
      roles: {
        superadmin: "Superadmin",
        admin: "Administrator",
        support: "Kundendienst",
        accounting: "Buchhaltung",
        teacher: "Lehrer",
        parent: "Eltern",
      },
      users: {
        title: "Benutzerverwaltung",
        filter: "Nach Rolle filtern",
        filterAll: "Alle",
        columns: {
          email: "E-Mail",
          name: "Name",
          role: "Rolle",
          phone: "Telefon",
          joined: "Beigetreten",
          verify: "Lehrer-Verifizierung",
          active: "Aktiv",
          actions: "Aktionen",
        },
        verify: "Verifizieren",
        unverify: "Entfernen",
        toggleActiveAria: "Benutzer aktivieren oder deaktivieren",
        deleteConfirm: "Diesen Benutzer löschen?",
        delete: "Löschen",
      },
      students: {
        title: "Schüler",
        ageYears: "Jahre",
        parent: "Eltern",
        dob: "Geburtsdatum",
      },
      lessons: {
        title: "Lektionen & Planung",
        idLabel: "Kennung",
        student: "Schüler",
        teacher: "Lehrer",
        duration: "Dauer",
        minutes: "Minuten",
        status: {
          scheduled: "Geplant",
          completed: "Abgeschlossen",
          cancelled: "Abgesagt",
        },
      },
      packs: {
        formEdit: "Paket bearbeiten",
        formNew: "Neues Paket",
        fields: {
          name: "Paketname",
          description: "Beschreibung",
          subject: "Fach",
          subjectPlaceholder: "Wählen...",
          price: "Preis",
          currency: "Währung",
          lessons: "Anzahl Sitzungen",
          sessionLength: "Sitzungsdauer (Minuten)",
          resources: "Ressourcen (eine URL pro Zeile)",
          image: "Bild (optional)",
          recommended: "Empfohlen für",
          gradientColors: "Verlaufsfarben",
          gradientStart: "Verlauf-Startfarbe",
          gradientEnd: "Verlauf-Endfarbe",
          featured: "Auf Startseite anzeigen",
          offersSection: "Angebotsbereich",
          offersSectionNone: "Keiner",
          offersKind: "Angebotstyp",
          offersDisplayOrder: "Anzeigereihenfolge (Angebote)",
          offersAccent: "Akzent (Angebote)",
          offersCategoryKey: "Kategorie-Schlüssel (Angebote)",
          offersTitleKey: "Titel-Schlüssel (Angebote)",
          offersSubtitleKey: "Untertitel-Schlüssel (Angebote)",
          offersDescriptionKey: "Beschreibungs-Schlüssel (Angebote)",
          offersPriceKey: "Preis-Schlüssel (Angebote)",
          offersBillingKey: "Abrechnungs-Schlüssel (Angebote)",
          offersFeaturesKey: "Vorteile-Schlüssel (Angebote)",
          offersCtaKey: "CTA-Schlüssel (Angebote)",
          offersCtaLink: "CTA-Link (Angebote)",
          offersBadgeKey: "Badge-Schlüssel (Angebote)",
          offersNoteKey: "Notiz-Schlüssel (Angebote)",
          offersPointsKey: "Punkte-Schlüssel (Angebote)",
        },
        placeholderResources: "https://.../video.mp4\nhttps://.../document.pdf",
        placeholders: {
          name: "Beispiel: Arabisch-Paket",
          description: "Beispiel: Wöchentliche Sitzungen mit Lehrkraft",
          price: "Beispiel: 120",
          lessons: "Beispiel: 6",
          sessionLength: "Beispiel: 60",
          image: "Beispiel: https://example.com/image.png",
          recommended: "Beispiel: Mittelstufe",
          offersKey: "Beispiel: offers.languages.arabic.title",
          offersLink: "Beispiel: /contact",
        },
        actions: {
          saving: "Speichern...",
          save: "Speichern",
          reset: "Zurücksetzen",
        },
        listTitle: "Aktuelle Pakete",
        sessions: "Sitzungen",
        minutesPerSession: "Min/Sitzung",
        resourcesCount: "Ressourcen",
        badgeFeatured: "Hervorgehoben",
        edit: "Bearbeiten",
        delete: "Löschen",
        deleteConfirm: "Dieses Paket löschen?",
        errorMissingNameSubject: "Bitte Paketname und Fach eingeben.",
        detailsTitle: "Paketdetails",
        errorPackNotFound: "Dieses Paket wurde nicht gefunden.",
      },
      payments: {
        title: "Zahlungen",
        columns: {
          user: "Benutzer",
          pack: "Paket",
          amount: "Betrag",
          status: "Status",
        },
        statuses: {
          pending: "Ausstehend",
          completed: "Abgeschlossen",
          failed: "Fehlgeschlagen",
          refunded: "Erstattet",
        },
      },
      support: {
        title: "Support & Nachrichten",
        from: "Von",
        read: "Gelesen",
        new: "Neu",
        type: "Typ",
        markRead: "Als gelesen markieren",
        reply: "Antworten",
        replyTitle: "Neue Nachricht",
        replyClose: "Schließen",
        replyTo: "An",
        replySubject: "Betreff",
        replyMessage: "Nachricht",
        replySend: "Senden",
        replySending: "Wird gesendet...",
        replyEmpty: "Bitte schreibe eine Nachricht, bevor du sie sendest.",
        replySubjectFallback: "Re: Kontakt Nachricht",
      },
    },
  },
  it: {
    meta: { name: "Italiano", dir: "ltr" },
    testsModule: testsModuleIt,
    common: { id: "ID" },
    nav: {
      home: "Home",
      courses: "Offerte",
      about: "Chi siamo",
      contact: "Contatti",
      searchLabel: "Cerca su Casaclass",
      searchPlaceholder: "Cerca una lezione o risorsa",
      menuLabel: "Menu",
      languageLabel: "Lingua",
    },
    auth: {
      login: "Accedi",
      signup: "Crea account",
    },
    protectedRoute: {
      loading: "Verifica del tuo account...",
    },
    footer: {
      title: "Casaclass",
      description: "La tua piattaforma per il successo scolastico.",
      quickLinks: "Link rapidi",
      home: "Home",
      courses: "Corsi",
      about: "Chi siamo",
      contact: "Contatti",
      email: "contact@casaclassroom.com",
      phone: "+216 55 544 475",
      copyright: "Tutti i diritti riservati.",
    },
    sidebar: {
      close: "Chiudi",
      toggle: "Mostra/nascondi menu",
      role: {
        admin: "Admin piattaforma",
        superadmin: "Super admin",
        support: "Supporto",
        accounting: "Contabilità",
        teacher: "Docente",
        parent: "Genitore",
        student: "Studente",
        user: "Utente",
        actions: {
          save: "Salva",
          saving: "Salvataggio...",
          create: "Crea",
          cancel: "Annulla",
          edit: "Modifica",
          delete: "Elimina",
        },
      },
      links: {
        dashboard: "Dashboard",
        programs: "Programmi",
        lessons: "Lezioni",
        timetable: "Orario",
        resources: "Risorse",
        tests: "Test",
        homeworks: "Compiti",
        offers: "Offerte",
        contact: "Supporto",
        gradientStart: "Colore iniziale del gradiente",
        gradientEnd: "Colore finale del gradiente",
        profile: "Il mio account",
        admin: "Console admin",
        students: "Studenti",
        newLesson: "Nuova lezione",
        myStudents: "I miei studenti",
        myChildren: "I miei figli",
        myLessons: "Le mie lezioni",
      },
      sections: {
        main: "Menu principale",
        management: "Gestione accademica",
        other: "Altro",
      },
      logout: "Esci",
    },
    studentShell: {
      shortcutsLabel: "Scorciatoie studente",
      mainNavLabel: "Navigazione principale studente",
    },
    comingSoon: {
      badge: "Presto",
      defaultTitle: "Pagina in arrivo",
      levelTitle: "Livello {{level}}",
      defaultDescription: "La pagina che cerchi è in costruzione.",
      levelDescription:
        "Stiamo preparando i contenuti del livello {{level}} — presto online.",
      pathNotReady: "Il percorso {{path}} non è ancora disponibile.",
      backHome: "Torna alla home",
      contactUs: "Contattaci",
      notFoundTitle: "Pagina non disponibile",
      notFoundMessage: "La pagina che cerchi non esiste o è in preparazione.",
    },
    contactPage: {
      status: {
        loading: "Invio del messaggio...",
        success: "Messaggio inviato! Ti ricontatteremo a breve.",
        error: "Impossibile inviare il messaggio. Riprova.",
      },
      hero: {
        label: "Contattaci",
        title: "Pianifichiamo insieme un percorso di apprendimento",
        lead: "Raccontaci di cosa hai bisogno e costruiremo un percorso su misura per la tua famiglia. Il nostro team è pronto ad aiutarti.",
      },
      form: {
        cardTitle: "Scrivici subito",
        cardSubtitle:
          "Compila il modulo e ti risponderemo entro un giorno lavorativo.",
        fullNameLabel: "Nome completo",
        fullNamePlaceholder: "Inserisci il tuo nome",
        emailLabel: "Email",
        emailPlaceholder: "example@mail.com",
        phoneLabel: "Numero di telefono",
        phonePlaceholder: "Inserisci il tuo numero di telefono",
        subjectLabel: "Oggetto",
        subjectPlaceholder: "Aggiungi un oggetto breve",
        messageLabel: "Come possiamo aiutarti?",
        messagePlaceholder:
          "Descrivi la tua esigenza per proporre la soluzione migliore",
        submit: "Invia messaggio",
        submitting: "Invio in corso...",
        phoneAppend: "Numero di telefono: {{phone}}",
      },
      calendly: {
        title: "Prenota una consulenza",
        subtitle: "Scegli l'orario migliore per parlare con il nostro team.",
      },
    },
    errors: {
      adminRequired: "Questa azione richiede un account admin.",
      authRequired: "Devi essere autenticato per eseguire questa azione.",
      operationFailed: "Impossibile completare l'operazione.",
      fetchFailed: "Impossibile recuperare i dati. Riprova.",
      lessonIdRequired: "L'ID della lezione è obbligatorio.",
    },
    lessons: {
      title: "Lezioni",
      subtitleStudent: "Lezioni per lo studente attivo",
      subtitleStaff:
        "Tutte le lezioni collegate al tuo account con filtri e stati.",
      newLesson: "Nuova lezione",
      searchLabel: "Cerca lezioni",
      searchPlaceholder: "Titolo, studente, docente",
      statusFilter: "Filtra per stato",
      refresh: "Aggiorna elenco",
      loading: "Caricamento lezioni...",
      empty: "Nessuna lezione corrisponde alla vista attuale.",
      emptyCta: "Crea la prima lezione",
      error: "Errore nel caricamento delle lezioni: ",
      deleteConfirm: "Confermi l'eliminazione di questa lezione?",
      student: "Studente",
      teacher: "Docente",
      pack: "Pacchetto",
      duration: "Durata",
      minutes: "minuti",
      viewDetails: "Vedi dettagli",
      joinMeeting: "Partecipa alla lezione",
      joinMeetingSoon: "Disponibile 2 ore prima",
      generateMeeting: "Genera link riunione",
      generatingMeeting: "Generazione in corso...",
      edit: "Modifica",
      delete: "Elimina",
      statusScheduled: "Programmato",
      statusCompleted: "Completato",
      statusCancelled: "Annullato",
      filterAll: "Tutti gli stati",
      filterScheduled: "In arrivo",
      filterCompleted: "Completati",
      filterCancelled: "Annullati",
      timetable: {
        days: "Giorni",
        item: "elemento",
        items: "elementi",
        noLessonsForWeek: "Nessuna lezione questa settimana",
        selectChild: "Seleziona figlio",
        previousWeek: "Settimana precedente",
        nextWeek: "Settimana successiva",
        today: "Oggi",
        classLabel: "Classe:",
        month: "Mese",
        week: "Settimana",
        yourWeeklyTimetable: "Il tuo orario settimanale",
      },
    },
    programDetails: {
      loading: "Caricamento...",
      eyebrow: "Programmi",
      notFound: {
        title: "Programma non trovato",
        hint: "Scegli un programma dall'elenco o creane uno nuovo.",
      },
      actions: {
        backToDashboard: "Torna alla dashboard",
        backToHome: "Torna alla home",
        newProgram: "Nuovo programma",
        addLevel: "Aggiungi livello",
      },
      sidebar: {
        allPrograms: "Tutti i programmi",
        editTitle: "Modifica",
        editAction: "Modifica",
      },
      sections: {
        overview: "Panoramica",
        learning: "Cosa impareranno gli studenti",
        morePrograms: "Altri programmi",
        levels: { single: "Livello", plural: "Livelli" },
      },
      levels: {
        pickFirst: "Scegli prima un livello per vedere i dettagli.",
        chooseLevel: "Scegli livello",
        levelTitle: "Livello {{grade}}",
        levelImageAlt: "Immagine del livello {{grade}}",
      },
      cta: { enrollNow: "Iscriviti ora" },
      editor: {
        title: "Modifica programma",
        delete: "Elimina",
        save: "Salva",
        cancel: "Annulla",
      },
      fields: {
        accentColor: "Colore accento",
        icon: "Icona",
        custom: "Personalizzato",
        assignedTeacher: "Insegnante assegnato",
        unassigned: "Non assegnato",
        teacherFallback: "Insegnante",
        title: "Titolo",
        shortDescription: "Descrizione breve",
        details: "Dettagli",
        keyPoints: "Punti chiave",
        levels: "Livelli",
        previewLevelsPage: "Anteprima pagina livelli",
        levelRowTitle: "Livello {{index}}",
        remove: "Rimuovi",
        grade: "Grado",
        label: "Etichetta",
        description: "Descrizione",
        uploadImage: "Carica immagine",
        uploading: "Caricamento…",
        chooseFile: "Scegli file",
        removeImage: "Rimuovi immagine",
        imageUrl: "URL immagine",
        ctaLabel: "Testo pulsante",
        ctaLink: "Link pulsante",
        displayOrder: "Ordine di visualizzazione",
        active: "Attivo",
      },
      placeholders: { grade: "es. 1", levelName: "Nome livello" },
      errors: {
        unauthorized: "Non autorizzato",
        uploadFailed: "Caricamento non riuscito",
        levelsRequireGrade:
          "Completa il grado/ID di tutti i livelli prima di salvare",
        titleRequired: "Il titolo è obbligatorio",
      },
      confirm: {
        deleteProgram:
          "Eliminare questo programma? Questa azione non può essere annullata.",
      },
      draft: { title: "Nuovo programma" },
      icons: {
        reading: "Lettura",
        graduation: "Diploma",
        math: "Matematica",
        science: "Scienza",
        language: "Lingua",
        coding: "Programmazione",
        islamicStudies: "Studi islamici",
        atom: "Atomo",
        design: "Design",
        writing: "Scrittura",
        globe: "Globo",
        star: "Stella",
        bookLegacy: "Libro (legacy)",
        scienceLegacy: "Scienza (legacy)",
      },
    },
    programLevelSelect: {
      title: "Scegli un livello",
      subtitle: {
        forProgram: "Per il programma: {{title}}",
        continue: "Poi continua ai dettagli del programma.",
      },
      actions: { backToHome: "Torna alla home" },
      states: {
        noLevels: "Nessun livello disponibile per questo programma al momento.",
      },
    },
    lessonDetail: {
      idLabel: "ID lezione",
      backToList: "Torna all'elenco",
      edit: "Modifica lezione",
      delete: "Elimina lezione",
      deleteConfirm: "Eliminare definitivamente questa lezione?",
      loading: "Caricamento dettagli lezione...",
      error: "Impossibile caricare la lezione: ",
      notFound: "Lezione non trovata.",
      scheduledAt: "Data e ora della lezione",
      description: "Descrizione della lezione",
      student: "Studente",
      teacher: "Docente",
      duration: "Durata della lezione",
      minutes: "minuti",
      createdAt: "Creata il",
      updatedAt: "Aggiornata il",
      packInfo: "Dettagli pacchetto",
      pack: "Pacchetto",
      subject: "Materia",
      price: "Prezzo",
      partOfPack: "Parte del pacchetto",
      meetingStatus: "Link riunione",
      meetingReady: "Pronto",
      meetingPending: "Non ancora creato",
      joinMeeting: "Partecipa alla lezione",
      generateMeeting: "Genera link riunione",
      generatingMeeting: "Generazione in corso...",
      notifyParentsTitle: "Avvisa i genitori",
      notifyParentsStatus: "Stato",
      notifyParentsMessage: "Messaggio",
      notifyParentsSend: "Invia",
      notifyParentsSending: "Invio...",
      notifyParentsSuccess: "Notifica inviata.",
      notifyParentsSuccessCount: "Notifica inviata a {{count}} genitori.",
    },
    lessonEditor: {
      accessDenied: "Questo account non può creare o modificare lezioni.",
      backToList: "Torna all'elenco lezioni",
      loading: "Preparazione del modulo...",
      loadError: "Impossibile caricare la lezione",
      title: { edit: "Modifica lezione", create: "Crea nuova lezione" },
      note: {
        edit: "Aggiorna dettagli, orario o stato della lezione.",
        create: "Inserisci la prossima lezione e collega lo studente corretto.",
      },
      genericError: "Si è verificato un errore durante il caricamento",
      form: {
        title: "Titolo della lezione",
        description: "Descrizione",
        scheduledAt: "Orario della lezione",
        duration: "Durata della lezione (minuti)",
        status: "Stato della lezione",
        classGroup: "Classe",
        allStudents: "Tutti gli studenti",
        students: "Studenti",
        student: "Studente",
        teacher: "ID docente (admin)",
        allowParentJoinMeeting:
          "Consenti al genitore di partecipare alla riunione",
        pack: "Pacchetto collegato (opzionale)",
        image: "URL immagine (opzionale)",
      },
      placeholders: {
        title: "Es. Ripasso di matematica — decimali",
        description: "Annotazioni su obiettivi, risorse o indicazioni",
        student: "Inserisci l'ID dello studente o scegli dalla lista",
        teacher: "Inserisci l'ID del docente responsabile",
        noPack: "Nessun pacchetto specifico",
        image: "https://",
      },
      help: {
        scheduledAt:
          "L'orario viene salvato nel tuo fuso e convertito automaticamente in UTC.",
        student:
          "Gli ID studenti compaiono qui. I genitori vedono tutti i figli, i docenti vedono gli studenti già seguiti.",
        teacher:
          "Questo numero deve appartenere a un utente con ruolo docente.",
        allowParentJoinMeeting:
          "Se disattivato, il genitore non vedrà il link della riunione.",
        classCreatesLessons:
          "Selezionare una classe creerà una lezione per ogni studente in quella classe.",
        classStudents: "Studenti della classe",
      },
      status: {
        scheduled: "Programmato",
        completed: "Completato",
        cancelled: "Annullato",
      },
      errors: {
        title: "Inserisci un titolo.",
        schedule: "Seleziona una data e un orario validi.",
        student: "ID studente non valido. Usa l'identificativo numerico.",
        duration: "La durata deve essere un numero positivo.",
        teacher: "ID docente non valido.",
        noStudentsInClass: "Questa classe non ha studenti",
      },
      actions: {
        saving: "Salvataggio in corso...",
        update: "Aggiorna lezione",
        save: "Salva lezione",
        cancel: "Annulla e torna indietro",
      },
    },
    teacherPublicProfile: {
      avatarAlt: "Avatar",
      actions: {
        back: "Indietro",
        follow: "Segui",
        chat: "Chat",
        viewProfile: "Vedi",
      },
      sections: {
        about: "Info",
        experience: "Esperienza",
        education: "Istruzione",
        skills: "Competenze",
        teachers: "Docenti",
      },
      labels: {
        noInfo: "Nessuna informazione al momento",
        defaultHeadline: "Docente Casaclass",
        since: "Dal",
        verified: "Verificato",
        teacher: "Docente",
      },
      states: {
        loading: "Caricamento...",
        notFound: "Docente non trovato.",
        loadError: "Impossibile caricare il profilo del docente.",
      },
      tooltips: { comingSoon: "In arrivo" },
    },
    profile: {
      roles: {
        adminFull: "Amministratore della piattaforma",
        teacherFull: "Docente Casaclass",
        parentFull: "Genitore",
        studentFull: "Studente",
        adminShort: "Admin",
        teacherShort: "Docente",
        parentShort: "Genitore",
      },
      common: {
        loadingData: "Caricamento...",
        idLabel: "ID: {{id}}",
        dobLabel: "Data di nascita: {{date}}",
        unknown: "Non specificato",
      },
      messages: {
        profileUpdated: "I tuoi dati sono stati aggiornati con successo.",
        avatarUpdated: "La foto profilo è stata aggiornata con successo.",
      },
      actions: {
        saving: "Salvataggio in corso...",
        saveChanges: "Salva modifiche",
        cancelEdit: "Annulla modifica",
        edit: "Modifica",
        delete: "Elimina",
        refresh: "Aggiorna",
      },
      overview: {
        aboutTitle: "Info",
        aboutTextStudent:
          "Questo è il profilo dello studente collegato alla modalità Studente.",
        aboutTextUser:
          "Gestisci qui le informazioni principali dell'account e aggiorna il nome mostrato sulla piattaforma.",
        uploadingPhoto: "Caricamento foto...",
        changePhoto: "Cambia foto",
        upcomingLessons: "Lezioni in arrivo",
        noUpcomingLessons: "Nessuna lezione in arrivo.",
      },
      progress: {
        title: "Avanzamento profilo",
        subtitle: "Completa i tuoi dati per migliorare l'esperienza.",
        completeProfile: "Completa profilo",
      },
      studentDetails: {
        title: "Dettagli studente",
        notFound: "Impossibile trovare lo studente.",
      },
      personal: {
        title: "Informazioni personali",
        subtitleStudent: "Informazioni dello studente in modalità Studente.",
        subtitleUser: "Aggiorna il nome mostrato sulla piattaforma.",
        edit: "Modifica",
        accountDetailsAria: "Dettagli account",
      },
      fields: {
        firstName: "Nome",
        lastName: "Cognome",
        phone: "Numero di telefono",
        role: "Ruolo",
        email: "Email",
        dob: "Data di nascita",
        completion: "Completamento profilo",
        status: "Stato",
        notes: "Note",
      },
      placeholders: {
        firstName: "es. Ahmed",
        lastName: "es. Ben Mahmoud",
        phone: "es. +216 55 544 475",
      },
      students: {
        title: "I miei figli",
        subtitle:
          "Aggiungi figli o aggiorna i loro dati per facilitare la pianificazione delle lezioni.",
        placeholders: {
          firstName: "es. Ali",
          lastName: "es. Ben Salem",
          notes: "Info aggiuntive utili al team Casaclass",
        },
        actions: {
          add: "Aggiungi studente",
          update: "Aggiorna studente",
        },
        loading: "Caricamento studenti...",
        empty: "Non sono stati aggiunti figli ancora.",
        errors: {
          firstNameRequired: "Il nome è obbligatorio",
        },
        confirmDelete: "Vuoi eliminare questo studente?",
      },
      classes: {
        title: "Le mie classi",
        subtitle:
          "Crea una classe con uno o più studenti per organizzare le lezioni.",
        fields: {
          name: "Nome classe",
          students: "Studenti",
        },
        placeholders: {
          name: "es. Classe di matematica",
        },
        actions: {
          add: "Aggiungi classe",
          update: "Aggiorna classe",
        },
        loading: "Caricamento classi...",
        empty: "Nessuna classe creata finora.",
        emptyRoster: "Nessuno studente è ancora collegato alle tue lezioni.",
        studentsCount: "Studenti: {{count}}",
        noStudentsSelected: "Nessuno studente selezionato.",
        errors: {
          nameRequired: "Il nome della classe è obbligatorio",
        },
        confirmDelete: "Vuoi eliminare questa classe?",
      },
      lessons: {
        title: "Panoramica lezioni",
        subtitle: "Uno sguardo rapido alle lezioni e ai prossimi appuntamenti.",
        stats: {
          total: "Lezioni totali",
          completed: "Completate",
          cancelled: "Annullate",
        },
        labels: {
          scheduledAt: "Data: {{datetime}}",
          student: "Studente: {{name}}",
          duration: "Durata: {{minutes}} minuti",
        },
        empty: "Nessuna lezione registrata finora.",
      },
      users: {
        title: "Gestione utenti",
        subtitle:
          "Consulta gli account registrati e modifica i ruoli se necessario.",
        filters: {
          role: "Filtra per ruolo",
          allRoles: "Tutti i ruoli",
          search: "Cerca per email o nome",
        },
        placeholders: {
          search: "example@casaclass.com",
        },
        actions: {
          search: "Cerca",
          reset: "Reimposta",
        },
        loading: "Caricamento utenti...",
        summary:
          "Risultati: {{total}} — Admin: {{admins}}, Docenti: {{teachers}}, Genitori: {{parents}}",
        empty: "Nessun account corrisponde alla ricerca.",
        table: {
          email: "Email",
          name: "Nome",
          role: "Ruolo",
          status: "Stato",
        },
      },
    },
    studentsPage: {
      noAccess: {
        title: "Gestione figli",
        lead: "Questa pagina è riservata ai genitori per gestire i propri figli su Casaclass.",
        body: "Il tuo account non ha i permessi per gestire gli studenti. Torna alla dashboard.",
      },
      title: "I miei figli",
      lead: "Aggiungi nuovi figli, aggiorna i dati e segui le lezioni in arrivo da qui.",
      leadStudentMode:
        'Puoi attivare il "modo studente" per accedere alla vista di un figlio direttamente dall\'account genitore.',
      form: {
        newTitle: "Aggiungi un nuovo studente",
        editTitle: "Aggiorna i dati dello studente",
        firstName: "Nome",
        lastName: "Cognome",
        dob: "Data di nascita",
        password: "Password",
        notes: "Note",
      },
      placeholders: {
        firstName: "es. Yasmine",
        lastName: "es. Ben Salah",
        password: "Almeno 8 caratteri",
        notes: "Informazioni aggiuntive utili ai docenti.",
      },
      actions: {
        create: "Aggiungi studente",
        update: "Aggiorna studente",
        saving: "Salvataggio...",
        cancel: "Annulla",
      },
      list: {
        title: "Elenco figli",
        refresh: "Aggiorna",
        loading: "Caricamento studenti...",
        timetable: "Horario",
        empty: "Nessun figlio registrato.",
      },
      card: {
        upcoming: "{{count}} lezioni in arrivo",
        noUpcoming: "Nessuna lezione in arrivo",
        dob: "Data di nascita: {{date}}",
        edit: "Modifica",
        enterAs: "Accedi come studente",
        delete: "Elimina",
      },
      confirmDelete: "Vuoi eliminare questo studente?",
      feedback: {
        created: "Studente aggiunto con successo.",
        createdWithLogin: "Studente aggiunto. Email di accesso: {{email}}",
        updated: "Studente aggiornato.",
        deleted: "Studente eliminato.",
      },
      detail: {
        title: "Dettagli per {{name}}",
        lead: "Consulta il profilo dello studente e le sue prossime lezioni qui.",
        loadingLessons: "Aggiornamento lezioni...",
        activate: "Attiva modo studente",
        active: "Modo studente attivo per questo account",
        stats: {
          total: "Totale lezioni",
          completed: "Completate",
          cancelled: "Annullate",
        },
        info: {
          title: "Info studente",
          name: "Nome:",
          dob: "Data di nascita:",
          notes: "Note:",
          noNotes: "Nessuna nota",
        },
        upcoming: {
          title: "Prossime lezioni",
          time: "Orario: {{value}}",
          duration: "Durata: {{value}} minuti",
          teacher: "Docente: {{value}}",
          empty: "Nessuna lezione in arrivo per questo studente.",
        },
      },
      errors: {
        firstNameRequired: "Il nome è obbligatorio",
        passwordRequired: "La password è obbligatoria",
        passwordMin: "La password deve contenere almeno 8 caratteri",
      },
    },
    aboutPage: {
      hero: {
        label: "Casaclass",
        title: "La nostra storia",
        story: [
          "Dal primo giorno vogliamo offrire a ogni bambino tunisino, in patria o all'estero, uno spazio caldo e moderno che protegga la sua identità.",
          "L'educazione è più della conoscenza: è un ponte tra generazioni e una fonte di appartenenza.",
        ],
        illustrationAlt: "Illustrazione della community Casaclass",
        highlights: [
          {
            icon: "🌍",
            title: "Diaspora connessa",
            description: "Una scuola tunisina che viaggia con la tua famiglia.",
          },
          {
            icon: "🎓",
            title: "Esperti appassionati",
            description:
              "Docenti tunisini certificati che curano ogni percorso.",
          },
          {
            icon: "🤝",
            title: "Follow-up attento",
            description:
              "Test d'ingresso, coaching 1:1 e attestati di progresso.",
          },
        ],
      },
      mission: {
        label: "La nostra missione",
        title: "Ciò che difendiamo",
        description:
          "Unire eccellenza accademica e radici culturali per ogni famiglia tunisina.",
        items: [
          {
            title: "Accesso di qualità",
            description: "Lezioni su misura con docenti tunisini qualificati.",
          },
          {
            title: "Radici e identità",
            description: "Arabo, Corano e Hadith per restare connessi.",
          },
          {
            title: "Apertura globale",
            description:
              "Programmi in linea con i curricula tunisini e internazionali.",
          },
          {
            title: "Flessibile e motivante",
            description:
              "Pacchetti Ramadan, estivi, di revisione e sessioni coinvolgenti.",
          },
        ],
      },
      resources: {
        label: "Le nostre risorse",
        title: "Cosa offriamo",
        description:
          "Strumenti concreti, pacchetti tematici e un team pronto ad aiutare sempre.",
        items: [
          {
            title: "Team specializzato",
            description:
              "Docenti esperti nei percorsi accademici e spirituali.",
          },
          {
            title: "Pacchetti pronti",
            description:
              "Pacchetti Ramadan, unità scolastiche, supporto continuo.",
          },
          {
            title: "Guida completa",
            description:
              "Test di ingresso, follow-up individuale, valutazioni e attestati.",
          },
          {
            title: "Piattaforma accessibile",
            description: "Accesso online da Europa, Golfo e Tunisia.",
          },
        ],
      },
      values: {
        label: "I nostri valori",
        title: "Principi guida",
        description:
          "I nostri valori orientano ogni decisione educativa e umana.",
        items: [
          {
            title: "Cura",
            description:
              "L'apprendente al centro con un accompagnamento umano caloroso.",
          },
          {
            title: "Eccellenza",
            description: "Ogni lezione è progettata e revisionata con rigore.",
          },
          {
            title: "Autenticità",
            description:
              "Valorizziamo le radici tunisine e la dimensione spirituale.",
          },
          {
            title: "Innovazione",
            description:
              "Strumenti moderni, video interattivi e verifiche ludiche.",
          },
          {
            title: "Equità",
            description:
              "Un'educazione accessibile ovunque vivano le famiglie.",
          },
        ],
      },
      vision: {
        label: "La nostra visione",
        title: "Dove stiamo andando",
        description:
          "Far crescere Casaclass insieme alle famiglie in un modello sostenibile.",
        intro:
          "Vogliamo diventare il riferimento e-learning tunisino per i bambini costruendo:",
        points: [
          "Una comunità di studenti, genitori e docenti che condividono cultura e ambizione.",
          "Programmi rinnovati con pacchetti tematici e innovazione pedagogica.",
          "Una piattaforma scalabile e sostenibile per le famiglie tunisine ovunque.",
        ],
      },
      uniques: {
        label: "Cosa ci distingue",
        title: "Perché Casaclass è unica",
        description:
          "Un'esperienza completa che unisce rigore, spiritualità e innovazione digitale.",
        items: [
          {
            title: "Approccio ibrido",
            description: "Accademico e spirituale, con competenze digitali.",
          },
          {
            title: "Personalizzazione totale",
            description:
              "Test d'ingresso e percorso su misura per ogni bambino.",
          },
          {
            title: "Flessibilità geografica",
            description: "Ideale per famiglie in Europa, Golfo e Tunisia.",
          },
          {
            title: "Impegno educativo",
            description:
              "Docenti appassionati, strumenti moderni, vero follow-up.",
          },
        ],
      },
      showcase: {
        label: "In immagini",
        title: "La nostra visione in scatti",
        description:
          "Tre sguardi su Casaclass: energia della community, percorso guidato e piattaforma ovunque.",
        cards: [
          {
            title: "Community coinvolta",
            description: "Famiglie, studenti e mentor che avanzano insieme.",
            alt: "Community Casaclass",
          },
          {
            title: "Percorso immersivo",
            description:
              "Roadmap chiara, attività piacevoli, feedback costante.",
            alt: "Percorso Casaclass",
          },
          {
            title: "Sempre accessibile",
            description:
              "Interfaccia moderna e semplice in ogni viaggio e dispositivo.",
            alt: "Piattaforma Casaclass",
          },
        ],
      },
      cta: {
        title: "Pronto a entrare nella community Casaclass?",
        description:
          "Parla con il nostro team, trova il programma giusto e dai slancio all'apprendimento di tuo figlio.",
        primary: "Parla con il team",
        secondary: "Crea un account",
      },
    },
    dashboard: {
      role: {
        admin: "Admin di piattaforma",
        superadmin: "Super admin",
        support: "Supporto",
        accounting: "Contabilità",
        teacher: "Docente",
        parent: "Genitore",
        member: "Membro Casaclass",
      },
      searchPlaceholder: "Cerca...",
      loading: "Caricamento...",
      hero: {
        greeting: "Benvenuto/a {{name}}, 👋",
        intro:
          "Un colpo d'occhio su lezioni in arrivo, studenti collegati e pacchetti Casaclass consigliati.",
        manageLessons: "Gestisci lezioni",
        browseOffers: "Vedi offerte",
        nextLesson: "Prossima lezione",
        student: "Studente",
        teacher: "Docente",
        time: "Orario",
        duration: "Durata",
      },
      stats: {
        total: { label: "Lezioni", hint: "Tutte le lezioni registrate" },
        upcoming: { label: "In arrivo", hint: "Programmate a breve" },
        completed: { label: "Completate", hint: "Già svolte" },
        cancelled: { label: "Annullate", hint: "Lezioni annullate" },
      },
      upcoming: {
        title: "Lezioni in arrivo",
        subtitle: "Le prossime quattro lezioni per restare in carreggiata.",
        viewAll: "Vedi tutte",
        loading: "Caricamento lezioni...",
        empty:
          "Nessuna lezione in arrivo. Puoi programmarne una nuova dalla pagina Lezioni.",
      },
      students: {
        title: "Studenti collegati",
        subtitle: "Studenti associati al tuo account.",
        id: "Identificativo",
        dob: "Data di nascita",
        empty: "Nessun dato studente.",
      },
      featured: {
        title: "Pacchetti suggeriti",
        subtitle: "Raccomandazioni dal catalogo Casaclass.",
        explore: "Esplora tutti i pacchetti",
        lessonsCount: "Lezioni",
        sessionLength: "Durata sessione",
        price: "Prezzo",
        learnMore: "Scopri di più",
      },
      errors: {
        loadData: "Non siamo riusciti a caricare alcuni dati: {{error}}",
      },
      teacher: {
        roleLabel: "Dashboard docente",
        greeting: "Ciao {{name}}",
        intro:
          "Controllo rapido di lezioni, studenti e comunicazione con i genitori.",
        performance: {
          title: "Prestazioni",
          completed: "Completate",
          cancelled: "Annullate",
        },
        programs: {
          title: "I miei programmi",
          loading: "Caricamento programmi...",
          edit: "Modifica",
          empty: "Nessun programma per ora.",
        },
        weeklyActivity: {
          title: "Attività settimanale",
          hint: "Ultimi 7 giorni",
        },
        topStudents: {
          title: "Studenti più attivi",
          lessons: "{{count}} lezioni",
          empty: "Non ci sono ancora abbastanza dati.",
        },
        updates: {
          title: "Ultimi aggiornamenti",
          empty: "Nessun aggiornamento per ora.",
        },
        actions: {
          schedule: "Programma lezioni",
          newLesson: "Crea lezione",
        },
        stats: {
          activeStudents: { label: "Studenti attivi" },
          hoursGiven: { label: "Ore di insegnamento" },
          completed: { label: "Sessioni completate" },
          cancelled: { label: "Sessioni annullate" },
        },
        schedule: {
          title: "Calendario lezioni",
          subtitle: "Lezioni più vicine e loro stato.",
          view: "Vedi calendario",
          loading: "Caricamento calendario...",
          empty: "Nessuna lezione in arrivo.",
        },
        manage: {
          title: "Gestisci lezioni",
          subtitle: "Crea lezioni, risorse e presenze.",
          createEdit: {
            title: "Crea / modifica",
            description: "Pianifica, modifica o duplica lezioni facilmente.",
          },
          upload: {
            title: "Carica risorse",
            description: "Aggiungi PDF, video o quiz.",
          },
          attendance: {
            title: "Registra presenze",
            description: "Segna le presenze per ogni lezione.",
          },
        },
        assessments: {
          title: "Valutazioni & feedback",
          subtitle: "Voti, commenti e storico compiti/test.",
          grades: {
            title: "Voti & note",
            description: "Aggiungi un voto e una nota per ogni studente.",
          },
          homework: {
            title: "Registro compiti / test",
            description: "Rivedi compiti corretti e tracciali.",
          },
        },
        communication: {
          title: "Comunicazione",
          subtitle: "Messaggi interni e notifiche.",
          messaging: {
            title: "Messaggi interni",
            description: "Chat sicura con studenti e genitori.",
          },
          notifications: {
            title: "Notifiche di sistema",
            description: "Nuovi studenti o cambi di calendario.",
          },
        },
        payments: {
          title: "Pagamenti",
          subtitle: "Trasferimenti Casaclass e fatture mensili.",
          history: {
            title: "Storico trasferimenti",
            description: "I tuoi trasferimenti appaiono qui.",
          },
          invoicing: {
            title: "Fatture automatiche",
            description: "Riepilogo mensile generato automaticamente.",
          },
        },
      },
      parent: {
        roleLabel: "Dashboard genitore",
        greeting: "Ciao {{name}}",
        intro: "Monitora figli, lezioni, avvisi e fatturazione.",
        classes: {
          title: "Classi",
          subtitle: "Classi attuali per ciascun figlio",
        },
        widgets: {
          studentModeLabel: "Modalità studente",
          studentModePlaceholder: "Entra come studente",
          notifications: "Notifiche",
          weekSubtitle: "Panoramica delle lezioni di questa settimana.",
          noLessons: "Nessuna lezione.",
          reminders: "Promemoria",
          reminderCheckbox: "Segna come fatto",
          recommended: "Consigliati",
          monthStats: "Statistiche del mese",
          monthStatsHint: "Riepilogo",
          children: "Figli",
          homework: "Compiti",
          homeworkHint: "Prossime lezioni in arrivo.",
        },
        notifications: {
          empty: "Nessuna notifica.",
          markRead: "Segna come letto",
          status: {
            cancelled: "Annullata",
            postponed: "Rimandata",
            updated: "Aggiornata",
          },
        },
        actions: {
          weekly: "Calendario settimanale",
          support: "Apri ticket supporto",
        },
        activeStudent: {
          status: "Modalità studente attiva",
          none: "Nessuno studente selezionato",
          label: "Modalità {{name}}",
          subtitle: "Accesso diretto allo spazio dello studente selezionato.",
          deactivate: "Disattiva modalità",
          prompt: "Seleziona uno studente per attivare il suo spazio.",
        },
        children: {
          title: "Figli collegati",
          subtitle: "Progresso generale e prossime lezioni.",
          addChild: "Aggiungi un figlio",
          progress: "Progresso",
          nextLesson: "Prossima lezione",
          activate: "Attiva modalità studente",
          active: "Modalità studente attiva",
          viewLessons: "Vedi lezioni",
          loading: "Caricamento figli...",
          empty: "Nessun figlio collegato.",
        },
        followup: {
          title: "Follow-up lezioni",
          subtitle: "Calendario settimanale e registrazioni (replay/risorse).",
          loading: "Caricamento lezioni...",
          empty: "Nessuna lezione programmata questa settimana.",
        },
        communication: {
          title: "Comunicazione",
          subtitle: "Chat sicura con docenti e supporto.",
          teacherChat: {
            title: "Chat docente",
            description: "Thread privato per lezione.",
          },
          supportTicket: {
            title: "Ticket supporto",
            description: "Invia richieste al team Casaclass.",
          },
        },
        billing: {
          title: "Pagamenti & fatture",
          subtitle: "Abbonamenti, fatture PDF e gestione pacchetti.",
          activeSubs: {
            title: "Abbonamenti attivi",
            description: "Le offerte correnti appaiono qui.",
          },
          invoices: {
            title: "Fatture scaricabili",
            description: "Scarica le tue fatture (PDF).",
          },
          renew: {
            title: "Rinnova / annulla",
            description: "Gestisci le opzioni di abbonamento.",
          },
        },
        profile: {
          title: "Profilo genitore",
          subtitle: "Contatti e metodo di pagamento preferito.",
          contact: {
            title: "Dettagli contatto",
            description: "Aggiorna le tue informazioni.",
          },
          payment: {
            title: "Metodo di pagamento",
            description: "Aggiungi o modifica un metodo di pagamento.",
          },
          widgets: {
            studentModeLabel: "Modo estudiante",
            studentModePlaceholder: "Entrar como estudiante",
            notifications: "Notificaciones",
            weekSubtitle: "Vista rápida de las clases de esta semana.",
            noLessons: "No hay clases.",
            reminders: "Recordatorios",
            reminderCheckbox: "Marcar como hecho",
            recommended: "Recomendado",
            monthStats: "Estadísticas del mes",
            monthStatsHint: "Resumen",
            children: "Hijos",
            homework: "Tareas",
            homeworkHint: "Próximas clases.",
          },
          manageChildren: {
            title: "Gestisci figli",
            description: "Aggiungi o rimuovi figli collegati.",
          },
        },
        modal: {
          exitTitle: "Conferma ritorno alla modalità genitore",
          exitBody:
            "Per sicurezza, inserisci la password del genitore prima di tornare indietro.",
          passwordLabel: "Parola d'ordine",
          passwordError: "Password errata. Riprova.",
          cancel: "Annulla",
          confirm: "Conferma",
          verifying: "Verifica...",
          backToParent: "Torna alla modalità genitore",
          logout: "Esci",
        },
      },
      studentSpace: {
        tag: "Spazio studente",
        title: "Dashboard studente — {{name}}",
        subtitle: "Lezioni in arrivo, progresso, messaggi e risorse.",
        errors: {
          profileLoad: "Impossibile caricare il profilo studente.",
        },
        banner: {
          badge: "Stella del giorno",
          greeting: "Ciao, {{name}}",
          hint: "Felice di rivederti! Preparati e continua la lezione di oggi.",
          imageAlt: "Bambini che imparano",
          stats: {
            courses: "Corsi",
            xp: "XP",
            completed: "Completate",
          },
        },
        today: {
          title: "Lezioni di oggi",
          hint: "Lezioni divertenti ti aspettano oggi!",
          empty: "Nessuna lezione oggi. Buona pausa!",
        },
        missions: {
          title: "Le tue missioni",
          hint: "Scegli una missione e guadagna stelle!",
          mentor: {
            title: "Chiedi a un mentor",
            body: "Ricevi un consiglio veloce per oggi.",
          },
          challenge: {
            title: "Nuova sfida",
            body: "Inizia una nuova lezione e raccogli XP!",
          },
        },
        classes: {
          title: "La tua classe",
          hint: "Le tue classi e amici",
          allTab: "Tutte",
          friends: "{{count}} amici",
          classLabel: "Classe: {{name}}",
          empty: "Nessuna classe collegata.",
        },
        activity: {
          title: "La tua attività",
          hint: "Uno sguardo rapido ai tuoi progressi negli ultimi mesi.",
        },
        cards: {
          upcoming: { label: "In arrivo", hint: "Sessioni programmate" },
          past: { label: "Passate", hint: "Record recenti" },
          badges: { label: "Badge", hint: "Progresso visibile" },
          stars: { label: "Stelle", hint: "Motivazione" },
        },
        upcoming: {
          title: "Lezioni in arrivo",
          subtitle: "Entra nella stanza live (Zoom/BBB).",
          empty: "Nessuna lezione programmata.",
          join: "Entra nella stanza",
        },
        past: {
          title: "Lezioni passate",
          subtitle: "Replay, file e valutazioni.",
          empty: "Nessuna lezione passata.",
          viewResources: "Vedi risorse",
        },
        resources: {
          title: "Risorse",
          subtitle: "Biblioteca per materia con link e video.",
        },
        messages: {
          title: "Ultimi messaggi",
          subtitle: "Scambio con i docenti.",
          open: "Apri messaggi",
        },
        feedback: {
          title: "Valutazioni",
          subtitle: "Vedi voti, commenti e valuta la lezione.",
        },
      },
    },
    landingPage: {
      subjectsGrid: {
        title: "Materie",
        description:
          "Scopri i nostri programmi pensati per supportare tuo figlio in ogni materia, con un accompagnamento pedagogico specializzato che promuove eccellenza e fiducia.",
        cta: "Scopri le offerte",
        ariaLabel: "Programmi",
        managePrograms: "Gestisci programmi",
        items: [],
      },
      hero: {
        title: "Con te ad ogni passo",
        lead: "Casaclass è una piattaforma tunisina che arriva a casa tua ovunque tu sia. Accompagniamo i tuoi figli in studio, lingue e valori perché crescano con fiducia, identità e conoscenza.",
        primaryCta: "Inizia ora",
        secondaryCta: "Scopri le offerte",
        videoTitle: "Video di presentazione Casaclass",
        statsLabel: "Numeri chiave Casaclass",
        stats: [
          { value: "5.000+", label: "Famiglie accompagnate" },
          { value: "230+", label: "Lezioni interattive" },
          { value: "45", label: "Docenti tunisini" },
          { value: "4,9/5", label: "Soddisfazione genitori" },
        ],
      },
      features: {
        tag: "Una scuola per ogni bambino",
        title: "Perché Casaclass?",
        description:
          "Nata per mantenere i bambini legati a lingua, cultura e valori ovunque vivano. Uniamo pedagogia tunisina e strumenti moderni per un apprendimento motivante.",
        cta: "Scopri i programmi",
        cards: [
          {
            title: "Percorso personalizzato",
            description:
              "Test di ingresso, percorso su misura e supporto alla famiglia",
            alt: "Studente che segue un percorso personalizzato",
          },
          {
            title: "Live e on-demand",
            description: "Sessioni live + libreria video per ripassare",
            alt: "Lezione live su Casaclass",
          },
          {
            title: "Accompagnamento neuro-pedagogico",
            description:
              "Diagnosi, accompagnamento e percorsi educativi personalizzati per l'eccellenza",
            alt: "Illustrazione di accompagnamento neuro-pedagogico",
          },
        ],
      },
      journey: {
        ariaLabel: "Storia di Casaclass con le famiglie",
        title: "La storia",
        imageAlt: "Famiglia che si affida al percorso Casaclass",
        paragraphs: [
          "Ogni cervello è unico.",
          "Per trasformare le difficoltà in successo grazie a un accompagnamento neuro-pedagogico su misura, mettiamo a disposizione di tuo figlio i migliori esperti di psicologia, neuropsichiatria e pedagogia.",
        ],
        cta: "Avvia il test di livello",
      },
      levels: {
        tag: "Si parte",
        title: "Scegli il livello da esplorare",
        description:
          "Ogni livello combina video in streaming, dispense stampabili e monitoraggio degli obiettivi. Scegli oggi il livello giusto e inizia un percorso che cresce con tuo figlio.",
        note: "Se il sogno è possibile, il piano è vicino.",
        ariaPrefix: "Scopri il livello",
        items: [
          {
            grade: "1",
            label: "Livello 1",
            accent: 1,
            ariaLabel: "Scopri il livello 1",
          },
          {
            grade: "2",
            label: "Livello 2",
            accent: 2,
            ariaLabel: "Scopri il livello 2",
          },
          {
            grade: "3",
            label: "Livello 3",
            accent: 3,
            ariaLabel: "Scopri il livello 3",
          },
          {
            grade: "4",
            label: "Livello 4",
            accent: 4,
            ariaLabel: "Scopri il livello 4",
          },
          {
            grade: "5",
            label: "Livello 5",
            accent: 5,
            ariaLabel: "Scopri il livello 5",
          },
          {
            grade: "6",
            label: "Livello 6",
            accent: 6,
            ariaLabel: "Scopri il livello 6",
          },
          {
            grade: "7",
            label: "Livello 7",
            accent: 7,
            ariaLabel: "Scopri il livello 7",
          },
          {
            grade: "8",
            label: "Livello 8",
            accent: 8,
            ariaLabel: "Scopri il livello 8",
          },
          {
            grade: "9",
            label: "Livello 9",
            accent: 9,
            ariaLabel: "Scopri il livello 9",
          },
        ],
      },
      programs: {
        badge: "Programmi Casaclass",
        title: "Le quattro colonne di Casaclass",
        imageAlt: "Illustrazione delle colonne Casaclass",
        items: [
          {
            title: "1. Percorso scolastico — dalla 1a alla 9a",
            list: [
              "Ripasso + esercizi + video esplicativi",
              "Supporto individuale con docenti tunisini",
              "Follow-up mensile con i genitori",
              "Percorso che avanza passo dopo passo",
            ],
            slogan: "Studio chiaro, progresso garantito.",
            cta: "Unisciti al programma scolastico",
            ctaLink: "/signup",
          },
          {
            title: "2. Francese",
            list: [
              "Programmi approvati dal Ministero tunisino",
              "Laboratori di pronuncia ed espressione orale",
              "Ripasso di grammatica e scrittura con esempi",
              "Follow-up individuale e valutazioni regolari",
            ],
            slogan: "Una seconda lingua, una porta all'estero.",
            cta: "Scopri i corsi di francese",
            ctaLink: "/courses",
          },
          {
            title: "3. Arabo • Corano • Hadith",
            list: [
              "Memorizzazione semplificata",
              "Basi di tajwid",
              "Sira e valori",
              "Arabo pensato per la nuova generazione",
            ],
            cta: "Scopri i corsi di arabo e Corano",
            ctaLink: "/courses",
          },
          {
            title: "4. Club di coding per bambini",
            list: [
              "Scratch, Python Kids, robotica",
              "Giochi educativi",
              "Mini-progetti mensili",
              "I bambini di oggi, coder di domani",
            ],
            slogan: "Imparare il futuro parte ora.",
            cta: "Entra nel club di coding",
            ctaLink: "/signup",
          },
        ],
      },
      specialNeeds: {
        ariaLabel: "Supporto bisogni speciali",
        title: "Tuo figlio ha bisogni specifici",
        description:
          "C'è posto per lui qui: in contatto con specialisti per integrarsi e progredire al suo ritmo, secondo le sue necessità.",
        imageAlt: "Le tre colonne dei programmi Casaclass",
        cta: "Contattaci",
      },
      ecosystem: {
        title: "Un universo Casaclass chiaro",
        cta: "Entra nell'universo Casaclass",
        cards: [
          {
            icon: "👨‍👩‍👦",
            title: "Spazio genitori",
            items: [
              "Monitoraggio progressi",
              "Report settimanale",
              "Scelta docente/gruppo",
            ],
            alt: "Dashboard genitori in Casaclass",
          },
          {
            icon: "👦",
            title: "Spazio studente",
            items: ["Compiti", "Lezioni brevi", "Badge e ricompense"],
            alt: "Dashboard studente in Casaclass",
          },
          {
            icon: "👩‍🏫",
            title: "Spazio docente",
            items: ["Dashboard", "Pianificazione", "Valutazioni"],
            alt: "Dashboard docenti in Casaclass",
          },
        ],
      },
      ramadan: {
        ariaLabel: "Packs di Ramadan per bambini",
        badge: "Packs e Ramadan per bambini",
        title: "Packs di Ramadan",
        lead: "30 video di valori, Corano, storie ed etica per bambini 5-12 anni: un Ramadan pieno di luce, identità e meraviglia.",
        items: [
          "Programmazione quotidiana ispirata al Ramadan",
          "Storie illustrate ed esercizi sui valori ogni giorno",
          "Sessioni di Corano semplificate con tajwid chiaro",
          "Attività familiari per rafforzare il legame",
        ],
        slogan: "Luce, apprendimento e guida.",
        cta: "Disponibile a breve",
        imageAlt: "Docente Casaclass che guida i bambini nel programma Ramadan",
      },
      testimonials: {
        ariaLabel: "Testimonianze della community Casaclass",
        tag: "Storie dalla community",
        title: "La fiducia di famiglie e docenti",
        lead: "Dai genitori all'estero ai docenti in Tunisia, la piattaforma riunisce bambini ispirati e li accompagna passo dopo passo.",
        prev: "Testimonianza precedente",
        next: "Testimonianza successiva",
        dotsLabel: "Naviga le testimonianze",
        dotLabel: "Mostra la testimonianza di {{name}}",
        imageAlt: "Genitore: {{name}}",
        items: [
          {
            quote:
              "Da quando abbiamo iniziato con Casaclass, il ripasso è diventato un momento piacevole in famiglia. Mia figlia ama il percorso chiaro e i premi digitali, e io seguo i progressi con serenità dallo spazio genitori.",
            name: "Amel Ben Salem",
            place: "Lione, Francia",
          },
          {
            quote:
              "Viviamo a Dubai e gli orari rendevano difficili i corsi tunisini. Con Casaclass seguiamo live o repliche quando conviene e i bambini interagiscono con i docenti come se fossero in Tunisia.",
            name: "Rami & Sirine",
            place: "Dubai, EAU",
          },
          {
            quote:
              "Mio figlio fatica a concentrarsi; il coach pedagogico ci ha dato un piano chiaro. Riceviamo report settimanali e consigli, e ora è motivato e racconta da solo le lezioni di arabo e Corano.",
            name: "Laila Marzouki",
            place: "Toronto, Canada",
          },
        ],
      },
      faq: {
        ariaLabel: "Domande frequenti Casaclass",
        tag: "FAQ",
        title: "Le vostre domande",
        lead: "Restiamo al vostro fianco dal primo giorno fino ai risultati dei vostri figli.",
        items: [
          {
            question: "Per quanto tempo restano accessibili le risorse?",
            answer:
              "Ogni abbonamento apre tutte le unità per 12 mesi con aggiornamenti gratuiti ogni trimestre.",
          },
          {
            question: "I corsi sono adatti alle famiglie all'estero?",
            answer:
              "Sì. Il contenuto è bilingue (arabo/francese) e segue il programma tunisino con flessibilità di fuso orario.",
          },
          {
            question: "C'è un follow-up personalizzato?",
            answer:
              "Dall'iscrizione c'è un coach educativo con check-in mensili e consigli su misura per la famiglia.",
          },
          {
            question: "Come inizio?",
            answer:
              "Crea un account, scegli il livello di tuo figlio e avvia subito il test di ingresso e le prime lezioni.",
          },
        ],
      },
      finalCta: {
        ariaLabel: "Unisciti a Casaclass",
        label: "Pronti?",
        title: "Attiva oggi la prima lezione",
        description: "Registrazione rapida + lezione di prova gratuita",
        primary: "Iscriviti ora",
        secondary: "Parla con un consulente",
      },
    },
    authPage: {
      loginTitle: "Accesso",
      loginLead: "Riprendi subito le tue lezioni.",
      email: "Email",
      emailPlaceholder: "example@mail.com",
      phoneLabel: "Numero di telefono",
      phonePlaceholder: "Inserisci il tuo numero di telefono",
      password: "Password",
      passwordPlaceholder: "Inserisci la tua password",
      showPassword: "Mostra password",
      hidePassword: "Nascondi password",
      loginCta: "Accedi",
      loginLoading: "Accesso in corso...",
      noAccount: "Non hai un account?",
      goSignup: "Creane uno ora",
      signupTitle: "Crea un account",
      signupLead: "Unisciti a Casaclass e progredisci con piacere.",
      name: "Nome completo",
      namePlaceholder: "Inserisci il tuo nome completo",
      roleLabel: "Tipo di account",
      roleParent: "Genitore",
      roleTeacher: "Insegnante",
      resumeLabel: "Curriculum (CV)",
      resumeRequired: "Carica il tuo CV per registrarti come insegnante.",
      confirmPassword: "Conferma password",
      confirmPasswordPlaceholder: "Reinserisci la password",
      signupCta: "Unisciti a Casaclass",
      signupLoading: "Creazione in corso...",
      hasAccount: "Hai già un account?",
      goLogin: "Accedi",
      passwordLength: "La password deve avere almeno 8 caratteri.",
      passwordMatch: "Le password non coincidono.",
      loginError: "Impossibile accedere. Riprova.",
      signupError: "Impossibile creare l'account. Riprova più tardi.",
      forgotLink: "Hai dimenticato la password?",
      forgotTitle: "Password dimenticata",
      forgotLead:
        "Inserisci la tua email e invieremo un link di reset se l'account esiste.",
      forgotCta: "Invia link di reset",
      forgotSending: "Invio...",
      forgotSuccess:
        "Se questa email è registrata, riceverai a breve le istruzioni.",
      forgotBack: "Torna al login",
      socialDivider: "Oppure continua con Google",
      googleError: "Impossibile accedere con Google. Riprova.",
      googleLoading: "Verifica dell'account Google...",
    },
    verificationPage: {
      title: "Account in attesa di verifica",
      message:
        "Il tuo account insegnante è stato creato correttamente, ma potrai accedere alla piattaforma solo dopo la verifica da parte di un amministratore.",
      logout: "Esci",
    },
    resources: {
      title: "Risorse",
      subtitleTeacher:
        "Crea risorse e assegnale a una classe o a uno studente.",
      subtitleStudent: "Le risorse assegnate a te appariranno qui.",
      loading: "Caricamento...",
      create: "Crea risorsa",
      creating: "Creazione...",
      listTitle: "Risorse",
      empty: "Nessuna risorsa per ora.",
      delete: "Elimina",
      confirmDelete: "Eliminare questa risorsa?",
      failedLoad: "Impossibile caricare le risorse",
      failedCreate: "Impossibile creare la risorsa",
      failedDelete: "Impossibile eliminare la risorsa",
      titleRequired: "Il titolo è obbligatorio",
      targetRequired: "Seleziona una classe o uno studente",
      targetClass: "Classe",
      targetStudent: "Studente",
      fields: {
        title: "Titolo",
        titlePlaceholder: "es. Materiale settimana 3",
        text: "Testo",
        textPlaceholder: "Descrizione o istruzioni (opzionale)",
        assignTo: "Assegna a",
        class: "Classe",
        student: "Studente",
        attachments: "Allegati",
      },
      assign: {
        class: "Classe",
        student: "Studente",
      },
      pickClass: "Seleziona una classe",
      pickStudent: "Seleziona uno studente",
    },
    offers: {
      heroTag: "Offerte",
      heroTitle: "Pacchetti Casaclass pronti",
      heroDescription:
        "Scegliete il percorso più adatto alla vostra famiglia. Ogni offerta unisce lezioni live, risorse digitali e supporto del team pedagogico.",
      packLabel: "Scegli un pack:",
      packPlaceholder: "-- Seleziona --",
      sections: {
        classTypes: {
          tag: "Modalità di apprendimento",
          heading: "Scegliete l'ambiente più comodo per il bambino",
          description:
            "Dalla lezione individuale ai gruppi più grandi, ogni formato è pensato per profili e budget diversi.",
        },
        languages: {
          tag: "Lingue",
          heading: "Percorsi di lingua dal vivo",
          description:
            "Viaggi completi dalle basi agli esami internazionali, con contenuti interattivi che danno sicurezza.",
        },
        upcoming: {
          tag: "In arrivo",
          heading: "Corsi sulle competenze del futuro",
          description:
            "Iscrivetevi per essere avvisati quando apriamo coding, AI e laboratori per giovani leader.",
        },
      },
      classTypes: {
        full: {
          category: "Tipi di classe",
          title: "Full Classes",
          subtitle: "Lezione individuale totalmente personalizzata",
          description:
            "Esperienza 100% personale con un insegnante che crea il piano attorno alle esigenze di vostro figlio.",
          price: "25 TND / lezione",
          billing: "Sessione privata di 60 minuti",
          features: [
            "Programma personalizzato rivisto regolarmente",
            "Attenzione individuale",
            "Massima flessibilità di orario",
          ],
          cta: "Unisciti alle Full Classes",
        },
        duo: {
          category: "Tipi di classe",
          title: "DUO Classes",
          subtitle: "Lezione condivisa con amico o fratello",
          description: "Pensato per una coppia che si motiva a vicenda.",
          price: "15 TND / lezione",
          billing: "Prezzo per studente",
          features: [
            "Contenuto su misura per due",
            "Attività collaborative",
            "Follow-up sulla divisione dei compiti",
          ],
          cta: "Unisciti alle DUO Classes",
          badge: "Il più scelto",
        },
        vip: {
          category: "Tipi di classe",
          title: "VIP Classes",
          subtitle: "Piccoli gruppi fino a 4 studenti",
          description:
            "Coinvolgimento continuo in un gruppo selezionato con attenzione personale.",
          price: "10 TND / lezione",
          billing: "Prezzo per studente",
          features: [
            "Sessioni interattive con coetanei",
            "Attività cooperative per la fiducia",
            "Guida individuale nel gruppo",
          ],
          cta: "Unisciti alle VIP Classes",
        },
        normal: {
          category: "Tipi di classe",
          title: "Normal Classes",
          subtitle: "Fino a 8 studenti",
          description:
            "Opzione economica che mantiene l'impegno in un gruppo collaborativo.",
          price: "7.5 TND / lezione",
          billing: "Prezzo per studente",
          features: [
            "Ambiente di gruppo strutturato",
            "Attività che incoraggiano la partecipazione",
            "Miglior valore per apprendimento costante",
          ],
          cta: "Unisciti alle Normal Classes",
        },
      },
      languagePrograms: {
        french: {
          category: "Programmi di lingua",
          title: "Francese",
          subtitle: "A1-C2 • DELF/DALF",
          description:
            "Rafforza grammatica e conversazione con preparazione completa agli esami DELF/DALF.",
          price: "180 TND / mese",
          billing: "Sessioni live + risorse digitali",
          features: [
            "Progressione dalle lettere alla scrittura accademica",
            "Esercitazioni DELF/DALF",
            "Laboratori di pronuncia e orale",
          ],
          cta: "Iscriviti a Francese",
        },
        english: {
          category: "Programmi di lingua",
          title: "Inglese",
          subtitle: "Conversazione + IELTS",
          description:
            "Percorso completo per parlare con sicurezza e preparare l'IELTS con moduli business.",
          price: "220 TND / mese",
          billing: "Live • risorse interattive",
          features: [
            "Preparazione IELTS completa",
            "Business English e colloqui",
            "Club di conversazione settimanali",
          ],
          cta: "Prova una lezione",
          badge: "Preferito",
        },
        arabic: {
          category: "Programmi di lingua",
          title: "Arabo",
          subtitle: "Per non madrelingua",
          description:
            "Introduce lettere, pronuncia corretta e conversazione quotidiana con tocco culturale.",
          price: "160 TND / mese",
          billing: "Sessioni comunicative + supporto a casa",
          features: [
            "Lettere e suoni corretti dal primo giorno",
            "Dialoghi quotidiani e vocabolario base",
            "Storie e attività culturali",
          ],
          cta: "Iscriviti ad Arabo",
        },
      },
      upcoming: {
        coding: {
          category: "In arrivo",
          title: "Coding for Kids",
          subtitle: "Progetti Scratch e Minecraft",
          description:
            "Laboratorio digitale che insegna logica con progetti divertenti ogni mese.",
          price: "Presto",
          billing: "Iscrizioni nel prossimo trimestre",
          features: [
            "Workshop di coding progressivi",
            "Badge digitali",
            "Collaborazione in piccoli team",
          ],
          cta: "Avvisami al lancio",
        },
        ai: {
          category: "In arrivo",
          title: "AI & Future Skills",
          common: { id: "ID" },
          subtitle: "IA semplificata per i ragazzi",
          description:
            "Esplora IA, design thinking e automazione tramite mini-progetti.",
          price: "Presto",
          billing: "Lancio estate 2026",
          features: [
            "Concetti IA senza complessità",
            "Laboratori di robotica con kit semplici",
            "Sfide di pensiero critico",
          ],
          cta: "Unisciti alla lista d'attesa",
        },
        leaders: {
          category: "In arrivo",
          title: "Future Leaders Lab",
          subtitle: "Comunicazione e presentazione",
          description:
            "Unisce presentazioni, problem solving e mini-progetti per i teen.",
          price: "Presto",
          billing: "Pilota autunno 2026",
          features: [
            "Sessioni 1:1 e di gruppo",
            "Progetti applicati",
            "Coaching da esperti di comunicazione",
          ],
          cta: "Registrare interesse",
        },
      },
      addons: {
        tag: "Add-on opzionali",
        heading: "Servizi che completano l'esperienza",
        description:
          "Aggiungeteli a qualsiasi pacchetto principale o prenotateli separatamente quando serve un boost.",
        coaching: {
          title: "Sessione di coaching familiare",
          price: "30 TND / sessione",
          description:
            "Chiamata di 45 minuti per valutare bisogni e definire un piano mensile.",
          points: [
            "Analisi rapida del livello",
            "Mappa obiettivi di 4 settimane",
            "Attività a casa e follow-up",
          ],
          cta: "Prenota la sessione",
        },
        assessment: {
          title: "Test di posizionamento avanzato",
          price: "45 TND una tantum",
          description:
            "Test interattivo + rapporto scritto con raccomandazioni precise.",
          points: [
            "Test digitale in lingua e matematica",
            "Analisi scritta di punti di forza e bisogni",
            "Piano di transizione per le prime settimane",
          ],
          cta: "Richiedi il report",
        },
        oneToOne: {
          title: "Lezioni 1:1 intensive",
          price: "25 TND / sessione",
          description:
            "Lezioni private online con docente Casaclass per rafforzare una skill specifica.",
          points: [
            "Materia e orario flessibili",
            "Nota di follow-up dopo ogni sessione",
            "Ideale prima degli esami o per sicurezza",
          ],
          cta: "Coordinati con noi",
        },
      },
      support: {
        heading: "Serve aiuto a scegliere?",
        description:
          "Il team Casaclass può creare un piano personalizzato. Contattateci: proporremo il percorso giusto e verificheremo la preparazione prima di iniziare.",
        ctaCall: "Prenota una call di orientamento",
        ctaSignup: "Crea un account ora",
      },
    },
    adminPage: {
      accessDenied: "Accesso riservato agli admin.",
      headerTag: "Console amministrativa",
      headerTitle: "Dashboard admin",
      dashboard: {
        welcome: "Bentornato!",
        viewAll: "Vedi tutto",
        manageTitle: "Gestione",
        manageColumns: {
          section: "Sezione",
          count: "Totale",
          open: "Apri",
        },
        cards: {
          newStudents: "Nuovi studenti",
          newStudentsHint: "Periodo attuale",
          totalStudents: "Studenti totali",
          totalStudentsHint: "Tutti gli studenti",
          dailyAttend: "Presenza",
          dailyAttendHint: "Ultimi 7 giorni",
          averageAttend: "Presenza media",
          averageAttendHint: "Questo mese",
        },
        activityTitle: "Attività studenti",
        thisMonth: "Questo mese",
        lastMonths: "Mese scorso",
        examsTitle: "Esami",
        examsFallback: "Monitoraggio esami",
        studentsTitle: "Elenco studenti",
        studentsColumns: {
          id: "ID",
          student: "Studente",
          parent: "Genitore",
          attends: "Presenze",
        },
        teachersTitle: "Docenti",
        teacherVerified: "Verificato",
        teacherPending: "In attesa",
        empty: "Nessun dato per ora.",
      },
      tabs: {
        overview: "Panoramica",
        users: "Utenti",
        students: "Studenti",
        lessons: "Lezioni e calendario",
        timetable: "Orario",
        pendingTeachers: "Verifiche insegnanti in sospeso",
        classes: "Classi",
        packs: "Pacchetti",
        payments: "Pagamenti",
        teachers: "Insegnanti",
        support: "Supporto",
      },
      teachers: {
        title: "Insegnanti",
        empty: "Nessun insegnante da mostrare.",
        resume: "Scarica CV",
        activeYes: "Sì",
        activeNo: "No",
        filter: {
          label: "Filtra per stato",
          all: "Tutti",
          pending: "In attesa",
          verified: "Verificato",
        },
        status: {
          verified: "Verificato",
          pending: "In attesa",
        },
        fields: {
          email: "Email",
          phone: "Telefono",
          active: "Attivo",
          joined: "Iscritto",
        },
      },
      actions: {
        save: "Salva",
        saving: "Salvataggio…",
        create: "Crea",
        cancel: "Annulla",
        edit: "Modifica",
        delete: "Elimina",
      },
      timetable: {
        calendarTitle: "Calendario",
        addEvent: "Aggiungi evento",
        configure: "Configura",
        previousDay: "Giorno precedente",
        nextDay: "Giorno successivo",
        scopeTeacher: "Insegnante",
        scopeClass: "Classe",
        scopeStudent: "Studente",
        allTeachers: "Tutti gli insegnanti",
        allClasses: "Tutte le classi",
        allStudents: "Tutti gli studenti",
        viewWeek: "Settimana",
        viewDay: "Giorno",
        faculty: "Docenti",
        searchFacultyPlaceholder: "Cerca docenti...",
        editLessonTitle: "Modifica lezione",
        newLessonTitle: "Nuova lezione",
        selectPlaceholder: "Seleziona…",
        lessonTitlePlaceholder: "Titolo della lezione",
        minutesShort: "min",
        permanentWeekly: "Settimanale permanente",
        fields: {
          teacher: "Insegnante",
          class: "Classe",
          students: "Studenti",
          assignTo: "Assegna a",
          student: "Studente",
          title: "Titolo",
          start: "Inizio",
          duration: "Durata",
          status: "Stato",
        },
        assignModes: {
          student: "Studente",
          class: "Classe",
        },
      },
      classes: {
        panelTitleEdit: "Modifica classe",
        panelTitleCreate: "Crea classe",
        classNamePlaceholder: "Nome della classe",
        fields: {
          name: "Nome",
          students: "Studenti",
        },
        errors: {
          nameRequired: "Il nome è obbligatorio",
        },
        confirmDelete: "Eliminare questa classe?",
        table: {
          class: "Classe",
          teacher: "Insegnante",
          students: "Studenti",
          actions: "Azioni",
        },
      },
      loading: "Caricamento dati...",
      stats: {
        activeStudents: "Studenti attivi",
        monthlyRevenue: "Entrate mensili",
        satisfaction: "Tasso di soddisfazione",
        outOfFive: "su 5",
        supportMessages: "Messaggi di supporto",
        teachers: "Docenti",
        unread: "non letti",
      },
      roles: {
        superadmin: "Super amministratore",
        admin: "Amministratore",
        support: "Supporto",
        accounting: "Amministrazione",
        teacher: "Docente",
        parent: "Genitore",
      },
      users: {
        title: "Gestione utenti",
        filter: "Filtra per ruolo",
        filterAll: "Tutti",
        columns: {
          email: "Email",
          name: "Nome",
          role: "Ruolo",
          phone: "Telefono",
          joined: "Iscrizione",
          verify: "Verifica docente",
          active: "Attivo",
          actions: "Azioni",
        },
        verify: "Verifica",
        unverify: "Revoca",
        toggleActiveAria: "Attiva o disattiva utente",
        deleteConfirm: "Eliminare questo utente?",
        delete: "Elimina",
      },
      students: {
        title: "Studenti",
        ageYears: "anni",
        parent: "Genitore",
        dob: "Data di nascita",
      },
      lessons: {
        title: "Lezioni e calendario",
        idLabel: "Identificativo",
        student: "Studente",
        teacher: "Docente",
        duration: "Durata",
        minutes: "minuti",
        status: {
          scheduled: "Programmato",
          completed: "Completato",
          cancelled: "Annullato",
        },
      },
      packs: {
        formEdit: "Modifica pacchetto",
        formNew: "Nuovo pacchetto",
        fields: {
          name: "Nome pacchetto",
          description: "Descrizione",
          subject: "Materia",
          subjectPlaceholder: "Scegli...",
          price: "Prezzo",
          currency: "Valuta",
          lessons: "Numero sessioni",
          sessionLength: "Durata sessione (min)",
          resources: "Risorse (un URL per riga)",
          image: "Immagine (opzionale)",
          recommended: "Consigliato per",
          gradientColors: "Colori del gradiente",
          gradientStart: "Colore iniziale del gradiente",
          gradientEnd: "Colore finale del gradiente",
          featured: "Mostra in home",
          offersSection: "Sezione offerte",
          offersSectionNone: "Nessuna",
          offersKind: "Tipo di offerta",
          offersDisplayOrder: "Ordine di visualizzazione (offerte)",
          offersAccent: "Accento (offerte)",
          offersCategoryKey: "Chiave categoria (offerte)",
          offersTitleKey: "Chiave titolo (offerte)",
          offersSubtitleKey: "Chiave sottotitolo (offerte)",
          offersDescriptionKey: "Chiave descrizione (offerte)",
          offersPriceKey: "Chiave prezzo (offerte)",
          offersBillingKey: "Chiave fatturazione (offerte)",
          offersFeaturesKey: "Chiave caratteristiche (offerte)",
          offersCtaKey: "Chiave CTA (offerte)",
          offersCtaLink: "Link CTA (offerte)",
          offersBadgeKey: "Chiave badge (offerte)",
          offersNoteKey: "Chiave nota (offerte)",
          offersPointsKey: "Chiave punti (offerte)",
        },
        placeholderResources: "https://.../video.mp4\nhttps://.../document.pdf",
        placeholders: {
          name: "Esempio: pacchetto lingua araba",
          description: "Esempio: sessioni settimanali con insegnante",
          price: "Esempio: 120",
          lessons: "Esempio: 6",
          sessionLength: "Esempio: 60",
          image: "Esempio: https://example.com/image.png",
          recommended: "Esempio: studenti delle medie",
          offersKey: "Esempio: offers.languages.arabic.title",
          offersLink: "Esempio: /contact",
        },
        actions: {
          saving: "Salvataggio...",
          save: "Salva",
          reset: "Reimposta",
        },
        listTitle: "Pacchetti esistenti",
        sessions: "sessioni",
        minutesPerSession: "min/sessione",
        resourcesCount: "risorse",
        badgeFeatured: "In evidenza",
        edit: "Modifica",
        delete: "Elimina",
        deleteConfirm: "Eliminare questo pacchetto?",
        errorMissingNameSubject: "Inserisci nome pacchetto e materia.",
        detailsTitle: "Dettagli del pacchetto",
        errorPackNotFound: "Impossibile trovare questo pacchetto.",
      },
      payments: {
        title: "Pagamenti",
        columns: {
          user: "Utente",
          pack: "Pacchetto",
          amount: "Importo",
          status: "Stato",
        },
        statuses: {
          pending: "In attesa",
          completed: "Completato",
          failed: "Fallito",
          refunded: "Rimborsato",
        },
      },
      support: {
        title: "Supporto e messaggi",
        from: "Da",
        read: "Letto",
        new: "Nuovo",
        type: "Tipo",
        markRead: "Segna come letto",
        reply: "Rispondi",
        replyTitle: "Nuovo messaggio",
        replyClose: "Chiudi",
        replyTo: "A",
        replySubject: "Oggetto",
        replyMessage: "Messaggio",
        replySend: "Invia",
        replySending: "Invio...",
        replyEmpty: "Scrivi un messaggio prima di inviare.",
        replySubjectFallback: "Re: Messaggio di contatto",
      },
    },
  },
  es: {
    meta: { name: "Español", dir: "ltr" },
    testsModule: testsModuleEs,
    common: { id: "ID" },
    nav: {
      home: "Inicio",
      courses: "Cursos",
      about: "Quiénes somos",
      contact: "Contacto",
      searchLabel: "Buscar en Casaclass",
      searchPlaceholder: "Busca una lección o recurso",
      menuLabel: "Menú",
      languageLabel: "Idioma",
    },
    auth: {
      login: "Iniciar sesión",
      signup: "Crear cuenta",
    },
    protectedRoute: {
      loading: "Verificando tu cuenta...",
    },
    footer: {
      title: "Casaclass",
      description: "Tu plataforma educativa para el éxito escolar.",
      quickLinks: "Enlaces rápidos",
      home: "Inicio",
      courses: "Cursos",
      about: "Quiénes somos",
      contact: "Contacto",
      email: "contact@casaclassroom.com",
      phone: "+216 55 544 475",
      copyright: "Todos los derechos reservados.",
    },
    sidebar: {
      close: "Cerrar",
      toggle: "Mostrar/ocultar menú",
      role: {
        admin: "Admin de plataforma",
        superadmin: "Super admin",
        support: "Soporte",
        accounting: "Contabilidad",
        teacher: "Docente",
        parent: "Padre/Madre",
        student: "Estudiante",
        user: "Usuario",
      },
      links: {
        dashboard: "Dashboard",
        programs: "Programas",
        lessons: "Clases",
        timetable: "Horario",
        resources: "Recursos",
        tests: "Pruebas",
        homeworks: "Tareas",
        offers: "Ofertas",
        contact: "Soporte",
        gradientStart: "Color inicial del degradado",
        gradientEnd: "Color final del degradado",
        profile: "Mi cuenta",
        admin: "Consola admin",
        students: "Estudiantes",
        newLesson: "Nueva clase",
        myStudents: "Mis estudiantes",
        myChildren: "Mis hijos",
        myLessons: "Mis clases",
      },
      sections: {
        main: "Menú principal",
        management: "Gestión académica",
        other: "Otros",
        actions: {
          save: "Guardar",
          saving: "Guardando...",
          create: "Crear",
          cancel: "Cancelar",
          edit: "Editar",
          delete: "Eliminar",
        },
      },
      logout: "Cerrar sesión",
    },
    studentShell: {
      shortcutsLabel: "Accesos directos del estudiante",
      mainNavLabel: "Navegación principal del estudiante",
    },
    comingSoon: {
      badge: "Pronto",
      defaultTitle: "Página en preparación",
      levelTitle: "Nivel {{level}}",
      defaultDescription: "La página que buscas está en construcción.",
      levelDescription:
        "Estamos preparando el contenido del nivel {{level}} — disponible pronto.",
      pathNotReady: "La ruta {{path}} aún no está disponible.",
      backHome: "Volver al inicio",
      contactUs: "Contáctanos",
      notFoundTitle: "Página no disponible",
      notFoundMessage: "La página que buscas no existe o está en preparación.",
    },
    contactPage: {
      status: {
        loading: "Enviando tu mensaje...",
        success: "¡Mensaje enviado! Te responderemos pronto.",
        error: "No pudimos enviar el mensaje. Inténtalo de nuevo.",
      },
      hero: {
        label: "Contáctanos",
        title: "Planifiquemos una experiencia de aprendizaje inspiradora",
        lead: "Cuéntanos lo que necesitas y crearemos un camino de aprendizaje para tu familia. Nuestro equipo está listo para ayudarte.",
      },
      form: {
        cardTitle: "Escríbenos directamente",
        cardSubtitle:
          "Completa el formulario y te responderemos dentro de un día hábil.",
        fullNameLabel: "Nombre completo",
        fullNamePlaceholder: "Ingresa tu nombre",
        emailLabel: "Correo electrónico",
        emailPlaceholder: "example@mail.com",
        phoneLabel: "Número de teléfono",
        phonePlaceholder: "Ingresa tu número de teléfono",
        subjectLabel: "Asunto",
        subjectPlaceholder: "Agrega un asunto breve",
        messageLabel: "¿Cómo podemos ayudarte?",
        messagePlaceholder:
          "Describe tu necesidad para proponer la mejor solución",
        submit: "Enviar mensaje",
        submitting: "Enviando...",
        phoneAppend: "Número de teléfono: {{phone}}",
      },
      calendly: {
        title: "Agenda una consulta",
        subtitle:
          "Elige el momento que mejor te convenga para hablar con nuestro equipo.",
      },
    },
    errors: {
      adminRequired: "Esta acción requiere una cuenta de administrador.",
      authRequired: "Debes iniciar sesión para realizar esta acción.",
      operationFailed: "No se pudo completar la operación.",
      fetchFailed: "No se pudieron obtener los datos. Inténtalo de nuevo.",
      lessonIdRequired: "El ID de la clase es obligatorio.",
    },
    lessons: {
      title: "Clases",
      subtitleStudent: "Mostrando clases del estudiante activo",
      subtitleStaff:
        "Todas las clases vinculadas a tu cuenta con filtros y estados.",
      newLesson: "Nueva clase",
      searchLabel: "Buscar clases",
      searchPlaceholder: "Título, estudiante, profesor",
      statusFilter: "Filtrar por estado",
      refresh: "Actualizar lista",
      loading: "Cargando clases...",
      empty: "No hay clases que coincidan con la vista actual.",
      emptyCta: "Crear la primera clase",
      error: "Error al cargar las clases: ",
      deleteConfirm: "¿Seguro que deseas eliminar esta clase?",
      student: "Estudiante",
      teacher: "Profesor",
      pack: "Paquete",
      duration: "Duración",
      minutes: "minutos",
      viewDetails: "Ver detalles",
      joinMeeting: "Unirse a la clase",
      joinMeetingSoon: "Disponible 2 h antes",
      generateMeeting: "Generar enlace de reunión",
      generatingMeeting: "Generando...",
      edit: "Editar",
      delete: "Eliminar",
      statusScheduled: "Programada",
      statusCompleted: "Completada",
      statusCancelled: "Cancelada",
      filterAll: "Todos los estados",
      filterScheduled: "Próximas",
      filterCompleted: "Completadas",
      filterCancelled: "Canceladas",
      timetable: {
        days: "Días",
        item: "elemento",
        items: "elementos",
        noLessonsForWeek: "No hay clases esta semana",
        selectChild: "Seleccionar hijo",
        previousWeek: "Semana anterior",
        nextWeek: "Semana siguiente",
        today: "Hoy",
        classLabel: "Clase:",
        month: "Mes",
        week: "Semana",
        yourWeeklyTimetable: "Tu horario semanal",
      },
    },
    programDetails: {
      loading: "Cargando...",
      eyebrow: "Programas",
      notFound: {
        title: "Programa no encontrado",
        hint: "Elige un programa de la lista o crea uno nuevo.",
      },
      actions: {
        backToDashboard: "Volver al panel",
        backToHome: "Volver al inicio",
        newProgram: "Nuevo programa",
        addLevel: "Agregar nivel",
      },
      sidebar: {
        allPrograms: "Todos los programas",
        editTitle: "Editar",
        editAction: "Editar",
      },
      sections: {
        overview: "Resumen",
        learning: "Lo que aprenderán los estudiantes",
        morePrograms: "Más programas",
        levels: { single: "Nivel", plural: "Niveles" },
      },
      levels: {
        pickFirst: "Elige primero un nivel para ver sus detalles.",
        chooseLevel: "Elegir nivel",
        levelTitle: "Nivel {{grade}}",
        levelImageAlt: "Imagen del nivel {{grade}}",
      },
      cta: { enrollNow: "Inscribirse ahora" },
      editor: {
        title: "Editar programa",
        delete: "Eliminar",
        save: "Guardar",
        cancel: "Cancelar",
      },
      fields: {
        accentColor: "Color de acento",
        icon: "Icono",
        custom: "Personalizado",
        assignedTeacher: "Profesor asignado",
        unassigned: "Sin asignar",
        teacherFallback: "Profesor",
        title: "Título",
        shortDescription: "Descripción corta",
        details: "Detalles",
        keyPoints: "Puntos clave",
        levels: "Niveles",
        previewLevelsPage: "Vista previa de niveles",
        levelRowTitle: "Nivel {{index}}",
        remove: "Quitar",
        grade: "Grado",
        label: "Etiqueta",
        description: "Descripción",
        uploadImage: "Subir imagen",
        uploading: "Subiendo…",
        chooseFile: "Elegir archivo",
        removeImage: "Quitar imagen",
        imageUrl: "URL de imagen",
        ctaLabel: "Texto del botón",
        ctaLink: "Enlace del botón",
        displayOrder: "Orden de visualización",
        active: "Activo",
      },
      placeholders: { grade: "p. ej. 1", levelName: "Nombre del nivel" },
      errors: {
        unauthorized: "No autorizado",
        uploadFailed: "Error al subir",
        levelsRequireGrade:
          "Completa el grado/ID de todos los niveles antes de guardar",
        titleRequired: "El título es obligatorio",
      },
      confirm: {
        deleteProgram: "¿Eliminar este programa? No se puede deshacer.",
      },
      draft: { title: "Nuevo programa" },
      icons: {
        reading: "Lectura",
        graduation: "Graduación",
        math: "Matemáticas",
        science: "Ciencia",
        language: "Idioma",
        coding: "Programación",
        islamicStudies: "Estudios islámicos",
        atom: "Átomo",
        design: "Diseño",
        writing: "Escritura",
        globe: "Globo",
        star: "Estrella",
        bookLegacy: "Libro (legacy)",
        scienceLegacy: "Ciencia (legacy)",
      },
    },
    programLevelSelect: {
      title: "Elige un nivel",
      subtitle: {
        forProgram: "Para el programa: {{title}}",
        continue: "Luego continúa a los detalles del programa.",
      },
      actions: { backToHome: "Volver al inicio" },
      states: {
        noLevels: "Aún no hay niveles disponibles para este programa.",
      },
    },
    lessonDetail: {
      idLabel: "ID de clase",
      backToList: "Volver a la lista",
      edit: "Editar clase",
      delete: "Eliminar clase",
      deleteConfirm: "¿Eliminar esta clase de forma permanente?",
      loading: "Cargando detalles de la clase...",
      error: "No se pudo cargar la clase: ",
      notFound: "Clase no encontrada.",
      scheduledAt: "Fecha y hora de la clase",
      description: "Descripción de la clase",
      student: "Estudiante",
      teacher: "Profesor",
      duration: "Duración de la clase",
      minutes: "minutos",
      createdAt: "Creada el",
      updatedAt: "Actualizada el",
      packInfo: "Detalles del paquete",
      pack: "Paquete",
      subject: "Materia",
      price: "Precio",
      partOfPack: "Parte del paquete",
      meetingStatus: "Enlace de reunión",
      meetingReady: "Listo",
      meetingPending: "Aún no creado",
      joinMeeting: "Unirse a la clase",
      generateMeeting: "Generar enlace de reunión",
      generatingMeeting: "Generando...",
      notifyParentsTitle: "Notificar a los padres",
      notifyParentsStatus: "Estado",
      notifyParentsMessage: "Mensaje",
      notifyParentsSend: "Enviar",
      notifyParentsSending: "Enviando...",
      notifyParentsSuccess: "Notificación enviada.",
      notifyParentsSuccessCount: "Notificación enviada a {{count}} padres.",
    },
    lessonEditor: {
      accessDenied: "Esta cuenta no puede crear ni editar clases.",
      backToList: "Volver a la lista de clases",
      loading: "Preparando el formulario...",
      loadError: "No se pudo cargar la clase",
      title: { edit: "Editar clase", create: "Crear nueva clase" },
      note: {
        edit: "Actualiza los detalles, horario o estado de la clase.",
        create: "Registra la próxima clase y vincula al estudiante correcto.",
      },
      genericError: "Ocurrió un error al cargar",
      form: {
        title: "Título de la clase",
        description: "Descripción",
        scheduledAt: "Horario de la clase",
        duration: "Duración de la clase (minutos)",
        status: "Estado de la clase",
        classGroup: "Clase",
        allStudents: "Todos los estudiantes",
        students: "Estudiantes",
        student: "Estudiante",
        teacher: "ID del profesor (admins)",
        allowParentJoinMeeting:
          "Permitir que el padre/madre se una a la reunión",
        pack: "Paquete vinculado (opcional)",
        image: "URL de imagen (opcional)",
      },
      placeholders: {
        title: "Ej. Repaso de matemáticas — decimales",
        description: "Notas sobre objetivos, recursos o indicaciones",
        student: "Ingresa el ID del estudiante o selecciónalo de la lista",
        teacher: "Ingresa el ID del profesor responsable",
        noPack: "Sin paquete específico",
        image: "https://",
      },
      help: {
        scheduledAt:
          "El horario se guarda en tu zona y se convierte automáticamente a UTC.",
        student:
          "Los IDs de estudiantes aparecen aquí. Los padres ven a todos sus hijos; los docentes ven alumnos que ya enseñaron.",
        teacher:
          "Este número debe pertenecer a un usuario con rol de profesor.",
        allowParentJoinMeeting:
          "Si se desactiva, el padre/madre no verá el enlace de reunión.",
        classCreatesLessons:
          "Seleccionar una clase creará una lección por cada estudiante de esa clase.",
        classStudents: "Estudiantes de la clase",
      },
      status: {
        scheduled: "Programada",
        completed: "Completada",
        cancelled: "Cancelada",
      },
      errors: {
        title: "Ingresa un título.",
        schedule: "Elige una fecha y hora válidas.",
        student: "ID de estudiante no válido. Usa el identificador numérico.",
        duration: "La duración debe ser un número positivo.",
        teacher: "ID de profesor no válido.",
        noStudentsInClass: "Esta clase no tiene estudiantes",
      },
      actions: {
        saving: "Guardando...",
        update: "Actualizar clase",
        save: "Guardar clase",
        cancel: "Cancelar y volver",
      },
    },
    teacherPublicProfile: {
      avatarAlt: "Avatar",
      actions: {
        back: "Volver",
        follow: "Seguir",
        chat: "Chat",
        viewProfile: "Ver",
      },
      sections: {
        about: "Acerca de",
        experience: "Experiencia",
        education: "Educación",
        skills: "Habilidades",
        teachers: "Profesores",
      },
      labels: {
        noInfo: "Aún no hay información",
        defaultHeadline: "Profesor de Casaclass",
        since: "Desde",
        verified: "Verificado",
        teacher: "Profesor",
      },
      states: {
        loading: "Cargando...",
        notFound: "Profesor no encontrado.",
        loadError: "No se pudo cargar el perfil del profesor.",
      },
      tooltips: { comingSoon: "Próximamente" },
    },
    profile: {
      roles: {
        adminFull: "Administrador de la plataforma",
        teacherFull: "Profesor de Casaclass",
        parentFull: "Padre/Madre",
        studentFull: "Estudiante",
        adminShort: "Admin",
        teacherShort: "Profesor",
        parentShort: "Padre/Madre",
      },
      common: {
        loadingData: "Cargando...",
        idLabel: "ID: {{id}}",
        dobLabel: "Fecha de nacimiento: {{date}}",
        unknown: "No especificado",
      },
      messages: {
        profileUpdated: "Tus datos se actualizaron correctamente.",
        avatarUpdated: "Tu foto de perfil se actualizó correctamente.",
      },
      actions: {
        saving: "Guardando...",
        saveChanges: "Guardar cambios",
        cancelEdit: "Cancelar edición",
        edit: "Editar",
        delete: "Eliminar",
        refresh: "Actualizar",
      },
      overview: {
        aboutTitle: "Acerca de",
        aboutTextStudent:
          "Este es el perfil del estudiante vinculado al modo Estudiante.",
        aboutTextUser:
          "Gestiona aquí la información básica de tu cuenta y actualiza el nombre que se muestra en la plataforma.",
        uploadingPhoto: "Subiendo foto...",
        changePhoto: "Cambiar foto",
        upcomingLessons: "Próximas clases",
        noUpcomingLessons: "No hay clases próximas.",
      },
      progress: {
        title: "Progreso del perfil",
        subtitle: "Completa tus datos para mejorar la experiencia.",
        completeProfile: "Completar perfil",
      },
      studentDetails: {
        title: "Detalles del estudiante",
        notFound: "No se pudo encontrar al estudiante.",
      },
      personal: {
        title: "Información personal",
        subtitleStudent: "Información del estudiante en modo Estudiante.",
        subtitleUser: "Actualiza el nombre que aparece en la plataforma.",
        edit: "Editar",
        accountDetailsAria: "Detalles de la cuenta",
      },
      fields: {
        firstName: "Nombre",
        lastName: "Apellido",
        phone: "Teléfono",
        role: "Rol",
        email: "Correo electrónico",
        dob: "Fecha de nacimiento",
        completion: "Completitud del perfil",
        status: "Estado",
        notes: "Notas",
      },
      placeholders: {
        firstName: "Ej.: Ahmed",
        lastName: "Ej.: Ben Mahmoud",
        phone: "Ej.: +216 55 544 475",
      },
      students: {
        title: "Mis hijos",
        subtitle:
          "Añade hijos o actualiza sus datos para que los docentes puedan programar clases más fácilmente.",
        placeholders: {
          firstName: "Ej.: Ali",
          lastName: "Ej.: Ben Salem",
          notes: "Información adicional útil para el equipo de Casaclass",
        },
        actions: {
          add: "Agregar estudiante",
          update: "Actualizar estudiante",
        },
        loading: "Cargando estudiantes...",
        empty: "Aún no se han añadido hijos.",
        errors: {
          firstNameRequired: "El nombre es obligatorio",
        },
        confirmDelete: "¿Quieres eliminar a este estudiante?",
      },
      classes: {
        title: "Mis clases",
        subtitle:
          "Crea una clase con uno o más estudiantes para organizar las lecciones.",
        fields: {
          name: "Nombre de la clase",
          students: "Estudiantes",
        },
        placeholders: {
          name: "Ej.: Clase de matemáticas",
        },
        actions: {
          add: "Agregar clase",
          update: "Actualizar clase",
        },
        loading: "Cargando clases...",
        empty: "Aún no se han creado clases.",
        emptyRoster: "Aún no hay estudiantes vinculados a tus clases.",
        studentsCount: "Estudiantes: {{count}}",
        noStudentsSelected: "No se han seleccionado estudiantes.",
        errors: {
          nameRequired: "El nombre de la clase es obligatorio",
        },
        confirmDelete: "¿Quieres eliminar esta clase?",
      },
      lessons: {
        title: "Resumen de clases",
        subtitle: "Una vista rápida de tus clases y los próximos horarios.",
        stats: {
          total: "Total de clases",
          completed: "Completadas",
          cancelled: "Canceladas",
        },
        labels: {
          scheduledAt: "Fecha: {{datetime}}",
          student: "Estudiante: {{name}}",
          duration: "Duración: {{minutes}} minutos",
        },
        empty: "Aún no hay clases registradas.",
      },
      users: {
        title: "Gestión de usuarios",
        subtitle:
          "Revisa las cuentas registradas y cambia roles cuando sea necesario.",
        filters: {
          role: "Filtrar por rol",
          allRoles: "Todos los roles",
          search: "Buscar por correo o nombre",
        },
        placeholders: {
          search: "example@casaclass.com",
        },
        actions: {
          search: "Buscar",
          reset: "Restablecer",
        },
        loading: "Cargando usuarios...",
        summary:
          "Resultados: {{total}} — Admins: {{admins}}, Profesores: {{teachers}}, Padres: {{parents}}",
        empty: "No hay cuentas que coincidan con la búsqueda.",
        table: {
          email: "Correo",
          name: "Nombre",
          role: "Rol",
          status: "Estado",
        },
      },
    },
    studentsPage: {
      noAccess: {
        title: "Gestión de hijos",
        lead: "Esta página está reservada para padres que gestionan a sus hijos en Casaclass.",
        body: "Tu cuenta no tiene permisos para gestionar estudiantes. Vuelve al panel.",
      },
      title: "Mis hijos",
      lead: "Añade hijos, actualiza sus datos y sigue sus próximas clases desde aquí.",
      leadStudentMode:
        'Puedes activar el "modo estudiante" para cambiar a la vista de un hijo directamente desde la cuenta de padre/madre.',
      form: {
        newTitle: "Agregar un nuevo estudiante",
        editTitle: "Actualizar datos del estudiante",
        firstName: "Nombre",
        lastName: "Apellido",
        dob: "Fecha de nacimiento",
        password: "Contraseña",
        notes: "Notas",
      },
      placeholders: {
        firstName: "Ej. Yasmine",
        lastName: "Ej. Ben Salah",
        password: "Al menos 8 caracteres",
        notes: "Información extra útil para los docentes.",
      },
      actions: {
        create: "Agregar estudiante",
        update: "Actualizar estudiante",
        saving: "Guardando",
        cancel: "Cancelar",
      },
      list: {
        title: "Lista de hijos",
        refresh: "Actualizar",
        loading: "Cargando estudiantes...",
        empty: "Aún no se registraron hijos.",
      },
      card: {
        upcoming: "{{count}} clases próximas",
        noUpcoming: "Sin clases próximas",
        dob: "Fecha de nacimiento: {{date}}",
        edit: "Editar",
        enterAs: "Entrar como estudiante",
        delete: "Eliminar",
      },
      confirmDelete: "¿Quieres eliminar a este estudiante?",
      feedback: {
        created: "Estudiante agregado correctamente.",
        createdWithLogin: "Estudiante agregado. Email de acceso: {{email}}",
        updated: "Estudiante actualizado.",
        deleted: "Estudiante eliminado.",
      },
      detail: {
        title: "Detalles de {{name}}",
        lead: "Revisa el perfil del estudiante y sus clases próximas aquí.",
        loadingLessons: "Actualizando clases...",
        activate: "Activar modo estudiante",
        active: "Modo estudiante activo para esta cuenta",
        stats: {
          total: "Total de clases",
          completed: "Completadas",
          cancelled: "Canceladas",
        },
        info: {
          title: "Información del estudiante",
          name: "Nombre:",
          dob: "Fecha de nacimiento:",
          notes: "Notas:",
          noNotes: "Sin notas",
        },
        upcoming: {
          title: "Próximas clases",
          time: "Horario: {{value}}",
          duration: "Duración: {{value}} minutos",
          teacher: "Profesor: {{value}}",
          empty: "No hay clases próximas para este estudiante.",
        },
      },
      errors: {
        firstNameRequired: "El nombre es obligatorio",
        passwordRequired: "La contraseña es obligatoria",
        passwordMin: "La contraseña debe tener al menos 8 caracteres",
      },
    },
    aboutPage: {
      hero: {
        label: "Casaclass",
        title: "Nuestra historia",
        story: [
          "Desde el primer día queremos que cada niño tunecino, en casa o en el exterior, aprenda en un entorno cálido y moderno que cuide su identidad.",
          "La educación es más que conocimiento: es un puente entre generaciones y una fuente de pertenencia.",
        ],
        illustrationAlt: "Ilustración de la comunidad Casaclass",
        highlights: [
          {
            icon: "🌍",
            title: "Diáspora conectada",
            description: "Una escuela tunecina que viaja con tu familia.",
          },
          {
            icon: "🎓",
            title: "Expertos apasionados",
            description:
              "Docentes tunecinos certificados que diseñan cada camino.",
          },
          {
            icon: "🤝",
            title: "Acompañamiento cercano",
            description:
              "Test de nivel, coaching 1:1 y certificados de progreso.",
          },
        ],
      },
      mission: {
        label: "Nuestra misión",
        title: "Lo que defendemos",
        description:
          "Unir excelencia académica y raíces culturales para cada familia tunecina.",
        items: [
          {
            title: "Acceso de calidad",
            description:
              "Lecciones a medida dirigidas por docentes tunecinos cualificados.",
          },
          {
            title: "Raíces e identidad",
            description: "Árabe, Corán y Hadiz para mantenerse conectados.",
          },
          {
            title: "Ajuste global",
            description:
              "Programas alineados con currículos tunecinos e internacionales.",
          },
          {
            title: "Flexible y motivador",
            description:
              "Packs de Ramadán, verano, repaso y sesiones atractivas.",
          },
        ],
      },
      resources: {
        label: "Nuestros recursos",
        title: "Lo que aportamos",
        description:
          "Herramientas concretas, packs temáticos y un equipo listo para ayudar siempre.",
        items: [
          {
            title: "Equipo especializado",
            description:
              "Docentes expertos en los ejes académico y espiritual.",
          },
          {
            title: "Packs listos",
            description:
              "Packs de Ramadán, unidades escolares, apoyo continuo.",
          },
          {
            title: "Acompañamiento completo",
            description:
              "Test de ingreso, seguimiento 1:1, evaluaciones y certificados.",
          },
          {
            title: "Plataforma accesible",
            description: "Acceso online desde Europa, el Golfo y Túnez.",
          },
        ],
      },
      values: {
        label: "Nuestros valores",
        title: "Principios guía",
        description:
          "Nuestros valores dirigen cada decisión educativa y humana.",
        items: [
          {
            title: "Cuidado",
            description:
              "El alumno en el centro con acompañamiento humano cálido.",
          },
          {
            title: "Excelencia",
            description: "Cada clase se diseña y revisa con rigor.",
          },
          {
            title: "Autenticidad",
            description:
              "Honramos las raíces tunecinas y la dimensión espiritual.",
          },
          {
            title: "Innovación",
            description:
              "Herramientas modernas, videos interactivos y evaluaciones lúdicas.",
          },
          {
            title: "Equidad",
            description:
              "Educación accesible sin importar dónde viva la familia.",
          },
        ],
      },
      vision: {
        label: "Nuestra visión",
        title: "Hacia dónde vamos",
        description:
          "Impulsar Casaclass hacia un modelo sostenible que crezca con las familias.",
        intro:
          "Queremos ser la referencia e-learning tunecina para niños construyendo:",
        points: [
          "Una comunidad de estudiantes, padres y docentes que comparte cultura y ambición.",
          "Programas renovados constantemente con packs temáticos e innovación pedagógica.",
          "Una plataforma escalable y sostenible para familias tunecinas en todas partes.",
        ],
      },
      uniques: {
        label: "Lo que nos diferencia",
        title: "Por qué Casaclass destaca",
        description:
          "Una experiencia integral que combina rigor, espiritualidad e innovación digital.",
        items: [
          {
            title: "Enfoque híbrido",
            description: "Académico y espiritual, con habilidades digitales.",
          },
          {
            title: "Personalización total",
            description: "Test de nivel y camino ajustado para cada niño.",
          },
          {
            title: "Flexibilidad geográfica",
            description: "Ideal para familias en Europa, el Golfo y Túnez.",
          },
          {
            title: "Compromiso educativo",
            description:
              "Docentes apasionados, herramientas modernas, seguimiento real.",
          },
        ],
      },
      showcase: {
        label: "En imágenes",
        title: "Nuestra visión en momentos",
        description:
          "Tres miradas a Casaclass: energía comunitaria, camino guiado y plataforma en todas partes.",
        cards: [
          {
            title: "Comunidad comprometida",
            description: "Familias, alumnos y mentores avanzan juntos.",
            alt: "Comunidad Casaclass",
          },
          {
            title: "Trayecto inmersivo",
            description:
              "Ruta clara, actividades agradables, feedback constante.",
            alt: "Trayecto Casaclass",
          },
          {
            title: "Siempre accesible",
            description:
              "Interfaz moderna y sencilla en cada viaje y dispositivo.",
            alt: "Plataforma Casaclass",
          },
        ],
      },
      cta: {
        title: "¿Listo para unirte a la comunidad Casaclass?",
        description:
          "Habla con nuestro equipo, encuentra el programa adecuado y potencia el aprendizaje de tu hijo.",
        primary: "Hablar con el equipo",
        secondary: "Crear una cuenta",
      },
    },
    dashboard: {
      role: {
        admin: "Admin de plataforma",
        superadmin: "Super admin",
        support: "Soporte",
        accounting: "Contabilidad",
        teacher: "Docente",
        parent: "Padre/Madre",
        member: "Miembro Casaclass",
      },
      searchPlaceholder: "Buscar...",
      loading: "Cargando...",
      hero: {
        greeting: "Bienvenido/a {{name}}, 👋",
        intro:
          "Un vistazo rápido a tus próximas clases, estudiantes vinculados y packs Casaclass destacados.",
        manageLessons: "Gestionar clases",
        browseOffers: "Ver ofertas",
        nextLesson: "Próxima clase",
        student: "Estudiante",
        teacher: "Docente",
        time: "Hora",
        duration: "Duración",
      },
      stats: {
        total: { label: "Clases", hint: "Todas las clases registradas" },
        upcoming: { label: "Próximas", hint: "Programadas pronto" },
        completed: { label: "Completadas", hint: "Ya realizadas" },
        cancelled: { label: "Canceladas", hint: "Clases canceladas" },
      },
      upcoming: {
        title: "Clases próximas",
        subtitle: "Las próximas cuatro clases para seguir el ritmo.",
        viewAll: "Ver todo",
        loading: "Cargando clases...",
        empty:
          "No hay clases próximas. Puedes programar una nueva desde la página de Clases.",
      },
      students: {
        title: "Estudiantes vinculados",
        subtitle: "Estudiantes asociados a tu cuenta.",
        id: "Identificador",
        dob: "Fecha de nacimiento",
        empty: "Sin datos de estudiantes.",
      },
      featured: {
        title: "Packs sugeridos",
        subtitle: "Recomendaciones del catálogo Casaclass.",
        explore: "Explorar todos los packs",
        lessonsCount: "Clases",
        sessionLength: "Duración de sesión",
        price: "Precio",
        learnMore: "Saber más",
      },
      errors: {
        loadData: "No pudimos cargar algunos datos: {{error}}",
      },
      teacher: {
        roleLabel: "Dashboard docente",
        greeting: "Hola {{name}}",
        intro:
          "Control rápido de clases, estudiantes y comunicación con padres.",
        performance: {
          title: "Rendimiento",
          completed: "Completadas",
          cancelled: "Canceladas",
        },
        programs: {
          title: "Mis programas",
          loading: "Cargando programas...",
          edit: "Editar",
          empty: "Aún no hay programas.",
        },
        weeklyActivity: {
          title: "Actividad semanal",
          hint: "Últimos 7 días",
        },
        topStudents: {
          title: "Estudiantes más activos",
          lessons: "{{count}} clases",
          empty: "Aún no hay suficientes datos.",
        },
        updates: {
          title: "Últimas actualizaciones",
          empty: "Aún no hay actualizaciones.",
        },
        actions: {
          schedule: "Programar clases",
          newLesson: "Crear clase",
        },
        stats: {
          activeStudents: { label: "Estudiantes activos" },
          hoursGiven: { label: "Horas de enseñanza" },
          completed: { label: "Sesiones completadas" },
          cancelled: { label: "Sesiones canceladas" },
        },
        schedule: {
          title: "Calendario de clases",
          subtitle: "Clases más cercanas y su estado.",
          view: "Ver calendario",
          loading: "Cargando calendario...",
          empty: "No hay clases próximas.",
        },
        manage: {
          title: "Gestionar clases",
          subtitle: "Crear clases, recursos y asistencia.",
          createEdit: {
            title: "Crear / editar",
            description: "Planifica, edita o duplica clases fácilmente.",
          },
          upload: {
            title: "Subir recursos",
            description: "Añade PDF, video o cuestionarios.",
          },
          attendance: {
            title: "Registrar asistencia",
            description: "Marca asistencia para cada clase.",
          },
        },
        assessments: {
          title: "Evaluaciones y feedback",
          subtitle: "Notas, comentarios e historial de tareas/tests.",
          grades: {
            title: "Notas y apuntes",
            description: "Añade una nota y comentario por estudiante.",
          },
          homework: {
            title: "Registro de tareas / tests",
            description: "Revisa tareas corregidas y haz seguimiento.",
          },
        },
        communication: {
          title: "Comunicación",
          subtitle: "Mensajes internos y notificaciones.",
          messaging: {
            title: "Mensajes internos",
            description: "Chat seguro con estudiantes y padres.",
          },
          notifications: {
            title: "Notificaciones del sistema",
            description: "Nuevos estudiantes o cambios de calendario.",
          },
        },
        payments: {
          title: "Pagos",
          subtitle: "Transferencias Casaclass y facturas mensuales.",
          history: {
            title: "Historial de transferencias",
            description: "Tus transferencias aparecen aquí.",
          },
          invoicing: {
            title: "Facturas automáticas",
            description: "Resumen mensual generado automáticamente.",
          },
        },
      },
      parent: {
        roleLabel: "Dashboard de padres",
        greeting: "Hola {{name}}",
        intro: "Sigue a tus hijos, clases, alertas y facturación.",
        classes: {
          title: "Clases",
          subtitle: "Clases actuales para cada hijo",
        },
        widgets: {
          studentModeLabel: "Modo estudiante",
          studentModePlaceholder: "Entrar como estudiante",
          notifications: "Notificaciones",
          weekSubtitle: "Vista rápida de las clases de esta semana.",
          noLessons: "No hay clases.",
          reminders: "Recordatorios",
          reminderCheckbox: "Marcar como hecho",
          recommended: "Recomendado",
          monthStats: "Estadísticas del mes",
          monthStatsHint: "Resumen",
          children: "Hijos",
          homework: "Tareas",
          homeworkHint: "Próximas clases.",
        },
        notifications: {
          empty: "No hay notificaciones.",
          markRead: "Marcar como leído",
          status: {
            cancelled: "Cancelada",
            postponed: "Aplazada",
            updated: "Actualizada",
          },
        },
        actions: {
          weekly: "Calendario semanal",
          support: "Abrir ticket de soporte",
        },
        activeStudent: {
          status: "El modo estudiante está activo",
          none: "Ningún estudiante seleccionado",
          label: "Modo {{name}}",
          subtitle: "Acceso directo al espacio del estudiante seleccionado.",
          deactivate: "Desactivar modo",
          prompt: "Selecciona un estudiante para activar su espacio.",
        },
        children: {
          title: "Hijos vinculados",
          subtitle: "Progreso general y próximas clases.",
          addChild: "Agregar hijo",
          progress: "Progreso",
          nextLesson: "Próxima clase",
          activate: "Activar modo estudiante",
          active: "Modo estudiante activo",
          viewLessons: "Ver clases",
          loading: "Cargando hijos...",
          empty: "No hay hijos vinculados.",
        },
        followup: {
          title: "Seguimiento de clases",
          subtitle: "Calendario semanal y registros (replays/recursos).",
          loading: "Cargando clases...",
          empty: "No hay clases programadas esta semana.",
        },
        communication: {
          title: "Comunicación",
          subtitle: "Chat seguro con docentes y soporte.",
          teacherChat: {
            title: "Chat con docente",
            description: "Hilo privado por clase.",
          },
          supportTicket: {
            title: "Ticket de soporte",
            description: "Envía tus solicitudes al equipo Casaclass.",
          },
        },
        billing: {
          title: "Pagos y facturación",
          subtitle: "Suscripciones, facturas PDF y gestión de packs.",
          activeSubs: {
            title: "Suscripciones activas",
            description: "Tus ofertas actuales aparecen aquí.",
          },
          invoices: {
            title: "Facturas descargables",
            description: "Descarga tus facturas (PDF).",
          },
          renew: {
            title: "Renovar / cancelar",
            description: "Gestiona opciones de suscripción.",
          },
        },
        profile: {
          title: "Perfil de padres",
          subtitle: "Datos de contacto y método de pago preferido.",
          contact: {
            title: "Datos de contacto",
            description: "Actualiza tu información personal.",
          },
          payment: {
            title: "Método de pago",
            description: "Añade o cambia el método de pago.",
          },
          manageChildren: {
            title: "Gestionar hijos",
            description: "Añade o elimina hijos vinculados.",
          },
        },
        modal: {
          exitTitle: "Confirmar vuelta al modo padres",
          exitBody:
            "Por seguridad, introduce la contraseña de padre/madre antes de volver.",
          passwordLabel: "Contraseña",
          passwordError: "Contraseña incorrecta. Inténtalo de nuevo.",
          cancel: "Cancelar",
          confirm: "Confirmar",
          verifying: "Verificando...",
          backToParent: "Volver al modo padres",
          logout: "Cerrar sesión",
        },
      },
      studentSpace: {
        tag: "Espacio estudiante",
        title: "Dashboard del estudiante — {{name}}",
        subtitle: "Clases próximas, progreso, mensajes y recursos.",
        errors: {
          profileLoad: "No se pudo cargar el perfil del estudiante.",
        },
        banner: {
          badge: "Estrella del día",
          greeting: "Hola, {{name}}",
          hint: "¡Qué bueno verte de nuevo! Prepárate y continúa tu clase hoy.",
          imageAlt: "Niños aprendiendo",
          stats: {
            courses: "Cursos",
            xp: "XP",
            completed: "Completadas",
          },
        },
        today: {
          title: "Clases de hoy",
          hint: "¡Clases divertidas te esperan hoy!",
          empty: "No hay clases hoy. ¡Disfruta un descanso!",
        },
        missions: {
          title: "Tus misiones",
          hint: "Elige una misión y gana estrellas!",
          mentor: {
            title: "Preguntar a un mentor",
            body: "Consigue un consejo rápido para hoy.",
          },
          challenge: {
            title: "Nuevo desafío",
            body: "Empieza una nueva clase y gana XP!",
          },
        },
        classes: {
          title: "Tu clase",
          hint: "Tus clases y amigos",
          allTab: "Todas",
          friends: "{{count}} amigos",
          classLabel: "Clase: {{name}}",
          empty: "No hay clases vinculadas.",
        },
        activity: {
          title: "Tu actividad",
          hint: "Un vistazo rápido a tu progreso de los últimos meses.",
        },
        cards: {
          upcoming: { label: "Próximas", hint: "Sesiones programadas" },
          past: { label: "Pasadas", hint: "Registros recientes" },
          badges: { label: "Insignias", hint: "Progreso visible" },
          stars: { label: "Estrellas", hint: "Motivación" },
        },
        upcoming: {
          title: "Clases próximas",
          subtitle: "Únete a la sala en vivo (Zoom/BBB).",
          empty: "No hay clases programadas.",
          join: "Unirse a la sala",
        },
        past: {
          title: "Clases pasadas",
          subtitle: "Replays, archivos y evaluaciones.",
          empty: "No hay clases pasadas.",
          viewResources: "Ver recursos",
        },
        resources: {
          title: "Recursos",
          subtitle: "Biblioteca por materia con enlaces y videos.",
        },
        messages: {
          title: "Últimos mensajes",
          subtitle: "Intercambio con docentes.",
          open: "Abrir mensajes",
        },
        feedback: {
          title: "Comentarios",
          subtitle: "Ver notas, comentarios y valorar la clase.",
        },
      },
    },
    landingPage: {
      subjectsGrid: {
        title: "Materias",
        description:
          "Descubre nuestros programas diseñados para apoyar a tu hijo en cada materia, con acompañamiento pedagógico especializado que fomenta la excelencia y la confianza.",
        cta: "Ver ofertas",
        ariaLabel: "Programas",
        managePrograms: "Gestionar programas",
        items: [],
      },
      hero: {
        title: "Contigo en cada paso",
        lead: "Casaclass es una plataforma tunecina que llega a tu hogar donde estés. Acompañamos a tus hijos en estudios, idiomas y valores para que crezcan con confianza, identidad y conocimiento.",
        primaryCta: "Empieza ahora",
        secondaryCta: "Ver ofertas",
        videoTitle: "Video principal de Casaclass",
        statsLabel: "Cifras clave de Casaclass",
        stats: [
          { value: "5.000+", label: "Familias acompañadas" },
          { value: "230+", label: "Clases interactivas" },
          { value: "45", label: "Docentes tunecinos" },
          { value: "4,9/5", label: "Satisfacción de padres" },
        ],
      },
      features: {
        tag: "Una escuela para cada niño",
        title: "¿Por qué Casaclass?",
        description:
          "Creada para mantener a los niños conectados con su lengua, cultura y valores sin importar dónde vivan. Combinamos pedagogía tunecina y herramientas modernas para un aprendizaje motivador.",
        cta: "Descubrir programas",
        cards: [
          {
            title: "Ruta personalizada",
            description: "Test de nivel, camino a medida y apoyo familiar",
            alt: "Estudiante en un camino de aprendizaje personalizado",
          },
          {
            title: "En vivo y a demanda",
            description: "Sesiones en vivo + biblioteca de video para repasar",
            alt: "Sesión en vivo en Casaclass",
          },
          {
            title: "Acompañamiento neuro-pedagógico",
            description:
              "Diagnóstico, acompañamiento y rutas de aprendizaje personalizadas para la excelencia",
            alt: "Ilustración de acompañamiento neuro-pedagógico",
          },
        ],
      },
      journey: {
        ariaLabel: "Historia de Casaclass con las familias",
        title: "La historia",
        imageAlt: "Familia confiando en el camino Casaclass",
        paragraphs: [
          "Cada cerebro es único.",
          "Para transformar los desafíos en éxito con un acompañamiento neuro-pedagógico a medida, ponemos a tu disposición los mejores expertos en psicología, neuropsiquiatría y pedagogía.",
        ],
        cta: "Iniciar test de nivel",
      },
      levels: {
        tag: "Empecemos",
        title: "Elige el nivel que quieres explorar",
        description:
          "Cada nivel combina videos en streaming, cuadernos imprimibles y seguimiento de objetivos. Elige el nivel adecuado hoy y empieza un camino que crece con tu hijo.",
        note: "Si el sueño es posible, el plan está cerca.",
        ariaPrefix: "Explorar nivel",
        items: [
          {
            grade: "1",
            label: "Nivel 1",
            accent: 1,
            ariaLabel: "Explorar nivel 1",
          },
          {
            grade: "2",
            label: "Nivel 2",
            accent: 2,
            ariaLabel: "Explorar nivel 2",
          },
          {
            grade: "3",
            label: "Nivel 3",
            accent: 3,
            ariaLabel: "Explorar nivel 3",
          },
          {
            grade: "4",
            label: "Nivel 4",
            accent: 4,
            ariaLabel: "Explorar nivel 4",
          },
          {
            grade: "5",
            label: "Nivel 5",
            accent: 5,
            ariaLabel: "Explorar nivel 5",
          },
          {
            grade: "6",
            label: "Nivel 6",
            accent: 6,
            ariaLabel: "Explorar nivel 6",
          },
          {
            grade: "7",
            label: "Nivel 7",
            accent: 7,
            ariaLabel: "Explorar nivel 7",
          },
          {
            grade: "8",
            label: "Nivel 8",
            accent: 8,
            ariaLabel: "Explorar nivel 8",
          },
          {
            grade: "9",
            label: "Nivel 9",
            accent: 9,
            ariaLabel: "Explorar nivel 9",
          },
        ],
      },
      programs: {
        badge: "Programas Casaclass",
        title: "Cuatro pilares Casaclass",
        imageAlt: "Ilustración de pilares Casaclass",
        items: [
          {
            title: "1. Escolares — de 1º a 9º",
            list: [
              "Repaso + ejercicios + videos explicativos",
              "Apoyo 1:1 con docentes tunecinos",
              "Seguimiento mensual con padres",
              "Ruta que avanza paso a paso",
            ],
            slogan: "Aprendizaje claro, progreso seguro.",
            cta: "Unirse al programa escolar",
            ctaLink: "/signup",
          },
          {
            title: "2. Francés",
            list: [
              "Programas avalados por el Ministerio tunecino",
              "Talleres de pronunciación y expresión oral",
              "Repaso de gramática y escritura con ejemplos",
              "Seguimiento individual y evaluaciones regulares",
            ],
            slogan: "Una segunda lengua es una puerta en el exterior.",
            cta: "Ver cursos de francés",
            ctaLink: "/courses",
          },
          {
            title: "3. Árabe • Corán • Hadiz",
            list: [
              "Memorización sencilla",
              "Bases de tajwid",
              "Sira y valores",
              "Árabe pensado para las nuevas generaciones",
            ],
            cta: "Ver cursos de árabe y Corán",
            ctaLink: "/courses",
          },
          {
            title: "4. Club de programación kids",
            list: [
              "Scratch, Python Kids, robótica",
              "Juegos educativos",
              "Mini proyectos mensuales",
              "Niños de hoy, programadores de mañana",
            ],
            slogan: "Aprender el futuro empieza ahora.",
            cta: "Unirse al club de coding",
            ctaLink: "/signup",
          },
        ],
      },
      specialNeeds: {
        ariaLabel: "Apoyo para necesidades especiales",
        title: "Tu hijo tiene necesidades específicas",
        description:
          "Tiene su lugar aquí, en contacto con especialistas para ayudarlo a integrarse y avanzar a su ritmo según sus necesidades.",
        imageAlt: "Tres pilares de los programas Casaclass",
        cta: "Contáctanos",
      },
      ecosystem: {
        title: "Un universo Casaclass claro",
        cta: "Únete al universo Casaclass",
        cards: [
          {
            icon: "👨‍👩‍👦",
            title: "Espacio padres",
            items: [
              "Seguimiento de progreso",
              "Reporte semanal",
              "Elegir docente/grupo",
            ],
            alt: "Panel de padres en Casaclass",
          },
          {
            icon: "👦",
            title: "Espacio estudiante",
            items: ["Tareas", "Lecciones cortas", "Insignias y recompensas"],
            alt: "Panel de estudiante en Casaclass",
          },
          {
            icon: "👩‍🏫",
            title: "Espacio docente",
            items: ["Dashboard", "Planificación", "Evaluaciones"],
            alt: "Panel de docentes en Casaclass",
          },
        ],
      },
      ramadan: {
        ariaLabel: "Packs de Ramadan para niños",
        badge: "Packs y Ramadan para niños",
        title: "Packs de Ramadan",
        lead: "30 videos de valores, Corán, historias y ética para niños de 5 a 12: un Ramadan lleno de luz, identidad y asombro.",
        items: [
          "Programación diaria inspirada en Ramadan",
          "Historias ilustradas y ejercicios de valores cada día",
          "Sesiones de Corán simplificadas con tajwid claro",
          "Actividades familiares para reforzar el vínculo",
        ],
        slogan: "Luz, aprendizaje y guía.",
        cta: "Próximamente",
        imageAlt:
          "Docente Casaclass acompañando a los niños en el programa de Ramadan",
      },
      testimonials: {
        ariaLabel: "Testimonios de la comunidad Casaclass",
        tag: "Historias de nuestra comunidad",
        title: "La confianza de familias y docentes",
        lead: "De padres en el exterior a docentes en Túnez, la plataforma reúne niños inspiradores y los acompaña paso a paso.",
        prev: "Testimonio anterior",
        next: "Siguiente testimonio",
        dotsLabel: "Navegar testimonios",
        dotLabel: "Ver testimonio de {{name}}",
        imageAlt: "Padre/madre: {{name}}",
        items: [
          {
            quote:
              "Desde que empezamos con Casaclass, el repaso se volvió un momento agradable en casa. Mi hija disfruta el camino claro y las recompensas digitales, y yo sigo su progreso desde el panel de padres sin estrés.",
            name: "Amel Ben Salem",
            place: "Lyon, Francia",
          },
          {
            quote:
              "Vivimos en Dubái y los horarios hacían difícil encontrar clases tunecinas. Con Casaclass vamos a sesiones en vivo o vemos repeticiones cuando conviene, y los niños conectan con los profes como si estuvieran en Túnez.",
            name: "Rami & Sirine",
            place: "Dubái, EAU",
          },
          {
            quote:
              "Mi hijo tiene problemas de concentración; el coach educativo nos dio un plan claro. Recibimos reportes semanales y consejos, y ahora está motivado y cuenta por sí mismo sus clases de árabe y Corán.",
            name: "Laila Marzouki",
            place: "Toronto, Canadá",
          },
        ],
      },
      faq: {
        ariaLabel: "Preguntas frecuentes Casaclass",
        tag: "FAQ",
        title: "Tus preguntas",
        lead: "Estamos cerca de ustedes desde el inicio hasta celebrar los logros de sus hijos.",
        items: [
          {
            question: "¿Cuánto tiempo dura el acceso a los recursos?",
            answer:
              "Cada suscripción abre todas las unidades durante 12 meses con actualizaciones gratuitas cada trimestre.",
          },
          {
            question: "¿Las clases sirven para familias en el exterior?",
            answer:
              "Sí. El contenido es bilingüe (árabe/francés) y sigue el programa tunecino con flexibilidad horaria.",
          },
          {
            question: "¿Hay seguimiento personalizado?",
            answer:
              "Desde el registro tienes un coach educativo con revisiones mensuales y consejos adaptados a tu familia.",
          },
          {
            question: "¿Cómo empiezo?",
            answer:
              "Crea una cuenta, elige el nivel de tu hijo y comienza ya con el test de nivel y las primeras clases.",
          },
        ],
      },
      finalCta: {
        ariaLabel: "Únete a Casaclass",
        label: "¿Listos?",
        title: "Activa hoy la primera clase",
        description: "Registro rápido + clase de prueba gratuita",
        primary: "Regístrate ahora",
        secondary: "Habla con un asesor",
      },
    },
    authPage: {
      loginTitle: "Iniciar sesión",
      loginLead: "Retoma tus clases al instante.",
      email: "Correo electrónico",
      emailPlaceholder: "example@mail.com",
      phoneLabel: "Número de teléfono",
      phonePlaceholder: "Ingresa tu número de teléfono",
      password: "Contraseña",
      passwordPlaceholder: "Ingresa tu contraseña",
      showPassword: "Mostrar contraseña",
      hidePassword: "Ocultar contraseña",
      loginCta: "Entrar",
      loginLoading: "Ingresando...",
      noAccount: "¿No tienes cuenta?",
      goSignup: "Crea una ahora",
      signupTitle: "Crear cuenta",
      signupLead: "Únete a Casaclass y progresa con motivación.",
      name: "Nombre completo",
      namePlaceholder: "Ingresa tu nombre completo",
      roleLabel: "Tipo de cuenta",
      roleParent: "Padre/Madre",
      roleTeacher: "Docente",
      resumeLabel: "Currículum (CV)",
      resumeRequired: "Sube tu currículum para registrarte como docente.",
      confirmPassword: "Confirmar contraseña",
      confirmPasswordPlaceholder: "Vuelve a escribir la contraseña",
      signupCta: "Unirse a Casaclass",
      signupLoading: "Creando...",
      hasAccount: "¿Ya tienes cuenta?",
      goLogin: "Inicia sesión",
      passwordLength: "La contraseña debe tener al menos 8 caracteres.",
      passwordMatch: "Las contraseñas no coinciden.",
      loginError: "No se pudo iniciar sesión. Intenta de nuevo.",
      signupError: "No se pudo crear la cuenta. Intenta más tarde.",
      forgotLink: "¿Olvidaste tu contraseña?",
      forgotTitle: "Recuperar contraseña",
      forgotLead:
        "Ingresa tu correo y enviaremos un enlace si tu cuenta existe.",
      forgotCta: "Enviar enlace",
      forgotSending: "Enviando...",
      forgotSuccess:
        "Si este correo está registrado, recibirás instrucciones pronto.",
      forgotBack: "Volver al inicio de sesión",
      socialDivider: "O continúa con Google",
      googleError: "No pudimos iniciar sesión con Google. Inténtalo de nuevo.",
      googleLoading: "Verificando tu cuenta de Google...",
    },
    verificationPage: {
      title: "Cuenta pendiente de verificación",
      message:
        "Tu cuenta de docente se creó correctamente, pero no podrás acceder a la plataforma hasta que un administrador la verifique.",
      logout: "Cerrar sesión",
    },
    resources: {
      title: "Recursos",
      subtitleTeacher:
        "Crea recursos y asígnalos a una clase o a un estudiante.",
      subtitleStudent: "Los recursos asignados a ti aparecerán aquí.",
      loading: "Cargando...",
      create: "Crear recurso",
      creating: "Creando...",
      listTitle: "Recursos",
      empty: "Aún no hay recursos.",
      delete: "Eliminar",
      confirmDelete: "¿Eliminar este recurso?",
      failedLoad: "No se pudieron cargar los recursos",
      failedCreate: "No se pudo crear el recurso",
      failedDelete: "No se pudo eliminar el recurso",
      titleRequired: "El título es obligatorio",
      targetRequired: "Elige una clase o un estudiante",
      targetClass: "Clase",
      targetStudent: "Estudiante",
      fields: {
        title: "Título",
        titlePlaceholder: "p. ej. Material de la semana 3",
        text: "Texto",
        textPlaceholder: "Descripción o instrucciones (opcional)",
        assignTo: "Asignar a",
        class: "Clase",
        student: "Estudiante",
        attachments: "Adjuntos",
      },
      assign: {
        class: "Clase",
        student: "Estudiante",
      },
      pickClass: "Selecciona una clase",
      pickStudent: "Selecciona un estudiante",
    },
    offers: {
      heroTag: "Ofertas",
      heroTitle: "Paquetes Casaclass listos",
      heroDescription:
        "Elige el camino que se adapte a tu familia. Cada oferta combina clases en vivo, recursos digitales y acompañamiento del equipo pedagógico.",
      packLabel: "Elige un pack:",
      packPlaceholder: "-- Seleccionar --",
      sections: {
        classTypes: {
          tag: "Modalidades",
          heading: "Elijan el entorno cómodo para su hijo",
          description:
            "De sesiones uno a uno a grupos más grandes, cada formato se adapta a distintas personalidades y presupuestos.",
        },
        languages: {
          tag: "Idiomas",
          heading: "Trayectos de idiomas en vivo",
          description:
            "Recorridos completos desde lo básico hasta exámenes internacionales, con contenido interactivo que da confianza.",
        },
        upcoming: {
          tag: "Próximamente",
          heading: "Cursos de habilidades futuras",
          description:
            "Anota tu interés para recibir aviso cuando abramos coding, IA y laboratorios de liderazgo juvenil.",
        },
      },
      classTypes: {
        full: {
          category: "Tipos de clase",
          title: "Full Classes",
          subtitle: "Aprendizaje individual totalmente personalizado",
          description:
            "Experiencia 100 % personal con un docente que diseña el plan según tu hijo.",
          price: "25 TND / sesión",
          billing: "Sesión privada de 60 minutos",
          features: [
            "Programa personalizado y revisado",
            "Atención individual",
            "Flexibilidad total de horarios",
          ],
          cta: "Unirse a Full Classes",
        },
        duo: {
          category: "Tipos de clase",
          title: "DUO Classes",
          subtitle: "Clase compartida con amigo o hermano",
          description: "Diseñado para un dúo que se motiva aprendiendo juntos.",
          price: "15 TND / sesión",
          billing: "Precio por persona",
          features: [
            "Contenido adaptado para dos",
            "Actividades colaborativas",
            "Seguimiento del reparto de tareas",
          ],
          cta: "Unirse a DUO Classes",
          badge: "Más popular",
        },
        vip: {
          category: "Tipos de clase",
          title: "VIP Classes",
          subtitle: "Grupos pequeños hasta 4 alumnos",
          description:
            "Interacción constante en un grupo seleccionado con atención personal.",
          price: "10 TND / sesión",
          billing: "Precio por persona",
          features: [
            "Sesiones interactivas con pares cercanos",
            "Actividades cooperativas para la confianza",
            "Guía individual dentro del grupo",
          ],
          cta: "Unirse a VIP Classes",
        },
        normal: {
          category: "Tipos de clase",
          title: "Normal Classes",
          subtitle: "Hasta 8 alumnos",
          description:
            "Opción económica que mantiene la participación en un grupo colaborativo.",
          price: "7.5 TND / sesión",
          billing: "Precio por persona",
          features: [
            "Entorno grupal estructurado",
            "Actividades que fomentan la participación",
            "Mejor valor para aprendizaje continuo",
          ],
          cta: "Unirse a Normal Classes",
        },
      },
      languagePrograms: {
        french: {
          category: "Programas de idiomas",
          title: "Francés",
          subtitle: "A1 a C2 • DELF/DALF",
          description:
            "Refuerza gramática y conversación con preparación completa para DELF/DALF.",
          price: "180 TND / mes",
          billing: "Sesiones en vivo + recursos digitales",
          features: [
            "Progreso desde letras hasta escritura académica",
            "Práctica de examen DELF/DALF",
            "Talleres de pronunciación y oral",
          ],
          cta: "Inscribirse en Francés",
        },
        english: {
          category: "Programas de idiomas",
          title: "Inglés",
          subtitle: "Conversación + IELTS",
          description:
            "Ruta completa para hablar con confianza y preparar IELTS con módulos de negocios.",
          price: "220 TND / mes",
          billing: "En vivo • recursos interactivos",
          features: [
            "Preparación completa para IELTS",
            "Business English y entrevistas",
            "Clubs de conversación semanales",
          ],
          cta: "Probar una clase",
          badge: "Favorito",
        },
        arabic: {
          category: "Programas de idiomas",
          title: "Árabe",
          subtitle: "Para no nativos",
          description:
            "Introduce letras, pronunciación correcta y conversación diaria con toque cultural.",
          price: "160 TND / mes",
          billing: "Sesiones comunicativas + apoyo en casa",
          features: [
            "Letras y sonidos claros desde el día uno",
            "Diálogo diario y vocabulario esencial",
            "Historias y actividades culturales",
          ],
          cta: "Inscribirse en Árabe",
        },
      },
      upcoming: {
        coding: {
          category: "Próximamente",
          title: "Coding for Kids",
          subtitle: "Proyectos de Scratch y Minecraft",
          description:
            "Laboratorio digital que enseña lógica con proyectos divertidos cada mes.",
          price: "Próximamente",
          billing: "Inscripciones el próximo trimestre",
          features: [
            "Talleres de código progresivos",
            "Insignias digitales",
            "Colaboración en equipos pequeños",
          ],
          cta: "Avísenme al lanzamiento",
        },
        ai: {
          category: "Próximamente",
          title: "IA y Habilidades del Futuro",
          subtitle: "IA sencilla para jóvenes",
          description:
            "Explora IA, design thinking y automatización mediante mini proyectos.",
          price: "Próximamente",
          billing: "Lanzamiento verano 2026",
          features: [
            "Conceptos de IA sin complejidad",
            "Talleres de robótica con kits simples",
            "Retos de pensamiento crítico",
          ],
          cta: "Unirse a la lista de espera",
        },
        leaders: {
          category: "Próximamente",
          title: "Future Leaders Lab",
          subtitle: "Comunicación y presentaciones",
          description:
            "Combina presentaciones, resolución de problemas y mini proyectos para adolescentes.",
          price: "Próximamente",
          billing: "Piloto otoño 2026",
          features: [
            "Sesiones individuales y grupales",
            "Proyectos aplicados reales",
            "Coaching de expertos en comunicación",
          ],
          cta: "Registrar interés",
        },
      },
      addons: {
        tag: "Complementos",
        heading: "Servicios que completan la experiencia",
        description:
          "Añádelos a cualquier pack principal o resérvalos aparte cuando necesites un empujón extra.",
        coaching: {
          title: "Sesión de coaching familiar",
          price: "30 TND / sesión",
          description:
            "Llamada de 45 minutos para evaluar necesidades y fijar un plan mensual.",
          points: [
            "Evaluación rápida del nivel",
            "Mapa de objetivos de 4 semanas",
            "Actividades en casa y seguimiento",
          ],
          cta: "Reservar la sesión",
        },
        assessment: {
          title: "Test de nivel avanzado",
          price: "45 TND único",
          description:
            "Prueba interactiva + informe escrito con recomendaciones claras.",
          points: [
            "Prueba digital en lengua y matemáticas",
            "Análisis escrito de fortalezas y necesidades",
            "Plan de transición para las primeras semanas",
          ],
          cta: "Solicitar el informe",
        },
        oneToOne: {
          title: "Sesiones 1:1 intensivas",
          price: "25 TND / sesión",
          description:
            "Clases privadas online con docente Casaclass para reforzar una habilidad.",
          points: [
            "Materia y horario flexibles",
            "Nota de seguimiento tras cada sesión",
            "Ideal antes de exámenes o para ganar confianza",
          ],
          cta: "Coordinar con nosotros",
        },
      },
      support: {
        heading: "¿Necesitas ayuda para elegir?",
        description:
          "El equipo Casaclass puede crear un plan personalizado. Escríbenos y te propondremos el camino adecuado y revisaremos la preparación antes de empezar.",
        ctaCall: "Agenda una llamada de orientación",
        ctaSignup: "Crea una cuenta ahora",
      },
    },
    adminPage: {
      accessDenied: "Acceso restringido a administradores.",
      headerTag: "Consola administrativa",
      headerTitle: "Panel de administración",
      dashboard: {
        welcome: "¡Bienvenido de nuevo!",
        viewAll: "Ver todo",
        manageTitle: "Gestión",
        manageColumns: {
          section: "Sección",
          count: "Total",
          open: "Abrir",
        },
        cards: {
          newStudents: "Nuevos estudiantes",
          newStudentsHint: "Periodo actual",
          totalStudents: "Total estudiantes",
          totalStudentsHint: "Todos los estudiantes",
          dailyAttend: "Asistencia",
          dailyAttendHint: "Últimos 7 días",
          averageAttend: "Asistencia media",
          averageAttendHint: "Este mes",
        },
        activityTitle: "Actividad de estudiantes",
        thisMonth: "Este mes",
        lastMonths: "Mes pasado",
        examsTitle: "Exámenes",
        examsFallback: "Seguimiento de exámenes",
        studentsTitle: "Lista de estudiantes",
        studentsColumns: {
          id: "ID",
          student: "Estudiante",
          parent: "Padre/Madre",
          attends: "Asistencia",
        },
        teachersTitle: "Profesores",
        teacherVerified: "Verificado",
        teacherPending: "Pendiente",
        empty: "Aún no hay datos.",
      },
      tabs: {
        overview: "Resumen",
        users: "Usuarios",
        students: "Estudiantes",
        lessons: "Clases y agenda",
        timetable: "Horario",
        pendingTeachers: "Verificaciones de profesores pendientes",
        classes: "Clases",
        packs: "Paquetes",
        payments: "Pagos",
        teachers: "Profesores",
        support: "Soporte",
      },
      teachers: {
        title: "Profesores",
        empty: "No hay profesores para mostrar.",
        resume: "Descargar CV",
        activeYes: "Sí",
        activeNo: "No",
        filter: {
          label: "Filtrar por estado",
          all: "Todos",
          pending: "Pendiente",
          verified: "Verificado",
        },
        status: {
          verified: "Verificado",
          pending: "Pendiente",
        },
        fields: {
          email: "Correo",
          phone: "Teléfono",
          active: "Activo",
          joined: "Registrado",
        },
      },
      actions: {
        save: "Guardar",
        saving: "Guardando…",
        create: "Crear",
        cancel: "Cancelar",
        edit: "Editar",
        delete: "Eliminar",
      },
      timetable: {
        calendarTitle: "Calendario",
        addEvent: "Añadir evento",
        configure: "Configurar",
        previousDay: "Día anterior",
        nextDay: "Día siguiente",
        scopeTeacher: "Profesor",
        scopeClass: "Clase",
        scopeStudent: "Estudiante",
        allTeachers: "Todos los profesores",
        allClasses: "Todas las clases",
        allStudents: "Todos los estudiantes",
        viewWeek: "Semana",
        viewDay: "Día",
        faculty: "Profesorado",
        searchFacultyPlaceholder: "Buscar profesores...",
        editLessonTitle: "Editar clase",
        newLessonTitle: "Nueva clase",
        selectPlaceholder: "Seleccionar…",
        lessonTitlePlaceholder: "Título de la lección",
        minutesShort: "min",
        permanentWeekly: "Semanal permanente",
        fields: {
          teacher: "Profesor",
          class: "Clase",
          students: "Estudiantes",
          assignTo: "Asignar a",
          student: "Estudiante",
          title: "Título",
          start: "Inicio",
          duration: "Duración",
          status: "Estado",
        },
        assignModes: {
          student: "Estudiante",
          class: "Clase",
        },
      },
      classes: {
        panelTitleEdit: "Editar clase",
        panelTitleCreate: "Crear clase",
        classNamePlaceholder: "Nombre de la clase",
        fields: {
          name: "Nombre",
          students: "Estudiantes",
        },
        errors: {
          nameRequired: "El nombre es obligatorio",
        },
        confirmDelete: "¿Eliminar esta clase?",
        table: {
          class: "Clase",
          teacher: "Profesor",
          students: "Estudiantes",
          actions: "Acciones",
        },
      },
      loading: "Cargando datos...",
      stats: {
        activeStudents: "Estudiantes activos",
        monthlyRevenue: "Ingresos mensuales",
        satisfaction: "Tasa de satisfacción",
        outOfFive: "de 5",
        supportMessages: "Mensajes de soporte",
        teachers: "Profesores",
        unread: "sin leer",
      },
      roles: {
        superadmin: "Súper administrador",
        admin: "Administrador",
        support: "Soporte",
        accounting: "Contabilidad",
        teacher: "Profesor",
        parent: "Padre/Madre",
      },
      users: {
        title: "Gestión de usuarios",
        filter: "Filtrar por rol",
        filterAll: "Todos",
        columns: {
          email: "Correo",
          name: "Nombre",
          role: "Rol",
          phone: "Teléfono",
          joined: "Registro",
          verify: "Verificación docente",
          active: "Activo",
          actions: "Acciones",
        },
        verify: "Verificar",
        unverify: "Quitar",
        toggleActiveAria: "Activar o desactivar usuario",
        deleteConfirm: "¿Eliminar este usuario?",
        delete: "Eliminar",
      },
      students: {
        title: "Estudiantes",
        ageYears: "años",
        parent: "Padre/Madre",
        dob: "Fecha de nacimiento",
      },
      lessons: {
        title: "Clases y agenda",
        idLabel: "Identificador",
        student: "Estudiante",
        teacher: "Profesor",
        duration: "Duración",
        minutes: "minutos",
        status: {
          scheduled: "Programada",
          completed: "Completada",
          cancelled: "Cancelada",
        },
      },
      packs: {
        formEdit: "Editar paquete",
        formNew: "Nuevo paquete",
        fields: {
          name: "Nombre del paquete",
          description: "Descripción",
          subject: "Materia",
          subjectPlaceholder: "Elige...",
          price: "Precio",
          currency: "Moneda",
          lessons: "Número de sesiones",
          sessionLength: "Duración (minutos)",
          resources: "Recursos (una URL por línea)",
          image: "Imagen (opcional)",
          recommended: "Recomendado para",
          gradientColors: "Colores del degradado",
          gradientStart: "Color inicial del degradado",
          gradientEnd: "Color final del degradado",
          featured: "Mostrar en inicio",
          offersSection: "Sección de ofertas",
          offersSectionNone: "Ninguna",
          offersKind: "Tipo de oferta",
          offersDisplayOrder: "Orden de visualización (ofertas)",
          offersAccent: "Acento (ofertas)",
          offersCategoryKey: "Clave de categoría (ofertas)",
          offersTitleKey: "Clave del título (ofertas)",
          offersSubtitleKey: "Clave del subtítulo (ofertas)",
          offersDescriptionKey: "Clave de descripción (ofertas)",
          offersPriceKey: "Clave de precio (ofertas)",
          offersBillingKey: "Clave de facturación (ofertas)",
          offersFeaturesKey: "Clave de características (ofertas)",
          offersCtaKey: "Clave CTA (ofertas)",
          offersCtaLink: "Enlace CTA (ofertas)",
          offersBadgeKey: "Clave de insignia (ofertas)",
          offersNoteKey: "Clave de nota (ofertas)",
          offersPointsKey: "Clave de puntos (ofertas)",
        },
        placeholderResources: "https://.../video.mp4\nhttps://.../document.pdf",
        placeholders: {
          name: "Ejemplo: paquete de árabe",
          description: "Ejemplo: sesiones semanales con profesor",
          price: "Ejemplo: 120",
          lessons: "Ejemplo: 6",
          sessionLength: "Ejemplo: 60",
          image: "Ejemplo: https://example.com/image.png",
          recommended: "Ejemplo: estudiantes de secundaria",
          offersKey: "Ejemplo: offers.languages.arabic.title",
          offersLink: "Ejemplo: /contact",
        },
        actions: {
          saving: "Guardando...",
          save: "Guardar",
          reset: "Restablecer",
        },
        listTitle: "Paquetes actuales",
        sessions: "sesiones",
        minutesPerSession: "min/sesión",
        resourcesCount: "recursos",
        badgeFeatured: "Destacado",
        edit: "Editar",
        delete: "Eliminar",
        deleteConfirm: "¿Eliminar este paquete?",
        errorMissingNameSubject: "Ingresa nombre del paquete y materia.",
        detailsTitle: "Detalles del paquete",
        errorPackNotFound: "No se pudo encontrar este paquete.",
      },
      payments: {
        title: "Pagos",
        columns: {
          user: "Usuario",
          pack: "Paquete",
          amount: "Monto",
          status: "Estado",
        },
        statuses: {
          pending: "Pendiente",
          completed: "Completado",
          failed: "Fallido",
          refunded: "Reembolsado",
        },
      },
      support: {
        title: "Soporte y mensajes",
        from: "De",
        read: "Leído",
        new: "Nuevo",
        type: "Tipo",
        markRead: "Marcar como leído",
        reply: "Responder",
        replyTitle: "Nuevo mensaje",
        replyClose: "Cerrar",
        replyTo: "Para",
        replySubject: "Asunto",
        replyMessage: "Mensaje",
        replySend: "Enviar",
        replySending: "Enviando...",
        replyEmpty: "Escribe un mensaje antes de enviar.",
        replySubjectFallback: "Re: Mensaje de contacto",
      },
    },
  },
};

export default translations;
